var map = {
	"./00000-como-os-filtros-de-circuito-respondem-a-um-impulso.md": [
		76886,
		76886
	],
	"./00001-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		43584,
		43584
	],
	"./00002-como-a-transformacao-de-fontes-pode-simplificar-a-analise-de-circuitos.md": [
		18195,
		18195
	],
	"./00003-como-a-energia-armazenada-em-um-capacitor-varia-ao-longo-do-tempo-em-um-circuito-de-primeira-ordem.md": [
		34892,
		34892
	],
	"./00004-o-que-e-um-circuito-de-segunda-ordem-sub-amortecido.md": [
		20233,
		20233
	],
	"./00005-o-que-e-a-impedancia-em-circuitos-de-corrente-alternada.md": [
		63604,
		63604
	],
	"./00006-qual-a-diferenca-entre-sistemas-monofasicos-e-trifasicos.md": [
		31569,
		31569
	],
	"./00007-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		17601,
		17601
	],
	"./00008-qual-a-diferenca-entre-um-mosfet-e-um-transistor-bipolar.md": [
		8256,
		8256
	],
	"./00009-o-que-e-um-oscilador-de-wien-e-como-ele-funciona-em-circuitos-analogicos.md": [
		86783,
		86783
	],
	"./00010-como-funciona-a-conversao-de-sinais-analogicos-para-digitais-em-circuitos-cmos.md": [
		77358,
		77358
	],
	"./00011-o-que-e-um-circuito-rc-e-como-ele-funciona.md": [
		66556,
		66556
	],
	"./00012-o-que-e-um-curto-circuito-e-como-ele-afeta-um-sistema-eletrico.md": [
		61629,
		61629
	],
	"./00013-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		11549,
		11549
	],
	"./00014-o-que-e-o-teorema-de-norton-e-como-ele-e-aplicado-na-analise-de-circuitos.md": [
		21320,
		21320
	],
	"./00015-como-os-circuitos-de-primeira-ordem-armazenam-e-liberam-energia.md": [
		63990,
		63990
	],
	"./00016-o-que-e-um-circuito-de-segunda-ordem-e-como-ele-se-comporta.md": [
		55172,
		55172
	],
	"./00017-o-que-e-o-valor-eficaz-em-circuitos-de-corrente-alternada.md": [
		7939,
		7939
	],
	"./00018-o-que-e-um-circuito-trifasico-equilibrado-e-como-ele-funciona.md": [
		97472,
		97472
	],
	"./00019-o-que-e-um-filtro-passa-faixas-e-como-ele-funciona-em-circuitos-eletricos.md": [
		25856,
		25856
	],
	"./00020-como-o-teorema-de-thevenin-se-aplica-a-circuitos-com-transistores-bipolares-bjt.md": [
		98002,
		98002
	],
	"./00021-o-que-e-um-multivibrador-astavel-e-como-ele-funciona-em-circuitos-analogicos.md": [
		5124,
		5124
	],
	"./00022-como-simplificar-uma-expressao-logica-usando-o-mapa-de-karnaugh.md": [
		58807,
		58807
	],
	"./00023-como-a-tensao-se-comporta-em-um-circuito-rc-em-serie.md": [
		4061,
		4061
	],
	"./00024-o-que-e-um-curto-circuito-e-como-ele-ocorre-em-um-circuito-eletrico.md": [
		34958,
		34958
	],
	"./00025-qual-a-diferenca-entre-componentes-passivos-e-ativos-em-circuitos-eletricos.md": [
		60864,
		60864
	],
	"./00026-o-que-e-a-analise-nodal-e-como-ela-e-aplicada-em-circuitos-eletricos.md": [
		1315,
		1315
	],
	"./00027-o-que-e-um-circuito-de-primeira-ordem-e-como-ele-se-comporta-durante-a-descarga.md": [
		18651,
		18651
	],
	"./00028-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-se-comportam.md": [
		57801,
		57801
	],
	"./00029-como-a-superposicao-e-aplicada-em-circuitos-rlc-em-corrente-alternada.md": [
		8614,
		8614
	],
	"./00030-qual-a-diferenca-entre-as-conexoes-triangulo-e-estrela-em-circuitos-trifasicos.md": [
		58306,
		58306
	],
	"./00031-o-que-e-a-transformada-de-laplace-e-como-ela-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		40295,
		40295
	],
	"./00032-o-que-e-um-igbt-e-como-ele-funciona-em-circuitos-eletricos.md": [
		76491,
		76491
	],
	"./00033-o-que-e-um-circuito-astavel-e-como-ele-funciona.md": [
		64713,
		64713
	],
	"./00034-como-funcionam-as-portas-logicas-em-circuitos-digitais.md": [
		76055,
		76055
	],
	"./00035-como-funciona-um-circuito-schmitt-trigger.md": [
		78755,
		78755
	],
	"./00036-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		80932,
		80932
	],
	"./00037-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		48355,
		48355
	],
	"./00038-como-o-teorema-da-superposicao-e-aplicado-na-analise-de-circuitos-eletricos.md": [
		91275,
		91275
	],
	"./00039-como-a-tensao-em-um-indutor-varia-em-um-circuito-de-primeira-ordem.md": [
		39093,
		39093
	],
	"./00040-como-funciona-a-resposta-de-um-circuito-rlc-super-amortecido.md": [
		2731,
		2731
	],
	"./00041-como-funciona-o-principio-da-superposicao-em-circuitos-de-corrente-alternada.md": [
		81267,
		81267
	],
	"./00042-o-que-e-o-fator-de-potencia-em-circuitos-trifasicos-e-por-que-ele-e-importante.md": [
		23763,
		23763
	],
	"./00043-como-a-transformada-de-fourier-e-aplicada-na-analise-de-circuitos-rlc.md": [
		84736,
		84736
	],
	"./00044-o-que-e-a-regiao-de-saturacao-em-um-transistor-igbt.md": [
		98655,
		98655
	],
	"./00045-como-funciona-um-circuito-astavel-em-um-sistema-analogico.md": [
		36080,
		36080
	],
	"./00046-qual-a-diferenca-entre-circuitos-combinacionais-e-sequenciais.md": [
		58982,
		58982
	],
	"./00047-o-que-e-um-amplificador-operacional-e-como-ele-funciona-em-um-circuito-analogico.md": [
		85529,
		85529
	],
	"./00048-o-que-e-um-no-em-um-circuito-eletrico-e-qual-sua-importancia.md": [
		37504,
		37504
	],
	"./00049-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		2220,
		2220
	],
	"./00050-o-que-e-uma-supermalha-em-circuitos-eletricos.md": [
		96478,
		96478
	],
	"./00051-como-a-energia-armazenada-em-um-indutor-afeta-o-comportamento-de-um-circuito-de-primeira-ordem.md": [
		58173,
		58173
	],
	"./00052-o-que-e-um-circuito-de-segunda-ordem-e-como-ele-se-comporta.md": [
		43404,
		43404
	],
	"./00053-o-que-e-o-fator-de-potencia-em-circuitos-de-corrente-alternada.md": [
		34346,
		34346
	],
	"./00054-qual-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		55604,
		55604
	],
	"./00055-o-que-e-um-filtro-passa-faixas-e-como-ele-e-utilizado-na-analise-de-circuitos.md": [
		474,
		474
	],
	"./00056-como-os-semicondutores-sao-utilizados-em-circuitos-eletricos.md": [
		71157,
		71157
	],
	"./00057-o-que-e-um-oscilador-de-wien-e-como-ele-funciona.md": [
		25392,
		25392
	],
	"./00058-qual-e-a-diferenca-entre-circuitos-combinacionais-e-sequenciais.md": [
		55923,
		55923
	],
	"./00059-o-que-significa-nivel-logico-alto-em-circuitos-ttl.md": [
		42886,
		42886
	],
	"./00060-o-que-e-um-curto-circuito-e-como-ele-ocorre-em-um-circuito-eletrico.md": [
		61206,
		61206
	],
	"./00061-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		59218,
		59218
	],
	"./00062-o-que-e-a-teoria-da-maxima-transferencia-de-potencia-em-circuitos-eletricos.md": [
		96711,
		96711
	],
	"./00063-como-a-energia-e-armazenada-em-circuitos-de-primeira-ordem.md": [
		47250,
		47250
	],
	"./00064-o-que-e-um-circuito-sub-amortecido-e-como-ele-se-comporta.md": [
		10428,
		10428
	],
	"./00065-como-a-impedancia-afeta-o-comportamento-de-circuitos-rlc-em-corrente-alternada.md": [
		62300,
		62300
	],
	"./00066-o-que-e-um-circuito-trifasico-equilibrado.md": [
		70623,
		70623
	],
	"./00067-como-a-propriedade-de-parseval-e-aplicada-na-analise-de-circuitos-rlc.md": [
		27387,
		27387
	],
	"./00068-qual-a-diferenca-entre-um-transistor-bjt-e-um-mesfet.md": [
		7211,
		7211
	],
	"./00069-qual-e-a-diferenca-entre-sinais-analogicos-e-digitais-em-circuitos-eletricos.md": [
		18994,
		18994
	],
	"./00070-o-que-e-um-flip-flop-e-qual-sua-importancia-em-circuitos-digitais.md": [
		74696,
		74696
	],
	"./00071-como-funcionam-as-portas-logicas-ttl-em-circuitos-eletricos.md": [
		42971,
		42971
	],
	"./00072-o-que-e-um-circuito-eletrico-em-serie-e-como-ele-funciona.md": [
		42133,
		42133
	],
	"./00073-qual-a-funcao-de-um-capacitor-em-um-circuito-eletrico.md": [
		35574,
		35574
	],
	"./00074-como-determinar-a-potencia-transferida-em-um-circuito-eletrico.md": [
		50921,
		50921
	],
	"./00075-como-a-corrente-se-comporta-em-um-circuito-rc-de-primeira-ordem.md": [
		26052,
		26052
	],
	"./00076-o-que-e-uma-resposta-super-amortecida-em-circuitos-de-segunda-ordem.md": [
		71958,
		49577
	],
	"./00077-como-calcular-a-potencia-maxima-em-um-circuito-em-corrente-alternada.md": [
		15867,
		15867
	],
	"./00078-qual-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		5630,
		5630
	],
	"./00079-como-a-transformada-de-fourier-e-aplicada-na-analise-de-circuitos-rlc.md": [
		74653,
		74653
	],
	"./00080-como-os-semicondutores-influenciam-o-comportamento-dos-circuitos-eletricos.md": [
		70220,
		70220
	],
	"./00081-como-funcionam-os-filtros-passivos-em-circuitos-analogicos.md": [
		55861,
		55861
	],
	"./00082-como-os-transistores-sao-usados-na-implementacao-de-portas-logicas-em-circuitos-digitais.md": [
		39927,
		39927
	],
	"./00083-como-funciona-um-circuito-rc-e-qual-sua-aplicacao-pratica.md": [
		91747,
		91747
	],
	"./00084-o-que-e-tensao-eletrica-e-como-ela-se-relaciona-com-a-lei-de-ohm.md": [
		78447,
		78447
	],
	"./00085-como-funcionam-os-capacitores-em-circuitos-eletricos.md": [
		6765,
		6765
	],
	"./00086-o-que-e-o-principio-da-linearidade-em-circuitos-eletricos.md": [
		40713,
		40713
	],
	"./00087-o-que-acontece-com-a-corrente-em-um-circuito-rl-durante-a-descarga-do-indutor.md": [
		90310,
		90310
	],
	"./00088-qual-a-diferenca-entre-um-circuito-sub-amortecido-e-um-circuito-super-amortecido.md": [
		732,
		732
	],
	"./00089-o-que-e-admitancia-em-circuitos-de-corrente-alternada.md": [
		61056,
		61056
	],
	"./00090-qual-e-a-diferenca-entre-as-conexoes-triangulo-e-estrela-em-circuitos-trifasicos.md": [
		16178,
		16178
	],
	"./00091-o-que-e-a-transformada-de-laplace-e-como-ela-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		86157,
		86157
	],
	"./00092-como-um-transistor-bjt-funciona-em-um-circuito-simples.md": [
		23035,
		23035
	],
	"./00093-o-que-e-um-multivibrador-astavel-e-como-ele-funciona-em-circuitos-analogicos.md": [
		68775,
		68775
	],
	"./00094-como-funciona-a-simplificacao-de-circuitos-digitais-usando-o-mapa-de-karnaugh.md": [
		80837,
		80837
	],
	"./00095-como-funciona-um-circuito-rc-basico-em-um-sistema-digital.md": [
		30487,
		30487
	],
	"./00096-o-que-e-tensao-eletrica-e-como-ela-e-medida.md": [
		9671,
		9671
	],
	"./00097-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		26429,
		26429
	],
	"./00098-como-funciona-a-analise-nodal-em-circuitos-eletricos.md": [
		3125,
		3125
	],
	"./00099-como-o-tempo-afeta-a-resposta-de-um-circuito-rl-de-primeira-ordem.md": [
		12340,
		12340
	],
	"./00100-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-se-comportam.md": [
		96392,
		96392
	],
	"./00101-o-que-e-a-admitancia-em-circuitos-de-corrente-alternada.md": [
		9173,
		9173
	],
	"./00102-o-que-e-o-fator-de-potencia-em-circuitos-trifasicos.md": [
		99335,
		99335
	],
	"./00103-como-o-teorema-da-superposicao-e-aplicado-na-analise-de-circuitos-com-fontes-de-rampa.md": [
		21871,
		21871
	],
	"./00104-como-os-diodos-sao-utilizados-em-circuitos-retificadores.md": [
		59237,
		59237
	],
	"./00105-o-que-e-um-filtro-passivo-e-como-ele-funciona-em-circuitos-analogicos.md": [
		70346,
		70346
	],
	"./00106-como-os-flip-flops-sao-utilizados-em-circuitos-digitais.md": [
		31129,
		31129
	],
	"./00107-como-utilizar-um-osciloscopio-para-medir-sinais-ttl-em-circuitos-eletricos.md": [
		44602,
		44602
	],
	"./00108-o-que-e-a-lei-de-ohm-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		62603,
		62603
	],
	"./00109-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		48893,
		48893
	],
	"./00110-como-funciona-o-principio-da-superposicao-em-circuitos-eletricos.md": [
		13175,
		13175
	],
	"./00111-o-que-sao-circuitos-de-primeira-ordem-e-como-eles-se-comportam-ao-longo-do-tempo.md": [
		20869,
		20869
	],
	"./00112-o-que-e-uma-resposta-amortecida-em-circuitos-de-segunda-ordem.md": [
		27977,
		27977
	],
	"./00113-o-que-e-a-impedancia-equivalente-em-circuitos-de-corrente-alternada.md": [
		53610,
		53610
	],
	"./00114-qual-e-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		98907,
		21288
	],
	"./00115-o-que-e-uma-funcao-degrau-e-como-ela-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		5948,
		5948
	],
	"./00116-o-que-e-uma-juncao-pn-e-como-ela-funciona-em-semicondutores.md": [
		88536,
		88536
	],
	"./00117-o-que-e-um-oscilador-de-wien-e-como-ele-funciona-em-circuitos-analogicos.md": [
		84727,
		84727
	],
	"./00118-como-simplificar-uma-funcao-logica-em-circuitos-digitais.md": [
		21774,
		21774
	],
	"./00119-como-funciona-a-analise-de-circuitos-combinacionais-em-um-laboratorio-de-engenharia.md": [
		14130,
		14130
	],
	"./00120-o-que-e-um-no-em-um-circuito-eletrico.md": [
		62387,
		62387
	],
	"./00121-qual-a-diferenca-entre-componentes-passivos-e-ativos-em-circuitos-eletricos.md": [
		39491,
		39491
	],
	"./00122-como-aplicar-o-teorema-de-norton-na-analise-basica-de-circuitos.md": [
		77420,
		77420
	],
	"./00123-como-a-corrente-e-a-tensao-se-comportam-em-um-circuito-rc-de-primeira-ordem.md": [
		34668,
		34668
	],
	"./00124-o-que-e-a-resposta-natural-de-um-circuito-de-segunda-ordem.md": [
		25773,
		25773
	],
	"./00125-o-que-e-a-resposta-em-regime-permanente-em-circuitos-de-corrente-alternada.md": [
		26782,
		26782
	],
	"./00126-o-que-e-o-fator-de-potencia-em-circuitos-trifasicos.md": [
		7245,
		7245
	],
	"./00127-como-a-transformada-de-fourier-e-utilizada-na-analise-de-circuitos-passa-faixas.md": [
		79349,
		79349
	],
	"./00128-como-funciona-um-transistor-bipolar-de-juncao-bjt-em-um-circuito-eletrico.md": [
		19092,
		19092
	],
	"./00129-como-funciona-um-oscilador-de-wien-em-circuitos-analogicos.md": [
		31633,
		31633
	],
	"./00130-como-funciona-a-simplificacao-de-circuitos-logicos-combinacionais.md": [
		25879,
		25879
	],
	"./00131-o-que-e-uma-porta-logica-combinacional-e-como-ela-funciona.md": [
		12460,
		12460
	],
	"./00132-o-que-e-a-lei-de-ohm-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		51416,
		51416
	],
	"./00133-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		24798,
		24798
	],
	"./00134-o-que-e-uma-supermalha-em-circuitos-eletricos.md": [
		76895,
		76895
	],
	"./00135-como-determinar-a-resposta-de-um-circuito-rl-de-primeira-ordem.md": [
		14091,
		14091
	],
	"./00136-o-que-e-uma-resposta-sub-amortecida-em-circuitos-de-segunda-ordem.md": [
		82810,
		82810
	],
	"./00137-como-aplicar-o-teorema-de-thevenin-em-circuitos-rlc-em-corrente-alternada.md": [
		34753,
		34753
	],
	"./00138-o-que-e-um-circuito-trifasico-e-como-ele-funciona.md": [
		50575,
		50575
	],
	"./00139-como-a-transformada-de-fourier-e-aplicada-na-analise-de-circuitos-rlc.md": [
		37594,
		37594
	],
	"./00140-o-que-e-uma-juncao-pn-e-como-ela-funciona-em-semicondutores.md": [
		86771,
		86771
	],
	"./00141-o-que-e-um-circuito-biestavel-e-como-ele-funciona.md": [
		10516,
		10516
	],
	"./00142-como-funcionam-os-flip-flops-em-circuitos-digitais.md": [
		67431,
		67431
	],
	"./00143-o-que-e-um-conversor-r2r-e-como-ele-funciona-em-circuitos-ttl.md": [
		70946,
		70946
	],
	"./00144-o-que-e-um-circuito-aberto-e-como-ele-afeta-a-corrente-eletrica.md": [
		89402,
		89402
	],
	"./00145-o-que-e-um-componente-passivo-em-circuitos-eletricos.md": [
		232,
		232
	],
	"./00146-como-a-transformacao-de-fontes-facilita-a-analise-de-circuitos.md": [
		59069,
		59069
	],
	"./00147-como-funcionam-os-circuitos-rl-e-rc-de-primeira-ordem-durante-a-carga-e-descarga.md": [
		6804,
		6804
	],
	"./00148-como-a-resposta-de-um-circuito-lc-de-segunda-ordem-se-comporta-apos-a-aplicacao-de-um-degrau-de-tensao.md": [
		92198,
		92198
	],
	"./00149-como-aplicar-o-teorema-de-thevenin-em-circuitos-de-corrente-alternada.md": [
		66089,
		66089
	],
	"./00150-o-que-e-uma-conexao-triangulo-estrela-em-circuitos-trifasicos-e-quando-ela-e-usada.md": [
		75239,
		75239
	],
	"./00151-o-que-e-a-transformada-de-fourier-e-como-ela-se-aplica-na-analise-de-circuitos-eletricos.md": [
		53328,
		53328
	],
	"./00152-o-que-e-a-regiao-de-saturacao-em-um-mosfet.md": [
		8983,
		8983
	],
	"./00153-o-que-e-uma-ponte-de-wheatstone-e-como-ela-e-utilizada-em-circuitos-analogicos.md": [
		77023,
		77023
	],
	"./00154-como-funciona-a-implementacao-de-circuitos-combinacionais-em-sistemas-digitais.md": [
		72423,
		72423
	],
	"./00155-o-que-e-uma-porta-schmitt-e-qual-sua-aplicacao-em-circuitos-combinacionais.md": [
		16960,
		16960
	],
	"./00156-o-que-e-a-lei-de-kirchhoff-das-correntes-lkc-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		83912,
		83912
	],
	"./00157-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		94736,
		94736
	],
	"./00158-o-que-e-o-teorema-de-transferencia-em-circuitos-eletricos.md": [
		33668,
		33668
	],
	"./00159-como-a-energia-e-armazenada-em-um-circuito-rl-de-primeira-ordem.md": [
		49371,
		49371
	],
	"./00160-qual-e-a-diferenca-entre-a-resposta-subamortecida-e-a-superamortecida-em-circuitos-de-segunda-ordem.md": [
		73908,
		73908
	],
	"./00161-o-que-e-admitancia-em-circuitos-de-corrente-alternada.md": [
		25845,
		25845
	],
	"./00162-o-que-e-uma-conexao-trifasica-e-como-ela-e-usada-em-circuitos-eletricos.md": [
		44167,
		44167
	],
	"./00163-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		25704,
		25704
	],
	"./00164-como-funcionam-os-diodos-em-circuitos-eletricos.md": [
		63685,
		63685
	],
	"./00165-como-funciona-um-multivibrador-astavel-utilizando-bjts.md": [
		43342,
		43342
	],
	"./00166-qual-a-diferenca-entre-um-flip-flop-e-um-latch-em-circuitos-digitais.md": [
		7087,
		7087
	],
	"./00167-como-configurar-corretamente-um-multimetro-para-medir-tensao-em-um-circuito-basico.md": [
		76339,
		76339
	],
	"./00168-o-que-e-um-circuito-eletrico-simples.md": [
		86081,
		86081
	],
	"./00169-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		78095,
		78095
	],
	"./00170-o-que-e-uma-supermalha-em-circuitos-eletricos.md": [
		82647,
		5028
	],
	"./00171-como-a-constante-de-tempo-afeta-a-resposta-de-um-circuito-rc.md": [
		25674,
		25674
	],
	"./00172-o-que-e-um-circuito-super-amortecido-e-como-ele-se-comporta.md": [
		41769,
		41769
	],
	"./00173-como-funciona-a-analise-nodal-em-circuitos-rlc-em-serie.md": [
		3056,
		3056
	],
	"./00174-o-que-e-um-circuito-trifasico-equilibrado-e-como-ele-se-diferencia-de-um-circuito-monofasico.md": [
		17070,
		17070
	],
	"./00175-como-o-teorema-de-parseval-e-aplicado-na-analise-de-circuitos-eletricos.md": [
		65952,
		65952
	],
	"./00176-qual-a-diferenca-entre-mosfet-e-mesfet.md": [
		13631,
		13631
	],
	"./00177-o-que-e-um-diagrama-de-bode-e-como-ele-e-utilizado-na-analise-de-circuitos-analogicos.md": [
		7649,
		7649
	],
	"./00178-como-funcionam-os-latches-em-circuitos-digitais.md": [
		99028,
		99028
	],
	"./00179-o-que-e-um-conversor-r2r-e-como-ele-funciona-em-circuitos-eletricos.md": [
		71235,
		71235
	],
	"./00180-o-que-e-um-no-em-um-circuito-eletrico.md": [
		81289,
		81289
	],
	"./00181-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		52045,
		52045
	],
	"./00182-como-o-teorema-de-thevenin-facilita-a-analise-de-circuitos-eletricos.md": [
		82955,
		82955
	],
	"./00183-o-que-acontece-com-a-corrente-em-um-circuito-rc-de-primeira-ordem-durante-a-descarga-do-capacitor.md": [
		97809,
		97809
	],
	"./00184-como-a-continuidade-afeta-a-resposta-de-circuitos-rlc-de-segunda-ordem.md": [
		32278,
		32278
	],
	"./00185-o-que-e-impedancia-em-circuitos-de-corrente-alternada.md": [
		11773,
		11773
	],
	"./00186-qual-e-a-aplicacao-pratica-dos-circuitos-trifasicos-em-sistemas-eletricos.md": [
		99267,
		99267
	],
	"./00187-o-que-e-a-transformada-de-fourier-e-como-ela-se-aplica-na-analise-de-circuitos-rlc.md": [
		92330,
		92330
	],
	"./00188-como-o-mosfet-se-comporta-em-um-circuito-com-resistor-e-fonte-de-thevenin.md": [
		67524,
		67524
	],
	"./00189-o-que-e-um-diagrama-de-bode-e-como-ele-e-utilizado-em-circuitos-analogicos.md": [
		94097,
		94097
	],
	"./00190-como-simplificar-expressoes-logicas-usando-o-mapa-de-karnaugh.md": [
		6005,
		6005
	],
	"./00191-o-que-e-um-trigger-em-circuitos-eletricos-e-como-ele-funciona.md": [
		62101,
		62101
	],
	"./00192-qual-a-diferenca-entre-circuitos-em-serie-e-em-paralelo.md": [
		39005,
		39005
	],
	"./00193-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		26436,
		26436
	],
	"./00194-como-funciona-o-principio-da-superposicao-em-circuitos-eletricos.md": [
		92963,
		92963
	],
	"./00195-como-a-energia-armazenada-em-um-indutor-varia-ao-longo-do-tempo.md": [
		33164,
		33164
	],
	"./00196-o-que-e-a-continuidade-da-tensao-em-circuitos-de-segunda-ordem.md": [
		26812,
		26812
	],
	"./00197-como-a-analise-de-thevenin-e-aplicada-em-circuitos-de-corrente-alternada.md": [
		12747,
		12747
	],
	"./00198-o-que-e-um-sistema-trifasico-equilibrado-e-como-ele-e-usado-em-circuitos-eletricos.md": [
		59294,
		59294
	],
	"./00199-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		39033,
		39033
	],
	"./00200-como-os-diodos-semicondutores-funcionam-em-um-circuito-simples.md": [
		48410,
		48410
	],
	"./00201-como-funciona-um-circuito-trigger-com-amplificador-operacional.md": [
		69011,
		69011
	],
	"./00202-como-os-circuitos-cmos-sao-utilizados-na-implementacao-de-circuitos-combinacionais.md": [
		2674,
		2674
	],
	"./00203-como-os-bjts-sao-utilizados-em-circuitos-digitais-ttl.md": [
		6101,
		6101
	],
	"./00204-o-que-e-a-lei-de-ohm-e-como-ela-se-aplica-em-circuitos-eletricos-basicos.md": [
		13497,
		13497
	],
	"./00205-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		84502,
		84502
	],
	"./00206-o-que-e-o-teorema-de-thevenin-e-como-ele-facilita-a-analise-de-circuitos.md": [
		38488,
		38488
	],
	"./00207-como-ocorre-a-descarga-de-um-indutor-em-um-circuito-de-primeira-ordem.md": [
		55642,
		55642
	],
	"./00208-o-que-e-uma-resposta-criticamente-amortecida-em-circuitos-de-segunda-ordem.md": [
		87806,
		87806
	],
	"./00209-como-a-superposicao-e-aplicada-em-circuitos-de-corrente-alternada.md": [
		62727,
		62727
	],
	"./00210-o-que-e-um-circuito-trifasico-equilibrado-e-qual-sua-importancia.md": [
		17334,
		17334
	],
	"./00211-o-que-e-uma-singularidade-em-circuitos-eletricos-e-como-ela-afeta-a-analise-de-circuitos-rlc.md": [
		66581,
		66581
	],
	"./00212-como-funciona-um-mosfet-em-um-circuito-simples.md": [
		32179,
		32179
	],
	"./00213-o-que-e-um-amplificador-operacional-e-como-ele-funciona-em-circuitos-analogicos.md": [
		96583,
		96583
	],
	"./00214-como-funcionam-as-portas-logicas-em-circuitos-digitais.md": [
		44559,
		44559
	],
	"./00215-como-os-componentes-analogicos-se-comportam-em-circuitos-em-serie.md": [
		96018,
		96018
	],
	"./00216-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		49596,
		49596
	],
	"./00217-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		78327,
		78327
	],
	"./00218-como-aplicar-o-teorema-de-norton-na-analise-basica-de-circuitos.md": [
		30812,
		30812
	],
	"./00219-o-que-e-uma-constante-de-tempo-em-circuitos-de-primeira-ordem.md": [
		1503,
		1503
	],
	"./00220-o-que-e-uma-resposta-sub-amortecida-em-circuitos-de-segunda-ordem.md": [
		87780,
		87780
	],
	"./00221-o-que-e-admitancia-em-circuitos-de-corrente-alternada.md": [
		78008,
		78008
	],
	"./00222-o-que-e-um-circuito-trifasico-e-como-ele-e-utilizado.md": [
		26181,
		26181
	],
	"./00223-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		59109,
		59109
	],
	"./00224-como-funciona-um-diodo-em-um-circuito-eletrico.md": [
		20609,
		20609
	],
	"./00225-o-que-e-um-amplificador-schmitt-trigger-e-como-ele-funciona.md": [
		11806,
		11806
	],
	"./00226-o-que-e-um-flip-flop-e-qual-sua-importancia-em-circuitos-digitais.md": [
		45981,
		45981
	],
	"./00227-como-funciona-um-circuito-combinacional-utilizando-bjt.md": [
		49391,
		49391
	],
	"./00228-o-que-sao-submultiplos-e-multiplos-de-unidades-eletricas.md": [
		96735,
		96735
	],
	"./00229-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		42688,
		42688
	],
	"./00230-como-aplicar-o-teorema-de-thevenin-em-um-circuito-com-multiplos-resistores.md": [
		73442,
		73442
	],
	"./00231-como-a-energia-e-armazenada-em-capacitores-e-indutores-em-circuitos-de-primeira-ordem.md": [
		91897,
		91897
	],
	"./00232-o-que-e-um-circuito-de-segunda-ordem-e-como-ele-se-comporta.md": [
		37816,
		37816
	],
	"./00233-o-que-e-a-impedancia-em-circuitos-de-corrente-alternada.md": [
		82139,
		82139
	],
	"./00234-o-que-e-um-circuito-trifasico-equilibrado-em-conexao-triangulo-triangulo.md": [
		8013,
		8013
	],
	"./00235-como-o-teorema-de-parseval-e-aplicado-na-analise-de-circuitos-eletricos.md": [
		19749,
		19749
	],
	"./00236-como-funciona-um-transistor-bipolar-de-juncao-bjt.md": [
		80469,
		80469
	],
	"./00237-o-que-e-um-diagrama-de-bode-e-como-ele-e-utilizado-em-circuitos-analogicos.md": [
		69125,
		69125
	],
	"./00238-como-funciona-a-implementacao-de-portas-logicas-em-circuitos-digitais.md": [
		69423,
		69423
	],
	"./00239-como-configurar-um-amplificador-em-serie-em-um-circuito-analogico.md": [
		87280,
		87280
	],
	"./00240-o-que-e-um-no-em-um-circuito-eletrico-e-qual-sua-importancia.md": [
		17774,
		17774
	],
	"./00241-o-que-e-um-capacitor-e-como-ele-funciona-em-um-circuito-eletrico.md": [
		5646,
		5646
	],
	"./00242-como-funciona-o-principio-da-superposicao-em-circuitos-eletricos.md": [
		50533,
		50533
	],
	"./00243-o-que-e-um-circuito-de-primeira-ordem-e-como-ele-se-comporta-apos-a-comutacao.md": [
		71921,
		71921
	],
	"./00244-qual-e-a-diferenca-entre-um-circuito-sub-amortecido-e-um-super-amortecido.md": [
		19649,
		19649
	],
	"./00245-como-a-superposicao-e-aplicada-em-circuitos-de-corrente-alternada.md": [
		45399,
		45399
	],
	"./00246-o-que-e-um-sistema-trifasico-equilibrado.md": [
		8093,
		8093
	],
	"./00247-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		5028,
		82647
	],
	"./00248-como-funciona-um-transistor-mosfet-em-circuitos-eletricos.md": [
		31371,
		31371
	],
	"./00249-como-funciona-um-oscilador-de-wien-em-circuitos-analogicos.md": [
		94848,
		94848
	],
	"./00250-como-os-circuitos-combinacionais-implementam-operacoes-booleanas.md": [
		19726,
		19726
	],
	"./00251-como-configurar-um-amplificador-para-medir-tensao-em-um-circuito.md": [
		54662,
		54662
	],
	"./00252-o-que-e-um-curto-circuito-e-como-ele-afeta-um-circuito-eletrico.md": [
		28595,
		28595
	],
	"./00253-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		41931,
		41931
	],
	"./00254-o-que-e-a-transformacao-de-fontes-em-circuitos-eletricos.md": [
		99254,
		99254
	],
	"./00255-como-a-energia-armazenada-em-um-circuito-de-primeira-ordem-se-comporta-ao-longo-do-tempo.md": [
		71477,
		71477
	],
	"./00256-o-que-e-um-circuito-de-segunda-ordem-super-amortecido.md": [
		60647,
		60647
	],
	"./00257-o-que-e-a-transferencia-de-potencia-maxima-em-circuitos-de-corrente-alternada.md": [
		66735,
		66735
	],
	"./00258-qual-e-a-diferenca-entre-a-conexao-estrela-e-a-conexao-triangulo-em-circuitos-trifasicos.md": [
		42804,
		42804
	],
	"./00259-o-que-e-a-transformada-de-laplace-e-como-ela-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		48103,
		48103
	],
	"./00260-como-funciona-a-regiao-de-saturacao-em-um-transistor.md": [
		42015,
		42015
	],
	"./00261-o-que-e-um-multivibrador-biestavel-e-como-ele-funciona-em-circuitos-analogicos.md": [
		52333,
		52333
	],
	"./00262-como-funciona-a-conversao-de-numeros-binarios-para-decimais-e-vice-versa-em-circuitos-digitais.md": [
		60957,
		60957
	],
	"./00263-como-funciona-o-trigger-em-circuitos-digitais.md": [
		6275,
		6275
	],
	"./00264-o-que-e-a-lei-de-ohm-e-como-ela-se-aplica-em-circuitos-simples.md": [
		43777,
		43777
	],
	"./00265-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		39744,
		39744
	],
	"./00266-o-que-e-uma-supermalha-e-como-ela-e-utilizada-na-analise-de-circuitos.md": [
		73791,
		73791
	],
	"./00267-o-que-sao-circuitos-de-primeira-ordem-e-como-eles-funcionam.md": [
		23925,
		23925
	],
	"./00268-o-que-e-um-circuito-de-segunda-ordem-criticamente-amortecido.md": [
		2201,
		2201
	],
	"./00269-como-determinar-a-impedancia-de-thevenin-em-circuitos-de-corrente-alternada.md": [
		21107,
		21107
	],
	"./00270-o-que-e-uma-conexao-estrela-triangulo-em-circuitos-trifasicos.md": [
		23485,
		23485
	],
	"./00271-como-a-analise-de-circuitos-em-serie-e-afetada-por-sinais-de-entrada-em-rampa-e-degrau.md": [
		52346,
		52346
	],
	"./00272-o-que-e-uma-juncao-pn-e-como-ela-funciona-em-um-circuito-eletrico.md": [
		72458,
		72458
	],
	"./00273-como-funcionam-os-amplificadores-operacionais-em-circuitos-analogicos.md": [
		85513,
		85513
	],
	"./00274-como-funcionam-as-portas-logicas-em-circuitos-digitais.md": [
		2485,
		2485
	],
	"./00275-como-funciona-o-circuito-r2r-em-um-conversor-digital-analogico.md": [
		31956,
		31956
	],
	"./00276-o-que-e-um-curto-circuito-e-como-ele-afeta-um-sistema-eletrico.md": [
		95677,
		95677
	],
	"./00277-como-funcionam-os-transformadores-em-circuitos-eletricos.md": [
		5888,
		5888
	],
	"./00278-como-verificar-a-validade-de-uma-fonte-de-tensao-em-um-circuito.md": [
		29766,
		29766
	],
	"./00279-como-obter-a-resposta-de-um-circuito-rl-de-primeira-ordem-com-fonte-variavel.md": [
		6543,
		6543
	],
	"./00280-como-determinar-o-valor-final-de-um-circuito-de-segunda-ordem.md": [
		74785,
		74785
	],
	"./00281-como-aplicar-a-analise-nodal-em-circuitos-de-corrente-alternada.md": [
		94731,
		94731
	],
	"./00282-o-que-e-a-conexao-estrela-triangulo-em-circuitos-trifasicos.md": [
		28278,
		28278
	],
	"./00283-o-que-e-a-transformada-de-laplace-e-como-ela-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		8500,
		8500
	],
	"./00284-como-funciona-um-transistor-em-modo-saturado.md": [
		98807,
		98807
	],
	"./00285-como-funciona-um-oscilador-de-wien-em-circuitos-analogicos.md": [
		85192,
		85192
	],
	"./00286-como-funciona-a-conversao-de-sinais-analogicos-para-digitais-em-circuitos-digitais.md": [
		499,
		499
	],
	"./00287-o-que-e-um-circuito-r2r-e-como-ele-funciona.md": [
		11804,
		11804
	],
	"./00288-o-que-e-um-circuito-eletrico-e-quais-sao-seus-elementos-basicos.md": [
		80023,
		80023
	],
	"./00289-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		3722,
		3722
	],
	"./00290-o-que-e-a-analise-de-malha-em-circuitos-eletricos.md": [
		91715,
		91715
	],
	"./00291-o-que-acontece-com-a-corrente-em-um-indutor-apos-a-comutacao-de-uma-fonte-em-um-circuito-de-primeira-ordem.md": [
		47001,
		47001
	],
	"./00292-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-se-comportam.md": [
		23186,
		23186
	],
	"./00293-o-que-e-o-fator-de-potencia-em-circuitos-de-corrente-alternada.md": [
		380,
		380
	],
	"./00294-qual-a-diferenca-entre-a-conexao-estrela-e-a-conexao-triangulo-em-circuitos-trifasicos.md": [
		38502,
		38502
	],
	"./00295-o-que-e-um-filtro-passa-faixas-e-como-ele-e-aplicado-em-circuitos-rlc-em-serie.md": [
		27987,
		27987
	],
	"./00296-o-que-e-um-igbt-e-como-ele-funciona-em-circuitos-eletricos.md": [
		33319,
		33319
	],
	"./00297-como-funciona-um-multivibrador-biestavel-em-circuitos-analogicos.md": [
		43215,
		43215
	],
	"./00298-como-simplificar-expressoes-logicas-em-circuitos-digitais.md": [
		55755,
		55755
	],
	"./00299-o-que-e-um-trigger-ttl-e-como-ele-e-utilizado-em-projetos-de-circuitos-logicos.md": [
		55942,
		55942
	],
	"./00300-como-a-tensao-se-comporta-em-resistores-em-paralelo.md": [
		26159,
		26159
	],
	"./00301-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		56591,
		56591
	],
	"./00302-como-o-teorema-de-thevenin-e-o-teorema-de-norton-sao-utilizados-na-analise-de-circuitos.md": [
		43930,
		43930
	],
	"./00303-como-ocorre-a-carga-e-descarga-de-um-capacitor-em-um-circuito-de-primeira-ordem.md": [
		36923,
		36923
	],
	"./00304-o-que-e-uma-resposta-amortecida-em-um-circuito-lc-de-segunda-ordem.md": [
		28548,
		28548
	],
	"./00305-o-que-e-a-impedancia-em-circuitos-rlc-em-corrente-alternada.md": [
		25976,
		25976
	],
	"./00306-qual-a-diferenca-entre-circuitos-monofasicos-e-trifasicos.md": [
		82366,
		82366
	],
	"./00307-como-a-aplicacao-de-um-degrau-de-tensao-afeta-um-circuito-passa-faixas-em-serie.md": [
		29064,
		29064
	],
	"./00308-como-os-mosfets-funcionam-em-circuitos-eletricos.md": [
		61498,
		61498
	],
	"./00309-o-que-e-um-multivibrador-biestavel-e-como-ele-funciona-em-circuitos-analogicos.md": [
		53222,
		53222
	],
	"./00310-como-converter-numeros-decimais-para-binarios-em-circuitos-digitais.md": [
		27533,
		27533
	],
	"./00311-o-que-e-o-regime-permanente-em-circuitos-eletricos.md": [
		71203,
		71203
	],
	"./00312-o-que-e-um-elemento-passivo-em-um-circuito-eletrico.md": [
		84628,
		84628
	],
	"./00313-o-que-sao-componentes-eletronicos-passivos-e-ativos.md": [
		11463,
		11463
	],
	"./00314-como-determinar-a-potencia-maxima-transferida-para-uma-carga-em-um-circuito.md": [
		37184,
		37184
	],
	"./00315-como-a-energia-armazenada-em-um-circuito-rl-e-obtida-e-simulada.md": [
		30336,
		7955
	],
	"./00316-o-que-e-uma-resposta-sub-amortecida-em-circuitos-de-segunda-ordem.md": [
		7534,
		7534
	],
	"./00317-o-que-e-impedancia-em-circuitos-de-corrente-alternada.md": [
		6952,
		6952
	],
	"./00318-qual-e-a-diferenca-entre-sistemas-trifasicos-equilibrados-e-monofasicos.md": [
		57758,
		57758
	],
	"./00319-o-que-e-um-filtro-passa-faixas-e-como-ele-funciona-em-circuitos-eletricos.md": [
		40421,
		40421
	],
	"./00320-como-funcionam-os-transistores-mosfet-e-hbt-em-circuitos-eletricos.md": [
		45836,
		45836
	],
	"./00321-como-funcionam-os-filtros-em-circuitos-analogicos.md": [
		45159,
		45159
	],
	"./00322-como-converter-uma-expressao-booleana-em-um-mapa-de-karnaugh-e-vice-versa.md": [
		76612,
		76612
	],
	"./00323-o-que-e-o-regime-permanente-senoidal-em-circuitos-eletricos.md": [
		17450,
		17450
	],
	"./00324-o-que-e-um-no-em-um-circuito-eletrico.md": [
		18937,
		18937
	],
	"./00325-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		66717,
		66717
	],
	"./00326-como-a-linearidade-afeta-a-analise-de-circuitos-eletricos.md": [
		21524,
		21524
	],
	"./00327-o-que-e-um-circuito-de-primeira-ordem-e-como-ele-funciona.md": [
		36374,
		36374
	],
	"./00328-o-que-e-um-circuito-criticamente-amortecido-e-como-ele-se-comporta.md": [
		22259,
		22259
	],
	"./00329-como-funciona-um-circuito-rlc-serie-em-regime-senoidal.md": [
		88931,
		88931
	],
	"./00330-o-que-e-uma-conexao-estrela-triangulo-em-circuitos-trifasicos.md": [
		72926,
		72926
	],
	"./00331-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-rlc.md": [
		16990,
		16990
	],
	"./00332-como-determinar-se-um-transistor-bjt-esta-em-saturacao.md": [
		48627,
		48627
	],
	"./00333-o-que-e-um-filtro-de-wien-e-como-ele-funciona-em-circuitos-analogicos.md": [
		97223,
		97223
	],
	"./00334-o-que-e-um-flip-flop-e-qual-sua-importancia-em-circuitos-digitais.md": [
		56421,
		56421
	],
	"./00335-qual-a-diferenca-entre-circuitos-analogicos-e-digitais.md": [
		51190,
		51190
	],
	"./00336-o-que-e-um-ramo-em-um-circuito-eletrico.md": [
		49912,
		49912
	],
	"./00337-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		24168,
		24168
	],
	"./00338-o-que-e-o-teorema-de-thevenin-e-como-ele-facilita-a-analise-de-circuitos.md": [
		17778,
		17778
	],
	"./00339-como-resolver-circuitos-de-primeira-ordem-com-fontes-de-corrente.md": [
		39972,
		39972
	],
	"./00340-o-que-e-um-circuito-super-amortecido-e-como-ele-se-comporta.md": [
		23862,
		23862
	],
	"./00341-como-a-associacao-de-componentes-rlc-afeta-a-amplitude-maxima-em-circuitos-de-corrente-alternada.md": [
		30569,
		30569
	],
	"./00342-como-a-potencia-e-calculada-em-circuitos-trifasicos.md": [
		4918,
		4918
	],
	"./00343-como-a-funcao-impulso-e-aplicada-na-analise-avancada-de-circuitos.md": [
		13378,
		13378
	],
	"./00344-como-os-semicondutores-influenciam-o-funcionamento-dos-circuitos-eletricos.md": [
		10701,
		10701
	],
	"./00345-como-funciona-a-implementacao-pratica-de-um-amplificador-analogico-em-ac.md": [
		24603,
		24603
	],
	"./00346-como-converter-um-numero-binario-para-decimal-e-vice-versa.md": [
		76757,
		76757
	],
	"./00347-como-funcionam-as-portas-logicas-ttl-em-circuitos-analogicos.md": [
		26985,
		26985
	],
	"./00348-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		34008,
		34008
	],
	"./00349-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		28015,
		28015
	],
	"./00350-como-funciona-o-teorema-da-superposicao-em-circuitos-eletricos.md": [
		93629,
		93629
	],
	"./00351-como-a-energia-e-obtida-em-circuitos-de-primeira-ordem.md": [
		87091,
		87091
	],
	"./00352-qual-e-a-diferenca-entre-um-circuito-rlc-subamortecido-e-um-criticamente-amortecido.md": [
		12225,
		12225
	],
	"./00353-como-calcular-a-impedancia-equivalente-em-circuitos-de-corrente-alternada.md": [
		79513,
		79513
	],
	"./00354-qual-e-a-diferenca-entre-potencia-ativa-reativa-e-aparente-em-circuitos-trifasicos.md": [
		7224,
		7224
	],
	"./00355-como-a-transformada-de-laplace-e-aplicada-na-analise-avancada-de-circuitos.md": [
		17304,
		17304
	],
	"./00356-como-funciona-a-juncao-pn-em-semicondutores.md": [
		77495,
		77495
	],
	"./00357-o-que-e-um-amplificador-biestavel-e-como-ele-funciona-em-circuitos-analogicos.md": [
		25802,
		25802
	],
	"./00358-como-os-flip-flops-funcionam-em-circuitos-digitais.md": [
		3844,
		3844
	],
	"./00359-o-que-e-um-trigger-em-circuitos-digitais.md": [
		70433,
		70433
	],
	"./00360-o-que-e-a-lei-de-kirchhoff-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		75353,
		75353
	],
	"./00361-qual-a-funcao-de-um-capacitor-em-um-circuito-eletrico.md": [
		32676,
		32676
	],
	"./00362-o-que-e-uma-supermalha-em-circuitos-eletricos.md": [
		4250,
		4250
	],
	"./00363-o-que-e-um-circuito-de-primeira-ordem-e-como-ele-se-comporta-ao-longo-do-tempo.md": [
		48024,
		48024
	],
	"./00364-o-que-e-um-circuito-de-segunda-ordem-e-como-ele-se-comporta.md": [
		97684,
		97684
	],
	"./00365-como-funciona-a-transferencia-de-potencia-em-circuitos-de-corrente-alternada.md": [
		60652,
		60652
	],
	"./00366-o-que-e-um-circuito-trifasico-equilibrado-em-configuracao-triangulo-triangulo.md": [
		13007,
		13007
	],
	"./00367-como-a-transformada-de-fourier-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		12886,
		12886
	],
	"./00368-qual-a-diferenca-entre-um-mosfet-e-um-bjt-em-circuitos-eletricos.md": [
		18316,
		18316
	],
	"./00369-o-que-e-um-amplificador-operacional-e-como-ele-funciona.md": [
		51659,
		51659
	],
	"./00370-como-converter-um-numero-decimal-para-binario-e-vice-versa-em-circuitos-digitais.md": [
		61452,
		61452
	],
	"./00371-como-configurar-um-dac-em-um-circuito-digital.md": [
		65347,
		65347
	],
	"./00372-o-que-e-a-lei-de-kirchhoff-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		53416,
		53416
	],
	"./00373-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		81360,
		81360
	],
	"./00374-o-que-e-uma-supermalha-e-como-ela-e-utilizada-na-analise-de-circuitos.md": [
		15559,
		15559
	],
	"./00375-o-que-acontece-com-a-tensao-em-um-capacitor-apos-a-comutacao-em-um-circuito-de-primeira-ordem.md": [
		86072,
		86072
	],
	"./00376-o-que-e-uma-resposta-criticamente-amortecida-em-circuitos-de-segunda-ordem.md": [
		1084,
		1084
	],
	"./00377-o-que-e-a-potencia-instantanea-em-circuitos-de-corrente-alternada.md": [
		9803,
		9803
	],
	"./00378-o-que-e-um-sistema-trifasico-equilibrado-e-qual-sua-importancia-em-circuitos-eletricos.md": [
		28255,
		28255
	],
	"./00379-o-que-e-a-propriedade-de-parseval-em-circuitos-rlc.md": [
		2927,
		2927
	],
	"./00380-o-que-e-um-transistor-de-heterojuncao-bipolar-hbt-e-como-ele-funciona.md": [
		78557,
		78557
	],
	"./00381-como-funciona-um-oscilador-astavel-em-circuitos-analogicos.md": [
		30782,
		30782
	],
	"./00382-como-converter-uma-expressao-booleana-em-um-circuito-digital.md": [
		68606,
		68606
	],
	"./00383-qual-a-diferenca-entre-sinais-analogicos-e-digitais-em-circuitos-eletricos.md": [
		37031,
		37031
	],
	"./00384-o-que-e-um-no-em-um-circuito-eletrico.md": [
		57851,
		57851
	],
	"./00385-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		21303,
		21303
	],
	"./00386-o-que-e-o-teorema-de-thevenin-e-como-ele-simplifica-a-analise-de-circuitos.md": [
		8003,
		8003
	],
	"./00387-como-funciona-a-resposta-natural-de-um-circuito-rl-de-primeira-ordem.md": [
		7372,
		7372
	],
	"./00388-o-que-e-um-circuito-de-segunda-ordem-e-quais-sao-os-casos-de-resposta-possiveis.md": [
		6472,
		6472
	],
	"./00389-o-que-e-a-potencia-maxima-transferida-em-circuitos-de-corrente-alternada.md": [
		89219,
		89219
	],
	"./00390-qual-a-diferenca-entre-um-circuito-trifasico-equilibrado-e-um-desequilibrado.md": [
		75327,
		75327
	],
	"./00391-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-rlc.md": [
		56080,
		56080
	],
	"./00392-qual-a-diferenca-entre-um-mesfet-e-um-hemt.md": [
		5679,
		5679
	],
	"./00393-o-que-e-um-schmitt-trigger-e-como-ele-funciona-em-circuitos-analogicos.md": [
		23398,
		23398
	],
	"./00394-como-funcionam-os-circuitos-logicos-combinacionais.md": [
		29152,
		29152
	],
	"./00395-como-medir-a-corrente-em-um-circuito-serie.md": [
		12927,
		12927
	],
	"./00396-o-que-e-um-curto-circuito-e-como-ele-afeta-um-sistema-eletrico.md": [
		40154,
		40154
	],
	"./00397-qual-a-diferenca-entre-componentes-passivos-e-ativos-em-circuitos-eletricos.md": [
		40424,
		40424
	],
	"./00398-como-a-transferencia-de-energia-e-afetada-pela-resistencia-em-um-circuito.md": [
		49015,
		49015
	],
	"./00399-como-a-comutacao-afeta-a-resposta-de-um-circuito-rc-de-primeira-ordem.md": [
		20555,
		20555
	],
	"./00400-o-que-e-uma-resposta-sub-amortecida-em-circuitos-de-segunda-ordem.md": [
		56560,
		56560
	],
	"./00401-o-que-e-impedancia-em-circuitos-de-corrente-alternada.md": [
		1030,
		1030
	],
	"./00402-qual-e-a-importancia-do-fator-de-potencia-em-circuitos-trifasicos.md": [
		97748,
		97748
	],
	"./00403-como-a-serie-de-fourier-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		77075,
		77075
	],
	"./00404-qual-a-diferenca-entre-um-diodo-e-um-transistor-bjt.md": [
		43286,
		43286
	],
	"./00405-o-que-e-um-circuito-schmitt-trigger-e-como-ele-funciona.md": [
		19503,
		19503
	],
	"./00406-como-converter-uma-tabela-verdade-em-um-circuito-digital.md": [
		72378,
		72378
	],
	"./00407-o-que-e-um-circuito-rc-de-primeira-ordem-e-como-ele-se-comporta-em-regime-transitorio.md": [
		60426,
		60426
	],
	"./00408-o-que-e-um-no-em-um-circuito-eletrico.md": [
		94646,
		94646
	],
	"./00409-o-que-e-um-capacitor-e-como-ele-funciona-em-um-circuito-eletrico.md": [
		44588,
		44588
	],
	"./00410-o-que-e-o-teorema-de-superposicao-e-como-ele-e-aplicado-na-analise-de-circuitos.md": [
		97375,
		19756
	],
	"./00411-como-obter-a-resposta-de-um-circuito-rl-de-primeira-ordem.md": [
		31261,
		31261
	],
	"./00412-como-a-continuidade-das-variaveis-afeta-circuitos-de-segunda-ordem.md": [
		44516,
		44516
	],
	"./00413-o-que-e-o-valor-rms-em-circuitos-de-corrente-alternada.md": [
		43375,
		43375
	],
	"./00414-o-que-e-o-fator-de-potencia-em-circuitos-trifasicos.md": [
		6943,
		6943
	],
	"./00415-o-que-e-a-resposta-ao-degrau-em-um-circuito-rlc.md": [
		45475,
		45475
	],
	"./00416-qual-a-diferenca-entre-mosfet-e-mesfet.md": [
		58980,
		58980
	],
	"./00417-como-funciona-o-oscilador-de-wien-em-circuitos-analogicos.md": [
		95086,
		95086
	],
	"./00418-como-mapas-de-karnaugh-simplificam-circuitos-combinacionais.md": [
		15068,
		15068
	],
	"./00419-como-medir-a-resposta-permanente-em-um-circuito-senoidal.md": [
		12710,
		12710
	],
	"./00420-o-que-e-a-lei-de-kirchhoff-das-tensoes-lkt-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		99005,
		99005
	],
	"./00421-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		44542,
		44542
	],
	"./00422-o-que-e-a-analise-nodal-em-circuitos-eletricos.md": [
		82077,
		82077
	],
	"./00423-o-que-acontece-com-a-carga-de-um-capacitor-em-um-circuito-rc-de-primeira-ordem-apos-a-comutacao.md": [
		14933,
		14933
	],
	"./00424-o-que-e-um-circuito-de-segunda-ordem-e-como-ele-se-comporta.md": [
		8409,
		8409
	],
	"./00425-o-que-e-impedancia-em-circuitos-de-corrente-alternada.md": [
		684,
		684
	],
	"./00426-o-que-e-um-circuito-trifasico-e-onde-ele-e-usado.md": [
		3150,
		3150
	],
	"./00427-o-que-e-a-funcao-de-transferencia-em-um-filtro-passa-faixas.md": [
		18583,
		18583
	],
	"./00428-como-funciona-a-juncao-pn-em-semicondutores.md": [
		95059,
		17440
	],
	"./00429-o-que-e-um-circuito-astavel-e-como-ele-funciona.md": [
		78838,
		78838
	],
	"./00430-como-os-mapas-de-karnaugh-ajudam-na-simplificacao-de-circuitos-digitais.md": [
		8157,
		8157
	],
	"./00431-o-que-e-um-filtro-passa-alto-e-como-ele-funciona-em-circuitos-eletricos.md": [
		5706,
		5706
	],
	"./00432-o-que-e-um-curto-circuito-e-como-ele-afeta-um-circuito-eletrico.md": [
		28115,
		28115
	],
	"./00433-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		91211,
		91211
	],
	"./00434-como-aplicar-o-teorema-de-superposicao-em-circuitos-eletricos.md": [
		24625,
		24625
	],
	"./00435-como-a-constante-de-tempo-afeta-a-resposta-de-um-circuito-rc.md": [
		85859,
		85859
	],
	"./00436-o-que-e-uma-resposta-super-amortecida-em-circuitos-de-segunda-ordem.md": [
		81470,
		81470
	],
	"./00437-como-o-teorema-de-norton-e-aplicado-em-circuitos-de-corrente-alternada.md": [
		27157,
		27157
	],
	"./00438-qual-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		19190,
		19190
	],
	"./00439-como-a-transformada-de-laplace-e-utilizada-na-analise-avancada-de-circuitos.md": [
		72471,
		72471
	],
	"./00440-como-a-juncao-de-um-diodo-afeta-a-tensao-em-um-circuito-com-bjt.md": [
		16182,
		16182
	],
	"./00441-o-que-e-um-circuito-astavel-e-como-ele-funciona.md": [
		36560,
		36560
	],
	"./00442-como-os-mapas-de-karnaugh-simplificam-expressoes-booleanas-em-circuitos-digitais.md": [
		7839,
		7839
	],
	"./00443-o-que-e-um-sinal-ttl-e-como-ele-e-utilizado-em-circuitos-digitais.md": [
		95775,
		95775
	],
	"./00444-o-que-e-um-no-em-um-circuito-eletrico.md": [
		6710,
		6710
	],
	"./00445-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		63444,
		63444
	],
	"./00446-como-aplicar-o-teorema-de-superposicao-na-analise-de-circuitos-eletricos.md": [
		24921,
		24921
	],
	"./00447-como-a-resposta-de-um-circuito-rl-de-primeira-ordem-e-influenciada-por-uma-fonte-de-tensao.md": [
		58543,
		58543
	],
	"./00448-o-que-e-um-circuito-de-segunda-ordem-super-amortecido.md": [
		2826,
		2826
	],
	"./00449-o-que-e-a-resposta-em-regime-permanente-em-circuitos-rlc-em-serie.md": [
		71273,
		71273
	],
	"./00450-qual-a-diferenca-entre-circuitos-monofasicos-e-trifasicos.md": [
		24876,
		24876
	],
	"./00451-o-que-e-a-transformada-de-laplace-e-como-ela-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		62813,
		62813
	],
	"./00452-como-funciona-um-mosfet-em-um-circuito-eletrico.md": [
		40703,
		40703
	],
	"./00453-como-funciona-um-conversor-r2r-em-circuitos-analogicos.md": [
		6181,
		6181
	],
	"./00454-como-funciona-a-simplificacao-de-circuitos-logicos-digitais.md": [
		99709,
		99709
	],
	"./00455-como-funciona-um-conversor-r2r-em-circuitos-eletricos.md": [
		9801,
		9801
	],
	"./00456-o-que-e-um-no-em-um-circuito-eletrico.md": [
		357,
		357
	],
	"./00457-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		53921,
		53921
	],
	"./00458-como-verificar-a-tensao-em-um-no-utilizando-o-teorema-de-thevenin.md": [
		41,
		41
	],
	"./00459-como-a-constante-de-tempo-afeta-a-carga-e-descarga-de-capacitores-e-indutores-em-circuitos-de-primeira-ordem.md": [
		87659,
		87659
	],
	"./00460-o-que-e-uma-resposta-sub-amortecida-em-circuitos-de-segunda-ordem.md": [
		89090,
		89090
	],
	"./00461-o-que-e-o-fator-de-potencia-em-circuitos-de-corrente-alternada.md": [
		80577,
		80577
	],
	"./00462-qual-a-diferenca-entre-as-conexoes-triangulo-estrela-e-triangulo-triangulo-em-circuitos-trifasicos.md": [
		24211,
		24211
	],
	"./00463-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-rlc.md": [
		66736,
		66736
	],
	"./00464-como-funciona-um-mosfet-em-modo-saturado.md": [
		21154,
		21154
	],
	"./00465-o-que-e-um-circuito-r2r-e-como-ele-funciona.md": [
		80098,
		80098
	],
	"./00466-como-os-transistores-mos-sao-utilizados-na-implementacao-de-circuitos-digitais.md": [
		86232,
		86232
	],
	"./00467-como-funcionam-as-portas-logicas-em-circuitos-combinacionais.md": [
		39440,
		39440
	],
	"./00468-o-que-e-a-lei-de-ohm-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		55244,
		55244
	],
	"./00469-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		94098,
		94098
	],
	"./00470-como-determinar-a-potencia-maxima-dissipada-em-um-resistor.md": [
		12219,
		12219
	],
	"./00471-o-que-acontece-com-a-tensao-em-um-capacitor-quando-uma-fonte-e-comutada-em-um-circuito-de-primeira-ordem.md": [
		57957,
		57957
	],
	"./00472-o-que-e-um-circuito-criticamente-amortecido-e-como-ele-se-comporta.md": [
		58201,
		58201
	],
	"./00473-o-que-e-o-valor-rms-em-circuitos-de-corrente-alternada.md": [
		95733,
		95733
	],
	"./00474-qual-a-diferenca-entre-a-conexao-triangulo-e-estrela-em-circuitos-trifasicos.md": [
		71328,
		71328
	],
	"./00475-como-a-transformada-de-fourier-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		52866,
		52866
	],
	"./00476-como-funciona-um-mosfet-e-qual-a-sua-importancia-em-circuitos-eletricos.md": [
		5904,
		5904
	],
	"./00477-como-funciona-um-circuito-astavel-com-amplificador-operacional.md": [
		19900,
		19900
	],
	"./00478-o-que-e-uma-porta-logica-e-como-ela-funciona-em-circuitos-digitais.md": [
		18284,
		18284
	],
	"./00479-o-que-e-a-configuracao-emissor-comum-em-circuitos-eletricos.md": [
		98809,
		98809
	],
	"./00480-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		5829,
		5829
	],
	"./00481-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		63524,
		63524
	],
	"./00482-como-a-transformacao-de-fontes-facilita-a-analise-de-circuitos-eletricos.md": [
		41469,
		41469
	],
	"./00483-como-a-energia-armazenada-em-um-indutor-se-comporta-em-um-circuito-de-primeira-ordem.md": [
		72253,
		72253
	],
	"./00484-como-determinar-a-resposta-de-um-circuito-rlc-sub-amortecido.md": [
		13174,
		13174
	],
	"./00485-como-funciona-a-transferencia-de-energia-em-circuitos-rlc-em-serie.md": [
		96405,
		96405
	],
	"./00486-qual-e-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		8851,
		8851
	],
	"./00487-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-com-entrada-em-rampa.md": [
		471,
		471
	],
	"./00488-o-que-significa-um-mosfet-estar-na-regiao-de-saturacao.md": [
		5802,
		5802
	],
	"./00489-o-que-e-um-oscilador-astavel-em-circuitos-analogicos.md": [
		88290,
		88290
	],
	"./00490-como-funcionam-os-circuitos-combinacionais.md": [
		73300,
		73300
	],
	"./00491-como-a-transformada-de-fourier-e-utilizada-na-analise-de-circuitos-digitais.md": [
		47224,
		47224
	],
	"./00492-o-que-e-uma-carga-eletrica-em-um-circuito-simples.md": [
		44935,
		44935
	],
	"./00493-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		38961,
		38961
	],
	"./00494-o-que-e-o-teorema-da-transferencia-de-maxima-potencia-em-circuitos-eletricos.md": [
		379,
		379
	],
	"./00495-o-que-acontece-com-a-tensao-em-um-capacitor-quando-um-circuito-rc-e-comutado.md": [
		48111,
		48111
	],
	"./00496-o-que-e-uma-resposta-sub-amortecida-em-circuitos-de-segunda-ordem.md": [
		77055,
		77055
	],
	"./00497-o-que-e-a-corrente-rms-e-por-que-ela-e-importante-em-circuitos-de-corrente-alternada.md": [
		6212,
		6212
	],
	"./00498-o-que-e-um-circuito-trifasico-equilibrado-e-por-que-ele-e-usado.md": [
		45528,
		45528
	],
	"./00499-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-com-funcoes-de-singularidade.md": [
		83567,
		83567
	],
	"./00500-como-os-semicondutores-influenciam-o-comportamento-dos-circuitos-eletricos.md": [
		21081,
		21081
	],
	"./00501-o-que-e-um-amplificador-operacional-e-como-ele-funciona-em-circuitos-analogicos.md": [
		17253,
		17253
	],
	"./00502-como-simplificar-circuitos-digitais-usando-algebra-booleana.md": [
		86047,
		86047
	],
	"./00503-como-montar-um-conversor-de-tensao-em-regime-permanente.md": [
		40508,
		40508
	],
	"./00504-o-que-sao-multiplos-e-submultiplos-de-unidades-eletricas.md": [
		85590,
		85590
	],
	"./00505-qual-a-diferenca-entre-componentes-passivos-e-ativos-em-circuitos-eletricos.md": [
		64781,
		64781
	],
	"./00506-como-aplicar-o-teorema-da-superposicao-em-circuitos-eletricos.md": [
		82411,
		82411
	],
	"./00507-o-que-acontece-com-a-tensao-em-um-circuito-rl-apos-a-comutacao.md": [
		53407,
		53407
	],
	"./00508-o-que-e-a-resposta-natural-de-um-circuito-rlc-de-segunda-ordem.md": [
		49025,
		49025
	],
	"./00509-como-aplicar-o-teorema-de-thevenin-em-circuitos-de-corrente-alternada.md": [
		99481,
		99481
	],
	"./00510-o-que-e-uma-conexao-triangulo-triangulo-em-circuitos-trifasicos.md": [
		27467,
		27467
	],
	"./00511-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-rlc.md": [
		70550,
		70550
	],
	"./00512-qual-a-diferenca-entre-mosfet-e-bjt.md": [
		51275,
		51275
	],
	"./00513-como-os-amplificadores-operacionais-funcionam-em-circuitos-analogicos.md": [
		11216,
		11216
	],
	"./00514-como-a-logica-cmos-e-utilizada-na-simplificacao-de-expressoes-logicas.md": [
		41930,
		41930
	],
	"./00515-como-funcionam-os-filtros-analogicos-em-circuitos-eletricos.md": [
		88563,
		88563
	],
	"./00516-o-que-e-um-curto-circuito-e-como-ele-ocorre-em-um-circuito-paralelo.md": [
		30123,
		30123
	],
	"./00517-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		24032,
		24032
	],
	"./00518-como-funciona-a-analise-nodal-em-circuitos-eletricos.md": [
		84991,
		84991
	],
	"./00519-como-a-tensao-varia-em-um-circuito-de-primeira-ordem-com-uma-fonte-de-tensao-constante.md": [
		12036,
		12036
	],
	"./00520-qual-e-a-diferenca-entre-uma-resposta-subamortecida-e-uma-resposta-superamortecida-em-circuitos-rlc.md": [
		71754,
		71754
	],
	"./00521-como-calcular-a-impedancia-equivalente-em-circuitos-de-corrente-alternada.md": [
		14698,
		14698
	],
	"./00522-qual-e-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		14004,
		14004
	],
	"./00523-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		89690,
		89690
	],
	"./00524-como-funciona-um-transistor-bipolar-em-um-circuito-eletrico.md": [
		43432,
		43432
	],
	"./00525-como-um-amplificador-operacional-funciona-em-circuitos-analogicos.md": [
		45550,
		45550
	],
	"./00526-como-funciona-a-simplificacao-de-circuitos-logicos-combinacionais.md": [
		88616,
		88616
	],
	"./00527-o-que-e-um-circuito-trigger-e-como-ele-funciona-em-projetos-analogicos.md": [
		76068,
		76068
	],
	"./00528-o-que-e-um-ramo-em-um-circuito-eletrico.md": [
		48757,
		48757
	],
	"./00529-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		81091,
		81091
	],
	"./00530-o-que-e-o-teorema-de-thevenin-e-como-ele-e-aplicado-na-analise-de-circuitos.md": [
		32138,
		32138
	],
	"./00531-como-a-carga-armazenada-em-um-capacitor-afeta-a-tensao-em-circuitos-de-primeira-ordem.md": [
		90459,
		90459
	],
	"./00532-o-que-e-um-circuito-de-segunda-ordem-super-amortecido.md": [
		30344,
		30344
	],
	"./00533-o-que-e-admitancia-em-circuitos-de-corrente-alternada.md": [
		37170,
		37170
	],
	"./00534-qual-e-a-diferenca-entre-a-conexao-estrela-e-a-conexao-triangulo-em-circuitos-trifasicos.md": [
		6613,
		6613
	],
	"./00535-como-a-resposta-ao-degrau-de-um-circuito-rlc-serie-e-representada-graficamente.md": [
		86429,
		86429
	],
	"./00536-qual-a-diferenca-entre-um-igbt-e-um-bjt.md": [
		6009,
		6009
	],
	"./00537-como-funciona-um-amplificador-operacional-em-um-circuito-schmitt-trigger.md": [
		93128,
		93128
	],
	"./00538-como-funcionam-os-circuitos-sequenciais-em-sistemas-digitais.md": [
		92372,
		92372
	],
	"./00539-como-funciona-um-amplificador-operacional-em-um-circuito-eletrico.md": [
		22628,
		22628
	],
	"./00540-o-que-e-um-no-em-um-circuito-eletrico.md": [
		32209,
		32209
	],
	"./00541-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		77201,
		77201
	],
	"./00542-como-calcular-a-potencia-dissipada-em-um-resistor-usando-a-lei-de-ohm.md": [
		77406,
		77406
	],
	"./00543-como-ocorre-a-descarga-de-um-indutor-em-um-circuito-rl-de-primeira-ordem.md": [
		50146,
		50146
	],
	"./00544-o-que-e-uma-resposta-amortecida-em-circuitos-de-segunda-ordem.md": [
		95874,
		95874
	],
	"./00545-o-que-e-a-resposta-em-regime-permanente-em-circuitos-de-corrente-alternada.md": [
		90232,
		90232
	],
	"./00546-o-que-e-potencia-instantanea-em-circuitos-trifasicos.md": [
		77449,
		77449
	],
	"./00547-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		30228,
		30228
	],
	"./00548-como-funciona-um-mosfet-em-um-circuito-simples.md": [
		35289,
		35289
	],
	"./00549-como-funciona-um-conversor-digital-analogico-dac-r2r.md": [
		64599,
		64599
	],
	"./00550-como-funciona-a-conversao-de-sinais-analogicos-para-digitais-em-circuitos-digitais.md": [
		67941,
		67941
	],
	"./00551-como-funcionam-as-portas-logicas-em-circuitos-digitais.md": [
		32569,
		32569
	],
	"./00552-o-que-e-um-ramo-em-um-circuito-eletrico.md": [
		27448,
		27448
	],
	"./00553-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		31464,
		31464
	],
	"./00554-como-aplicar-o-teorema-de-thevenin-na-analise-de-circuitos.md": [
		63632,
		63632
	],
	"./00555-como-a-carga-e-descarga-de-um-capacitor-afetam-a-corrente-e-a-tensao-em-um-circuito-de-primeira-ordem.md": [
		50232,
		50232
	],
	"./00556-o-que-e-um-circuito-super-amortecido-e-como-ele-se-comporta.md": [
		86703,
		86703
	],
	"./00557-o-que-e-a-forma-rms-e-por-que-ela-e-importante-em-circuitos-de-corrente-alternada.md": [
		96504,
		96504
	],
	"./00558-o-que-e-um-circuito-trifasico-e-como-ele-e-usado-em-sistemas-eletricos.md": [
		12704,
		12704
	],
	"./00559-o-que-e-a-resposta-ao-impulso-em-circuitos-eletricos.md": [
		52112,
		52112
	],
	"./00560-como-funciona-a-juncao-pn-em-semicondutores.md": [
		33948,
		33948
	],
	"./00561-o-que-e-a-analise-de-pequeno-sinal-em-circuitos-analogicos.md": [
		45926,
		45926
	],
	"./00562-como-funciona-a-simplificacao-de-circuitos-digitais.md": [
		3128,
		3128
	],
	"./00563-como-funciona-um-conversor-digital-analogico-dac-r2r.md": [
		42331,
		42331
	],
	"./00564-o-que-e-a-lei-de-kirchhoff-das-correntes-lkc-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		48027,
		48027
	],
	"./00565-qual-a-diferenca-entre-um-diodo-e-um-transistor.md": [
		40097,
		40097
	],
	"./00566-como-determinar-a-resistencia-equivalente-em-um-circuito-complexo.md": [
		33458,
		33458
	],
	"./00567-como-a-energia-e-armazenada-e-dissipada-em-circuitos-rc-e-rl.md": [
		18945,
		18945
	],
	"./00568-o-que-e-uma-resposta-sub-amortecida-em-circuitos-de-segunda-ordem.md": [
		54577,
		54577
	],
	"./00569-como-determinar-a-corrente-eficaz-em-um-circuito-de-corrente-alternada.md": [
		98970,
		98970
	],
	"./00570-como-calcular-a-potencia-instantanea-em-um-sistema-trifasico.md": [
		60716,
		60716
	],
	"./00571-o-que-e-uma-singularidade-em-circuitos-eletricos-e-como-ela-afeta-a-analise-avancada.md": [
		28946,
		28946
	],
	"./00572-qual-a-diferenca-entre-um-bjt-e-um-mosfet-em-um-circuito-eletrico.md": [
		77176,
		77176
	],
	"./00573-como-funciona-um-oscilador-em-circuitos-analogicos.md": [
		47884,
		47884
	],
	"./00574-como-funcionam-os-flip-flops-e-latches-em-circuitos-digitais.md": [
		10805,
		10805
	],
	"./00575-como-funcionam-as-portas-logicas-ttl-em-circuitos-eletricos.md": [
		68028,
		68028
	],
	"./00576-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		14583,
		14583
	],
	"./00577-qual-a-diferenca-entre-componentes-passivos-e-ativos-em-circuitos-eletronicos.md": [
		51517,
		51517
	],
	"./00578-o-que-e-uma-supermalha-e-como-ela-e-utilizada-na-analise-de-circuitos.md": [
		38521,
		38521
	],
	"./00579-o-que-e-um-circuito-de-primeira-ordem-e-como-ele-se-comporta.md": [
		80604,
		80604
	],
	"./00580-o-que-e-um-circuito-de-segunda-ordem-criticamente-amortecido.md": [
		35004,
		35004
	],
	"./00581-como-aplicar-o-teorema-de-norton-em-circuitos-de-corrente-alternada.md": [
		91828,
		91828
	],
	"./00582-qual-a-diferenca-entre-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		59815,
		59815
	],
	"./00583-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		13430,
		13430
	],
	"./00584-como-funciona-a-regiao-de-saturacao-em-um-mosfet.md": [
		93385,
		93385
	],
	"./00585-o-que-e-um-circuito-biestavel-e-como-ele-funciona.md": [
		72784,
		72784
	],
	"./00586-o-que-e-um-latch-em-circuitos-digitais-e-como-ele-funciona.md": [
		70135,
		70135
	],
	"./00587-como-funcionam-os-conversores-de-tensao-em-circuitos-eletricos.md": [
		16566,
		16566
	],
	"./00588-o-que-e-a-lei-de-kirchhoff-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		57205,
		57205
	],
	"./00589-qual-a-diferenca-entre-um-capacitor-e-um-indutor-em-um-circuito-eletrico.md": [
		61311,
		61311
	],
	"./00590-o-que-e-uma-supermalha-em-circuitos-eletricos.md": [
		37925,
		37925
	],
	"./00591-como-a-energia-armazenada-em-um-capacitor-afeta-a-tensao-em-um-circuito-de-primeira-ordem.md": [
		92310,
		92310
	],
	"./00592-o-que-e-uma-resposta-super-amortecida-em-circuitos-de-segunda-ordem.md": [
		82311,
		82311
	],
	"./00593-o-que-e-um-fasor-e-como-ele-e-utilizado-em-circuitos-rlc.md": [
		73491,
		73491
	],
	"./00594-qual-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		99341,
		99341
	],
	"./00595-como-a-singularidade-afeta-a-analise-de-circuitos-rlc-em-serie.md": [
		63995,
		63995
	],
	"./00596-o-que-significa-um-transistor-bjt-estar-em-modo-saturado.md": [
		36545,
		36545
	],
	"./00597-qual-a-diferenca-entre-circuitos-analogicos-e-digitais.md": [
		22080,
		22080
	],
	"./00598-como-funciona-a-tabela-verdade-em-circuitos-digitais-cmos.md": [
		34164,
		34164
	],
	"./00599-como-um-conversor-dac-funciona-em-um-circuito-eletrico.md": [
		79657,
		79657
	],
	"./00600-como-aplicar-a-lei-de-kirchhoff-das-malhas-em-um-circuito-basico.md": [
		48563,
		48563
	],
	"./00601-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		36866,
		36866
	],
	"./00602-como-aplicar-o-teorema-da-superposicao-em-circuitos-eletricos.md": [
		61454,
		61454
	],
	"./00603-o-que-e-a-constante-de-tempo-em-circuitos-de-primeira-ordem.md": [
		22558,
		22558
	],
	"./00604-o-que-e-um-circuito-super-amortecido-e-como-ele-se-comporta.md": [
		22281,
		22281
	],
	"./00605-como-aplicar-o-principio-da-superposicao-em-circuitos-de-corrente-alternada.md": [
		48264,
		48264
	],
	"./00606-o-que-e-o-fator-de-potencia-em-circuitos-trifasicos.md": [
		64494,
		64494
	],
	"./00607-como-a-transformada-de-laplace-e-utilizada-na-analise-avancada-de-circuitos.md": [
		24652,
		24652
	],
	"./00608-qual-a-diferenca-entre-um-bjt-e-um-jfet.md": [
		1238,
		1238
	],
	"./00609-o-que-e-um-circuito-astavel-e-como-ele-opera-em-sistemas-analogicos.md": [
		47970,
		25589
	],
	"./00610-como-converter-uma-tabela-verdade-em-um-mapa-de-karnaugh-e-vice-versa.md": [
		25903,
		25903
	],
	"./00611-o-que-e-uma-porta-logica-schmitt-e-como-ela-funciona.md": [
		71980,
		71980
	],
	"./00612-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		47684,
		47684
	],
	"./00613-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		8899,
		8899
	],
	"./00614-como-a-transformacao-de-fontes-afeta-a-analise-de-circuitos.md": [
		34437,
		34437
	],
	"./00615-como-determinar-a-resposta-natural-de-um-circuito-rc-de-primeira-ordem.md": [
		65783,
		65783
	],
	"./00616-o-que-e-uma-resposta-super-amortecida-em-circuitos-de-segunda-ordem.md": [
		85606,
		85606
	],
	"./00617-como-calcular-a-admitancia-equivalente-em-circuitos-de-corrente-alternada.md": [
		54788,
		54788
	],
	"./00618-o-que-e-um-circuito-trifasico-equilibrado.md": [
		68864,
		68864
	],
	"./00619-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-com-entrada-em-rampa.md": [
		94320,
		94320
	],
	"./00620-como-funciona-a-juncao-pn-em-semicondutores.md": [
		82013,
		82013
	],
	"./00621-o-que-e-um-oscilador-de-wien-e-como-ele-funciona.md": [
		10729,
		10729
	],
	"./00622-como-os-mapas-de-karnaugh-simplificam-funcoes-logicas-em-circuitos-digitais.md": [
		75559,
		75559
	],
	"./00623-como-montar-um-amplificador-analogico-de-segunda-ordem.md": [
		78665,
		78665
	],
	"./00624-o-que-e-um-curto-circuito-e-como-ele-ocorre-em-um-circuito-eletrico.md": [
		600,
		600
	],
	"./00625-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		67224,
		67224
	],
	"./00626-o-que-e-a-linearidade-em-circuitos-eletricos-e-como-ela-afeta-a-analise-de-nos.md": [
		66934,
		66934
	],
	"./00627-como-a-energia-armazenada-em-um-indutor-afeta-o-comportamento-de-um-circuito-rl-de-primeira-ordem.md": [
		66863,
		66863
	],
	"./00628-o-que-e-uma-resposta-sub-amortecida-em-circuitos-de-segunda-ordem.md": [
		36144,
		36144
	],
	"./00629-como-a-analise-de-malha-e-aplicada-em-circuitos-de-corrente-alternada.md": [
		56365,
		56365
	],
	"./00630-o-que-e-um-circuito-trifasico-e-como-ele-funciona.md": [
		86778,
		86778
	],
	"./00631-como-o-teorema-de-parseval-e-aplicado-na-analise-de-circuitos-eletricos.md": [
		84421,
		84421
	],
	"./00632-como-funciona-um-transistor-bjt-em-um-circuito-simples.md": [
		66295,
		66295
	],
	"./00633-o-que-e-um-circuito-trigger-e-como-ele-funciona-em-circuitos-analogicos.md": [
		77607,
		77607
	],
	"./00634-como-os-flip-flops-sao-utilizados-em-circuitos-digitais.md": [
		84429,
		84429
	],
	"./00635-o-que-e-um-amplificador-schmitt-e-como-ele-funciona.md": [
		13802,
		13802
	],
	"./00636-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		70166,
		70166
	],
	"./00637-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		15681,
		15681
	],
	"./00638-como-funciona-a-analise-nodal-em-circuitos-eletricos.md": [
		76561,
		76561
	],
	"./00639-como-a-energia-e-armazenada-em-circuitos-rc-e-rl.md": [
		16146,
		16146
	],
	"./00640-como-determinar-a-resposta-de-um-circuito-rlc-sub-amortecido.md": [
		87672,
		87672
	],
	"./00641-o-que-e-o-fator-de-potencia-em-circuitos-de-corrente-alternada.md": [
		72777,
		72777
	],
	"./00642-qual-e-a-diferenca-entre-as-conexoes-triangulo-e-estrela-em-circuitos-trifasicos.md": [
		57293,
		57293
	],
	"./00643-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		16583,
		16583
	],
	"./00644-como-funcionam-os-transistores-bipolares-de-juncao-bjt.md": [
		9415,
		9415
	],
	"./00645-o-que-e-um-diagrama-de-bode-e-qual-sua-importancia-em-circuitos-analogicos.md": [
		9152,
		9152
	],
	"./00646-o-que-sao-portas-logicas-e-como-elas-funcionam-em-circuitos-digitais.md": [
		32589,
		32589
	],
	"./00647-o-que-e-um-trigger-em-circuitos-eletricos.md": [
		44905,
		44905
	],
	"./00648-o-que-e-a-lei-de-kirchhoff-das-correntes-lkc-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		71430,
		71430
	],
	"./00649-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		93750,
		93750
	],
	"./00650-como-o-teorema-de-thevenin-simplifica-a-analise-de-circuitos.md": [
		99970,
		77589
	],
	"./00651-como-a-energia-armazenada-em-um-capacitor-varia-ao-longo-do-tempo-em-um-circuito-rc.md": [
		66351,
		66351
	],
	"./00652-como-a-resposta-de-um-circuito-rlc-de-segunda-ordem-e-determinada.md": [
		37087,
		37087
	],
	"./00653-o-que-e-o-valor-rms-em-circuitos-de-corrente-alternada.md": [
		93597,
		93597
	],
	"./00654-qual-a-diferenca-entre-sistemas-monofasicos-e-trifasicos-em-termos-de-aplicacao-e-potencia.md": [
		74678,
		74678
	],
	"./00655-como-a-transformada-de-fourier-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		67898,
		67898
	],
	"./00656-como-funciona-um-jfet-em-circuitos-eletricos.md": [
		1799,
		1799
	],
	"./00657-o-que-e-um-filtro-passa-baixa-e-como-ele-funciona-em-circuitos-analogicos.md": [
		81953,
		81953
	],
	"./00658-como-funciona-a-conversao-de-sinais-analogicos-para-digitais-em-circuitos-digitais.md": [
		15450,
		15450
	],
	"./00659-o-que-e-um-filtro-rlc-e-como-ele-funciona-em-circuitos-analogicos.md": [
		78010,
		78010
	],
	"./00660-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		78185,
		78185
	],
	"./00661-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		47900,
		47900
	],
	"./00662-como-funciona-o-teorema-da-superposicao-em-circuitos-eletricos.md": [
		74019,
		74019
	],
	"./00663-o-que-e-a-constante-de-tempo-em-circuitos-rc-e-rl.md": [
		51087,
		51087
	],
	"./00664-o-que-e-um-circuito-super-amortecido-e-como-ele-se-comporta.md": [
		32883,
		32883
	],
	"./00665-o-que-e-a-admitancia-em-circuitos-de-corrente-alternada.md": [
		49410,
		49410
	],
	"./00666-qual-a-diferenca-entre-as-conexoes-triangulo-estrela-e-triangulo-triangulo-em-circuitos-trifasicos.md": [
		5005,
		5005
	],
	"./00667-como-a-transformada-de-fourier-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		5879,
		5879
	],
	"./00668-como-os-transistores-bipolares-de-juncao-bjt-funcionam-em-circuitos-eletricos.md": [
		24357,
		24357
	],
	"./00669-como-funciona-um-amplificador-operacional-em-um-circuito-analogico.md": [
		29994,
		29994
	],
	"./00670-como-funcionam-as-portas-logicas-em-circuitos-digitais.md": [
		36549,
		36549
	],
	"./00671-o-que-e-o-regime-permanente-em-circuitos-eletricos.md": [
		22100,
		22100
	],
	"./00672-o-que-e-um-no-em-um-circuito-eletrico.md": [
		63657,
		63657
	],
	"./00673-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		62221,
		62221
	],
	"./00674-como-a-teoria-da-superposicao-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		16824,
		16824
	],
	"./00675-como-a-constante-de-tempo-afeta-a-resposta-de-um-circuito-rl.md": [
		6828,
		6828
	],
	"./00676-o-que-e-um-circuito-rlc-super-amortecido.md": [
		50431,
		50431
	],
	"./00677-o-que-e-o-fator-de-potencia-em-circuitos-de-corrente-alternada.md": [
		19682,
		19682
	],
	"./00678-o-que-e-uma-conexao-estrela-triangulo-em-circuitos-trifasicos.md": [
		93529,
		93529
	],
	"./00679-o-que-e-a-transformada-de-laplace-e-como-ela-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		62253,
		62253
	],
	"./00680-o-que-e-um-transistor-hemt-e-como-ele-funciona-em-um-circuito-saturado.md": [
		21243,
		21243
	],
	"./00681-o-que-e-um-oscilador-de-wien-e-como-ele-funciona-em-circuitos-analogicos.md": [
		45833,
		45833
	],
	"./00682-como-os-flip-flops-funcionam-em-circuitos-digitais.md": [
		57892,
		57892
	],
	"./00683-o-que-e-o-regime-permanente-em-um-circuito-rlc-serie.md": [
		78369,
		78369
	],
	"./00684-o-que-sao-multiplos-e-submultiplos-de-unidades-eletricas.md": [
		65401,
		65401
	],
	"./00685-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		36722,
		36722
	],
	"./00686-o-que-e-uma-supermalha-em-circuitos-eletricos.md": [
		32911,
		32911
	],
	"./00687-como-a-carga-em-um-capacitor-varia-ao-longo-do-tempo-em-um-circuito-rc.md": [
		55674,
		55674
	],
	"./00688-o-que-e-uma-resposta-sub-amortecida-em-circuitos-de-segunda-ordem.md": [
		34822,
		34822
	],
	"./00689-como-a-analise-nodal-e-aplicada-em-circuitos-de-corrente-alternada.md": [
		59996,
		59996
	],
	"./00690-o-que-e-um-circuito-trifasico-e-como-ele-funciona.md": [
		90696,
		90696
	],
	"./00691-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		26794,
		26794
	],
	"./00692-como-funciona-o-modelo-equivalente-de-um-transistor-bjt-em-circuitos-eletricos.md": [
		16181,
		16181
	],
	"./00693-como-funciona-um-conversor-r2r-em-circuitos-analogicos.md": [
		46855,
		46855
	],
	"./00694-o-que-e-um-latch-e-como-ele-e-implementado-em-circuitos-digitais.md": [
		71573,
		71573
	],
	"./00695-o-que-e-um-amplificador-schmitt-e-como-ele-funciona.md": [
		34308,
		34308
	],
	"./00696-o-que-e-a-lei-de-kirchhoff-das-correntes-lkc-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		28551,
		28551
	],
	"./00697-o-que-e-um-componente-eletronico-linear.md": [
		10013,
		10013
	],
	"./00698-o-que-e-o-teorema-de-thevenin-e-como-ele-simplifica-a-analise-de-circuitos.md": [
		13919,
		13919
	],
	"./00699-como-a-energia-e-armazenada-em-capacitores-e-indutores.md": [
		40368,
		40368
	],
	"./00700-o-que-e-um-circuito-de-segunda-ordem-sub-amortecido.md": [
		25372,
		25372
	],
	"./00701-o-que-e-o-fator-de-potencia-em-circuitos-rlc-em-serie.md": [
		26486,
		26486
	],
	"./00702-qual-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		69074,
		69074
	],
	"./00703-como-a-transformada-inversa-de-laplace-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		85249,
		85249
	],
	"./00704-como-funcionam-os-transistores-de-juncao-bipolar-bjt.md": [
		13478,
		13478
	],
	"./00705-como-funciona-um-amplificador-operacional-em-um-circuito-astavel.md": [
		41254,
		41254
	],
	"./00706-como-funciona-a-simplificacao-de-expressoes-booleanas-usando-o-mapa-de-karnaugh.md": [
		64603,
		64603
	],
	"./00707-o-que-e-um-circuito-schmitt-trigger-e-como-ele-e-utilizado-em-aplicacoes-praticas.md": [
		22992,
		22992
	],
	"./00708-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		89632,
		89632
	],
	"./00709-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		89699,
		89699
	],
	"./00710-como-aplicar-o-principio-da-superposicao-na-analise-de-circuitos-eletricos.md": [
		42447,
		42447
	],
	"./00711-como-a-corrente-em-um-indutor-se-comporta-em-um-circuito-de-primeira-ordem.md": [
		7121,
		7121
	],
	"./00712-qual-e-a-diferenca-entre-uma-resposta-subamortecida-e-uma-superamortecida-em-circuitos-de-segunda-ordem.md": [
		30007,
		30007
	],
	"./00713-o-que-e-o-fator-de-potencia-em-circuitos-de-corrente-alternada.md": [
		69893,
		69893
	],
	"./00714-qual-e-a-diferenca-entre-as-conexoes-estrela-triangulo-e-triangulo-triangulo-em-circuitos-trifasicos.md": [
		68865,
		68865
	],
	"./00715-como-a-aplicacao-de-um-degrau-de-tensao-afeta-um-circuito-eletrico.md": [
		60187,
		60187
	],
	"./00716-como-funcionam-os-transistores-de-juncao-bipolar-bjt.md": [
		58451,
		58451
	],
	"./00717-como-funciona-um-oscilador-em-circuitos-analogicos.md": [
		9888,
		9888
	],
	"./00718-como-funcionam-os-circuitos-sequenciais-em-sistemas-digitais.md": [
		16392,
		16392
	],
	"./00719-o-que-e-o-regime-permanente-em-circuitos-rc.md": [
		57908,
		57908
	],
	"./00720-o-que-e-um-curto-circuito-e-como-ele-ocorre-em-um-circuito-eletrico.md": [
		37675,
		37675
	],
	"./00721-qual-a-diferenca-entre-componentes-passivos-e-ativos-em-circuitos-eletronicos.md": [
		92680,
		92680
	],
	"./00722-como-aplicar-o-metodo-nodal-na-analise-de-circuitos.md": [
		18735,
		18735
	],
	"./00723-o-que-sao-circuitos-de-primeira-ordem-e-como-eles-funcionam.md": [
		38914,
		38914
	],
	"./00724-como-funciona-a-resposta-de-um-circuito-rlc-paralelo-a-uma-fonte-degrau.md": [
		90039,
		90039
	],
	"./00725-o-que-e-a-admitancia-em-circuitos-de-corrente-alternada.md": [
		69161,
		69161
	],
	"./00726-o-que-e-um-sistema-trifasico-equilibrado.md": [
		16606,
		16606
	],
	"./00727-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		95790,
		95790
	],
	"./00728-como-funcionam-os-diodos-semicondutores.md": [
		91662,
		91662
	],
	"./00729-o-que-e-um-diagrama-de-bode-e-qual-sua-importancia-em-circuitos-analogicos.md": [
		79523,
		79523
	],
	"./00730-como-os-flip-flops-sao-implementados-em-circuitos-digitais.md": [
		51070,
		51070
	],
	"./00731-como-funciona-um-circuito-rc-em-um-experimento-pratico.md": [
		59486,
		59486
	],
	"./00732-o-que-e-um-circuito-eletrico-em-malha-aberta.md": [
		57031,
		57031
	],
	"./00733-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		47740,
		47740
	],
	"./00734-como-determinar-o-circuito-equivalente-de-thevenin.md": [
		21446,
		21446
	],
	"./00735-como-a-energia-armazenada-em-um-indutor-e-obtida-e-aplicada-em-circuitos-de-primeira-ordem.md": [
		42968,
		42968
	],
	"./00736-o-que-e-uma-resposta-super-amortecida-em-um-circuito-rlc-de-segunda-ordem.md": [
		63285,
		63285
	],
	"./00737-como-o-teorema-de-thevenin-e-aplicado-em-circuitos-rlc-em-corrente-alternada.md": [
		64044,
		64044
	],
	"./00738-qual-a-diferenca-entre-a-conexao-estrela-e-a-conexao-triangulo-em-circuitos-trifasicos.md": [
		24697,
		24697
	],
	"./00739-como-a-resposta-de-um-circuito-rlc-a-um-impulso-pode-ser-representada-graficamente.md": [
		87621,
		87621
	],
	"./00740-como-funciona-a-juncao-pn-em-um-diodo.md": [
		96172,
		96172
	],
	"./00741-qual-a-diferenca-entre-circuitos-analogicos-e-digitais.md": [
		5123,
		5123
	],
	"./00742-como-funcionam-as-portas-logicas-em-circuitos-digitais.md": [
		64703,
		64703
	],
	"./00743-como-o-trigger-afeta-a-medida-de-sinais-senoidais-em-experimentos-de-circuitos-eletricos.md": [
		60227,
		60227
	],
	"./00744-como-a-associacao-em-serie-afeta-a-tensao-em-um-circuito-eletrico.md": [
		76543,
		76543
	],
	"./00745-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		44640,
		44640
	],
	"./00746-como-aplicar-o-teorema-de-thevenin-em-um-circuito-eletrico.md": [
		18818,
		18818
	],
	"./00747-como-a-associacao-de-componentes-afeta-a-resposta-de-circuitos-de-primeira-ordem.md": [
		30186,
		30186
	],
	"./00748-o-que-e-um-circuito-rlc-criticamente-amortecido.md": [
		98188,
		98188
	],
	"./00749-o-que-e-admitancia-em-circuitos-de-corrente-alternada.md": [
		18717,
		18717
	],
	"./00750-o-que-e-um-circuito-trifasico-equilibrado-e-como-ele-funciona.md": [
		25909,
		25909
	],
	"./00751-o-que-e-a-resposta-impulsiva-de-um-circuito-eletrico.md": [
		70404,
		70404
	],
	"./00752-como-a-juncao-pn-afeta-o-comportamento-de-um-diodo.md": [
		7567,
		7567
	],
	"./00753-o-que-e-um-multivibrador-e-como-ele-funciona-em-circuitos-analogicos.md": [
		75307,
		75307
	],
	"./00754-como-converter-um-numero-decimal-para-uma-expressao-booleana.md": [
		71500,
		71500
	],
	"./00755-como-a-tensao-de-saida-de-um-dac-e-determinada.md": [
		73353,
		73353
	],
	"./00756-o-que-e-a-lei-dos-nos-em-circuitos-eletricos.md": [
		51227,
		51227
	],
	"./00757-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		72486,
		72486
	],
	"./00758-como-a-analise-nodal-e-utilizada-para-determinar-a-corrente-em-um-resistor.md": [
		72992,
		72992
	],
	"./00759-como-o-comportamento-de-um-capacitor-em-um-circuito-rc-de-primeira-ordem-e-influenciado-por-uma-fonte-variavel.md": [
		49250,
		49250
	],
	"./00760-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-se-comportam.md": [
		10236,
		10236
	],
	"./00761-como-funciona-a-associacao-de-componentes-em-circuitos-de-corrente-alternada.md": [
		55169,
		55169
	],
	"./00762-qual-e-a-diferenca-entre-um-circuito-trifasico-e-um-circuito-monofasico.md": [
		79960,
		79960
	],
	"./00763-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		8324,
		8324
	],
	"./00764-como-funciona-a-regiao-de-saturacao-em-um-transistor.md": [
		5718,
		5718
	],
	"./00765-o-que-e-um-conversor-analogico-digital-e-como-ele-funciona-em-circuitos-eletricos.md": [
		53482,
		53482
	],
	"./00766-como-converter-um-numero-binario-para-decimal-e-vice-versa.md": [
		57155,
		57155
	],
	"./00767-o-que-e-um-circuito-schmitt-trigger-e-como-ele-funciona.md": [
		87878,
		87878
	],
	"./00768-o-que-e-um-circuito-eletrico-simples.md": [
		95955,
		95955
	],
	"./00769-qual-a-funcao-de-um-capacitor-em-um-circuito-eletrico.md": [
		29792,
		29792
	],
	"./00770-como-a-superposicao-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		77248,
		77248
	],
	"./00771-o-que-acontece-com-a-tensao-em-um-capacitor-apos-a-comutacao-em-um-circuito-rc.md": [
		67886,
		67886
	],
	"./00772-o-que-e-um-circuito-super-amortecido-e-como-ele-se-comporta.md": [
		98407,
		98407
	],
	"./00773-o-que-e-impedancia-em-circuitos-de-corrente-alternada.md": [
		97378,
		97378
	],
	"./00774-qual-e-a-diferenca-entre-as-conexoes-estrela-triangulo-e-triangulo-triangulo-em-circuitos-trifasicos.md": [
		94811,
		94811
	],
	"./00775-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		14033,
		14033
	],
	"./00776-o-que-e-um-mosfet-e-como-ele-funciona-em-circuitos-eletricos.md": [
		78038,
		78038
	],
	"./00777-como-funciona-a-implementacao-de-um-multivibrador-astavel-usando-bjt.md": [
		11973,
		11973
	],
	"./00778-como-funciona-a-simplificacao-de-circuitos-logicos-usando-o-mapa-de-karnaugh.md": [
		3974,
		3974
	],
	"./00779-o-que-e-um-conversor-senoidal-e-como-ele-e-utilizado-em-circuitos-eletricos.md": [
		23512,
		23512
	],
	"./00780-o-que-e-um-no-em-um-circuito-eletrico.md": [
		53643,
		53643
	],
	"./00781-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		46291,
		46291
	],
	"./00782-como-a-linearidade-afeta-a-resposta-de-um-circuito-eletrico.md": [
		89071,
		89071
	],
	"./00783-o-que-acontece-durante-a-descarga-de-um-capacitor-em-um-circuito-rc.md": [
		86757,
		86757
	],
	"./00784-como-a-continuidade-de-corrente-e-tensao-afeta-circuitos-lc-de-segunda-ordem.md": [
		33276,
		33276
	],
	"./00785-como-o-principio-da-superposicao-e-aplicado-em-circuitos-de-corrente-alternada.md": [
		28738,
		28738
	],
	"./00786-o-que-e-uma-conexao-triangulo-triangulo-em-circuitos-trifasicos.md": [
		65654,
		65654
	],
	"./00787-o-que-e-uma-funcao-passa-faixas-em-circuitos-rlc.md": [
		83338,
		83338
	],
	"./00788-como-os-diodos-influenciam-a-corrente-em-um-circuito-eletrico.md": [
		97892,
		97892
	],
	"./00789-como-funciona-um-amplificador-em-um-circuito-analogico.md": [
		82979,
		82979
	],
	"./00790-como-os-flip-flops-sao-utilizados-em-circuitos-digitais.md": [
		45248,
		45248
	],
	"./00791-como-funcionam-os-circuitos-senoidais-em-projetos-avancados.md": [
		64243,
		64243
	],
	"./00792-o-que-e-um-no-em-um-circuito-eletrico.md": [
		97132,
		97132
	],
	"./00793-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		96294,
		96294
	],
	"./00794-como-aplicar-o-teorema-de-norton-na-analise-de-circuitos.md": [
		56517,
		56517
	],
	"./00795-como-a-constante-de-tempo-afeta-a-resposta-de-um-circuito-rc.md": [
		72922,
		72922
	],
	"./00796-o-que-e-uma-resposta-super-amortecida-em-circuitos-de-segunda-ordem.md": [
		48085,
		48085
	],
	"./00797-como-a-admitancia-afeta-a-analise-de-circuitos-em-serie-em-corrente-alternada.md": [
		44881,
		44881
	],
	"./00798-qual-e-a-importancia-do-fator-de-potencia-em-circuitos-trifasicos.md": [
		88414,
		88414
	],
	"./00799-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		18387,
		18387
	],
	"./00800-como-o-teorema-de-thevenin-e-aplicado-em-circuitos-com-semicondutores.md": [
		86929,
		86929
	],
	"./00801-como-analisar-a-resposta-de-um-circuito-analogico-em-ac.md": [
		80912,
		80912
	],
	"./00802-como-converter-uma-funcao-booleana-em-um-circuito-cmos.md": [
		87381,
		87381
	],
	"./00803-como-funciona-o-trigger-de-schmitt-em-circuitos-analogicos.md": [
		53400,
		53400
	],
	"./00804-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		13797,
		13797
	],
	"./00805-qual-a-diferenca-entre-componentes-eletronicos-lineares-e-nao-lineares.md": [
		87335,
		87335
	],
	"./00806-como-funciona-a-analise-nodal-em-circuitos-eletricos.md": [
		91488,
		91488
	],
	"./00807-como-a-energia-armazenada-em-um-indutor-e-obtida-em-um-circuito-de-primeira-ordem.md": [
		35396,
		35396
	],
	"./00808-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-respondem-a-uma-fonte-degrau.md": [
		3021,
		3021
	],
	"./00809-o-que-e-o-valor-rms-em-circuitos-de-corrente-alternada.md": [
		77338,
		77338
	],
	"./00810-qual-a-diferenca-entre-um-sistema-trifasico-equilibrado-e-um-sistema-monofasico.md": [
		33370,
		33370
	],
	"./00811-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		32440,
		10059
	],
	"./00812-como-funcionam-os-transistores-bipolares-de-juncao-bjt.md": [
		91664,
		91664
	],
	"./00813-o-que-e-um-amplificador-schmitt-trigger-e-como-ele-funciona.md": [
		20709,
		20709
	],
	"./00814-como-os-transistores-sao-utilizados-em-circuitos-digitais-combinacionais.md": [
		12114,
		12114
	],
	"./00815-como-funciona-um-conversor-digital-analogico-dac-em-um-circuito-rc.md": [
		52301,
		52301
	],
	"./00816-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		89242,
		89242
	],
	"./00817-qual-e-a-funcao-de-um-transformador-em-um-circuito-eletrico.md": [
		4210,
		4210
	],
	"./00818-o-que-e-uma-supermalha-e-como-ela-e-utilizada-na-analise-de-circuitos.md": [
		84632,
		84632
	],
	"./00819-o-que-acontece-em-um-circuito-rl-quando-ocorre-a-comutacao.md": [
		18320,
		18320
	],
	"./00820-como-a-continuidade-afeta-circuitos-de-segunda-ordem.md": [
		80929,
		80929
	],
	"./00821-como-a-impedancia-afeta-a-potencia-em-circuitos-de-corrente-alternada.md": [
		26917,
		26917
	],
	"./00822-o-que-e-uma-conexao-triangulo-triangulo-em-circuitos-trifasicos.md": [
		16445,
		16445
	],
	"./00823-o-que-e-a-resposta-ao-degrau-em-um-circuito-rlc-e-qual-sua-importancia.md": [
		72492,
		72492
	],
	"./00824-o-que-e-um-transistor-bipolar-de-juncao-bjt-e-como-ele-funciona-em-um-circuito.md": [
		26814,
		26814
	],
	"./00825-qual-a-diferenca-entre-componentes-passivos-e-ativos-em-circuitos-analogicos.md": [
		83600,
		83600
	],
	"./00826-como-converter-uma-expressao-logica-em-um-circuito-digital.md": [
		33253,
		33253
	],
	"./00827-o-que-e-uma-porta-schmitt-trigger-e-qual-sua-aplicacao-em-circuitos-eletricos.md": [
		63252,
		63252
	],
	"./00828-o-que-e-um-no-em-um-circuito-eletrico.md": [
		81296,
		81296
	],
	"./00829-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		50174,
		50174
	],
	"./00830-como-aplicar-o-teorema-da-maxima-transferencia-de-potencia-em-um-circuito.md": [
		49674,
		49674
	],
	"./00831-como-analisar-circuitos-de-primeira-ordem-com-indutor-e-capacitor.md": [
		63214,
		63214
	],
	"./00832-o-que-e-um-circuito-de-segunda-ordem-sub-amortecido.md": [
		19636,
		19636
	],
	"./00833-o-que-e-a-impedancia-em-circuitos-de-corrente-alternada.md": [
		40425,
		40425
	],
	"./00834-o-que-e-um-sistema-trifasico-equilibrado.md": [
		98708,
		98708
	],
	"./00835-o-que-e-a-funcao-impulso-e-como-ela-e-aplicada-na-analise-de-circuitos.md": [
		45939,
		45939
	],
	"./00836-como-os-mosfets-sao-utilizados-em-circuitos-de-potencia.md": [
		98911,
		98911
	],
	"./00837-o-que-e-uma-ponte-de-wheatstone-e-como-ela-e-utilizada-em-circuitos-analogicos.md": [
		52584,
		52584
	],
	"./00838-o-que-e-um-circuito-combinacional-e-como-ele-funciona.md": [
		60567,
		60567
	],
	"./00839-como-os-filtros-analogicos-sao-projetados-e-configurados-em-circuitos-com-bjt.md": [
		18424,
		18424
	],
	"./00840-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		80525,
		80525
	],
	"./00841-qual-a-diferenca-entre-componentes-passivos-e-ativos-em-circuitos-eletricos.md": [
		27846,
		27846
	],
	"./00842-como-verificar-a-corrente-maxima-em-um-resistor-em-um-circuito-com-fonte-de-tensao.md": [
		88261,
		88261
	],
	"./00843-o-que-e-um-circuito-de-primeira-ordem-e-como-ele-armazena-energia.md": [
		59685,
		59685
	],
	"./00844-como-identificar-o-tipo-de-resposta-em-circuitos-rlc-de-segunda-ordem.md": [
		8590,
		8590
	],
	"./00845-o-que-e-admitancia-em-circuitos-de-corrente-alternada.md": [
		85712,
		63331
	],
	"./00846-qual-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		44961,
		44961
	],
	"./00847-o-que-e-a-resposta-ao-degrau-inverso-em-um-circuito-serie.md": [
		47294,
		47294
	],
	"./00848-qual-a-diferenca-entre-um-igbt-e-um-mesfet.md": [
		36261,
		36261
	],
	"./00849-o-que-e-uma-ponte-de-wheatstone-e-como-ela-e-utilizada-na-analise-de-circuitos.md": [
		2067,
		2067
	],
	"./00850-como-funcionam-os-circuitos-combinacionais-em-sistemas-digitais.md": [
		58314,
		58314
	],
	"./00851-como-funciona-um-amplificador-operacional-em-um-circuito-de-emissor-comum.md": [
		90528,
		90528
	],
	"./00852-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		52258,
		52258
	],
	"./00853-qual-a-diferenca-entre-componentes-passivos-e-ativos-em-circuitos-eletricos.md": [
		30913,
		30913
	],
	"./00854-o-que-e-uma-supermalha-e-como-ela-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		41605,
		41605
	],
	"./00855-como-determinar-a-constante-de-tempo-em-circuitos-de-primeira-ordem.md": [
		60644,
		60644
	],
	"./00856-o-que-sao-circuitos-de-segunda-ordem-sub-amortecidos-e-super-amortecidos.md": [
		20244,
		20244
	],
	"./00857-como-determinar-a-amplitude-de-uma-corrente-em-um-circuito-de-corrente-alternada-usando-o-teorema-de-thevenin.md": [
		91752,
		91752
	],
	"./00858-o-que-e-um-circuito-trifasico-equilibrado-e-como-ele-funciona.md": [
		19836,
		19836
	],
	"./00859-o-que-e-um-filtro-passa-faixas-e-como-ele-funciona-em-circuitos-eletricos.md": [
		20196,
		20196
	],
	"./00860-qual-a-diferenca-entre-bjt-e-mosfet-em-circuitos-eletricos.md": [
		49375,
		49375
	],
	"./00861-o-que-e-um-oscilador-schmitt-trigger-e-como-ele-funciona.md": [
		16431,
		16431
	],
	"./00862-como-os-transistores-mos-sao-utilizados-em-circuitos-digitais-combinacionais.md": [
		5637,
		5637
	],
	"./00863-como-funciona-um-amplificador-emissor-comum.md": [
		91812,
		91812
	],
	"./00864-o-que-e-a-lei-das-tensoes-de-kirchhoff-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		94929,
		94929
	],
	"./00865-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		42766,
		42766
	],
	"./00866-como-aplicar-o-principio-da-superposicao-na-analise-de-circuitos.md": [
		70598,
		70598
	],
	"./00867-o-que-sao-circuitos-de-primeira-ordem-e-como-eles-funcionam.md": [
		79795,
		79795
	],
	"./00868-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-se-comportam.md": [
		63757,
		63757
	],
	"./00869-como-determinar-a-frequencia-de-ressonancia-em-um-circuito-rlc.md": [
		85350,
		85350
	],
	"./00870-qual-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		23614,
		23614
	],
	"./00871-o-que-e-a-transformada-de-laplace-e-como-ela-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		59471,
		59471
	],
	"./00872-como-funciona-um-diodo-em-um-circuito-eletrico.md": [
		89102,
		89102
	],
	"./00873-o-que-e-um-amplificador-operacional-e-como-ele-funciona-em-circuitos-analogicos.md": [
		65987,
		65987
	],
	"./00874-o-que-sao-circuitos-combinacionais-e-como-eles-diferem-dos-circuitos-sequenciais.md": [
		58813,
		58813
	],
	"./00875-como-funcionam-os-conversores-digitais-em-circuitos-eletricos.md": [
		98360,
		98360
	],
	"./00876-o-que-e-a-lei-de-ohm-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		11081,
		11081
	],
	"./00877-qual-a-diferenca-entre-um-diodo-e-um-transistor.md": [
		77053,
		77053
	],
	"./00878-como-determinar-a-resistencia-equivalente-em-um-circuito.md": [
		91358,
		91358
	],
	"./00879-como-obter-a-corrente-em-um-circuito-rc-de-primeira-ordem.md": [
		58300,
		58300
	],
	"./00880-o-que-e-uma-resposta-amortecida-em-circuitos-de-segunda-ordem.md": [
		84853,
		84853
	],
	"./00881-o-que-e-a-impedancia-em-circuitos-de-corrente-alternada.md": [
		4368,
		4368
	],
	"./00882-qual-a-diferenca-entre-sistemas-monofasicos-e-trifasicos.md": [
		91469,
		91469
	],
	"./00883-o-que-e-a-transformada-de-laplace-e-como-ela-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		32498,
		32498
	],
	"./00884-o-que-significa-um-transistor-bjt-estar-em-modo-saturado.md": [
		63393,
		63393
	],
	"./00885-o-que-e-um-circuito-biestavel-e-como-ele-funciona.md": [
		55539,
		55539
	],
	"./00886-como-os-flip-flops-sao-utilizados-em-circuitos-digitais.md": [
		5642,
		5642
	],
	"./00887-como-a-transformada-de-fourier-e-aplicada-em-circuitos-eletricos.md": [
		33962,
		33962
	],
	"./00888-o-que-e-um-no-em-um-circuito-eletrico.md": [
		8930,
		8930
	],
	"./00889-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		76756,
		76756
	],
	"./00890-o-que-e-o-teorema-de-thevenin-e-como-ele-simplifica-a-analise-de-circuitos.md": [
		75841,
		75841
	],
	"./00891-como-a-tensao-em-um-indutor-varia-ao-longo-do-tempo-em-um-circuito-de-primeira-ordem.md": [
		44018,
		44018
	],
	"./00892-o-que-e-um-circuito-rlc-criticamente-amortecido.md": [
		61666,
		61666
	],
	"./00893-o-que-e-a-potencia-em-circuitos-de-corrente-alternada-senoidal.md": [
		31843,
		31843
	],
	"./00894-qual-e-a-diferenca-entre-as-conexoes-estrela-triangulo-e-triangulo-triangulo-em-circuitos-trifasicos.md": [
		17378,
		17378
	],
	"./00895-como-a-transformada-de-fourier-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		38166,
		38166
	],
	"./00896-como-os-transistores-bjt-e-igbt-funcionam-em-circuitos-eletricos.md": [
		41848,
		41848
	],
	"./00897-como-funciona-um-multivibrador-astavel-utilizando-amplificadores-operacionais.md": [
		63928,
		63928
	],
	"./00898-como-os-mapas-de-karnaugh-simplificam-circuitos-logicos.md": [
		50260,
		50260
	],
	"./00899-como-funciona-um-bjt-em-um-circuito-rc-senoidal.md": [
		88508,
		88508
	],
	"./00900-o-que-e-a-lei-de-ohm-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		18027,
		18027
	],
	"./00901-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		43497,
		43497
	],
	"./00902-como-a-linearidade-dos-resistores-afeta-a-analise-basica-de-circuitos.md": [
		70358,
		70358
	],
	"./00903-como-determinar-a-corrente-em-um-circuito-rc-de-primeira-ordem.md": [
		11615,
		11615
	],
	"./00904-o-que-e-uma-resposta-sub-amortecida-em-circuitos-de-segunda-ordem.md": [
		67259,
		67259
	],
	"./00905-como-analisar-circuitos-em-serie-em-corrente-alternada.md": [
		60040,
		60040
	],
	"./00906-o-que-e-um-circuito-trifasico-equilibrado-e-como-ele-funciona.md": [
		21540,
		21540
	],
	"./00907-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-em-serie.md": [
		3387,
		3387
	],
	"./00908-como-funciona-a-saturacao-em-um-transistor-bjt.md": [
		64053,
		64053
	],
	"./00909-como-funciona-a-implementacao-de-um-multivibrador-em-circuitos-analogicos.md": [
		73859,
		73859
	],
	"./00910-o-que-sao-circuitos-sequenciais-e-como-eles-diferem-dos-circuitos-combinacionais.md": [
		60494,
		60494
	],
	"./00911-o-que-e-um-filtro-rc-e-como-ele-funciona-em-circuitos-eletricos.md": [
		74531,
		74531
	],
	"./00912-o-que-e-uma-associacao-em-paralelo-de-resistores.md": [
		53229,
		53229
	],
	"./00913-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		96180,
		96180
	],
	"./00914-o-que-e-o-teorema-de-thevenin-e-como-ele-e-aplicado-na-analise-de-circuitos.md": [
		32376,
		32376
	],
	"./00915-o-que-acontece-com-a-tensao-em-um-capacitor-quando-uma-fonte-e-comutada-em-um-circuito-de-primeira-ordem.md": [
		51034,
		51034
	],
	"./00916-o-que-e-uma-resposta-sub-amortecida-em-circuitos-de-segunda-ordem.md": [
		20708,
		20708
	],
	"./00917-o-que-e-a-corrente-eficaz-rms-em-circuitos-de-corrente-alternada.md": [
		61509,
		61509
	],
	"./00918-qual-e-a-diferenca-entre-as-conexoes-triangulo-triangulo-e-triangulo-estrela-em-circuitos-trifasicos.md": [
		54083,
		54083
	],
	"./00919-como-a-transformada-de-fourier-e-aplicada-na-analise-de-circuitos-rlc.md": [
		19032,
		19032
	],
	"./00920-qual-a-diferenca-entre-mosfet-e-igbt.md": [
		40734,
		40734
	],
	"./00921-como-funciona-um-amplificador-operacional-em-um-circuito-analogico.md": [
		19545,
		19545
	],
	"./00922-como-funciona-um-latch-em-circuitos-digitais.md": [
		19564,
		19564
	],
	"./00923-como-configurar-um-amplificador-operacional-em-um-circuito-analogico.md": [
		10848,
		10848
	],
	"./00924-o-que-e-a-divisao-de-tensao-em-um-circuito-eletrico.md": [
		47827,
		47827
	],
	"./00925-o-que-e-um-transistor-e-qual-a-sua-funcao-em-um-circuito-eletrico.md": [
		10455,
		10455
	],
	"./00926-o-que-e-uma-supermalha-e-como-ela-e-utilizada-na-analise-de-circuitos.md": [
		87494,
		87494
	],
	"./00927-como-os-circuitos-rc-e-rl-respondem-a-uma-fonte-de-tensao.md": [
		15555,
		15555
	],
	"./00928-o-que-e-uma-resposta-criticamente-amortecida-em-circuitos-de-segunda-ordem.md": [
		62111,
		62111
	],
	"./00929-como-o-teorema-da-transferencia-maxima-de-potencia-se-aplica-em-circuitos-de-corrente-alternada.md": [
		6802,
		6802
	],
	"./00930-qual-e-a-diferenca-entre-a-conexao-triangulo-e-estrela-em-circuitos-trifasicos.md": [
		55279,
		55279
	],
	"./00931-o-que-e-a-transformada-de-laplace-e-como-ela-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		24832,
		24832
	],
	"./00932-como-funciona-a-regiao-de-saturacao-em-um-mosfet.md": [
		93654,
		93654
	],
	"./00933-como-funciona-a-operacao-de-um-amplificador-bjt-em-circuitos-analogicos.md": [
		40407,
		40407
	],
	"./00934-qual-e-a-diferenca-entre-circuitos-combinacionais-e-sequenciais.md": [
		91370,
		91370
	],
	"./00935-o-que-e-um-circuito-rlc-em-serie-e-como-ele-funciona.md": [
		6817,
		6817
	],
	"./00936-o-que-e-um-curto-circuito-e-como-ele-afeta-um-circuito-eletrico.md": [
		63331,
		85712
	],
	"./00937-qual-a-funcao-de-um-indutor-em-um-circuito-eletrico.md": [
		48604,
		48604
	],
	"./00938-como-funciona-o-principio-da-superposicao-em-circuitos-eletricos.md": [
		31557,
		31557
	],
	"./00939-como-a-tensao-se-comporta-em-um-circuito-rc-durante-a-carga-e-descarga.md": [
		80911,
		80911
	],
	"./00940-como-determinar-a-resposta-amortecida-em-circuitos-de-segunda-ordem.md": [
		8711,
		8711
	],
	"./00941-o-que-e-um-fasor-e-como-ele-e-utilizado-em-circuitos-de-corrente-alternada.md": [
		48766,
		48766
	],
	"./00942-qual-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		69960,
		69960
	],
	"./00943-como-analisar-circuitos-com-fontes-de-tensao-em-rampa.md": [
		60931,
		60931
	],
	"./00944-como-funcionam-os-transistores-igbt-e-hemt-em-circuitos-eletricos.md": [
		28876,
		28876
	],
	"./00945-como-funciona-um-oscilador-de-wien-em-circuitos-analogicos.md": [
		81395,
		81395
	],
	"./00946-como-converter-um-numero-decimal-para-binario-e-vice-versa.md": [
		12649,
		12649
	],
	"./00947-como-funciona-a-conversao-de-sinais-analogicos-para-digitais-usando-um-conversor-r2r.md": [
		36750,
		36750
	],
	"./00948-o-que-e-um-no-em-um-circuito-eletrico.md": [
		84661,
		84661
	],
	"./00949-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		13229,
		13229
	],
	"./00950-como-a-superposicao-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		18216,
		18216
	],
	"./00951-como-a-associacao-de-indutores-afeta-a-corrente-em-um-circuito-de-primeira-ordem.md": [
		92321,
		92321
	],
	"./00952-o-que-sao-circuitos-de-segunda-ordem-e-como-diferenciar-os-casos-sub-amortecido-e-super-amortecido.md": [
		87408,
		87408
	],
	"./00953-como-aplicar-o-teorema-de-thevenin-em-circuitos-de-corrente-alternada.md": [
		58734,
		58734
	],
	"./00954-qual-a-diferenca-entre-a-conexao-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		2619,
		2619
	],
	"./00955-o-que-e-a-transformada-de-laplace-e-como-ela-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		56918,
		56918
	],
	"./00956-como-funcionam-os-dispositivos-semicondutores-em-circuitos-eletricos.md": [
		11889,
		11889
	],
	"./00957-o-que-e-um-oscilador-de-wien-e-como-ele-funciona-em-circuitos-analogicos.md": [
		55075,
		55075
	],
	"./00958-como-funciona-a-simplificacao-de-circuitos-digitais-usando-o-mapa-de-karnaugh.md": [
		9218,
		9218
	],
	"./00959-como-a-tensao-senoidal-afeta-os-componentes-em-um-circuito-eletrico.md": [
		49775,
		49775
	],
	"./00960-o-que-e-um-ramo-em-um-circuito-eletrico.md": [
		35413,
		35413
	],
	"./00961-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		43583,
		43583
	],
	"./00962-o-que-e-a-transferencia-maxima-de-potencia-em-circuitos-eletricos.md": [
		6485,
		6485
	],
	"./00963-o-que-acontece-em-um-circuito-rc-de-primeira-ordem-quando-a-chave-e-comutada.md": [
		45004,
		45004
	],
	"./00964-o-que-e-a-continuidade-em-circuitos-de-segunda-ordem.md": [
		65876,
		65876
	],
	"./00965-o-que-e-impedancia-em-circuitos-de-corrente-alternada.md": [
		18831,
		18831
	],
	"./00966-o-que-e-um-circuito-trifasico-equilibrado-e-qual-sua-importancia.md": [
		76190,
		76190
	],
	"./00967-o-que-e-a-transformada-de-laplace-e-como-ela-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		99275,
		99275
	],
	"./00968-como-funciona-a-juncao-pn-em-um-jfet-saturado.md": [
		41382,
		41382
	],
	"./00969-como-os-amplificadores-operacionais-funcionam-em-circuitos-ac-e-dc.md": [
		39191,
		39191
	],
	"./00970-como-os-transistores-mos-sao-utilizados-na-implementacao-de-circuitos-logicos.md": [
		1398,
		1398
	],
	"./00971-como-funciona-um-conversor-r2r-em-um-circuito-combinacional.md": [
		59929,
		59929
	],
	"./00972-como-funciona-a-associacao-de-resistores-em-serie-e-paralelo.md": [
		88727,
		88727
	],
	"./00973-qual-e-a-funcao-de-um-diodo-em-um-circuito-eletrico.md": [
		38774,
		38774
	],
	"./00974-como-funciona-a-analise-nodal-em-circuitos-eletricos.md": [
		39954,
		39954
	],
	"./00975-como-a-tensao-se-comporta-em-um-circuito-rc-de-primeira-ordem.md": [
		8313,
		8313
	],
	"./00976-o-que-e-um-circuito-rlc-sub-amortecido.md": [
		58991,
		58991
	],
	"./00977-o-que-e-a-admitancia-em-circuitos-de-corrente-alternada.md": [
		60124,
		60124
	],
	"./00978-o-que-e-a-conexao-estrela-triangulo-em-circuitos-trifasicos-e-onde-ela-e-usada.md": [
		19405,
		19405
	],
	"./00979-como-a-transformada-de-laplace-e-aplicada-na-analise-avancada-de-circuitos.md": [
		17160,
		17160
	],
	"./00980-como-determinar-se-um-bjt-esta-em-saturacao.md": [
		7955,
		30336
	],
	"./00981-como-funciona-um-amplificador-operacional-em-um-circuito-analogico.md": [
		69267,
		69267
	],
	"./00982-como-as-portas-logicas-combinacionais-processam-expressoes-booleanas.md": [
		60751,
		60751
	],
	"./00983-o-que-e-o-regime-permanente-em-circuitos-eletricos.md": [
		84076,
		61695
	],
	"./00984-o-que-e-um-no-em-um-circuito-eletrico.md": [
		66709,
		66709
	],
	"./00985-como-os-diodos-funcionam-em-circuitos-eletricos.md": [
		82128,
		82128
	],
	"./00986-o-que-e-o-metodo-da-superposicao-na-analise-de-circuitos-eletricos.md": [
		28089,
		28089
	],
	"./00987-como-os-capacitores-e-indutores-afetam-o-comportamento-de-circuitos-de-primeira-ordem.md": [
		82879,
		82879
	],
	"./00988-como-a-continuidade-da-corrente-afeta-circuitos-de-segunda-ordem.md": [
		76121,
		76121
	],
	"./00989-o-que-e-a-potencia-complexa-em-circuitos-de-corrente-alternada.md": [
		50177,
		50177
	],
	"./00990-qual-a-diferenca-entre-sistemas-monofasicos-e-trifasicos.md": [
		96113,
		96113
	],
	"./00991-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-passivos.md": [
		95201,
		95201
	],
	"./00992-qual-a-diferenca-entre-um-transistor-hemt-e-um-transistor-bjt.md": [
		54615,
		54615
	],
	"./00993-como-os-filtros-analogicos-afetam-a-resposta-em-frequencia-de-um-sinal.md": [
		26283,
		26283
	],
	"./00994-como-funcionam-os-flip-flops-em-circuitos-digitais.md": [
		18790,
		18790
	],
	"./00995-como-a-configuracao-de-um-dac-afeta-a-tensao-de-saida-em-um-sinal-senoidal.md": [
		4222,
		4222
	],
	"./00996-o-que-e-uma-associacao-em-serie-de-resistores-e-como-ela-funciona.md": [
		69143,
		69143
	],
	"./00997-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		84704,
		84704
	],
	"./00998-o-que-e-a-linearidade-em-circuitos-eletricos-e-como-ela-afeta-a-analise-nodal.md": [
		49577,
		71958
	],
	"./00999-o-que-e-um-circuito-rc-de-primeira-ordem-e-como-ele-armazena-energia.md": [
		54421,
		54421
	],
	"./01000-como-a-continuidade-de-corrente-e-tensao-afeta-circuitos-rlc-em-paralelo.md": [
		85916,
		85916
	],
	"./01001-o-que-e-admitancia-em-circuitos-de-corrente-alternada.md": [
		58717,
		58717
	],
	"./01002-qual-e-a-diferenca-entre-as-conexoes-triangulo-e-estrela-em-circuitos-trifasicos.md": [
		94052,
		94052
	],
	"./01003-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		75024,
		75024
	],
	"./01004-qual-a-diferenca-entre-mosfet-e-mesfet-em-circuitos-semicondutores.md": [
		9320,
		9320
	],
	"./01005-como-funciona-um-multivibrador-astavel-utilizando-bjt.md": [
		67147,
		67147
	],
	"./01006-como-as-portas-logicas-sao-implementadas-em-circuitos-digitais.md": [
		48545,
		48545
	],
	"./01007-o-que-e-um-conversor-e-qual-a-sua-importancia-em-circuitos-eletricos.md": [
		12545,
		12545
	],
	"./01008-o-que-e-um-curto-circuito-e-como-ele-ocorre-em-um-circuito-eletrico-simples.md": [
		62987,
		62987
	],
	"./01009-o-que-e-um-capacitor-e-como-ele-funciona-em-um-circuito-eletrico.md": [
		63279,
		63279
	],
	"./01010-como-a-teoria-de-thevenin-e-aplicada-na-analise-de-circuitos.md": [
		7106,
		7106
	],
	"./01011-como-a-energia-e-armazenada-em-circuitos-rc-e-rl.md": [
		78857,
		78857
	],
	"./01012-o-que-e-uma-resposta-sub-amortecida-em-circuitos-de-segunda-ordem.md": [
		2906,
		2906
	],
	"./01013-como-determinar-a-potencia-em-um-circuito-de-corrente-alternada.md": [
		45617,
		45617
	],
	"./01014-qual-a-diferenca-entre-circuitos-monofasicos-e-trifasicos.md": [
		84597,
		84597
	],
	"./01015-como-funciona-um-filtro-passa-faixas-em-circuitos-eletricos.md": [
		13690,
		13690
	],
	"./01016-como-o-diodo-se-comporta-em-um-circuito-com-fonte-de-tensao-e-resistor.md": [
		72357,
		72357
	],
	"./01017-o-que-e-um-circuito-schmitt-trigger-e-como-ele-funciona.md": [
		46941,
		46941
	],
	"./01018-qual-e-a-diferenca-entre-circuitos-combinacionais-e-sequenciais.md": [
		20970,
		20970
	],
	"./01019-o-que-e-a-resposta-em-regime-permanente-em-circuitos-rlc.md": [
		73905,
		73905
	],
	"./01020-o-que-e-um-ramo-em-um-circuito-eletrico.md": [
		89171,
		89171
	],
	"./01021-o-que-e-um-capacitor-e-qual-a-sua-funcao-em-um-circuito-eletrico.md": [
		68236,
		68236
	],
	"./01022-como-a-transferencia-de-potencia-e-analisada-em-circuitos-eletricos.md": [
		98937,
		98937
	],
	"./01023-como-a-comutacao-afeta-a-energia-armazenada-em-um-circuito-rl.md": [
		97035,
		97035
	],
	"./01024-o-que-e-uma-resposta-super-amortecida-em-circuitos-de-segunda-ordem.md": [
		79156,
		79156
	],
	"./01025-o-que-e-a-defasagem-em-circuitos-de-corrente-alternada.md": [
		3489,
		3489
	],
	"./01026-o-que-e-um-circuito-trifasico-equilibrado-e-onde-ele-e-usado.md": [
		42811,
		42811
	],
	"./01027-o-que-e-um-filtro-passa-faixas-e-como-ele-e-utilizado-na-analise-de-circuitos.md": [
		63218,
		63218
	],
	"./01028-qual-a-diferenca-entre-um-transistor-jfet-e-um-mesfet.md": [
		86159,
		86159
	],
	"./01029-o-que-e-um-filtro-passa-baixa-e-como-ele-funciona-em-circuitos-analogicos.md": [
		991,
		991
	],
	"./01030-como-os-mapas-de-karnaugh-sao-utilizados-na-simplificacao-de-expressoes-logicas-em-circuitos-digitais.md": [
		90326,
		90326
	],
	"./01031-como-funciona-um-transistor-bjt-em-um-circuito-serie.md": [
		53578,
		31197
	],
	"./01032-o-que-e-a-lei-de-ohm-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		10306,
		10306
	],
	"./01033-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		87504,
		87504
	],
	"./01034-o-que-e-uma-supermalha-e-como-ela-e-utilizada-na-analise-de-circuitos.md": [
		26203,
		26203
	],
	"./01035-como-a-energia-armazenada-em-um-indutor-varia-em-circuitos-de-primeira-ordem.md": [
		18626,
		18626
	],
	"./01036-o-que-e-um-circuito-super-amortecido-e-como-ele-se-comporta.md": [
		93395,
		93395
	],
	"./01037-como-aplicar-o-teorema-de-thevenin-em-circuitos-de-corrente-alternada.md": [
		61402,
		61402
	],
	"./01038-o-que-e-um-circuito-trifasico-triangulo-estrela-e-como-ele-funciona.md": [
		74200,
		74200
	],
	"./01039-como-a-transformada-inversa-de-laplace-e-aplicada-na-analise-de-circuitos-rlc.md": [
		20803,
		20803
	],
	"./01040-qual-a-diferenca-entre-jfet-bjt-e-mosfet-em-circuitos-eletricos.md": [
		16654,
		16654
	],
	"./01041-como-funciona-um-amplificador-operacional-em-circuitos-analogicos.md": [
		65052,
		65052
	],
	"./01042-como-funciona-a-simplificacao-de-circuitos-combinacionais-usando-o-mapa-de-karnaugh.md": [
		32580,
		32580
	],
	"./01043-qual-a-diferenca-entre-sinais-analogicos-e-digitais-em-circuitos-eletricos.md": [
		66123,
		66123
	],
	"./01044-o-que-e-um-no-em-um-circuito-eletrico.md": [
		13783,
		13783
	],
	"./01045-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		76587,
		76587
	],
	"./01046-como-a-linearidade-afeta-a-analise-de-circuitos-eletricos.md": [
		61730,
		61730
	],
	"./01047-como-ocorre-a-descarga-de-um-indutor-em-um-circuito-de-primeira-ordem.md": [
		37037,
		37037
	],
	"./01048-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-se-comportam.md": [
		96242,
		96242
	],
	"./01049-o-que-e-o-regime-permanente-em-circuitos-rlc-em-corrente-alternada.md": [
		41566,
		41566
	],
	"./01050-o-que-e-um-sistema-trifasico-equilibrado-e-como-ele-se-diferencia-das-conexoes-estrela-e-triangulo.md": [
		20982,
		20982
	],
	"./01051-como-a-transformada-de-fourier-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		27729,
		27729
	],
	"./01052-como-funciona-a-juncao-pn-em-semicondutores.md": [
		90515,
		90515
	],
	"./01053-o-que-e-um-circuito-astavel-e-como-ele-funciona.md": [
		37974,
		37974
	],
	"./01054-como-converter-uma-expressao-logica-em-um-circuito-cmos.md": [
		31115,
		31115
	],
	"./01055-como-funciona-a-configuracao-de-um-amplificador-em-um-circuito-digital-ttl.md": [
		74588,
		74588
	],
	"./01056-o-que-e-um-no-em-um-circuito-eletrico.md": [
		59208,
		59208
	],
	"./01057-qual-a-diferenca-entre-componentes-eletronicos-lineares-e-nao-lineares.md": [
		7709,
		7709
	],
	"./01058-o-que-e-a-analise-nodal-em-circuitos-eletricos.md": [
		58589,
		58589
	],
	"./01059-como-a-energia-armazenada-em-um-capacitor-varia-ao-longo-do-tempo-em-um-circuito-rl.md": [
		79049,
		79049
	],
	"./01060-como-a-continuidade-da-tensao-afeta-a-resposta-de-circuitos-de-segunda-ordem.md": [
		34865,
		34865
	],
	"./01061-o-que-e-a-transferencia-de-potencia-maxima-em-circuitos-de-corrente-alternada.md": [
		50185,
		50185
	],
	"./01062-qual-e-a-diferenca-entre-as-conexoes-triangulo-e-estrela-em-circuitos-trifasicos.md": [
		37722,
		37722
	],
	"./01063-como-o-teorema-da-superposicao-e-aplicado-em-circuitos-com-fontes-dependentes.md": [
		18690,
		18690
	],
	"./01064-o-que-e-um-diodo-de-juncao-e-como-ele-funciona-em-um-circuito-eletrico.md": [
		19488,
		19488
	],
	"./01065-o-que-e-um-amplificador-biestavel-e-como-ele-funciona-em-circuitos-analogicos.md": [
		62743,
		62743
	],
	"./01066-como-os-circuitos-digitais-interpretam-numeros-binarios.md": [
		97455,
		97455
	],
	"./01067-como-funciona-um-amplificador-em-um-circuito-eletrico.md": [
		73343,
		73343
	],
	"./01068-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		86550,
		86550
	],
	"./01069-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		85173,
		85173
	],
	"./01070-como-a-transformacao-de-fontes-facilita-a-analise-de-circuitos-eletricos.md": [
		87469,
		87469
	],
	"./01071-como-a-energia-armazenada-em-um-circuito-de-primeira-ordem-varia-com-o-tempo.md": [
		91182,
		91182
	],
	"./01072-qual-a-diferenca-entre-uma-resposta-sub-amortecida-e-uma-super-amortecida-em-circuitos-de-segunda-ordem.md": [
		90951,
		90951
	],
	"./01073-o-que-e-impedancia-em-circuitos-de-corrente-alternada.md": [
		57406,
		57406
	],
	"./01074-o-que-e-a-conexao-triangulo-estrela-em-circuitos-trifasicos.md": [
		4440,
		4440
	],
	"./01075-como-o-teorema-da-superposicao-e-aplicado-na-analise-de-circuitos-eletricos.md": [
		32317,
		32317
	],
	"./01076-como-funciona-o-modelo-equivalente-de-um-mosfet-em-circuitos-eletricos.md": [
		33784,
		33784
	],
	"./01077-como-funciona-um-circuito-astavel-em-circuitos-analogicos.md": [
		13577,
		13577
	],
	"./01078-o-que-e-um-latch-e-como-ele-funciona-em-circuitos-digitais.md": [
		68578,
		68578
	],
	"./01079-o-que-e-um-trigger-em-circuitos-logicos.md": [
		7895,
		7895
	],
	"./01080-o-que-e-um-no-em-um-circuito-eletrico.md": [
		89815,
		89815
	],
	"./01081-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		55595,
		55595
	],
	"./01082-o-que-e-um-no-em-um-circuito-eletrico-e-qual-sua-importancia-na-analise-de-circuitos.md": [
		21251,
		21251
	],
	"./01083-como-a-energia-e-armazenada-em-um-circuito-rl-de-primeira-ordem.md": [
		618,
		618
	],
	"./01084-o-que-e-um-circuito-super-amortecido-e-como-ele-se-comporta.md": [
		49030,
		49030
	],
	"./01085-o-que-e-admitancia-em-circuitos-rlc-em-corrente-alternada.md": [
		23944,
		23944
	],
	"./01086-o-que-sao-conexoes-estrela-triangulo-e-triangulo-triangulo-em-circuitos-trifasicos.md": [
		26758,
		26758
	],
	"./01087-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		9718,
		9718
	],
	"./01088-qual-a-diferenca-entre-mosfet-e-mesfet-em-circuitos-semicondutores.md": [
		51396,
		51396
	],
	"./01089-o-que-e-a-ponte-de-wien-e-como-ela-funciona-em-circuitos-analogicos.md": [
		4837,
		4837
	],
	"./01090-como-implementar-um-circuito-sequencial-usando-mapas-de-karnaugh.md": [
		24013,
		24013
	],
	"./01091-o-que-e-um-trigger-e-como-ele-e-utilizado-em-circuitos-eletricos.md": [
		23903,
		23903
	],
	"./01092-o-que-e-um-circuito-em-serie-e-como-ele-funciona.md": [
		85012,
		85012
	],
	"./01093-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		54730,
		54730
	],
	"./01094-o-que-e-o-teorema-de-thevenin-e-como-ele-pode-ser-aplicado-na-analise-de-circuitos.md": [
		87188,
		87188
	],
	"./01095-como-a-corrente-em-um-indutor-varia-ao-longo-do-tempo-em-um-circuito-de-primeira-ordem.md": [
		62607,
		62607
	],
	"./01096-o-que-e-uma-resposta-sub-amortecida-em-circuitos-de-segunda-ordem.md": [
		91734,
		91734
	],
	"./01097-como-funciona-a-transferencia-de-potencia-maxima-em-circuitos-de-corrente-alternada.md": [
		22585,
		22585
	],
	"./01098-qual-a-diferenca-entre-a-conexao-triangulo-e-estrela-em-circuitos-trifasicos.md": [
		23465,
		23465
	],
	"./01099-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-passa-faixas.md": [
		32240,
		32240
	],
	"./01100-como-funciona-a-juncao-pn-em-semicondutores.md": [
		81223,
		81223
	],
	"./01101-como-funcionam-os-amplificadores-operacionais-em-circuitos-analogicos.md": [
		15156,
		15156
	],
	"./01102-o-que-e-um-flip-flop-e-como-ele-funciona-em-circuitos-digitais.md": [
		48125,
		48125
	],
	"./01103-qual-a-importancia-da-medida-de-tensao-em-circuitos-ttl.md": [
		10883,
		10883
	],
	"./01104-o-que-e-a-lei-de-kirchhoff-das-correntes-lkc-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		14778,
		14778
	],
	"./01105-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		36742,
		36742
	],
	"./01106-o-que-e-uma-supermalha-em-circuitos-eletricos.md": [
		74371,
		74371
	],
	"./01107-o-que-e-um-circuito-rl-de-primeira-ordem-e-como-ele-funciona.md": [
		97066,
		97066
	],
	"./01108-o-que-e-uma-resposta-criticamente-amortecida-em-circuitos-de-segunda-ordem.md": [
		910,
		910
	],
	"./01109-o-que-e-a-admitancia-em-circuitos-de-corrente-alternada.md": [
		85480,
		85480
	],
	"./01110-qual-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		87578,
		87578
	],
	"./01111-o-que-e-o-teorema-de-parseval-e-como-ele-se-aplica-na-analise-de-circuitos-eletricos.md": [
		75916,
		75916
	],
	"./01112-como-funciona-um-transistor-em-um-circuito-eletrico.md": [
		85982,
		85982
	],
	"./01113-o-que-e-um-oscilador-em-circuitos-analogicos-e-como-ele-funciona.md": [
		73812,
		73812
	],
	"./01114-como-implementar-uma-funcao-booleana-usando-portas-logicas.md": [
		62566,
		62566
	],
	"./01115-o-que-e-um-circuito-schmitt-e-como-ele-funciona-em-um-regime-permanente.md": [
		77465,
		77465
	],
	"./01116-o-que-e-um-no-em-um-circuito-eletrico.md": [
		44439,
		44439
	],
	"./01117-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		93895,
		93895
	],
	"./01118-o-que-e-um-no-em-um-circuito-eletrico-e-qual-sua-importancia-na-analise-de-circuitos.md": [
		87839,
		87839
	],
	"./01119-como-determinar-a-constante-de-tempo-em-um-circuito-rc-de-primeira-ordem.md": [
		72628,
		72628
	],
	"./01120-o-que-e-uma-constante-de-tempo-em-circuitos-de-segunda-ordem.md": [
		47811,
		47811
	],
	"./01121-o-que-e-a-impedancia-em-um-circuito-de-corrente-alternada.md": [
		88812,
		88812
	],
	"./01122-qual-a-diferenca-entre-circuitos-monofasicos-e-trifasicos.md": [
		50019,
		50019
	],
	"./01123-o-que-e-a-transformada-de-fourier-e-como-ela-e-utilizada-na-analise-avancada-de-circuitos-eletricos.md": [
		64850,
		64850
	],
	"./01124-qual-e-a-diferenca-entre-um-igbt-e-um-transistor-bipolar.md": [
		86280,
		86280
	],
	"./01125-como-funcionam-os-filtros-passivos-em-circuitos-analogicos.md": [
		6441,
		6441
	],
	"./01126-como-utilizar-o-mapa-de-karnaugh-para-simplificacao-de-circuitos-digitais.md": [
		29365,
		29365
	],
	"./01127-como-funciona-a-montagem-de-um-conversor-r2r-em-circuitos-eletricos.md": [
		39781,
		39781
	],
	"./01128-o-que-e-a-unidade-de-carga-eletrica-e-por-que-ela-e-importante-em-circuitos-eletricos.md": [
		35275,
		35275
	],
	"./01129-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		7504,
		7504
	],
	"./01130-como-a-linearidade-afeta-a-analise-de-circuitos-eletricos.md": [
		78732,
		78732
	],
	"./01131-como-ocorre-a-descarga-de-um-capacitor-em-um-circuito-rc.md": [
		87290,
		87290
	],
	"./01132-o-que-e-um-circuito-de-segunda-ordem-criticamente-amortecido.md": [
		9296,
		9296
	],
	"./01133-o-que-e-o-valor-eficaz-em-circuitos-de-corrente-alternada.md": [
		22335,
		22335
	],
	"./01134-o-que-e-um-circuito-trifasico-equilibrado-e-como-ele-e-usado.md": [
		83095,
		83095
	],
	"./01135-o-que-e-a-resposta-ao-degrau-em-um-circuito-eletrico.md": [
		97849,
		97849
	],
	"./01136-como-os-transistores-mosfet-funcionam-em-circuitos-eletricos.md": [
		76161,
		76161
	],
	"./01137-o-que-e-um-circuito-schmitt-trigger-e-qual-sua-importancia-em-circuitos-analogicos.md": [
		22806,
		22806
	],
	"./01138-como-converter-um-numero-decimal-para-binario-em-circuitos-digitais.md": [
		17689,
		17689
	],
	"./01139-como-a-serie-de-fourier-e-aplicada-em-circuitos-rc.md": [
		94566,
		94566
	],
	"./01140-o-que-e-um-curto-circuito-e-como-ele-ocorre-em-um-circuito-eletrico.md": [
		70334,
		70334
	],
	"./01141-como-funcionam-os-capacitores-em-circuitos-eletricos.md": [
		33471,
		33471
	],
	"./01142-como-aplicar-o-teorema-de-thevenin-na-analise-de-circuitos.md": [
		51502,
		51502
	],
	"./01143-como-a-comutacao-afeta-a-tensao-em-um-circuito-rc-de-primeira-ordem.md": [
		17440,
		95059
	],
	"./01144-o-que-e-uma-resposta-sub-amortecida-em-circuitos-de-segunda-ordem.md": [
		40682,
		40682
	],
	"./01145-o-que-e-a-corrente-eficaz-em-um-circuito-rlc.md": [
		73738,
		73738
	],
	"./01146-o-que-e-um-circuito-trifasico-equilibrado.md": [
		59223,
		59223
	],
	"./01147-como-o-teorema-de-laplace-e-aplicado-na-analise-de-circuitos-eletricos.md": [
		55480,
		33099
	],
	"./01148-como-funciona-um-diodo-semicondutor.md": [
		26487,
		26487
	],
	"./01149-o-que-e-um-circuito-astavel-e-como-ele-funciona.md": [
		12166,
		12166
	],
	"./01150-como-funcionam-os-circuitos-cmos-em-circuitos-digitais.md": [
		83647,
		83647
	],
	"./01151-o-que-e-um-circuito-rc-e-como-ele-funciona-em-um-regime-de-alto-emissor.md": [
		96526,
		74145
	],
	"./01152-o-que-e-um-no-em-um-circuito-eletrico.md": [
		81959,
		81959
	],
	"./01153-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		61563,
		61563
	],
	"./01154-o-que-e-o-teorema-de-norton-e-como-ele-e-aplicado-na-analise-de-circuitos.md": [
		91834,
		91834
	],
	"./01155-o-que-acontece-com-a-corrente-em-um-indutor-quando-uma-fonte-e-comutada.md": [
		67185,
		67185
	],
	"./01156-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-se-comportam.md": [
		16650,
		16650
	],
	"./01157-o-que-e-admitancia-em-um-circuito-em-corrente-alternada.md": [
		60982,
		60982
	],
	"./01158-qual-e-a-diferenca-entre-a-conexao-em-triangulo-e-estrela-em-circuitos-trifasicos.md": [
		61841,
		61841
	],
	"./01159-o-que-e-a-transformada-de-fourier-e-como-ela-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		67105,
		67105
	],
	"./01160-como-funcionam-os-dispositivos-semicondutores-em-circuitos-eletricos.md": [
		33617,
		33617
	],
	"./01161-o-que-e-um-multivibrador-e-como-ele-opera-em-circuitos-analogicos.md": [
		87959,
		87959
	],
	"./01162-como-os-mapas-de-karnaugh-simplificam-expressoes-booleanas.md": [
		40655,
		40655
	],
	"./01163-como-configurar-um-circuito-digital-basico-em-um-laboratorio-de-engenharia.md": [
		35802,
		35802
	],
	"./01164-o-que-acontece-com-a-potencia-dissipada-em-um-circuito-aberto.md": [
		68097,
		68097
	],
	"./01165-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		76604,
		76604
	],
	"./01166-como-verificar-a-corrente-em-um-no-usando-o-teorema-de-superposicao.md": [
		13219,
		13219
	],
	"./01167-como-a-energia-e-armazenada-em-um-circuito-rl-de-primeira-ordem.md": [
		35611,
		35611
	],
	"./01168-o-que-e-uma-resposta-super-amortecida-em-circuitos-de-segunda-ordem.md": [
		49835,
		49835
	],
	"./01169-o-que-e-um-fasor-e-como-ele-e-utilizado-em-circuitos-de-corrente-alternada.md": [
		43811,
		43811
	],
	"./01170-o-que-e-uma-conexao-triangulo-triangulo-em-circuitos-trifasicos.md": [
		62992,
		62992
	],
	"./01171-como-a-funcao-exponencial-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		84700,
		84700
	],
	"./01172-o-que-e-um-diodo-de-juncao-e-como-ele-funciona.md": [
		13659,
		13659
	],
	"./01173-como-funciona-um-oscilador-de-ponte-de-wien-em-circuitos-analogicos.md": [
		85940,
		85940
	],
	"./01174-como-simplificar-circuitos-combinacionais-usando-algebra-booleana.md": [
		74400,
		74400
	],
	"./01175-o-que-e-um-circuito-schmitt-trigger-e-qual-sua-aplicacao-em-sistemas-digitais.md": [
		85846,
		63465
	],
	"./01176-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		79726,
		79726
	],
	"./01177-o-que-sao-componentes-eletronicos-ativos-e-passivos.md": [
		72790,
		72790
	],
	"./01178-o-que-e-o-teorema-da-transferencia-de-potencia-maxima-em-circuitos-eletricos.md": [
		47359,
		47359
	],
	"./01179-como-a-energia-armazenada-em-um-capacitor-e-afetada-em-circuitos-de-primeira-ordem.md": [
		83633,
		83633
	],
	"./01180-como-determinar-a-resposta-de-um-circuito-rlc-subamortecido.md": [
		73249,
		73249
	],
	"./01181-o-que-e-a-potencia-eficaz-em-circuitos-rlc.md": [
		93039,
		93039
	],
	"./01182-o-que-e-uma-conexao-triangulo-triangulo-em-circuitos-trifasicos.md": [
		37045,
		37045
	],
	"./01183-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		83303,
		83303
	],
	"./01184-como-funciona-a-juncao-pn-em-um-diodo-semicondutor.md": [
		88166,
		88166
	],
	"./01185-como-funciona-um-oscilador-de-wien-em-circuitos-analogicos.md": [
		36664,
		36664
	],
	"./01186-qual-a-diferenca-entre-circuitos-combinacionais-e-sequenciais.md": [
		52200,
		52200
	],
	"./01187-como-montar-um-filtro-logico-ttl-em-um-circuito-eletrico.md": [
		95728,
		95728
	],
	"./01188-o-que-e-uma-associacao-em-serie-de-resistores.md": [
		62063,
		62063
	],
	"./01189-qual-a-funcao-de-um-capacitor-em-um-circuito-eletrico.md": [
		65317,
		65317
	],
	"./01190-o-que-e-a-transferencia-de-potencia-maxima-em-um-circuito-eletrico.md": [
		96658,
		96658
	],
	"./01191-o-que-acontece-com-a-corrente-em-um-indutor-quando-um-circuito-de-primeira-ordem-e-comutado.md": [
		15988,
		15988
	],
	"./01192-o-que-e-um-circuito-de-segunda-ordem-e-quais-sao-seus-tipos.md": [
		94880,
		94880
	],
	"./01193-qual-e-a-diferenca-entre-valor-eficaz-rms-e-amplitude-em-circuitos-de-corrente-alternada.md": [
		64953,
		64953
	],
	"./01194-o-que-e-uma-conexao-triangulo-estrela-em-circuitos-trifasicos.md": [
		84071,
		84071
	],
	"./01195-o-que-e-um-filtro-passa-baixa-e-como-ele-funciona-em-circuitos-eletricos.md": [
		48721,
		48721
	],
	"./01196-como-funciona-o-modelo-equivalente-de-dois-transistores-em-um-hbt.md": [
		35796,
		35796
	],
	"./01197-o-que-e-um-circuito-biestavel-e-como-ele-funciona.md": [
		62238,
		62238
	],
	"./01198-o-que-sao-circuitos-sequenciais-e-como-eles-diferem-dos-circuitos-combinacionais.md": [
		55877,
		55877
	],
	"./01199-como-funciona-um-amplificador-operacional-em-um-circuito-rc.md": [
		77359,
		77359
	],
	"./01200-o-que-e-uma-associacao-em-serie-de-resistores.md": [
		85366,
		85366
	],
	"./01201-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		88657,
		88657
	],
	"./01202-o-que-e-uma-supermalha-em-circuitos-eletricos.md": [
		61458,
		61458
	],
	"./01203-como-a-carga-em-um-capacitor-se-comporta-em-um-circuito-de-primeira-ordem.md": [
		41623,
		41623
	],
	"./01204-o-que-significa-um-circuito-de-segunda-ordem-ser-criticamente-amortecido.md": [
		12425,
		12425
	],
	"./01205-o-que-e-o-regime-permanente-em-circuitos-rlc-em-corrente-alternada.md": [
		13200,
		13200
	],
	"./01206-o-que-e-a-conexao-estrela-triangulo-em-circuitos-trifasicos.md": [
		85095,
		85095
	],
	"./01207-o-que-e-um-circuito-passivo-e-quais-sao-suas-propriedades.md": [
		4158,
		4158
	],
	"./01208-como-funciona-um-transistor-bipolar-de-juncao-bjt-em-um-circuito.md": [
		90956,
		90956
	],
	"./01209-o-que-e-um-trigger-schmitt-e-como-ele-funciona-em-circuitos-analogicos.md": [
		29313,
		29313
	],
	"./01210-o-que-e-um-flip-flop-e-qual-sua-importancia-em-circuitos-digitais.md": [
		88165,
		88165
	],
	"./01211-o-que-e-um-circuito-schmitt-trigger-e-qual-sua-aplicacao-em-circuitos-eletricos.md": [
		87225,
		87225
	],
	"./01212-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		94077,
		94077
	],
	"./01213-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		42920,
		42920
	],
	"./01214-o-que-e-a-transformacao-de-norton-e-como-ela-e-utilizada-na-analise-de-circuitos.md": [
		71168,
		71168
	],
	"./01215-como-ocorre-a-descarga-de-um-capacitor-em-um-circuito-rc-de-primeira-ordem.md": [
		59855,
		59855
	],
	"./01216-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-funcionam.md": [
		6010,
		6010
	],
	"./01217-como-a-frequencia-afeta-a-resposta-de-um-circuito-em-corrente-alternada.md": [
		46551,
		46551
	],
	"./01218-o-que-e-uma-conexao-triangulo-triangulo-em-circuitos-trifasicos.md": [
		48583,
		48583
	],
	"./01219-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		44401,
		44401
	],
	"./01220-como-funciona-um-mosfet-e-qual-a-sua-aplicacao-em-circuitos-eletricos.md": [
		86970,
		86970
	],
	"./01221-o-que-e-um-multivibrador-e-como-ele-funciona-em-circuitos-analogicos.md": [
		50758,
		50758
	],
	"./01222-como-funciona-um-latch-em-circuitos-digitais.md": [
		98327,
		98327
	],
	"./01223-o-que-e-um-circuito-schmitt-trigger-e-qual-sua-aplicacao-em-sistemas-digitais.md": [
		17652,
		17652
	],
	"./01224-o-que-e-um-curto-circuito-em-um-sistema-de-resistencias-em-serie.md": [
		85694,
		85694
	],
	"./01225-qual-a-funcao-de-um-capacitor-em-um-circuito-eletrico.md": [
		48374,
		48374
	],
	"./01226-o-que-e-o-teorema-de-thevenin-e-como-ele-simplifica-a-analise-de-circuitos.md": [
		40895,
		40895
	],
	"./01227-como-o-comportamento-de-um-circuito-rl-de-primeira-ordem-muda-com-a-aplicacao-de-uma-fonte-de-tensao.md": [
		14809,
		14809
	],
	"./01228-o-que-e-um-circuito-super-amortecido-e-como-ele-se-comporta.md": [
		60886,
		60886
	],
	"./01229-o-que-e-o-valor-rms-e-por-que-ele-e-importante-em-circuitos-de-corrente-alternada.md": [
		62176,
		62176
	],
	"./01230-qual-e-a-diferenca-entre-circuitos-monofasicos-e-trifasicos-em-termos-de-aplicacao-e-potencia.md": [
		35543,
		35543
	],
	"./01231-o-que-e-a-transformada-de-laplace-e-como-ela-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		25754,
		3373
	],
	"./01232-o-que-e-um-transistor-hemt-e-como-ele-funciona.md": [
		66768,
		66768
	],
	"./01233-como-funciona-um-oscilador-ativo-em-circuitos-analogicos.md": [
		53930,
		53930
	],
	"./01234-o-que-e-um-latch-em-circuitos-digitais.md": [
		74006,
		74006
	],
	"./01235-o-que-e-um-trigger-schmitt-e-como-ele-funciona-em-circuitos-logicos.md": [
		18936,
		18936
	],
	"./01236-o-que-e-um-ramo-em-um-circuito-eletrico.md": [
		2538,
		2538
	],
	"./01237-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		12718,
		12718
	],
	"./01238-o-que-e-o-teorema-de-thevenin-e-como-ele-facilita-a-analise-de-circuitos.md": [
		95160,
		95160
	],
	"./01239-o-que-sao-circuitos-de-primeira-ordem-e-como-eles-funcionam.md": [
		22591,
		22591
	],
	"./01240-o-que-e-uma-resposta-super-amortecida-em-circuitos-de-segunda-ordem.md": [
		56504,
		56504
	],
	"./01241-o-que-e-admitancia-em-circuitos-de-corrente-alternada.md": [
		30223,
		30223
	],
	"./01242-como-calcular-a-tensao-equivalente-em-uma-conexao-estrela-triangulo.md": [
		6851,
		6851
	],
	"./01243-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		27588,
		27588
	],
	"./01244-como-funciona-a-juncao-pn-em-um-diodo-semicondutor.md": [
		26357,
		26357
	],
	"./01245-o-que-e-um-multivibrador-e-como-ele-funciona-em-circuitos-analogicos.md": [
		56508,
		56508
	],
	"./01246-como-implementar-um-sistema-combinacional-usando-mapas-logicos.md": [
		45544,
		45544
	],
	"./01247-como-funcionam-os-circuitos-combinacionais-em-sistemas-logicos.md": [
		90569,
		90569
	],
	"./01248-o-que-e-tensao-eletrica-e-como-ela-se-relaciona-com-a-energia-em-um-circuito.md": [
		91567,
		91567
	],
	"./01249-qual-a-diferenca-entre-componentes-passivos-e-ativos-em-circuitos-eletricos.md": [
		89489,
		89489
	],
	"./01250-como-a-simulacao-no-ltspice-pode-ajudar-na-verificacao-de-circuitos-eletricos.md": [
		6214,
		6214
	],
	"./01251-o-que-acontece-com-a-carga-armazenada-em-um-capacitor-apos-a-comutacao-em-um-circuito-de-primeira-ordem.md": [
		99559,
		99559
	],
	"./01252-o-que-e-a-resposta-natural-de-um-circuito-de-segunda-ordem.md": [
		69042,
		69042
	],
	"./01253-o-que-e-impedancia-em-circuitos-de-corrente-alternada.md": [
		58210,
		58210
	],
	"./01254-qual-a-diferenca-entre-um-sistema-trifasico-equilibrado-e-um-sistema-monofasico.md": [
		65689,
		65689
	],
	"./01255-o-que-e-o-teorema-de-parseval-e-como-ele-se-aplica-na-analise-de-circuitos.md": [
		64410,
		64410
	],
	"./01256-como-funciona-um-diodo-semicondutor.md": [
		25377,
		25377
	],
	"./01257-o-que-e-um-amplificador-operacional-e-como-ele-funciona-em-circuitos-analogicos.md": [
		29790,
		29790
	],
	"./01258-o-que-e-um-latch-em-circuitos-digitais-e-como-ele-funciona.md": [
		5218,
		5218
	],
	"./01259-o-que-sao-circuitos-rc-e-rlc-e-como-eles-funcionam.md": [
		12453,
		12453
	],
	"./01260-o-que-e-a-lei-de-ohm-e-como-ela-se-aplica-a-um-circuito-simples.md": [
		58865,
		58865
	],
	"./01261-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		89963,
		89963
	],
	"./01262-o-que-e-uma-supermalha-em-circuitos-eletricos-e-como-ela-e-utilizada-na-analise-de-circuitos.md": [
		81728,
		81728
	],
	"./01263-como-funciona-a-carga-e-descarga-de-um-indutor-em-um-circuito-rl-de-primeira-ordem.md": [
		65228,
		65228
	],
	"./01264-o-que-e-uma-resposta-super-amortecida-em-circuitos-de-segunda-ordem.md": [
		76222,
		76222
	],
	"./01265-o-que-e-o-fator-de-potencia-em-circuitos-de-corrente-alternada.md": [
		28276,
		28276
	],
	"./01266-qual-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		51162,
		51162
	],
	"./01267-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		46998,
		46998
	],
	"./01268-qual-a-diferenca-entre-mosfet-e-igbt-em-circuitos-eletricos.md": [
		72,
		72
	],
	"./01269-o-que-e-um-conversor-r2r-e-como-ele-funciona-em-circuitos-analogicos.md": [
		36366,
		36366
	],
	"./01270-como-as-portas-logicas-sao-utilizadas-na-implementacao-de-circuitos-digitais.md": [
		17959,
		17959
	],
	"./01271-como-os-componentes-rlc-se-comportam-em-um-circuito-serie-com-uma-fonte-senoidal.md": [
		79104,
		79104
	],
	"./01272-o-que-e-potencia-eletrica-e-como-ela-se-relaciona-com-energia.md": [
		78950,
		78950
	],
	"./01273-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		54342,
		54342
	],
	"./01274-como-o-teorema-da-maxima-transferencia-de-potencia-e-aplicado-em-circuitos-eletricos.md": [
		11833,
		11833
	],
	"./01275-o-que-e-um-circuito-rl-de-primeira-ordem-e-como-ele-funciona.md": [
		96650,
		96650
	],
	"./01276-quais-sao-os-tipos-de-resposta-em-circuitos-de-segunda-ordem.md": [
		74864,
		74864
	],
	"./01277-como-a-frequencia-afeta-a-corrente-em-circuitos-de-corrente-alternada.md": [
		81836,
		81836
	],
	"./01278-o-que-e-um-sistema-trifasico-equilibrado-e-como-ele-funciona.md": [
		33139,
		33139
	],
	"./01279-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		47543,
		47543
	],
	"./01280-o-que-e-a-regiao-de-saturacao-em-um-jfet.md": [
		49911,
		49911
	],
	"./01281-como-funciona-um-oscilador-analogico-em-circuitos-eletricos.md": [
		12853,
		12853
	],
	"./01282-como-funcionam-as-portas-logicas-em-circuitos-digitais.md": [
		59861,
		59861
	],
	"./01283-qual-e-a-importancia-da-configuracao-de-amplificadores-em-circuitos-eletricos.md": [
		73770,
		73770
	],
	"./01284-o-que-e-a-lei-de-ohm-e-como-ela-se-aplica-em-circuitos-em-serie.md": [
		73788,
		73788
	],
	"./01285-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		93353,
		93353
	],
	"./01286-o-que-e-o-teorema-de-thevenin-e-como-ele-e-aplicado-na-analise-de-circuitos.md": [
		98871,
		98871
	],
	"./01287-como-a-energia-armazenada-em-um-indutor-afeta-circuitos-de-primeira-ordem.md": [
		92846,
		92846
	],
	"./01288-o-que-e-uma-resposta-sub-amortecida-em-circuitos-de-segunda-ordem.md": [
		27343,
		27343
	],
	"./01289-o-que-e-o-fator-de-potencia-em-circuitos-de-corrente-alternada.md": [
		95118,
		95118
	],
	"./01290-qual-a-diferenca-entre-um-circuito-monofasico-e-um-circuito-trifasico-equilibrado.md": [
		37813,
		37813
	],
	"./01291-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		18577,
		18577
	],
	"./01292-o-que-e-um-mesfet-e-como-ele-funciona-em-circuitos-eletricos.md": [
		49168,
		49168
	],
	"./01293-como-funciona-um-conversor-r2r-em-circuitos-analogicos.md": [
		62212,
		62212
	],
	"./01294-como-implementar-uma-funcao-booleana-em-um-circuito-digital-sequencial.md": [
		14518,
		14518
	],
	"./01295-como-funciona-a-configuracao-de-um-emissor-em-um-circuito-logico.md": [
		80721,
		80721
	],
	"./01296-o-que-e-um-curto-circuito-e-como-ele-ocorre-em-um-sistema-eletrico.md": [
		57142,
		57142
	],
	"./01297-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		80708,
		80708
	],
	"./01298-como-aplicar-o-teorema-da-maxima-transferencia-de-potencia-em-um-circuito.md": [
		34403,
		34403
	],
	"./01299-como-a-energia-armazenada-em-um-circuito-rc-e-dissipada-ao-longo-do-tempo.md": [
		94028,
		94028
	],
	"./01300-como-determinar-o-valor-inicial-em-circuitos-rlc-de-segunda-ordem.md": [
		37569,
		37569
	],
	"./01301-o-que-e-o-fator-de-potencia-em-circuitos-rlc-em-regime-senoidal.md": [
		33754,
		33754
	],
	"./01302-o-que-e-a-conexao-triangulo-estrela-em-circuitos-trifasicos.md": [
		56576,
		56576
	],
	"./01303-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		52941,
		52941
	],
	"./01304-qual-a-diferenca-entre-mosfet-e-mesfet.md": [
		57937,
		57937
	],
	"./01305-o-que-e-a-resposta-em-frequencia-de-um-circuito-analogico.md": [
		46868,
		46868
	],
	"./01306-o-que-e-um-latch-em-circuitos-digitais-e-como-ele-funciona.md": [
		19078,
		19078
	],
	"./01307-o-que-e-um-circuito-basico-e-como-ele-funciona-em-um-laboratorio-de-engenharia.md": [
		67403,
		67403
	],
	"./01308-o-que-e-um-no-em-um-circuito-eletrico.md": [
		43202,
		43202
	],
	"./01309-qual-a-diferenca-entre-um-diodo-e-um-transistor.md": [
		55028,
		55028
	],
	"./01310-como-realizar-a-analise-nodal-em-um-circuito-com-multiplas-fontes.md": [
		74355,
		74355
	],
	"./01311-como-a-energia-armazenada-em-um-capacitor-e-afetada-pela-comutacao-em-um-circuito-rc-de-primeira-ordem.md": [
		46169,
		46169
	],
	"./01312-o-que-e-uma-resposta-super-amortecida-em-circuitos-de-segunda-ordem.md": [
		99719,
		99719
	],
	"./01313-o-que-e-a-transferencia-de-potencia-em-circuitos-de-corrente-alternada.md": [
		58007,
		58007
	],
	"./01314-o-que-e-um-circuito-trifasico-equilibrado-e-qual-sua-importancia.md": [
		4416,
		4416
	],
	"./01315-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		31436,
		31436
	],
	"./01316-como-os-semicondutores-influenciam-a-conducao-de-corrente-em-circuitos-eletricos.md": [
		22604,
		22604
	],
	"./01317-o-que-e-um-multivibrador-e-como-ele-funciona-em-circuitos-analogicos.md": [
		39936,
		39936
	],
	"./01318-como-os-mapas-de-karnaugh-simplificam-circuitos-logicos.md": [
		62452,
		62452
	],
	"./01319-como-funciona-um-conversor-r2r-em-circuitos-eletricos.md": [
		93413,
		93413
	],
	"./01320-o-que-e-a-lei-de-ohm-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		33804,
		33804
	],
	"./01321-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		61554,
		61554
	],
	"./01322-como-funciona-a-transformacao-de-fontes-em-circuitos-eletricos.md": [
		7540,
		7540
	],
	"./01323-o-que-acontece-com-a-energia-armazenada-em-um-capacitor-apos-a-comutacao-em-um-circuito-de-primeira-ordem.md": [
		40730,
		40730
	],
	"./01324-qual-e-a-diferenca-entre-a-resposta-natural-e-a-resposta-forcada-em-circuitos-de-segunda-ordem.md": [
		86735,
		86735
	],
	"./01325-o-que-e-a-impedancia-em-circuitos-de-corrente-alternada.md": [
		57030,
		57030
	],
	"./01326-o-que-e-um-circuito-trifasico-em-configuracao-triangulo-triangulo.md": [
		52872,
		52872
	],
	"./01327-como-a-transformada-de-fourier-e-aplicada-na-analise-de-circuitos-rlc.md": [
		39458,
		39458
	],
	"./01328-qual-a-diferenca-entre-um-bjt-e-um-igbt-em-circuitos-eletricos.md": [
		47845,
		47845
	],
	"./01329-como-funciona-um-oscilador-de-wien-em-circuitos-analogicos.md": [
		22652,
		22652
	],
	"./01330-como-funciona-a-conversao-de-sinais-analogicos-para-digitais-e-vice-versa-em-circuitos-digitais.md": [
		92276,
		92276
	],
	"./01331-o-que-e-o-regime-permanente-em-um-circuito-rc-serie.md": [
		51718,
		51718
	],
	"./01332-o-que-e-um-curto-circuito-e-como-ele-afeta-um-sistema-eletrico.md": [
		36823,
		36823
	],
	"./01333-qual-a-diferenca-entre-um-diodo-e-um-transistor.md": [
		78405,
		78405
	],
	"./01334-como-funciona-o-teorema-da-superposicao-em-circuitos-eletricos.md": [
		83396,
		83396
	],
	"./01335-como-o-indutor-se-comporta-em-um-circuito-de-primeira-ordem-ao-longo-do-tempo.md": [
		98168,
		98168
	],
	"./01336-o-que-e-um-circuito-de-segunda-ordem-e-como-ele-se-comporta.md": [
		63465,
		85846
	],
	"./01337-como-aplicar-o-teorema-de-thevenin-em-circuitos-de-corrente-alternada.md": [
		35847,
		35847
	],
	"./01338-o-que-e-um-circuito-trifasico-equilibrado-e-como-ele-funciona.md": [
		35570,
		35570
	],
	"./01339-o-que-e-o-teorema-de-parseval-e-como-ele-se-aplica-na-analise-de-circuitos-eletricos.md": [
		3708,
		3708
	],
	"./01340-como-os-semicondutores-sao-utilizados-em-circuitos-eletricos.md": [
		47204,
		47204
	],
	"./01341-qual-a-diferenca-entre-sinais-ativos-e-passivos-em-circuitos-analogicos.md": [
		8784,
		8784
	],
	"./01342-como-funcionam-os-circuitos-combinacionais-em-sistemas-digitais.md": [
		51689,
		51689
	],
	"./01343-como-funciona-um-circuito-rc-em-um-experimento-pratico.md": [
		15766,
		15766
	],
	"./01344-o-que-e-um-no-em-um-circuito-eletrico-e-qual-sua-importancia.md": [
		30460,
		30460
	],
	"./01345-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		71960,
		71960
	],
	"./01346-como-verificar-a-linearidade-em-um-circuito-eletrico.md": [
		67333,
		67333
	],
	"./01347-o-que-acontece-com-a-tensao-em-um-capacitor-durante-a-descarga-em-um-circuito-rc.md": [
		88032,
		88032
	],
	"./01348-qual-a-diferenca-entre-circuitos-lc-e-rlc-sub-amortecidos.md": [
		53429,
		53429
	],
	"./01349-como-calcular-a-corrente-eficaz-em-um-circuito-em-serie-com-fontes-senoidais.md": [
		28087,
		28087
	],
	"./01350-qual-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		83072,
		83072
	],
	"./01351-o-que-e-a-resposta-ao-impulso-em-circuitos-eletricos-avancados.md": [
		22102,
		22102
	],
	"./01352-como-a-tensao-de-base-emissor-afeta-o-funcionamento-de-um-bjt.md": [
		13133,
		13133
	],
	"./01353-o-que-e-um-amplificador-operacional-amp-op-e-como-ele-funciona-em-circuitos-analogicos.md": [
		44760,
		44760
	],
	"./01354-como-os-latches-sao-implementados-em-circuitos-digitais.md": [
		10763,
		10763
	],
	"./01355-o-que-e-um-schmitt-trigger-e-como-ele-funciona-em-circuitos-eletricos.md": [
		70589,
		70589
	],
	"./01356-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		15670,
		15670
	],
	"./01357-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		7329,
		7329
	],
	"./01358-o-que-e-a-teoria-de-norton-e-como-ela-e-aplicada-na-analise-de-circuitos.md": [
		56405,
		56405
	],
	"./01359-como-a-energia-armazenada-em-um-capacitor-afeta-o-comportamento-de-um-circuito-rc.md": [
		90044,
		90044
	],
	"./01360-o-que-sao-circuitos-de-segunda-ordem-sub-amortecidos.md": [
		62700,
		62700
	],
	"./01361-o-que-e-a-impedancia-em-circuitos-de-corrente-alternada.md": [
		50430,
		50430
	],
	"./01362-o-que-e-um-sistema-trifasico-e-como-ele-e-usado-em-circuitos-eletricos.md": [
		12706,
		12706
	],
	"./01363-como-a-transformada-de-fourier-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		85193,
		85193
	],
	"./01364-como-funciona-um-transistor-bipolar-bjt-em-um-circuito-eletrico.md": [
		80566,
		80566
	],
	"./01365-como-os-amplificadores-operacionais-amp-op-sao-utilizados-em-circuitos-analogicos.md": [
		32581,
		32581
	],
	"./01366-como-os-mapas-de-karnaugh-simplificam-funcoes-booleanas-em-circuitos-digitais.md": [
		38087,
		38087
	],
	"./01367-o-que-e-o-regime-permanente-em-circuitos-eletricos.md": [
		34955,
		34955
	],
	"./01368-o-que-e-resistencia-eletrica-e-como-ela-afeta-a-corrente-em-um-circuito.md": [
		12565,
		12565
	],
	"./01369-qual-a-diferenca-entre-componentes-passivos-e-ativos-em-circuitos-eletricos.md": [
		39280,
		39280
	],
	"./01370-como-verificar-a-maxima-transferencia-de-potencia-em-um-circuito-usando-o-teorema-de-thevenin.md": [
		63712,
		63712
	],
	"./01371-como-a-energia-armazenada-em-um-indutor-se-comporta-ao-longo-do-tempo-em-um-circuito-de-primeira-ordem.md": [
		59307,
		59307
	],
	"./01372-o-que-e-uma-resposta-sub-amortecida-em-circuitos-de-segunda-ordem.md": [
		22341,
		22341
	],
	"./01373-o-que-e-admitancia-em-circuitos-de-corrente-alternada.md": [
		1213,
		1213
	],
	"./01374-o-que-e-potencia-instantanea-em-circuitos-trifasicos.md": [
		45755,
		45755
	],
	"./01375-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		85438,
		85438
	],
	"./01376-como-os-transistores-mesfet-e-hemt-diferem-dos-bjts.md": [
		28345,
		28345
	],
	"./01377-como-funciona-um-oscilador-em-circuitos-analogicos.md": [
		21409,
		21409
	],
	"./01378-como-funcionam-as-portas-logicas-em-circuitos-digitais.md": [
		93631,
		93631
	],
	"./01379-como-funciona-a-analise-de-um-circuito-rc-em-um-laboratorio-de-engenharia.md": [
		60847,
		60847
	],
	"./01380-o-que-e-a-lei-de-kirchhoff-das-tensoes-lkt-e-como-ela-se-aplica-em-circuitos-simples.md": [
		13352,
		13352
	],
	"./01381-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		95912,
		95912
	],
	"./01382-como-a-linearidade-afeta-a-analise-de-circuitos-eletricos.md": [
		37099,
		37099
	],
	"./01383-o-que-acontece-com-a-energia-armazenada-em-um-capacitor-durante-a-descarga-em-um-circuito-rc.md": [
		85908,
		63527
	],
	"./01384-o-que-e-um-circuito-super-amortecido-e-como-ele-se-comporta.md": [
		24043,
		24043
	],
	"./01385-como-aplicar-o-teorema-de-norton-em-circuitos-de-corrente-alternada.md": [
		48635,
		48635
	],
	"./01386-o-que-e-um-circuito-trifasico-em-configuracao-triangulo-triangulo.md": [
		71974,
		49593
	],
	"./01387-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		95817,
		95817
	],
	"./01388-o-que-e-uma-juncao-pn-em-semicondutores-e-como-ela-funciona.md": [
		60188,
		60188
	],
	"./01389-como-funcionam-os-filtros-analogicos-em-circuitos-eletricos.md": [
		13829,
		13829
	],
	"./01390-como-funcionam-os-flip-flops-em-circuitos-digitais.md": [
		11035,
		11035
	],
	"./01391-o-que-e-um-trigger-de-schmitt-e-como-ele-funciona-em-circuitos-analogicos.md": [
		58125,
		58125
	],
	"./01392-o-que-e-resistencia-eletrica-e-como-ela-se-aplica-em-circuitos-simples.md": [
		92725,
		92725
	],
	"./01393-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		39761,
		39761
	],
	"./01394-como-funciona-a-analise-nodal-em-circuitos-eletricos.md": [
		91369,
		91369
	],
	"./01395-o-que-acontece-com-a-corrente-em-um-indutor-durante-a-comutacao-em-um-circuito-de-primeira-ordem.md": [
		9244,
		9244
	],
	"./01396-o-que-e-a-resposta-natural-de-um-circuito-de-segunda-ordem-lc.md": [
		57721,
		57721
	],
	"./01397-como-a-associacao-de-impedancias-afeta-o-comportamento-de-um-circuito-em-corrente-alternada.md": [
		55739,
		55739
	],
	"./01398-o-que-e-a-potencia-instantanea-em-circuitos-trifasicos.md": [
		52911,
		52911
	],
	"./01399-como-a-transformada-de-fourier-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		12738,
		12738
	],
	"./01400-como-funciona-a-operacao-basica-de-um-mosfet.md": [
		36859,
		36859
	],
	"./01401-o-que-e-um-oscilador-de-wien-e-como-ele-funciona-em-circuitos-analogicos.md": [
		80988,
		80988
	],
	"./01402-como-funciona-um-flip-flop-e-qual-sua-importancia-em-circuitos-digitais.md": [
		93681,
		93681
	],
	"./01403-como-medir-a-resposta-de-um-amplificador-em-regime-permanente.md": [
		16641,
		16641
	],
	"./01404-qual-a-diferenca-entre-associacao-em-serie-e-em-paralelo.md": [
		81893,
		81893
	],
	"./01405-o-que-e-um-componente-eletronico-ativo-e-como-ele-difere-de-um-componente-passivo.md": [
		40027,
		40027
	],
	"./01406-como-aplicar-o-teorema-de-norton-na-analise-de-circuitos-eletricos.md": [
		13749,
		13749
	],
	"./01407-como-a-corrente-varia-durante-a-descarga-de-um-indutor-em-um-circuito-de-primeira-ordem.md": [
		54123,
		54123
	],
	"./01408-o-que-e-uma-resposta-natural-em-circuitos-de-segunda-ordem.md": [
		81108,
		81108
	],
	"./01409-como-calcular-a-potencia-em-circuitos-de-corrente-alternada.md": [
		82576,
		82576
	],
	"./01410-o-que-e-uma-conexao-triangulo-triangulo-em-circuitos-trifasicos.md": [
		59969,
		59969
	],
	"./01411-o-que-e-o-teorema-de-parseval-e-como-ele-se-aplica-na-analise-de-circuitos.md": [
		81912,
		81912
	],
	"./01412-como-funciona-o-modelo-equivalente-de-um-diodo-em-circuitos-eletricos.md": [
		11167,
		11167
	],
	"./01413-como-funciona-um-amplificador-operacional-em-circuitos-analogicos.md": [
		89967,
		89967
	],
	"./01414-o-que-e-um-latch-em-circuitos-digitais.md": [
		74182,
		74182
	],
	"./01415-o-que-e-um-circuito-combinacional-e-como-ele-difere-de-um-circuito-sequencial.md": [
		85960,
		85960
	],
	"./01416-como-funcionam-as-associacoes-de-resistores-em-circuitos-eletricos-simples.md": [
		30175,
		30175
	],
	"./01417-qual-a-diferenca-entre-componentes-eletronicos-lineares-e-nao-lineares.md": [
		43909,
		43909
	],
	"./01418-o-que-e-um-no-em-um-circuito-eletrico-e-qual-sua-importancia-na-analise-de-circuitos.md": [
		48254,
		48254
	],
	"./01419-como-os-circuitos-de-primeira-ordem-armazenam-e-liberam-energia.md": [
		5535,
		5535
	],
	"./01420-o-que-e-um-circuito-de-segunda-ordem-e-como-ele-se-comporta.md": [
		91448,
		91448
	],
	"./01421-como-aplicar-o-teorema-de-thevenin-em-circuitos-de-corrente-alternada.md": [
		33637,
		33637
	],
	"./01422-o-que-e-um-circuito-trifasico-e-como-ele-funciona.md": [
		48942,
		48942
	],
	"./01423-como-os-filtros-rlc-funcionam-em-circuitos-eletricos-avancados.md": [
		67452,
		67452
	],
	"./01424-o-que-e-um-igbt-e-como-ele-funciona-em-circuitos-eletricos.md": [
		11073,
		11073
	],
	"./01425-como-funciona-um-oscilador-em-circuitos-analogicos.md": [
		37551,
		37551
	],
	"./01426-o-que-sao-circuitos-combinacionais-e-como-eles-diferem-dos-flip-flops.md": [
		92023,
		92023
	],
	"./01427-como-funciona-a-montagem-de-um-conversor-digital-em-serie.md": [
		54672,
		54672
	],
	"./01428-o-que-sao-nos-e-malhas-em-circuitos-eletricos.md": [
		7771,
		7771
	],
	"./01429-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		77725,
		106
	],
	"./01430-o-que-e-uma-supermalha-em-circuitos-eletricos.md": [
		26065,
		26065
	],
	"./01431-como-a-energia-armazenada-em-um-indutor-se-comporta-ao-longo-do-tempo-em-um-circuito-de-primeira-ordem.md": [
		85468,
		85468
	],
	"./01432-como-determinar-a-resposta-de-um-circuito-rlc-paralelo-de-segunda-ordem.md": [
		35044,
		35044
	],
	"./01433-o-que-e-um-fasor-e-como-ele-e-utilizado-em-circuitos-de-corrente-alternada.md": [
		60011,
		60011
	],
	"./01434-qual-a-diferenca-entre-sistemas-trifasicos-e-monofasicos.md": [
		75081,
		75081
	],
	"./01435-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		13,
		13
	],
	"./01436-qual-a-diferenca-entre-bjt-e-mosfet.md": [
		27329,
		27329
	],
	"./01437-o-que-e-um-amplificador-operacional-e-como-ele-funciona-em-circuitos-analogicos.md": [
		26066,
		26066
	],
	"./01438-como-os-circuitos-cmos-sao-utilizados-na-implementacao-de-portas-logicas.md": [
		40463,
		40463
	],
	"./01439-como-medir-a-corrente-em-um-circuito-com-bjt.md": [
		13073,
		13073
	],
	"./01440-o-que-e-um-curto-circuito-e-como-ele-ocorre-em-um-circuito-eletrico.md": [
		5157,
		5157
	],
	"./01441-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		86903,
		86903
	],
	"./01442-como-determinar-a-potencia-maxima-dissipada-em-um-resistor-usando-o-teorema-de-thevenin.md": [
		76020,
		76020
	],
	"./01443-como-os-circuitos-rc-e-rl-de-primeira-ordem-respondem-a-uma-fonte-de-tensao-ao-longo-do-tempo.md": [
		38772,
		38772
	],
	"./01444-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-se-comportam.md": [
		234,
		234
	],
	"./01445-o-que-e-admitancia-em-circuitos-de-corrente-alternada.md": [
		22657,
		22657
	],
	"./01446-qual-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		98122,
		98122
	],
	"./01447-o-que-e-a-propriedade-de-parseval-em-circuitos-eletricos.md": [
		82375,
		82375
	],
	"./01448-como-funciona-a-juncao-pn-em-semicondutores.md": [
		68928,
		46547
	],
	"./01449-o-que-e-a-operacao-ativa-de-um-bjt-em-circuitos-analogicos.md": [
		52525,
		52525
	],
	"./01450-como-funciona-a-simplificacao-de-circuitos-digitais.md": [
		72551,
		72551
	],
	"./01451-o-que-e-um-filtro-de-primeira-ordem-e-como-ele-e-utilizado-em-circuitos-eletricos.md": [
		17081,
		17081
	],
	"./01452-o-que-e-a-lei-de-kirchhoff-das-correntes-lkc-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		70662,
		70662
	],
	"./01453-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		37942,
		37942
	],
	"./01454-como-funciona-o-principio-da-superposicao-na-analise-de-circuitos-eletricos.md": [
		44118,
		44118
	],
	"./01455-o-que-acontece-durante-a-descarga-de-um-circuito-rc.md": [
		85825,
		85825
	],
	"./01456-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-se-comportam.md": [
		48237,
		48237
	],
	"./01457-o-que-e-admitancia-em-circuitos-de-corrente-alternada.md": [
		40030,
		40030
	],
	"./01458-o-que-e-potencia-instantanea-em-circuitos-trifasicos.md": [
		41298,
		41298
	],
	"./01459-como-a-transformada-de-laplace-e-aplicada-na-analise-avancada-de-circuitos.md": [
		49088,
		49088
	],
	"./01460-como-funcionam-os-transistores-bipolares-em-circuitos-simples.md": [
		26705,
		26705
	],
	"./01461-como-um-amplificador-operacional-responde-a-diferentes-sinais-de-entrada.md": [
		99277,
		99277
	],
	"./01462-como-converter-uma-expressao-booleana-em-um-circuito-digital.md": [
		98972,
		98972
	],
	"./01463-o-que-e-um-conversor-analogico-digital-e-como-ele-funciona.md": [
		20286,
		20286
	],
	"./01464-o-que-e-um-curto-circuito-e-como-ele-afeta-um-sistema-eletrico.md": [
		11301,
		11301
	],
	"./01465-qual-a-diferenca-entre-componentes-passivos-e-ativos-em-circuitos-eletricos.md": [
		98877,
		98877
	],
	"./01466-o-que-e-uma-supermalha-em-circuitos-eletricos.md": [
		70962,
		70962
	],
	"./01467-o-que-acontece-durante-a-descarga-de-um-circuito-rl.md": [
		75989,
		75989
	],
	"./01468-como-a-resolucao-de-edos-se-aplica-em-circuitos-de-segunda-ordem.md": [
		98255,
		98255
	],
	"./01469-como-funciona-o-principio-da-superposicao-em-circuitos-rlc-em-corrente-alternada.md": [
		50831,
		50831
	],
	"./01470-o-que-e-a-conexao-triangulo-estrela-em-circuitos-trifasicos.md": [
		57416,
		57416
	],
	"./01471-o-que-e-o-teorema-do-inverso-em-circuitos-eletricos.md": [
		98110,
		98110
	],
	"./01472-como-funciona-a-juncao-pn-em-um-diodo-semicondutor.md": [
		69316,
		69316
	],
	"./01473-o-que-e-um-circuito-biestavel-e-como-ele-funciona.md": [
		67871,
		67871
	],
	"./01474-como-funcionam-as-portas-logicas-em-circuitos-digitais.md": [
		88135,
		88135
	],
	"./01475-como-a-serie-de-fourier-e-aplicada-em-sinais-senoidais-em-laboratorios-de-circuitos-eletricos.md": [
		3585,
		3585
	],
	"./01476-o-que-e-um-no-em-um-circuito-eletrico.md": [
		58406,
		58406
	],
	"./01477-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		67696,
		67696
	],
	"./01478-o-que-e-uma-supermalha-e-como-ela-e-utilizada-na-analise-de-circuitos.md": [
		98223,
		98223
	],
	"./01479-como-determinar-a-resposta-natural-de-um-circuito-rl-de-primeira-ordem.md": [
		26541,
		26541
	],
	"./01480-o-que-e-uma-resposta-criticamente-amortecida-em-circuitos-de-segunda-ordem.md": [
		55511,
		55511
	],
	"./01481-o-que-e-um-circuito-rlc-em-corrente-alternada.md": [
		84547,
		84547
	],
	"./01482-qual-a-diferenca-entre-conexao-estrela-e-delta-em-circuitos-trifasicos.md": [
		18043,
		18043
	],
	"./01483-o-que-e-a-singularidade-em-circuitos-eletricos-e-como-ela-afeta-a-analise-avancada.md": [
		32601,
		32601
	],
	"./01484-qual-a-diferenca-entre-mesfet-e-mosfet-em-circuitos-eletricos.md": [
		24332,
		24332
	],
	"./01485-como-funciona-um-conversor-digital-analogico-r2r.md": [
		78296,
		78296
	],
	"./01486-como-os-mapas-de-karnaugh-simplificam-funcoes-logicas-em-circuitos-digitais.md": [
		96754,
		96754
	],
	"./01487-como-a-transformada-de-fourier-e-utilizada-na-analise-de-circuitos-rlc.md": [
		4595,
		4595
	],
	"./01488-o-que-e-a-divisao-de-tensao-em-um-circuito-eletrico-simples.md": [
		54413,
		54413
	],
	"./01489-o-que-e-um-componente-passivo-em-circuitos-eletricos.md": [
		96826,
		96826
	],
	"./01490-como-verificar-a-potencia-dissipada-em-um-resistor-usando-ltspice.md": [
		66044,
		66044
	],
	"./01491-como-determinar-a-constante-de-tempo-em-um-circuito-rc.md": [
		1977,
		1977
	],
	"./01492-o-que-e-a-resposta-natural-de-um-circuito-rlc-de-segunda-ordem.md": [
		92494,
		92494
	],
	"./01493-o-que-e-um-circuito-rlc-serie-em-regime-permanente.md": [
		19821,
		19821
	],
	"./01494-qual-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		54851,
		54851
	],
	"./01495-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-rlc.md": [
		83056,
		83056
	],
	"./01496-como-funcionam-os-transistores-em-circuitos-eletricos.md": [
		67985,
		67985
	],
	"./01497-como-funciona-um-oscilador-com-amplificador-operacional.md": [
		61695,
		84076
	],
	"./01498-como-funciona-a-conversao-de-numeros-decimais-para-binarios-em-circuitos-digitais.md": [
		58635,
		58635
	],
	"./01499-o-que-e-um-circuito-r2r-e-como-ele-funciona.md": [
		21420,
		21420
	],
	"./01500-o-que-e-a-diferenca-entre-tensao-e-corrente-em-um-circuito-eletrico.md": [
		10840,
		10840
	],
	"./01501-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		44326,
		44326
	],
	"./01502-como-o-principio-da-superposicao-e-aplicado-na-analise-de-circuitos-eletricos.md": [
		76608,
		76608
	],
	"./01503-o-que-acontece-com-a-tensao-em-um-circuito-rc-apos-a-comutacao-da-fonte.md": [
		97158,
		97158
	],
	"./01504-qual-e-a-diferenca-entre-uma-resposta-super-amortecida-e-outras-respostas-em-circuitos-de-segunda-ordem.md": [
		25864,
		25864
	],
	"./01505-como-a-potencia-e-transferida-em-um-circuito-de-corrente-alternada.md": [
		27303,
		27303
	],
	"./01506-qual-a-diferenca-entre-as-conexoes-triangulo-estrela-e-triangulo-triangulo-em-circuitos-trifasicos.md": [
		40803,
		40803
	],
	"./01507-o-que-e-a-resposta-ao-degrau-em-um-circuito-eletrico.md": [
		94162,
		94162
	],
	"./01508-qual-a-diferenca-entre-mosfet-e-jfet.md": [
		29556,
		29556
	],
	"./01509-como-funcionam-os-filtros-em-circuitos-analogicos.md": [
		84670,
		84670
	],
	"./01510-como-funciona-a-conversao-de-numeros-binarios-em-circuitos-digitais.md": [
		91029,
		91029
	],
	"./01511-como-funciona-um-amplificador-operacional-em-um-circuito-r2r.md": [
		21852,
		21852
	],
	"./01512-o-que-e-um-no-em-um-circuito-eletrico.md": [
		59311,
		59311
	],
	"./01513-o-que-e-um-transformador-e-como-ele-funciona-em-um-circuito-eletrico.md": [
		64355,
		64355
	],
	"./01514-como-verificar-a-analise-de-um-circuito-basico-com-resistores-no-ltspice.md": [
		47527,
		47527
	],
	"./01515-como-a-corrente-em-um-circuito-rl-de-primeira-ordem-se-comporta-ao-longo-do-tempo.md": [
		83042,
		83042
	],
	"./01516-o-que-e-uma-resposta-sub-amortecida-em-circuitos-rlc.md": [
		7011,
		7011
	],
	"./01517-o-que-e-um-fasor-e-como-ele-e-utilizado-em-circuitos-de-corrente-alternada.md": [
		90832,
		90832
	],
	"./01518-qual-a-diferenca-entre-circuitos-monofasicos-e-trifasicos.md": [
		53754,
		53754
	],
	"./01519-o-que-e-a-resposta-ao-impulso-em-um-circuito-rlc.md": [
		46772,
		46772
	],
	"./01520-como-os-semicondutores-influenciam-a-corrente-em-circuitos-eletricos.md": [
		2104,
		2104
	],
	"./01521-o-que-e-um-circuito-biestavel-e-como-ele-funciona.md": [
		96283,
		18664
	],
	"./01522-como-funciona-a-simplificacao-de-expressoes-booleanas-em-circuitos-digitais.md": [
		65969,
		65969
	],
	"./01523-o-que-e-um-circuito-rlc-e-qual-sua-importancia-em-aplicacoes-praticas.md": [
		5573,
		5573
	],
	"./01524-o-que-e-um-ramo-em-um-circuito-eletrico.md": [
		64668,
		64668
	],
	"./01525-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		34728,
		34728
	],
	"./01526-como-o-teorema-da-superposicao-e-aplicado-na-analise-de-circuitos-eletricos.md": [
		31898,
		31898
	],
	"./01527-como-os-indutores-e-capacitores-afetam-a-resposta-de-circuitos-de-primeira-ordem.md": [
		19895,
		19895
	],
	"./01528-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-se-comportam.md": [
		75263,
		75263
	],
	"./01529-como-o-teorema-da-superposicao-e-aplicado-em-circuitos-rlc-em-corrente-alternada.md": [
		24600,
		24600
	],
	"./01530-o-que-e-a-potencia-instantanea-em-um-sistema-trifasico.md": [
		63360,
		63360
	],
	"./01531-como-a-transformada-de-fourier-e-aplicada-na-analise-de-circuitos-rlc-passa-faixas.md": [
		78527,
		78527
	],
	"./01532-como-funcionam-os-transistores-bjt-e-mosfet-em-circuitos-eletricos.md": [
		20208,
		20208
	],
	"./01533-o-que-e-um-multivibrador-astavel-e-como-ele-funciona-em-circuitos-analogicos.md": [
		54235,
		54235
	],
	"./01534-o-que-e-um-latch-em-circuitos-digitais.md": [
		37801,
		37801
	],
	"./01535-o-que-e-a-constante-de-tempo-em-um-circuito-rc-e-como-ela-afeta-a-resposta-do-circuito.md": [
		70654,
		70654
	],
	"./01536-o-que-e-tensao-eletrica-em-um-circuito-simples.md": [
		9767,
		9767
	],
	"./01537-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		51205,
		51205
	],
	"./01538-o-que-e-o-principio-da-superposicao-em-circuitos-eletricos.md": [
		91141,
		91141
	],
	"./01539-como-a-energia-armazenada-em-um-capacitor-e-afetada-pela-comutacao-em-um-circuito-de-primeira-ordem.md": [
		28441,
		28441
	],
	"./01540-o-que-e-um-circuito-de-segunda-ordem-e-como-ele-se-comporta.md": [
		89689,
		89689
	],
	"./01541-o-que-e-impedancia-em-circuitos-de-corrente-alternada.md": [
		37164,
		37164
	],
	"./01542-qual-e-a-diferenca-entre-uma-conexao-estrela-e-uma-conexao-triangulo-em-circuitos-trifasicos.md": [
		83033,
		83033
	],
	"./01543-como-o-teorema-da-singularidade-e-aplicado-na-analise-avancada-de-circuitos.md": [
		57535,
		57535
	],
	"./01544-o-que-e-um-transistor-hemt-e-como-ele-funciona-em-circuitos-eletricos.md": [
		12646,
		12646
	],
	"./01545-o-que-e-um-multivibrador-e-como-ele-funciona-em-circuitos-analogicos.md": [
		58207,
		58207
	],
	"./01546-qual-a-diferenca-entre-circuitos-combinacionais-e-sequenciais.md": [
		34328,
		34328
	],
	"./01547-como-o-circuito-rc-atua-no-regime-transitorio.md": [
		31868,
		31868
	],
	"./01548-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		6063,
		6063
	],
	"./01549-o-que-e-um-transformador-e-como-ele-funciona-em-um-circuito-eletrico.md": [
		43534,
		43534
	],
	"./01550-o-que-e-a-analise-de-malhas-em-circuitos-eletricos.md": [
		38740,
		38740
	],
	"./01551-como-a-energia-armazenada-em-um-capacitor-afeta-o-comportamento-de-um-circuito-rl.md": [
		66015,
		66015
	],
	"./01552-o-que-e-uma-resposta-super-amortecida-em-circuitos-rlc-paralelos.md": [
		81622,
		81622
	],
	"./01553-qual-e-a-diferenca-entre-potencia-media-e-potencia-instantanea-em-circuitos-de-corrente-alternada.md": [
		57232,
		57232
	],
	"./01554-o-que-e-um-circuito-trifasico-e-como-ele-funciona.md": [
		58224,
		58224
	],
	"./01555-como-a-propriedade-de-superposicao-e-aplicada-em-circuitos-rlc.md": [
		62716,
		62716
	],
	"./01556-como-os-semicondutores-influenciam-a-corrente-em-um-circuito.md": [
		86870,
		64489
	],
	"./01557-o-que-e-um-conversor-r2r-e-como-ele-funciona-em-circuitos-analogicos.md": [
		24302,
		24302
	],
	"./01558-como-funciona-a-conversao-de-uma-expressao-booleana-para-um-circuito-logico.md": [
		44217,
		44217
	],
	"./01559-como-os-filtros-de-frequencia-funcionam-em-circuitos-eletricos.md": [
		60721,
		60721
	],
	"./01560-o-que-e-a-lei-de-ohm-e-como-ela-se-aplica-em-circuitos-eletricos-simples.md": [
		10220,
		10220
	],
	"./01561-qual-a-diferenca-entre-componentes-passivos-e-ativos-em-circuitos-eletricos.md": [
		33194,
		33194
	],
	"./01562-como-funciona-o-principio-da-superposicao-em-circuitos-eletricos.md": [
		10315,
		10315
	],
	"./01563-como-os-capacitores-e-indutores-se-comportam-em-circuitos-de-primeira-ordem.md": [
		12107,
		12107
	],
	"./01564-qual-e-a-diferenca-entre-a-resposta-natural-e-a-resposta-forcada-em-circuitos-de-segunda-ordem.md": [
		83917,
		83917
	],
	"./01565-como-funciona-a-associacao-de-componentes-rlc-em-circuitos-de-corrente-alternada.md": [
		16850,
		16850
	],
	"./01566-o-que-e-um-circuito-trifasico-equilibrado.md": [
		29405,
		29405
	],
	"./01567-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-rlc-em-serie.md": [
		74044,
		74044
	],
	"./01568-como-funciona-a-juncao-em-um-mosfet.md": [
		36955,
		36955
	],
	"./01569-o-que-e-um-trigger-de-schmitt-e-como-ele-e-utilizado-em-circuitos-analogicos.md": [
		22706,
		22706
	],
	"./01570-como-funcionam-as-portas-logicas-em-circuitos-digitais.md": [
		26997,
		26997
	],
	"./01571-como-funciona-um-circuito-schmitt-trigger.md": [
		20513,
		20513
	],
	"./01572-o-que-e-um-no-em-um-circuito-eletrico.md": [
		8953,
		8953
	],
	"./01573-qual-a-funcao-de-um-capacitor-em-um-circuito-eletrico.md": [
		8852,
		8852
	],
	"./01574-o-que-e-o-teorema-de-norton-e-como-ele-e-aplicado-na-analise-de-circuitos.md": [
		29544,
		7163
	],
	"./01575-como-a-comutacao-afeta-a-energia-armazenada-em-indutores-e-capacitores.md": [
		98047,
		98047
	],
	"./01576-o-que-e-a-resposta-natural-de-um-circuito-de-segunda-ordem.md": [
		79439,
		79439
	],
	"./01577-o-que-e-a-impedancia-em-circuitos-rlc-em-corrente-alternada.md": [
		98798,
		98798
	],
	"./01578-o-que-e-um-circuito-trifasico-e-como-ele-funciona.md": [
		60270,
		60270
	],
	"./01579-o-que-e-a-serie-de-fourier-e-como-ela-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		20015,
		20015
	],
	"./01580-como-os-transistores-bjt-e-jfet-funcionam-em-circuitos-eletricos.md": [
		28958,
		28958
	],
	"./01581-o-que-e-um-trigger-de-schmitt-e-como-ele-funciona-em-circuitos-analogicos.md": [
		16126,
		16126
	],
	"./01582-como-os-flip-flops-sao-utilizados-em-circuitos-digitais.md": [
		19352,
		19352
	],
	"./01583-como-funciona-o-trigger-em-um-conversor-de-segunda-ordem.md": [
		84513,
		84513
	],
	"./01584-o-que-e-um-no-em-um-circuito-eletrico.md": [
		37936,
		37936
	],
	"./01585-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		76254,
		76254
	],
	"./01586-o-que-e-uma-supermalha-e-como-ela-e-utilizada-na-analise-de-circuitos.md": [
		88517,
		88517
	],
	"./01587-como-a-associacao-de-resistores-afeta-a-tensao-e-a-corrente-em-circuitos-de-primeira-ordem.md": [
		66836,
		66836
	],
	"./01588-o-que-e-um-circuito-super-amortecido-e-como-ele-se-comporta.md": [
		86589,
		86589
	],
	"./01589-o-que-e-um-fasor-e-como-ele-e-utilizado-em-circuitos-de-corrente-alternada.md": [
		89725,
		89725
	],
	"./01590-o-que-e-um-circuito-trifasico-e-como-ele-funciona.md": [
		73848,
		73848
	],
	"./01591-o-que-e-uma-singularidade-em-circuitos-eletricos-e-como-ela-afeta-a-analise-de-circuitos.md": [
		69647,
		69647
	],
	"./01592-como-funciona-o-transistor-bipolar-bjt-em-circuitos-eletricos.md": [
		30211,
		30211
	],
	"./01593-o-que-e-um-circuito-schmitt-trigger-e-como-ele-funciona.md": [
		88398,
		88398
	],
	"./01594-como-os-flip-flops-sao-utilizados-em-circuitos-digitais.md": [
		87495,
		87495
	],
	"./01595-como-montar-um-amplificador-em-regime-permanente.md": [
		63725,
		63725
	],
	"./01596-o-que-e-a-lei-de-ohm-e-como-ela-se-aplica-em-circuitos-simples.md": [
		9638,
		9638
	],
	"./01597-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		15303,
		15303
	],
	"./01598-o-que-e-a-analise-de-malha-em-circuitos-eletricos.md": [
		95647,
		95647
	],
	"./01599-como-a-comutacao-afeta-a-corrente-em-circuitos-de-primeira-ordem.md": [
		81352,
		81352
	],
	"./01600-o-que-e-uma-resposta-super-amortecida-em-circuitos-de-segunda-ordem.md": [
		88680,
		88680
	],
	"./01601-o-que-e-impedancia-em-circuitos-de-corrente-alternada.md": [
		48693,
		48693
	],
	"./01602-qual-a-diferenca-entre-um-circuito-trifasico-e-um-circuito-monofasico.md": [
		9450,
		9450
	],
	"./01603-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		31028,
		31028
	],
	"./01604-como-os-mosfets-diferem-dos-bjts-em-circuitos-eletricos.md": [
		91631,
		91631
	],
	"./01605-o-que-e-um-oscilador-de-wien-e-como-ele-funciona.md": [
		97296,
		97296
	],
	"./01606-como-simplificar-uma-funcao-logica-usando-o-mapa-de-karnaugh.md": [
		99608,
		99608
	],
	"./01607-o-que-e-um-circuito-schmitt-trigger-e-como-ele-funciona.md": [
		49334,
		49334
	],
	"./01608-o-que-e-um-no-em-um-circuito-eletrico-e-qual-sua-importancia.md": [
		62453,
		62453
	],
	"./01609-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		91833,
		91833
	],
	"./01610-o-que-e-a-analise-nodal-em-circuitos-eletricos.md": [
		21507,
		21507
	],
	"./01611-o-que-acontece-com-a-tensao-em-um-capacitor-durante-a-comutacao-em-um-circuito-rl.md": [
		57139,
		57139
	],
	"./01612-o-que-e-a-constante-de-tempo-em-circuitos-de-segunda-ordem.md": [
		73569,
		73569
	],
	"./01613-o-que-e-admitancia-em-circuitos-de-corrente-alternada.md": [
		66184,
		66184
	],
	"./01614-qual-e-a-diferenca-entre-um-sistema-trifasico-e-um-sistema-monofasico.md": [
		42593,
		42593
	],
	"./01615-o-que-e-a-transformada-de-laplace-e-como-ela-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		9412,
		9412
	],
	"./01616-como-os-diodos-influenciam-o-comportamento-de-um-circuito-com-resistores-e-fontes-de-tensao.md": [
		44011,
		44011
	],
	"./01617-como-funciona-um-amplificador-operacional-em-um-circuito-analogico.md": [
		29782,
		29782
	],
	"./01618-qual-e-a-diferenca-entre-circuitos-combinacionais-e-circuitos-sequenciais.md": [
		44148,
		44148
	],
	"./01619-como-funcionam-os-filtros-rlc-em-circuitos-eletricos.md": [
		80868,
		80868
	],
	"./01620-o-que-e-um-ramo-em-um-circuito-eletrico.md": [
		8413,
		8413
	],
	"./01621-o-que-e-um-componente-eletronico-ativo.md": [
		81049,
		81049
	],
	"./01622-o-que-e-a-transformacao-de-thevenin-e-norton-em-circuitos-eletricos.md": [
		31033,
		31033
	],
	"./01623-como-a-energia-armazenada-em-um-indutor-varia-em-um-circuito-rl-de-primeira-ordem.md": [
		97104,
		97104
	],
	"./01624-como-a-resolucao-de-circuitos-de-segunda-ordem-e-realizada.md": [
		34688,
		34688
	],
	"./01625-o-que-e-impedancia-em-circuitos-de-corrente-alternada.md": [
		98471,
		98471
	],
	"./01626-qual-e-a-diferenca-entre-tensao-instantanea-e-tensao-complexa-em-circuitos-trifasicos.md": [
		6712,
		6712
	],
	"./01627-o-que-e-o-teorema-de-parseval-e-como-ele-se-aplica-na-analise-de-circuitos-rlc.md": [
		60271,
		60271
	],
	"./01628-como-funciona-a-juncao-pn-em-um-diodo-semicondutor.md": [
		61371,
		61371
	],
	"./01629-como-funciona-o-filtro-de-frequencia-em-um-circuito-analogico-com-bjt.md": [
		47624,
		47624
	],
	"./01630-como-funciona-a-logica-cmos-em-circuitos-digitais.md": [
		9274,
		9274
	],
	"./01631-o-que-e-um-dac-e-como-ele-e-utilizado-em-circuitos-eletricos.md": [
		74783,
		74783
	],
	"./01632-o-que-e-um-no-em-um-circuito-eletrico.md": [
		24472,
		24472
	],
	"./01633-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		538,
		538
	],
	"./01634-como-o-teorema-da-superposicao-e-aplicado-na-analise-de-circuitos.md": [
		3721,
		3721
	],
	"./01635-como-a-constante-de-tempo-afeta-a-carga-e-descarga-de-um-capacitor-em-circuitos-de-primeira-ordem.md": [
		62967,
		62967
	],
	"./01636-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-funcionam.md": [
		24464,
		24464
	],
	"./01637-o-que-e-o-periodo-em-um-circuito-de-corrente-alternada.md": [
		8329,
		8329
	],
	"./01638-qual-a-diferenca-entre-um-sistema-trifasico-equilibrado-e-um-sistema-monofasico.md": [
		39059,
		39059
	],
	"./01639-como-aplicar-o-teorema-de-norton-em-circuitos-rlc.md": [
		30747,
		30747
	],
	"./01640-o-que-e-uma-juncao-pn-e-como-ela-funciona-em-semicondutores.md": [
		40071,
		40071
	],
	"./01641-como-funciona-a-implementacao-de-um-oscilador-em-circuitos-analogicos.md": [
		8021,
		8021
	],
	"./01642-qual-a-diferenca-entre-um-latch-e-um-flip-flop-em-circuitos-digitais.md": [
		667,
		667
	],
	"./01643-como-funciona-um-conversor-r2r-em-circuitos-eletricos.md": [
		56949,
		56949
	],
	"./01644-o-que-e-resistencia-eletrica-e-como-ela-afeta-um-circuito.md": [
		56196,
		56196
	],
	"./01645-qual-e-a-funcao-de-um-indutor-em-um-circuito-eletrico.md": [
		59799,
		59799
	],
	"./01646-o-que-e-uma-supermalha-e-como-ela-e-utilizada-na-analise-de-circuitos.md": [
		83580,
		83580
	],
	"./01647-como-funciona-a-associacao-de-capacitores-em-circuitos-rc-de-primeira-ordem.md": [
		33010,
		33010
	],
	"./01648-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-funcionam.md": [
		59299,
		59299
	],
	"./01649-o-que-e-admitancia-em-circuitos-de-corrente-alternada.md": [
		77115,
		77115
	],
	"./01650-qual-e-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		45767,
		45767
	],
	"./01651-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-com-entrada-em-degrau.md": [
		72106,
		72106
	],
	"./01652-como-funciona-a-analise-de-um-circuito-simples-com-um-transistor-saturado.md": [
		59002,
		59002
	],
	"./01653-o-que-e-um-circuito-biestavel-e-como-ele-funciona.md": [
		22675,
		22675
	],
	"./01654-como-simplificar-uma-expressao-booleana-usando-o-mapa-de-karnaugh.md": [
		19167,
		19167
	],
	"./01655-como-funciona-um-conversor-r2r-em-circuitos-eletricos.md": [
		30086,
		30086
	],
	"./01656-o-que-e-a-lei-de-ohm-e-como-ela-se-aplica-em-circuitos-em-serie.md": [
		32111,
		32111
	],
	"./01657-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		67888,
		67888
	],
	"./01658-como-aplicar-o-teorema-da-maxima-transferencia-de-potencia-em-um-circuito.md": [
		83355,
		83355
	],
	"./01659-como-ocorre-a-descarga-de-um-capacitor-em-um-circuito-rc.md": [
		21667,
		21667
	],
	"./01660-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-se-comportam.md": [
		93682,
		93682
	],
	"./01661-o-que-e-potencia-em-circuitos-de-corrente-alternada.md": [
		30071,
		30071
	],
	"./01662-o-que-e-um-circuito-trifasico-em-configuracao-triangulo-triangulo-e-onde-ele-e-usado.md": [
		37556,
		37556
	],
	"./01663-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		25476,
		25476
	],
	"./01664-como-funciona-um-transistor-bjt-em-um-circuito-simples.md": [
		8797,
		8797
	],
	"./01665-como-funciona-um-oscilador-de-wien-em-circuitos-analogicos.md": [
		35541,
		35541
	],
	"./01666-o-que-e-um-flip-flop-e-como-ele-funciona-em-circuitos-digitais.md": [
		39796,
		39796
	],
	"./01667-o-que-e-uma-onda-senoidal-e-qual-sua-importancia-em-circuitos-eletricos.md": [
		98961,
		98961
	],
	"./01668-o-que-e-um-no-em-um-circuito-eletrico.md": [
		28491,
		28491
	],
	"./01669-qual-a-diferenca-entre-componentes-passivos-e-ativos-em-circuitos-eletricos.md": [
		18664,
		96283
	],
	"./01670-o-que-e-a-analise-nodal-em-circuitos-eletricos.md": [
		92797,
		92797
	],
	"./01671-como-a-associacao-de-indutores-afeta-a-resposta-de-um-circuito-rl-de-primeira-ordem.md": [
		38760,
		38760
	],
	"./01672-como-resolver-circuitos-de-segunda-ordem-super-amortecidos.md": [
		49167,
		49167
	],
	"./01673-o-que-e-um-fasor-e-como-ele-e-utilizado-em-circuitos-de-corrente-alternada.md": [
		21045,
		21045
	],
	"./01674-o-que-e-um-circuito-trifasico-equilibrado-e-como-ele-e-aplicado.md": [
		88575,
		88575
	],
	"./01675-como-a-transformada-de-laplace-facilita-a-analise-de-circuitos-eletricos.md": [
		16975,
		16975
	],
	"./01676-qual-a-diferenca-entre-mosfet-mesfet-e-bjt.md": [
		64894,
		64894
	],
	"./01677-o-que-e-um-multivibrador-schmitt-e-como-ele-funciona-em-circuitos-analogicos.md": [
		24842,
		24842
	],
	"./01678-como-implementar-circuitos-digitais-a-partir-de-uma-tabela-verdade.md": [
		29300,
		29300
	],
	"./01679-o-que-e-o-regime-permanente-em-circuitos-eletricos-de-primeira-ordem.md": [
		74087,
		74087
	],
	"./01680-o-que-e-um-no-em-um-circuito-eletrico.md": [
		84010,
		84010
	],
	"./01681-qual-a-funcao-de-um-capacitor-em-um-circuito-eletrico.md": [
		6176,
		6176
	],
	"./01682-como-funciona-a-analise-nodal-em-circuitos-eletricos.md": [
		18321,
		18321
	],
	"./01683-o-que-acontece-com-a-energia-armazenada-em-um-capacitor-apos-a-comutacao-em-um-circuito-de-primeira-ordem.md": [
		86747,
		86747
	],
	"./01684-como-determinar-a-resposta-natural-de-um-circuito-rlc-de-segunda-ordem.md": [
		60184,
		60184
	],
	"./01685-o-que-e-um-fasor-e-como-ele-e-utilizado-em-circuitos-de-corrente-alternada.md": [
		8914,
		8914
	],
	"./01686-o-que-e-a-conexao-triangulo-estrela-em-circuitos-trifasicos.md": [
		4775,
		4775
	],
	"./01687-como-a-transformada-de-fourier-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		83264,
		83264
	],
	"./01688-como-funciona-a-juncao-pn-em-um-diodo-semicondutor.md": [
		43041,
		43041
	],
	"./01689-como-funciona-um-amplificador-bjt-em-circuitos-analogicos.md": [
		16993,
		16993
	],
	"./01690-o-que-e-um-flip-flop-e-como-ele-funciona-em-circuitos-digitais.md": [
		28035,
		28035
	],
	"./01691-o-que-e-um-filtro-rc-e-como-ele-funciona-em-um-circuito-eletrico.md": [
		23676,
		23676
	],
	"./01692-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		65721,
		65721
	],
	"./01693-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		46444,
		46444
	],
	"./01694-o-que-e-a-analise-nodal-em-circuitos-eletricos.md": [
		76191,
		76191
	],
	"./01695-o-que-acontece-com-a-energia-armazenada-em-um-capacitor-durante-a-comutacao-em-um-circuito-de-primeira-ordem.md": [
		54096,
		54096
	],
	"./01696-qual-e-a-diferenca-entre-uma-resposta-sub-amortecida-e-uma-resposta-criticamente-amortecida-em-circuitos-de-segunda-ordem.md": [
		9324,
		9324
	],
	"./01697-o-que-e-o-fator-de-potencia-em-circuitos-de-corrente-alternada.md": [
		56675,
		56675
	],
	"./01698-o-que-e-potencia-instantanea-em-circuitos-trifasicos.md": [
		83120,
		83120
	],
	"./01699-o-que-e-a-propriedade-de-parseval-e-como-ela-se-aplica-na-analise-de-circuitos-rlc.md": [
		40430,
		40430
	],
	"./01700-como-funciona-a-analise-de-circuitos-com-mosfets-e-diodos.md": [
		80606,
		80606
	],
	"./01701-o-que-e-um-diagrama-de-bode-e-qual-sua-importancia-em-circuitos-analogicos.md": [
		69218,
		69218
	],
	"./01702-como-o-mapa-de-karnaugh-ajuda-na-simplificacao-de-circuitos-logicos.md": [
		61249,
		61249
	],
	"./01703-como-funciona-o-conversor-r2r-em-circuitos-eletricos.md": [
		46987,
		46987
	],
	"./01704-o-que-sao-os-elementos-basicos-de-um-circuito-eletrico.md": [
		56581,
		56581
	],
	"./01705-qual-a-funcao-de-um-transformador-em-um-circuito-eletrico.md": [
		78535,
		78535
	],
	"./01706-o-que-e-a-analise-nodal-em-circuitos-eletricos.md": [
		92555,
		92555
	],
	"./01707-como-a-associacao-de-fontes-de-tensao-afeta-a-carga-em-circuitos-de-primeira-ordem.md": [
		74948,
		74948
	],
	"./01708-o-que-e-um-circuito-criticamente-amortecido.md": [
		75523,
		75523
	],
	"./01709-o-que-e-o-fator-de-potencia-em-circuitos-de-corrente-alternada.md": [
		40603,
		40603
	],
	"./01710-qual-a-diferenca-entre-um-sistema-trifasico-equilibrado-e-um-sistema-monofasico.md": [
		79438,
		79438
	],
	"./01711-o-que-e-a-transformada-de-laplace-e-como-ela-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		85897,
		85897
	],
	"./01712-qual-a-diferenca-entre-jfet-e-mosfet-em-circuitos-eletricos.md": [
		64785,
		64785
	],
	"./01713-como-funciona-um-amplificador-operacional-em-circuitos-analogicos.md": [
		10726,
		10726
	],
	"./01714-o-que-e-um-circuito-combinacional-e-como-ele-difere-de-um-circuito-sequencial.md": [
		58534,
		58534
	],
	"./01715-o-que-e-um-conversor-digital-analogico-dac-e-como-ele-funciona-em-circuitos-eletricos.md": [
		77083,
		77083
	],
	"./01716-o-que-e-a-lei-de-ohm-e-como-ela-se-aplica-em-circuitos-simples.md": [
		35512,
		35512
	],
	"./01717-qual-a-funcao-de-um-transistor-em-um-circuito-eletrico.md": [
		13959,
		13959
	],
	"./01718-o-que-e-a-transformacao-de-norton-e-como-ela-e-utilizada-na-analise-de-circuitos.md": [
		87517,
		87517
	],
	"./01719-o-que-acontece-com-a-corrente-em-um-circuito-rc-durante-a-comutacao.md": [
		21164,
		21164
	],
	"./01720-o-que-e-uma-resposta-sub-amortecida-em-circuitos-de-segunda-ordem.md": [
		96142,
		96142
	],
	"./01721-como-aplicar-o-teorema-de-thevenin-em-circuitos-de-corrente-alternada.md": [
		64772,
		64772
	],
	"./01722-o-que-e-um-circuito-trifasico-equilibrado-e-qual-sua-aplicacao-pratica.md": [
		7878,
		7878
	],
	"./01723-o-que-e-a-transformada-de-laplace-e-como-ela-e-aplicada-na-analise-de-circuitos-rlc.md": [
		61483,
		61483
	],
	"./01724-o-que-e-uma-juncao-pn-e-como-ela-funciona-em-semicondutores.md": [
		27202,
		27202
	],
	"./01725-o-que-e-um-circuito-astavel-e-como-ele-funciona.md": [
		18426,
		18426
	],
	"./01726-o-que-e-um-latch-em-circuitos-digitais-e-como-ele-funciona.md": [
		66828,
		66828
	],
	"./01727-o-que-e-um-circuito-rc-e-como-ele-funciona.md": [
		54695,
		54695
	],
	"./01728-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		73235,
		73235
	],
	"./01729-qual-a-funcao-de-um-capacitor-em-um-circuito-eletrico.md": [
		1457,
		1457
	],
	"./01730-como-determinar-a-resistencia-equivalente-em-um-circuito-eletrico.md": [
		65860,
		65860
	],
	"./01731-o-que-acontece-com-a-energia-armazenada-em-um-circuito-rc-apos-a-comutacao.md": [
		8794,
		8794
	],
	"./01732-como-a-continuidade-das-variaveis-afeta-a-resposta-de-um-circuito-de-segunda-ordem.md": [
		15128,
		15128
	],
	"./01733-o-que-e-o-fator-de-potencia-em-circuitos-de-corrente-alternada.md": [
		10059,
		32440
	],
	"./01734-o-que-e-um-circuito-trifasico-em-configuracao-triangulo-triangulo.md": [
		63135,
		63135
	],
	"./01735-o-que-e-a-transformada-exponencial-e-como-ela-e-utilizada-na-analise-avancada-de-circuitos.md": [
		93330,
		93330
	],
	"./01736-como-a-juncao-pn-afeta-a-corrente-e-a-tensao-em-um-circuito.md": [
		17409,
		17409
	],
	"./01737-como-funciona-o-oscilador-de-wien-em-circuitos-analogicos.md": [
		94364,
		94364
	],
	"./01738-como-a-tabela-verdade-e-utilizada-na-simplificacao-de-circuitos-digitais.md": [
		99552,
		99552
	],
	"./01739-como-funciona-um-circuito-trigger-em-um-sistema-digital.md": [
		78876,
		56495
	],
	"./01740-o-que-e-um-no-em-um-circuito-eletrico.md": [
		95490,
		95490
	],
	"./01741-o-que-sao-componentes-passivos-e-ativos-em-circuitos-eletricos.md": [
		37373,
		37373
	],
	"./01742-o-que-e-uma-supermalha-e-como-ela-e-utilizada-na-analise-de-circuitos.md": [
		98823,
		98823
	],
	"./01743-como-a-energia-armazenada-em-um-capacitor-e-obtida-em-circuitos-de-primeira-ordem.md": [
		62437,
		62437
	],
	"./01744-o-que-e-um-circuito-super-amortecido-e-como-ele-se-comporta.md": [
		72203,
		72203
	],
	"./01745-o-que-e-a-amplitude-em-um-circuito-de-corrente-alternada.md": [
		89784,
		89784
	],
	"./01746-o-que-e-um-circuito-trifasico-equilibrado.md": [
		84821,
		84821
	],
	"./01747-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		63817,
		63817
	],
	"./01748-o-que-significa-um-transistor-bjt-estar-em-modo-saturado.md": [
		67173,
		67173
	],
	"./01749-como-funciona-o-oscilador-de-wien-em-circuitos-analogicos.md": [
		14537,
		14537
	],
	"./01750-qual-e-a-diferenca-entre-latch-e-flip-flop-em-circuitos-digitais.md": [
		78513,
		78513
	],
	"./01751-como-funciona-um-amplificador-operacional-em-um-circuito-r2r.md": [
		65614,
		65614
	],
	"./01752-o-que-e-um-no-em-um-circuito-eletrico.md": [
		26993,
		26993
	],
	"./01753-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		21829,
		21829
	],
	"./01754-como-aplicar-a-analise-nodal-em-um-circuito-com-multiplas-fontes.md": [
		62043,
		62043
	],
	"./01755-como-a-energia-armazenada-em-um-indutor-varia-em-um-circuito-de-primeira-ordem.md": [
		23539,
		23539
	],
	"./01756-o-que-e-um-circuito-de-segunda-ordem-e-quais-sao-seus-tipos-de-resposta.md": [
		13102,
		13102
	],
	"./01757-o-que-e-o-regime-permanente-em-circuitos-rlc-em-corrente-alternada.md": [
		91888,
		91888
	],
	"./01758-o-que-e-o-fator-de-potencia-em-circuitos-trifasicos-e-por-que-ele-e-importante.md": [
		35650,
		35650
	],
	"./01759-como-o-teorema-de-superposicao-e-aplicado-na-analise-de-circuitos-eletricos.md": [
		77870,
		77870
	],
	"./01760-como-funciona-a-juncao-pn-em-semicondutores.md": [
		38343,
		38343
	],
	"./01761-o-que-e-um-circuito-schmitt-trigger-e-como-ele-funciona.md": [
		83377,
		83377
	],
	"./01762-como-converter-um-numero-decimal-para-binario-em-circuitos-digitais.md": [
		76356,
		76356
	],
	"./01763-como-configurar-um-circuito-combinacional-em-um-laboratorio-de-engenharia.md": [
		75451,
		75451
	],
	"./01764-o-que-e-um-circuito-aberto-e-um-curto-circuito.md": [
		64844,
		64844
	],
	"./01765-o-que-e-um-diodo-e-como-ele-funciona-em-um-circuito-eletrico.md": [
		24619,
		24619
	],
	"./01766-como-funciona-o-teorema-da-superposicao-em-circuitos-eletricos.md": [
		59565,
		59565
	],
	"./01767-o-que-e-um-circuito-rl-de-primeira-ordem-e-como-ele-armazena-energia.md": [
		69854,
		69854
	],
	"./01768-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-se-comportam.md": [
		91361,
		91361
	],
	"./01769-como-determinar-a-impedancia-equivalente-em-um-circuito-de-corrente-alternada-usando-o-teorema-de-thevenin.md": [
		34424,
		34424
	],
	"./01770-o-que-e-um-sistema-trifasico-equilibrado-e-qual-sua-aplicacao-pratica.md": [
		16039,
		16039
	],
	"./01771-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		49878,
		49878
	],
	"./01772-como-o-teorema-de-thevenin-e-aplicado-em-circuitos-com-mosfets.md": [
		71085,
		71085
	],
	"./01773-o-que-e-um-circuito-schmitt-trigger-e-como-ele-funciona.md": [
		18978,
		18978
	],
	"./01774-como-funciona-um-latch-em-circuitos-digitais.md": [
		41296,
		41296
	],
	"./01775-como-funcionam-os-conversores-dac-em-circuitos-analogicos.md": [
		19350,
		19350
	],
	"./01776-o-que-sao-os-submultiplos-das-unidades-eletricas-e-como-eles-sao-utilizados-em-circuitos.md": [
		38797,
		38797
	],
	"./01777-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		44747,
		44747
	],
	"./01778-como-funciona-o-metodo-de-superposicao-na-analise-de-circuitos-eletricos.md": [
		27948,
		27948
	],
	"./01779-como-a-energia-armazenada-em-um-capacitor-afeta-o-comportamento-de-um-circuito-rc-de-primeira-ordem.md": [
		3810,
		3810
	],
	"./01780-o-que-e-um-circuito-rlc-super-amortecido.md": [
		46182,
		46182
	],
	"./01781-como-os-fasores-sao-utilizados-na-analise-de-circuitos-em-corrente-alternada.md": [
		69675,
		69675
	],
	"./01782-o-que-e-um-circuito-trifasico-e-como-ele-se-diferencia-de-um-circuito-monofasico.md": [
		40458,
		40458
	],
	"./01783-como-a-transformada-de-fourier-e-utilizada-na-analise-avancada-de-circuitos.md": [
		89144,
		89144
	],
	"./01784-como-os-diodos-funcionam-em-circuitos-eletricos.md": [
		93004,
		93004
	],
	"./01785-como-funciona-um-oscilador-em-circuitos-analogicos.md": [
		60726,
		60726
	],
	"./01786-como-simplificar-uma-funcao-logica-usando-o-mapa-de-karnaugh.md": [
		41005,
		41005
	],
	"./01787-como-montar-um-conversor-analogico-digital-em-serie.md": [
		43806,
		43806
	],
	"./01788-o-que-e-um-no-em-um-circuito-eletrico.md": [
		36302,
		36302
	],
	"./01789-qual-a-funcao-de-um-capacitor-em-um-circuito-eletrico.md": [
		61583,
		61583
	],
	"./01790-o-que-e-o-teorema-da-superposicao-e-como-ele-e-aplicado-na-analise-de-circuitos-eletricos.md": [
		40290,
		40290
	],
	"./01791-o-que-e-um-circuito-de-primeira-ordem-e-como-ele-se-comporta-durante-a-descarga-de-um-capacitor.md": [
		20046,
		20046
	],
	"./01792-o-que-e-um-circuito-super-amortecido-e-como-ele-se-comporta.md": [
		43156,
		43156
	],
	"./01793-o-que-e-admitancia-em-circuitos-de-corrente-alternada.md": [
		73967,
		73967
	],
	"./01794-qual-a-diferenca-entre-a-conexao-estrela-e-a-conexao-triangulo-em-circuitos-trifasicos.md": [
		95724,
		95724
	],
	"./01795-como-os-filtros-afetam-a-forma-de-uma-onda-de-rampa-em-circuitos-eletricos.md": [
		3766,
		3766
	],
	"./01796-como-os-mosfets-funcionam-em-circuitos-eletricos.md": [
		45932,
		45932
	],
	"./01797-o-que-e-o-ponto-de-operacao-em-circuitos-analogicos.md": [
		66662,
		66662
	],
	"./01798-o-que-e-um-latch-em-circuitos-digitais.md": [
		34245,
		34245
	],
	"./01799-o-que-e-tensao-senoidal-e-como-ela-se-comporta-em-circuitos-eletricos.md": [
		53162,
		53162
	],
	"./01800-o-que-e-um-ramo-em-um-circuito-eletrico.md": [
		3661,
		3661
	],
	"./01801-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		61867,
		61867
	],
	"./01802-o-que-e-uma-supermalha-e-como-ela-e-utilizada-na-analise-de-circuitos.md": [
		36454,
		36454
	],
	"./01803-como-a-comutacao-afeta-a-tensao-em-um-indutor-em-circuitos-de-primeira-ordem.md": [
		90288,
		90288
	],
	"./01804-o-que-e-um-circuito-de-segunda-ordem-e-como-ele-se-comporta.md": [
		43890,
		43890
	],
	"./01805-o-que-e-a-impedancia-em-circuitos-de-corrente-alternada.md": [
		21545,
		21545
	],
	"./01806-o-que-e-uma-conexao-estrela-triangulo-em-circuitos-trifasicos.md": [
		26455,
		26455
	],
	"./01807-o-que-e-a-transformada-de-laplace-e-como-ela-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		21071,
		21071
	],
	"./01808-como-funciona-um-diodo-pn-e-qual-e-sua-importancia-em-circuitos-eletricos.md": [
		10322,
		10322
	],
	"./01809-como-os-circuitos-analogicos-diferem-dos-circuitos-digitais.md": [
		70352,
		70352
	],
	"./01810-o-que-e-um-flip-flop-e-como-ele-funciona-em-circuitos-digitais.md": [
		38973,
		38973
	],
	"./01811-como-funciona-um-amplificador-schmitt-trigger-usando-bjt.md": [
		73237,
		73237
	],
	"./01812-o-que-e-a-lei-de-ohm-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		55700,
		55700
	],
	"./01813-o-que-e-um-transistor-e-como-ele-funciona-em-um-circuito-eletrico.md": [
		28749,
		28749
	],
	"./01814-como-os-teoremas-de-norton-e-thevenin-simplificam-a-analise-de-circuitos.md": [
		22129,
		22129
	],
	"./01815-como-os-circuitos-rc-e-rl-armazenam-e-liberam-energia.md": [
		20032,
		20032
	],
	"./01816-o-que-e-uma-resposta-super-amortecida-em-circuitos-de-segunda-ordem.md": [
		52625,
		52625
	],
	"./01817-o-que-e-admitancia-em-circuitos-de-corrente-alternada.md": [
		48078,
		48078
	],
	"./01818-o-que-e-um-sistema-trifasico-em-configuracao-triangulo-triangulo.md": [
		89518,
		67137
	],
	"./01819-o-que-e-um-circuito-passa-faixas-e-como-ele-funciona.md": [
		14535,
		14535
	],
	"./01820-como-funciona-um-transistor-mesfet-em-circuitos-eletricos.md": [
		22644,
		22644
	],
	"./01821-o-que-e-um-amplificador-operacional-e-como-ele-funciona-em-circuitos-analogicos.md": [
		19301,
		19301
	],
	"./01822-como-a-simplificacao-de-circuitos-logicos-pode-ser-aplicada-em-circuitos-cmos.md": [
		76116,
		76116
	],
	"./01823-como-funciona-um-conversor-r2r-em-circuitos-eletricos.md": [
		23913,
		23913
	],
	"./01824-o-que-e-um-circuito-eletrico-simples-e-como-os-elementos-sao-associados.md": [
		79480,
		79480
	],
	"./01825-qual-a-diferenca-entre-capacitores-e-indutores-em-circuitos-eletricos.md": [
		33202,
		33202
	],
	"./01826-o-que-e-o-teorema-de-thevenin-e-como-ele-e-aplicado-na-analise-de-circuitos.md": [
		21075,
		21075
	],
	"./01827-como-a-constante-de-tempo-afeta-a-resposta-de-um-circuito-rl-de-primeira-ordem.md": [
		83464,
		83464
	],
	"./01828-o-que-e-uma-resposta-sub-amortecida-em-circuitos-de-segunda-ordem.md": [
		76411,
		76411
	],
	"./01829-o-que-e-impedancia-em-circuitos-de-corrente-alternada.md": [
		96333,
		96333
	],
	"./01830-qual-e-a-diferenca-entre-circuitos-monofasicos-e-trifasicos.md": [
		78817,
		78817
	],
	"./01831-o-que-e-um-circuito-passa-faixas-e-como-ele-funciona.md": [
		11149,
		11149
	],
	"./01832-como-funciona-a-saturacao-em-um-transistor-bjt.md": [
		41808,
		41808
	],
	"./01833-o-que-e-um-multivibrador-biestavel-e-como-ele-funciona-em-circuitos-analogicos.md": [
		9561,
		9561
	],
	"./01834-o-que-e-uma-porta-logica-e-qual-a-sua-funcao-em-circuitos-digitais.md": [
		20026,
		20026
	],
	"./01835-o-que-e-um-trigger-de-schmitt-e-como-ele-funciona-em-circuitos-ttl.md": [
		48566,
		48566
	],
	"./01836-o-que-e-um-circuito-aberto-e-como-ele-afeta-a-corrente-eletrica.md": [
		48565,
		48565
	],
	"./01837-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		10432,
		10432
	],
	"./01838-o-que-e-a-analise-de-supermalha-em-circuitos-eletricos.md": [
		67841,
		67841
	],
	"./01839-como-a-energia-armazenada-em-um-capacitor-e-afetada-em-circuitos-de-primeira-ordem.md": [
		80644,
		80644
	],
	"./01840-o-que-e-um-circuito-super-amortecido-e-como-ele-se-comporta.md": [
		61742,
		61742
	],
	"./01841-o-que-e-a-admitancia-em-um-circuito-rlc-em-serie.md": [
		30483,
		30483
	],
	"./01842-como-funciona-a-ligacao-triangulo-triangulo-em-circuitos-trifasicos.md": [
		68500,
		68500
	],
	"./01843-como-a-analise-grafica-pode-facilitar-a-compreensao-de-circuitos-eletricos-avancados.md": [
		96103,
		96103
	],
	"./01844-como-funciona-um-diodo-em-um-circuito-eletrico-simples.md": [
		81120,
		81120
	],
	"./01845-o-que-e-um-oscilador-de-ponte-de-wien-e-como-ele-funciona.md": [
		48939,
		48939
	],
	"./01846-como-funcionam-as-portas-logicas-em-circuitos-digitais.md": [
		81095,
		81095
	],
	"./01847-como-funcionam-os-filtros-em-circuitos-eletricos-combinacionais.md": [
		91061,
		91061
	],
	"./01848-o-que-e-um-curto-circuito-e-como-ele-ocorre-em-um-circuito-eletrico.md": [
		71425,
		71425
	],
	"./01849-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		88771,
		88771
	],
	"./01850-o-que-e-uma-supermalha-e-como-ela-e-utilizada-na-analise-de-circuitos.md": [
		14961,
		14961
	],
	"./01851-o-que-e-um-circuito-de-primeira-ordem-e-como-ele-se-comporta-durante-a-descarga-de-um-capacitor.md": [
		83039,
		83039
	],
	"./01852-qual-a-diferenca-entre-a-resposta-natural-e-a-resposta-forcada-em-circuitos-de-segunda-ordem.md": [
		70985,
		70985
	],
	"./01853-o-que-e-a-potencia-instantanea-em-circuitos-de-corrente-alternada.md": [
		50693,
		50693
	],
	"./01854-qual-a-diferenca-entre-circuitos-monofasicos-e-trifasicos.md": [
		825,
		825
	],
	"./01855-o-que-e-o-teorema-de-parseval-e-como-ele-se-aplica-na-analise-de-circuitos.md": [
		59804,
		59804
	],
	"./01856-o-que-e-uma-juncao-pn-em-semicondutores-e-como-ela-funciona.md": [
		50278,
		50278
	],
	"./01857-o-que-e-um-filtro-passivo-e-como-ele-e-implementado-em-circuitos-analogicos.md": [
		15859,
		15859
	],
	"./01858-o-que-e-um-latch-e-como-ele-funciona-em-circuitos-digitais.md": [
		16628,
		16628
	],
	"./01859-o-que-e-a-resposta-em-regime-permanente-em-um-circuito-eletrico.md": [
		60019,
		60019
	],
	"./01860-o-que-e-um-ramo-em-um-circuito-eletrico.md": [
		14519,
		14519
	],
	"./01861-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		9797,
		9797
	],
	"./01862-o-que-e-a-transferencia-de-tensao-em-um-circuito-eletrico.md": [
		25071,
		25071
	],
	"./01863-como-a-energia-e-armazenada-em-um-indutor-em-circuitos-de-primeira-ordem.md": [
		53943,
		53943
	],
	"./01864-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-se-comportam.md": [
		91788,
		91788
	],
	"./01865-como-a-impedancia-afeta-a-corrente-em-circuitos-de-corrente-alternada.md": [
		53323,
		53323
	],
	"./01866-o-que-e-um-sistema-trifasico-equilibrado-e-qual-sua-aplicacao-pratica.md": [
		93577,
		93577
	],
	"./01867-como-a-analise-de-fourier-e-aplicada-em-circuitos-rlc-serie.md": [
		11404,
		11404
	],
	"./01868-como-funciona-um-diodo-pn-em-um-circuito-eletrico.md": [
		11433,
		11433
	],
	"./01869-o-que-e-um-multivibrador-e-como-ele-funciona-em-circuitos-analogicos.md": [
		60580,
		60580
	],
	"./01870-como-funciona-a-conversao-de-sinais-analogicos-para-digitais-em-circuitos-digitais.md": [
		23461,
		23461
	],
	"./01871-como-funciona-um-amplificador-bjt-em-serie.md": [
		5944,
		5944
	],
	"./01872-o-que-e-um-ramo-em-um-circuito-eletrico.md": [
		54328,
		54328
	],
	"./01873-o-que-sao-componentes-eletronicos-lineares-e-como-eles-funcionam.md": [
		37351,
		37351
	],
	"./01874-como-a-analise-por-superposicao-afeta-a-potencia-em-um-circuito.md": [
		61424,
		61424
	],
	"./01875-o-que-acontece-com-a-corrente-em-um-circuito-rc-apos-a-comutacao.md": [
		84691,
		84691
	],
	"./01876-o-que-e-uma-resposta-subamortecida-em-circuitos-de-segunda-ordem.md": [
		67951,
		67951
	],
	"./01877-qual-e-a-diferenca-entre-valor-rms-e-valor-instantaneo-em-circuitos-de-corrente-alternada.md": [
		78227,
		78227
	],
	"./01878-qual-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		80485,
		80485
	],
	"./01879-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		62041,
		62041
	],
	"./01880-o-que-significa-um-bjt-estar-em-modo-saturado.md": [
		11480,
		11480
	],
	"./01881-o-que-e-um-circuito-astavel-e-como-ele-funciona.md": [
		45029,
		45029
	],
	"./01882-como-implementar-uma-funcao-logica-a-partir-de-uma-tabela-verdade.md": [
		25707,
		25707
	],
	"./01883-o-que-e-um-filtro-em-regime-permanente-em-circuitos-analogicos.md": [
		78959,
		78959
	],
	"./01884-o-que-e-a-lei-de-kirchhoff-das-correntes-lkc-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		99631,
		99631
	],
	"./01885-o-que-e-um-transformador-e-como-ele-funciona-em-circuitos-eletricos.md": [
		1878,
		1878
	],
	"./01886-como-funciona-o-principio-da-superposicao-em-circuitos-eletricos.md": [
		80348,
		80348
	],
	"./01887-como-ocorre-a-descarga-de-um-capacitor-em-um-circuito-de-primeira-ordem.md": [
		69410,
		69410
	],
	"./01888-o-que-e-um-circuito-lc-super-amortecido-e-como-ele-se-comporta.md": [
		68668,
		68668
	],
	"./01889-o-que-e-a-potencia-em-circuitos-de-corrente-alternada.md": [
		18113,
		18113
	],
	"./01890-o-que-e-um-circuito-trifasico-equilibrado.md": [
		10727,
		10727
	],
	"./01891-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		24311,
		24311
	],
	"./01892-qual-a-diferenca-entre-mosfet-e-mesfet.md": [
		25000,
		25000
	],
	"./01893-o-que-e-um-multivibrador-e-qual-sua-aplicacao-em-circuitos-analogicos.md": [
		43591,
		43591
	],
	"./01894-como-funciona-a-conversao-de-numeros-decimais-para-binarios-em-circuitos-digitais.md": [
		62587,
		62587
	],
	"./01895-como-medir-a-resposta-de-um-circuito-rlc-em-um-laboratorio-de-engenharia.md": [
		82124,
		82124
	],
	"./01896-o-que-e-um-ramo-em-um-circuito-eletrico.md": [
		19710,
		19710
	],
	"./01897-qual-a-diferenca-entre-um-indutor-e-um-capacitor-em-circuitos-eletricos.md": [
		25089,
		25089
	],
	"./01898-como-funciona-o-teorema-de-superposicao-em-circuitos-eletricos.md": [
		42421,
		42421
	],
	"./01899-o-que-acontece-durante-a-descarga-de-um-indutor-em-um-circuito-de-primeira-ordem.md": [
		57775,
		57775
	],
	"./01900-o-que-e-um-circuito-criticamente-amortecido-em-um-circuito-de-segunda-ordem.md": [
		31418,
		31418
	],
	"./01901-como-a-admitancia-afeta-circuitos-rlc-em-serie.md": [
		97430,
		97430
	],
	"./01902-o-que-e-um-circuito-trifasico-equilibrado-e-como-ele-se-relaciona-com-as-conexoes-estrela-e-triangulo.md": [
		37326,
		37326
	],
	"./01903-o-que-e-a-serie-de-fourier-e-como-ela-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		47194,
		47194
	],
	"./01904-como-a-teoria-de-thevenin-e-aplicada-na-analise-de-circuitos-com-mosfets.md": [
		74524,
		74524
	],
	"./01905-o-que-e-um-diagrama-de-bode-e-qual-sua-importancia-em-circuitos-analogicos.md": [
		1792,
		1792
	],
	"./01906-como-os-flip-flops-sao-utilizados-em-circuitos-digitais.md": [
		56104,
		56104
	],
	"./01907-o-que-e-um-schmitt-trigger-e-como-ele-funciona-em-circuitos-eletricos.md": [
		59224,
		59224
	],
	"./01908-o-que-e-potencia-em-circuitos-eletricos.md": [
		51580,
		51580
	],
	"./01909-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		98070,
		98070
	],
	"./01910-o-que-e-o-teorema-de-thevenin-e-como-ele-simplifica-a-analise-de-circuitos.md": [
		36235,
		36235
	],
	"./01911-o-que-acontece-com-a-corrente-em-um-circuito-rl-apos-a-comutacao.md": [
		36411,
		36411
	],
	"./01912-como-os-circuitos-de-segunda-ordem-respondem-a-um-degrau-de-tensao.md": [
		99984,
		99984
	],
	"./01913-como-aplicar-o-teorema-de-thevenin-em-circuitos-de-corrente-alternada.md": [
		98083,
		98083
	],
	"./01914-o-que-e-uma-conexao-triangulo-triangulo-em-circuitos-trifasicos.md": [
		2126,
		2126
	],
	"./01915-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		74482,
		74482
	],
	"./01916-como-a-juncao-pn-afeta-o-comportamento-dos-semicondutores.md": [
		8315,
		8315
	],
	"./01917-como-funciona-um-oscilador-wien-em-circuitos-analogicos.md": [
		41613,
		41613
	],
	"./01918-como-simplificar-expressoes-booleanas-usando-o-mapa-de-karnaugh.md": [
		96858,
		96858
	],
	"./01919-o-que-e-um-trigger-em-circuitos-eletricos-e-como-ele-funciona.md": [
		45520,
		45520
	],
	"./01920-o-que-e-tensao-eletrica-e-como-ela-se-relaciona-com-a-carga-em-um-circuito.md": [
		37181,
		37181
	],
	"./01921-qual-e-a-funcao-de-um-indutor-em-um-circuito-eletronico.md": [
		15163,
		15163
	],
	"./01922-o-que-e-o-teorema-da-superposicao-e-como-ele-e-aplicado-na-analise-de-circuitos-eletricos.md": [
		35030,
		35030
	],
	"./01923-como-os-capacitores-e-indutores-se-comportam-em-circuitos-de-primeira-ordem.md": [
		30779,
		30779
	],
	"./01924-o-que-e-uma-resposta-subamortecida-em-circuitos-de-segunda-ordem.md": [
		14499,
		14499
	],
	"./01925-o-que-e-impedancia-em-circuitos-de-corrente-alternada.md": [
		11830,
		11830
	],
	"./01926-o-que-e-um-circuito-trifasico-equilibrado-e-por-que-ele-e-usado.md": [
		37491,
		37491
	],
	"./01927-como-a-transformada-de-fourier-e-utilizada-na-analise-de-circuitos-rlc.md": [
		60972,
		60972
	],
	"./01928-como-funciona-a-juncao-pn-em-um-circuito-eletrico.md": [
		52040,
		52040
	],
	"./01929-o-que-e-um-circuito-astavel-e-como-ele-funciona.md": [
		78720,
		78720
	],
	"./01930-como-implementar-uma-funcao-booleana-usando-portas-logicas.md": [
		83804,
		61423
	],
	"./01931-o-que-e-o-regime-permanente-em-circuitos-eletricos.md": [
		36884,
		36884
	],
	"./01932-como-funciona-a-associacao-de-resistores-em-paralelo.md": [
		99769,
		99769
	],
	"./01933-qual-a-funcao-de-um-capacitor-em-um-circuito-eletrico.md": [
		90660,
		90660
	],
	"./01934-como-funciona-a-transformacao-de-fontes-em-circuitos-eletricos.md": [
		40839,
		40839
	],
	"./01935-como-a-energia-armazenada-em-um-capacitor-e-obtida-em-um-circuito-rc.md": [
		72708,
		72708
	],
	"./01936-o-que-e-uma-resposta-criticamente-amortecida-em-circuitos-de-segunda-ordem.md": [
		44989,
		44989
	],
	"./01937-como-funciona-o-principio-da-superposicao-em-circuitos-de-corrente-alternada.md": [
		81414,
		81414
	],
	"./01938-como-funciona-a-conexao-triangulo-triangulo-em-circuitos-trifasicos.md": [
		66135,
		66135
	],
	"./01939-como-a-transformada-de-fourier-e-utilizada-na-analise-de-circuitos-rlc.md": [
		84261,
		84261
	],
	"./01940-como-funciona-um-transistor-bjt.md": [
		49871,
		49871
	],
	"./01941-como-funciona-um-oscilador-em-circuitos-analogicos.md": [
		38468,
		38468
	],
	"./01942-como-converter-uma-expressao-booleana-em-uma-tabela-verdade.md": [
		88642,
		88642
	],
	"./01943-qual-e-a-importancia-das-portas-logicas-em-circuitos-digitais.md": [
		50499,
		50499
	],
	"./01944-o-que-e-tensao-eletrica-e-como-ela-se-relaciona-com-resistencia-e-potencia.md": [
		6720,
		6720
	],
	"./01945-o-que-e-um-transformador-e-como-ele-funciona-em-circuitos-eletricos.md": [
		22997,
		22997
	],
	"./01946-o-que-e-uma-supermalha-em-circuitos-eletricos.md": [
		75351,
		75351
	],
	"./01947-como-a-energia-armazenada-em-um-capacitor-varia-ao-longo-do-tempo-em-um-circuito-rc.md": [
		68044,
		68044
	],
	"./01948-o-que-e-a-resposta-natural-de-um-circuito-de-segunda-ordem.md": [
		44480,
		44480
	],
	"./01949-o-que-e-a-impedancia-em-circuitos-rlc-e-como-ela-afeta-a-fase-da-corrente.md": [
		92541,
		92541
	],
	"./01950-qual-e-a-diferenca-entre-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		89147,
		89147
	],
	"./01951-o-que-e-a-funcao-de-transferencia-inversa-em-circuitos-eletricos.md": [
		96506,
		96506
	],
	"./01952-qual-a-diferenca-entre-jfet-bjt-e-mosfet.md": [
		14100,
		14100
	],
	"./01953-como-funciona-um-circuito-trigger-com-amplificador-operacional.md": [
		9250,
		9250
	],
	"./01954-o-que-e-um-latch-em-circuitos-digitais.md": [
		19103,
		19103
	],
	"./01955-como-funciona-a-configuracao-de-um-circuito-rc-em-um-experimento-de-laboratorio.md": [
		5241,
		5241
	],
	"./01956-o-que-e-um-ramo-em-um-circuito-eletrico.md": [
		85337,
		85337
	],
	"./01957-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		59243,
		59243
	],
	"./01958-como-determinar-a-potencia-maxima-dissipada-em-um-resistor.md": [
		84255,
		84255
	],
	"./01959-o-que-acontece-com-a-corrente-em-um-circuito-rl-durante-a-descarga-do-capacitor.md": [
		30342,
		30342
	],
	"./01960-como-resolver-circuitos-de-segunda-ordem-em-paralelo.md": [
		10076,
		10076
	],
	"./01961-o-que-e-a-impedancia-em-circuitos-de-corrente-alternada.md": [
		39132,
		39132
	],
	"./01962-qual-e-a-diferenca-entre-potencia-instantanea-em-circuitos-monofasicos-e-trifasicos-equilibrados.md": [
		33048,
		33048
	],
	"./01963-como-funciona-um-filtro-passa-faixas-em-circuitos-eletricos.md": [
		50960,
		50960
	],
	"./01964-qual-a-diferenca-entre-um-transistor-hbt-e-um-mosfet.md": [
		50197,
		50197
	],
	"./01965-o-que-e-um-multivibrador-astavel-e-como-ele-funciona-em-circuitos-analogicos.md": [
		64489,
		86870
	],
	"./01966-qual-e-a-diferenca-entre-circuitos-combinacionais-e-circuitos-sequenciais.md": [
		35340,
		35340
	],
	"./01967-como-montar-um-filtro-rlc-em-um-circuito-experimental.md": [
		73858,
		73858
	],
	"./01968-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		59997,
		59997
	],
	"./01969-como-funcionam-os-transformadores-em-circuitos-eletricos.md": [
		35097,
		35097
	],
	"./01970-o-que-e-um-no-em-um-circuito-eletrico-e-qual-sua-importancia-na-analise-de-circuitos.md": [
		72605,
		72605
	],
	"./01971-o-que-acontece-com-a-energia-armazenada-em-um-circuito-rc-apos-a-comutacao.md": [
		30364,
		30364
	],
	"./01972-o-que-e-uma-resposta-sub-amortecida-em-um-circuito-lc-de-segunda-ordem.md": [
		27529,
		27529
	],
	"./01973-como-ocorre-a-transferencia-maxima-de-potencia-em-circuitos-de-corrente-alternada.md": [
		84529,
		84529
	],
	"./01974-qual-a-diferenca-entre-as-conexoes-triangulo-estrela-e-triangulo-triangulo-em-circuitos-trifasicos.md": [
		33268,
		33268
	],
	"./01975-o-que-e-um-filtro-passa-faixas-e-qual-sua-aplicacao-em-circuitos-rlc.md": [
		13373,
		13373
	],
	"./01976-como-os-semicondutores-sao-utilizados-em-circuitos-eletricos.md": [
		82373,
		82373
	],
	"./01977-o-que-e-um-filtro-passivo-em-circuitos-analogicos.md": [
		49644,
		49644
	],
	"./01978-como-os-flip-flops-sao-utilizados-em-circuitos-digitais.md": [
		92065,
		92065
	],
	"./01979-o-que-e-um-circuito-schmitt-trigger-e-qual-sua-importancia-em-sistemas-digitais.md": [
		17252,
		17252
	],
	"./01980-o-que-e-resistencia-eletrica-e-como-ela-se-comporta-em-diferentes-associacoes.md": [
		15217,
		15217
	],
	"./01981-o-que-e-um-diodo-e-como-ele-funciona-em-um-circuito-eletrico.md": [
		33599,
		33599
	],
	"./01982-o-que-e-o-teorema-da-superposicao-e-como-ele-e-aplicado-na-analise-de-circuitos.md": [
		7986,
		7986
	],
	"./01983-o-que-e-a-constante-de-tempo-em-circuitos-rc-e-qual-sua-importancia.md": [
		40118,
		40118
	],
	"./01984-o-que-e-a-continuidade-da-tensao-em-um-circuito-lc-de-segunda-ordem.md": [
		522,
		522
	],
	"./01985-o-que-e-potencia-instantanea-em-circuitos-de-corrente-alternada.md": [
		40627,
		40627
	],
	"./01986-qual-a-diferenca-entre-a-conexao-estrela-e-a-conexao-triangulo-em-circuitos-trifasicos.md": [
		65699,
		65699
	],
	"./01987-como-a-transformada-de-fourier-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		61433,
		61433
	],
	"./01988-o-que-e-um-igbt-e-como-ele-funciona-em-um-circuito-eletrico.md": [
		12215,
		12215
	],
	"./01989-o-que-e-um-filtro-ativo-e-como-ele-funciona-em-circuitos-analogicos.md": [
		58783,
		58783
	],
	"./01990-o-que-e-um-flip-flop-e-como-ele-funciona-em-circuitos-digitais.md": [
		37984,
		37984
	],
	"./01991-como-montar-seu-primeiro-circuito-basico.md": [
		61420,
		61420
	],
	"./01992-o-que-e-potencia-eletrica-e-como-ela-se-relaciona-com-tensao-e-carga.md": [
		81069,
		81069
	],
	"./01993-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		55079,
		55079
	],
	"./01994-como-verificar-a-linearidade-de-um-circuito-eletrico.md": [
		47217,
		47217
	],
	"./01995-como-a-energia-armazenada-em-um-capacitor-se-comporta-ao-longo-do-tempo-durante-a-descarga.md": [
		94672,
		94672
	],
	"./01996-o-que-e-a-resposta-natural-de-um-circuito-de-segunda-ordem.md": [
		79925,
		79925
	],
	"./01997-o-que-e-uma-onda-senoidal-em-circuitos-de-corrente-alternada.md": [
		52452,
		52452
	],
	"./01998-qual-a-diferenca-entre-a-conexao-triangulo-e-estrela-em-circuitos-trifasicos.md": [
		95980,
		95980
	],
	"./01999-o-que-e-o-teorema-do-inverso-e-como-ele-se-aplica-na-analise-de-circuitos.md": [
		44195,
		44195
	],
	"./02000-como-funcionam-os-diodos-em-circuitos-eletricos.md": [
		78258,
		78258
	],
	"./02001-como-funciona-um-amplificador-operacional-em-um-circuito-analogico.md": [
		71740,
		71740
	],
	"./02002-como-os-flip-flops-sao-utilizados-em-circuitos-digitais.md": [
		92652,
		92652
	],
	"./02003-como-funciona-um-conversor-dac-em-um-circuito-rlc-em-serie.md": [
		40269,
		40269
	],
	"./02004-o-que-e-um-no-em-um-circuito-eletrico.md": [
		75172,
		75172
	],
	"./02005-qual-a-funcao-de-um-capacitor-em-um-circuito-eletrico.md": [
		87785,
		87785
	],
	"./02006-como-a-linearidade-afeta-a-analise-de-circuitos-eletricos.md": [
		61621,
		61621
	],
	"./02007-o-que-acontece-com-a-tensao-em-um-circuito-rc-apos-a-comutacao.md": [
		79520,
		79520
	],
	"./02008-o-que-sao-circuitos-de-segunda-ordem-e-como-suas-respostas-diferem.md": [
		42004,
		42004
	],
	"./02009-o-que-e-a-admitancia-em-circuitos-de-corrente-alternada.md": [
		17296,
		17296
	],
	"./02010-qual-a-diferenca-entre-as-conexoes-triangulo-estrela-e-triangulo-triangulo-em-circuitos-trifasicos.md": [
		23954,
		23954
	],
	"./02011-o-que-e-um-filtro-passa-faixas-e-como-ele-funciona-em-circuitos-eletricos.md": [
		1210,
		1210
	],
	"./02012-como-funciona-a-juncao-de-um-diodo-semicondutor.md": [
		67685,
		67685
	],
	"./02013-o-que-e-um-trigger-de-schmitt-e-como-ele-funciona-em-circuitos-analogicos.md": [
		9601,
		9601
	],
	"./02014-o-que-e-um-latch-em-circuitos-digitais.md": [
		6555,
		6555
	],
	"./02015-como-configurar-um-filtro-combinacional-em-um-circuito-experimental.md": [
		37946,
		15565
	],
	"./02016-o-que-e-resistencia-eletrica-e-como-ela-se-comporta-em-um-circuito-em-serie.md": [
		4834,
		4834
	],
	"./02017-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		64751,
		64751
	],
	"./02018-o-que-e-uma-supermalha-e-como-ela-e-utilizada-na-analise-de-circuitos.md": [
		21650,
		21650
	],
	"./02019-como-funcionam-os-circuitos-de-primeira-ordem.md": [
		38295,
		38295
	],
	"./02020-como-a-continuidade-afeta-o-comportamento-inicial-de-circuitos-rlc.md": [
		64882,
		64882
	],
	"./02021-o-que-e-impedancia-em-circuitos-de-corrente-alternada.md": [
		7642,
		7642
	],
	"./02022-o-que-e-uma-conexao-triangulo-triangulo-em-circuitos-trifasicos.md": [
		28019,
		28019
	],
	"./02023-o-que-e-um-circuito-passivo-e-como-ele-e-representado-graficamente.md": [
		87973,
		87973
	],
	"./02024-como-funciona-a-juncao-pn-em-semicondutores.md": [
		25557,
		25557
	],
	"./02025-o-que-e-um-circuito-astavel-e-como-ele-funciona.md": [
		6684,
		6684
	],
	"./02026-como-funcionam-as-portas-logicas-mos-em-circuitos-digitais.md": [
		27176,
		27176
	],
	"./02027-o-que-e-um-conversor-digital-analogico-dac-e-como-ele-funciona.md": [
		69426,
		69426
	],
	"./02028-o-que-e-a-lei-de-ohm-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		54378,
		54378
	],
	"./02029-qual-a-diferenca-entre-componentes-passivos-e-ativos-em-circuitos-eletricos.md": [
		91394,
		91394
	],
	"./02030-como-aplicar-o-teorema-de-thevenin-na-analise-de-circuitos.md": [
		93605,
		93605
	],
	"./02031-o-que-e-a-constante-de-tempo-em-circuitos-de-primeira-ordem.md": [
		85071,
		85071
	],
	"./02032-como-a-continuidade-da-corrente-afeta-circuitos-lc-de-segunda-ordem.md": [
		29899,
		29899
	],
	"./02033-qual-e-a-diferenca-entre-potencia-media-e-potencia-instantanea-em-circuitos-de-corrente-alternada.md": [
		12446,
		12446
	],
	"./02034-o-que-e-um-sistema-trifasico-equilibrado-e-por-que-ele-e-usado.md": [
		35872,
		35872
	],
	"./02035-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-rlc.md": [
		34401,
		34401
	],
	"./02036-o-que-significa-um-mosfet-estar-na-regiao-de-saturacao.md": [
		49855,
		49855
	],
	"./02037-como-funciona-a-ponte-de-wheatstone-em-circuitos-analogicos.md": [
		93667,
		93667
	],
	"./02038-como-funciona-um-circuito-combinacional-cmos.md": [
		16765,
		16765
	],
	"./02039-como-montar-um-filtro-passa-baixa-em-um-laboratorio-de-circuitos-eletricos.md": [
		59742,
		59742
	],
	"./02040-o-que-sao-os-conceitos-basicos-de-um-circuito-eletrico.md": [
		64210,
		64210
	],
	"./02041-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		76354,
		76354
	],
	"./02042-o-que-e-uma-supermalha-e-como-ela-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		44248,
		44248
	],
	"./02043-como-a-corrente-se-comporta-em-um-circuito-rl-de-primeira-ordem-durante-a-descarga.md": [
		63209,
		63209
	],
	"./02044-o-que-e-uma-resposta-super-amortecida-em-circuitos-de-segunda-ordem.md": [
		80549,
		80549
	],
	"./02045-como-funciona-a-associacao-de-impedancias-em-circuitos-de-corrente-alternada.md": [
		3931,
		3931
	],
	"./02046-qual-a-diferenca-entre-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		6758,
		6758
	],
	"./02047-o-que-e-o-teorema-de-parseval-e-como-ele-se-aplica-na-analise-de-circuitos.md": [
		53684,
		53684
	],
	"./02048-como-funciona-um-transistor-bipolar-em-um-circuito-simples.md": [
		83345,
		83345
	],
	"./02049-como-funciona-um-oscilador-astavel-em-circuitos-analogicos.md": [
		75967,
		75967
	],
	"./02050-o-que-e-um-flip-flop-e-como-ele-funciona-em-circuitos-digitais.md": [
		16980,
		16980
	],
	"./02051-o-que-e-a-configuracao-de-emissor-comum-em-circuitos-eletricos.md": [
		71863,
		71863
	],
	"./02052-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		7172,
		7172
	],
	"./02053-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		30627,
		30627
	],
	"./02054-o-que-e-uma-supermalha-e-como-ela-e-utilizada-na-analise-de-circuitos.md": [
		36378,
		36378
	],
	"./02055-como-a-tensao-em-um-circuito-rc-de-primeira-ordem-varia-ao-longo-do-tempo.md": [
		74348,
		74348
	],
	"./02056-qual-a-diferenca-entre-uma-resposta-sub-amortecida-e-uma-resposta-super-amortecida-em-circuitos-de-segunda-ordem.md": [
		83366,
		83366
	],
	"./02057-o-que-e-admitancia-em-circuitos-de-corrente-alternada.md": [
		1929,
		1929
	],
	"./02058-qual-a-diferenca-entre-as-conexoes-triangulo-estrela-e-triangulo-triangulo-em-circuitos-trifasicos.md": [
		34014,
		34014
	],
	"./02059-como-o-teorema-de-parseval-e-aplicado-na-analise-de-circuitos-eletricos.md": [
		72319,
		72319
	],
	"./02060-como-funcionam-os-transistores-bipolares-e-mosfets-em-circuitos-eletricos.md": [
		23063,
		23063
	],
	"./02061-qual-a-diferenca-entre-circuitos-analogicos-e-digitais.md": [
		74376,
		74376
	],
	"./02062-como-converter-um-numero-decimal-para-binario-em-circuitos-digitais.md": [
		9210,
		9210
	],
	"./02063-o-que-e-o-regime-permanente-em-circuitos-rlc.md": [
		41338,
		41338
	],
	"./02064-o-que-e-um-ramo-em-um-circuito-eletrico.md": [
		29932,
		29932
	],
	"./02065-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		68708,
		68708
	],
	"./02066-o-que-e-a-transformacao-de-norton-e-como-ela-e-aplicada-em-circuitos-eletricos.md": [
		6984,
		6984
	],
	"./02067-como-a-tensao-em-um-capacitor-varia-durante-a-descarga-em-um-circuito-rc.md": [
		96990,
		96990
	],
	"./02068-como-os-circuitos-rlc-de-segunda-ordem-sao-aplicados-na-pratica.md": [
		78198,
		78198
	],
	"./02069-como-o-teorema-da-superposicao-e-aplicado-em-circuitos-de-corrente-alternada.md": [
		80977,
		80977
	],
	"./02070-qual-e-a-diferenca-entre-a-conexao-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		20040,
		20040
	],
	"./02071-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		54724,
		54724
	],
	"./02072-como-os-semicondutores-influenciam-o-comportamento-dos-circuitos-eletricos.md": [
		45849,
		45849
	],
	"./02073-como-funciona-um-oscilador-passivo-em-circuitos-analogicos.md": [
		77397,
		77397
	],
	"./02074-como-simplificar-a-implementacao-de-um-circuito-sequencial-digital.md": [
		92606,
		92606
	],
	"./02075-o-que-e-um-dac-e-qual-sua-importancia-em-circuitos-eletricos.md": [
		90298,
		90298
	],
	"./02076-o-que-e-um-no-em-um-circuito-eletrico.md": [
		25633,
		25633
	],
	"./02077-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		40161,
		40161
	],
	"./02078-como-a-linearidade-afeta-a-analise-nodal-em-circuitos-eletricos.md": [
		86802,
		86802
	],
	"./02079-como-a-energia-armazenada-em-um-capacitor-e-um-indutor-se-comporta-ao-longo-do-tempo-em-circuitos-de-primeira-ordem.md": [
		97111,
		97111
	],
	"./02080-como-determinar-a-resposta-de-um-circuito-de-segunda-ordem-com-uma-fonte-de-tensao.md": [
		12711,
		12711
	],
	"./02081-o-que-e-impedancia-em-circuitos-de-corrente-alternada.md": [
		59508,
		59508
	],
	"./02082-o-que-e-um-circuito-trifasico-equilibrado.md": [
		31295,
		31295
	],
	"./02083-o-que-e-uma-singularidade-em-um-circuito-rlc-serie.md": [
		8212,
		8212
	],
	"./02084-como-funciona-um-diodo-pn-em-um-circuito-eletrico.md": [
		17884,
		17884
	],
	"./02085-como-funciona-um-circuito-biestavel-em-circuitos-analogicos.md": [
		74168,
		74168
	],
	"./02086-como-funcionam-as-portas-logicas-em-circuitos-digitais.md": [
		52998,
		52998
	],
	"./02087-o-que-e-um-circuito-rc-e-qual-sua-aplicacao-pratica.md": [
		48940,
		26559
	],
	"./02088-o-que-e-um-no-em-um-circuito-eletrico.md": [
		5648,
		5648
	],
	"./02089-qual-a-diferenca-entre-componentes-passivos-e-ativos-em-circuitos-eletricos.md": [
		89204,
		89204
	],
	"./02090-como-funciona-o-principio-da-superposicao-em-circuitos-eletricos.md": [
		46068,
		46068
	],
	"./02091-como-ocorre-a-descarga-em-um-circuito-rc-de-primeira-ordem.md": [
		4952,
		4952
	],
	"./02092-o-que-e-uma-resposta-sub-amortecida-em-circuitos-de-segunda-ordem.md": [
		97921,
		97921
	],
	"./02093-como-funciona-a-analise-nodal-em-circuitos-de-corrente-alternada.md": [
		52183,
		52183
	],
	"./02094-o-que-e-a-potencia-instantanea-em-circuitos-trifasicos.md": [
		43713,
		43713
	],
	"./02095-o-que-e-o-teorema-de-parseval-e-como-ele-se-aplica-na-analise-de-circuitos.md": [
		673,
		673
	],
	"./02096-como-funciona-um-transistor-mesfet-em-um-circuito-simples.md": [
		42309,
		42309
	],
	"./02097-o-que-e-um-multivibrador-e-como-ele-funciona-em-circuitos-analogicos.md": [
		89346,
		89346
	],
	"./02098-como-funcionam-os-flip-flops-em-circuitos-digitais.md": [
		53497,
		53497
	],
	"./02099-como-montar-um-circuito-rlc-em-um-laboratorio-de-engenharia.md": [
		15769,
		15769
	],
	"./02100-o-que-e-um-no-em-um-circuito-eletrico.md": [
		82743,
		82743
	],
	"./02101-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		22795,
		22795
	],
	"./02102-o-que-e-o-teorema-de-thevenin-e-como-ele-pode-ser-aplicado-na-analise-de-circuitos.md": [
		14733,
		14733
	],
	"./02103-como-funciona-a-descarga-de-um-indutor-em-um-circuito-rl-de-primeira-ordem.md": [
		61215,
		61215
	],
	"./02104-como-a-continuidade-da-corrente-e-da-tensao-afeta-circuitos-de-segunda-ordem.md": [
		90508,
		90508
	],
	"./02105-o-que-e-um-fasor-e-como-ele-e-utilizado-em-circuitos-de-corrente-alternada.md": [
		34376,
		34376
	],
	"./02106-qual-a-diferenca-entre-as-conexoes-triangulo-e-estrela-em-circuitos-trifasicos.md": [
		14234,
		14234
	],
	"./02107-como-os-filtros-rlc-funcionam-em-circuitos-eletricos.md": [
		44649,
		44649
	],
	"./02108-qual-a-diferenca-entre-um-bjt-e-um-igbt.md": [
		70738,
		70738
	],
	"./02109-o-que-e-um-circuito-schmitt-trigger-e-como-ele-funciona.md": [
		63046,
		63046
	],
	"./02110-o-que-e-um-latch-em-circuitos-digitais.md": [
		88686,
		88686
	],
	"./02111-como-funcionam-os-amplificadores-em-circuitos-eletricos.md": [
		48614,
		48614
	],
	"./02112-o-que-e-a-lei-de-kirchhoff-para-nos-em-circuitos-eletricos.md": [
		24344,
		24344
	],
	"./02113-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		3526,
		3526
	],
	"./02114-como-verificar-a-tensao-maxima-em-um-no-utilizando-os-teoremas-de-thevenin-e-norton.md": [
		75939,
		75939
	],
	"./02115-o-que-acontece-com-a-energia-armazenada-em-um-capacitor-durante-a-comutacao-em-um-circuito-de-primeira-ordem.md": [
		54754,
		54754
	],
	"./02116-o-que-e-um-circuito-criticamente-amortecido.md": [
		73725,
		73725
	],
	"./02117-o-que-e-a-impedancia-em-um-circuito-de-corrente-alternada.md": [
		16590,
		16590
	],
	"./02118-o-que-e-um-circuito-trifasico-equilibrado-em-conexao-triangulo-triangulo.md": [
		89762,
		89762
	],
	"./02119-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-rlc.md": [
		56332,
		56332
	],
	"./02120-como-funciona-a-regiao-de-saturacao-em-um-transistor-bipolar.md": [
		92084,
		92084
	],
	"./02121-como-funciona-um-oscilador-passivo-em-circuitos-analogicos.md": [
		8629,
		8629
	],
	"./02122-como-funciona-a-simplificacao-de-circuitos-digitais-usando-mapas-de-karnaugh.md": [
		90480,
		90480
	],
	"./02123-o-que-sao-portas-logicas-e-como-elas-funcionam-em-circuitos-eletricos.md": [
		70267,
		70267
	],
	"./02124-o-que-e-um-no-em-um-circuito-eletrico.md": [
		49921,
		49921
	],
	"./02125-qual-e-a-funcao-de-um-indutor-em-um-circuito-eletrico.md": [
		5827,
		5827
	],
	"./02126-o-que-e-o-metodo-da-superposicao-em-circuitos-eletricos.md": [
		34184,
		34184
	],
	"./02127-o-que-e-um-circuito-de-primeira-ordem-e-como-ele-se-comporta.md": [
		26095,
		26095
	],
	"./02128-o-que-e-um-circuito-de-segunda-ordem-super-amortecido.md": [
		36993,
		36993
	],
	"./02129-o-que-e-um-fasor-e-como-ele-e-utilizado-na-analise-de-circuitos-em-corrente-alternada.md": [
		31250,
		31250
	],
	"./02130-qual-a-diferenca-entre-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		23260,
		23260
	],
	"./02131-o-que-e-o-teorema-de-parseval-e-como-ele-se-aplica-na-analise-de-circuitos.md": [
		61374,
		61374
	],
	"./02132-como-funciona-a-juncao-pn-em-semicondutores.md": [
		91889,
		91889
	],
	"./02133-como-funciona-um-oscilador-de-ponte-de-wien-em-circuitos-analogicos.md": [
		78771,
		78771
	],
	"./02134-como-implementar-um-flip-flop-em-um-circuito-digital.md": [
		3747,
		3747
	],
	"./02135-o-que-e-um-circuito-rlc-e-como-ele-funciona.md": [
		9091,
		9091
	],
	"./02136-o-que-e-a-lei-de-ohm-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		97350,
		97350
	],
	"./02137-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		56724,
		56724
	],
	"./02138-o-que-e-o-teorema-da-transferencia-de-potencia-maxima.md": [
		38020,
		38020
	],
	"./02139-como-a-energia-armazenada-em-um-indutor-afeta-a-corrente-em-um-circuito-de-primeira-ordem.md": [
		36193,
		36193
	],
	"./02140-o-que-e-um-circuito-criticamente-amortecido-de-segunda-ordem.md": [
		2204,
		2204
	],
	"./02141-como-funciona-a-analise-de-circuitos-em-serie-com-corrente-alternada.md": [
		97345,
		97345
	],
	"./02142-o-que-e-a-conexao-triangulo-estrela-em-circuitos-trifasicos.md": [
		87698,
		87698
	],
	"./02143-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-rlc.md": [
		95961,
		95961
	],
	"./02144-como-funciona-um-jfet-em-um-circuito-simples.md": [
		59768,
		59768
	],
	"./02145-como-funciona-um-oscilador-de-wien-em-circuitos-analogicos.md": [
		9125,
		9125
	],
	"./02146-como-a-simplificacao-de-circuitos-logicos-pode-melhorar-a-eficiencia-de-um-sistema-digital.md": [
		24326,
		24326
	],
	"./02147-como-funciona-um-filtro-analogico-de-ordem-superior-em-um-circuito-eletrico.md": [
		18962,
		18962
	],
	"./02148-o-que-e-a-lei-de-kirchhoff-das-correntes-lkc-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		48391,
		48391
	],
	"./02149-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		15383,
		15383
	],
	"./02150-como-a-teoria-da-superposicao-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		463,
		463
	],
	"./02151-como-a-carga-armazenada-em-um-capacitor-afeta-a-tensao-em-circuitos-de-primeira-ordem.md": [
		84023,
		84023
	],
	"./02152-qual-a-diferenca-entre-a-resposta-subamortecida-e-a-superamortecida-em-circuitos-de-segunda-ordem.md": [
		20817,
		20817
	],
	"./02153-o-que-e-um-fasor-e-como-ele-e-utilizado-em-circuitos-de-corrente-alternada.md": [
		51493,
		51493
	],
	"./02154-qual-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		65163,
		65163
	],
	"./02155-o-que-e-a-propriedade-de-parseval-e-como-ela-se-aplica-na-analise-de-circuitos.md": [
		58094,
		58094
	],
	"./02156-como-funciona-a-regiao-de-saturacao-em-um-mosfet.md": [
		70986,
		70986
	],
	"./02157-qual-a-diferenca-entre-componentes-passivos-e-ativos-em-circuitos-analogicos.md": [
		50932,
		50932
	],
	"./02158-como-funciona-a-conversao-de-uma-tabela-verdade-para-um-circuito-digital.md": [
		10754,
		10754
	],
	"./02159-o-que-e-um-trigger-em-circuitos-eletricos.md": [
		58353,
		58353
	],
	"./02160-o-que-e-potencia-em-circuitos-eletricos.md": [
		21221,
		21221
	],
	"./02161-qual-a-diferenca-entre-capacitores-e-indutores-em-circuitos-eletricos.md": [
		40578,
		40578
	],
	"./02162-o-que-e-o-teorema-de-thevenin-e-como-ele-e-aplicado-na-analise-de-circuitos.md": [
		963,
		963
	],
	"./02163-como-ocorre-a-descarga-de-um-circuito-rl-de-primeira-ordem.md": [
		20260,
		20260
	],
	"./02164-o-que-e-um-circuito-rlc-sub-amortecido.md": [
		2324,
		2324
	],
	"./02165-o-que-e-admitancia-em-circuitos-de-corrente-alternada.md": [
		42463,
		42463
	],
	"./02166-o-que-e-um-circuito-trifasico-equilibrado-e-como-ele-e-usado.md": [
		53975,
		53975
	],
	"./02167-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		57140,
		57140
	],
	"./02168-como-funciona-o-modelo-equivalente-de-um-diodo-em-um-circuito-de-thevenin.md": [
		14803,
		14803
	],
	"./02169-como-funciona-um-multivibrador-astavel-utilizando-amplificadores-operacionais.md": [
		67844,
		67844
	],
	"./02170-como-funciona-a-conversao-de-numeros-binarios-para-decimais-em-circuitos-digitais.md": [
		6637,
		6637
	],
	"./02171-o-que-e-um-amplificador-schmitt-e-como-ele-funciona.md": [
		68989,
		68989
	],
	"./02172-o-que-e-um-no-em-um-circuito-eletrico.md": [
		95694,
		95694
	],
	"./02173-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		65692,
		65692
	],
	"./02174-como-aplicar-o-teorema-de-thevenin-na-analise-de-circuitos.md": [
		89840,
		89840
	],
	"./02175-o-que-sao-circuitos-de-primeira-ordem-e-como-eles-se-comportam.md": [
		20894,
		20894
	],
	"./02176-o-que-e-um-circuito-rlc-super-amortecido-e-como-ele-se-comporta.md": [
		27373,
		27373
	],
	"./02177-o-que-e-potencia-media-em-circuitos-de-corrente-alternada.md": [
		657,
		657
	],
	"./02178-qual-a-diferenca-entre-as-conexoes-triangulo-estrela-e-triangulo-triangulo-em-circuitos-trifasicos.md": [
		8997,
		8997
	],
	"./02179-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		95257,
		95257
	],
	"./02180-como-funciona-o-modelo-equivalente-de-um-diodo-em-circuitos-eletricos.md": [
		29824,
		29824
	],
	"./02181-como-funciona-um-amplificador-operacional-em-um-circuito-astavel.md": [
		33398,
		33398
	],
	"./02182-como-simplificar-uma-funcao-booleana-em-circuitos-digitais.md": [
		84723,
		84723
	],
	"./02183-como-o-trigger-e-utilizado-em-medidas-experimentais-com-bjt.md": [
		49309,
		49309
	],
	"./02184-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		97608,
		97608
	],
	"./02185-o-que-e-um-transformador-e-como-ele-funciona-em-circuitos-eletricos.md": [
		74710,
		74710
	],
	"./02186-como-a-linearidade-afeta-a-analise-de-circuitos-eletricos.md": [
		15110,
		15110
	],
	"./02187-como-a-energia-armazenada-em-um-circuito-de-primeira-ordem-se-comporta-ao-longo-do-tempo.md": [
		94957,
		94957
	],
	"./02188-o-que-e-um-circuito-super-amortecido-de-segunda-ordem.md": [
		31379,
		31379
	],
	"./02189-como-o-metodo-nodal-e-aplicado-em-circuitos-de-corrente-alternada.md": [
		90468,
		90468
	],
	"./02190-o-que-e-potencia-instantanea-em-circuitos-trifasicos.md": [
		54402,
		54402
	],
	"./02191-como-a-funcao-impulso-afeta-a-resposta-de-um-circuito-passivo.md": [
		77763,
		77763
	],
	"./02192-qual-a-diferenca-entre-um-diodo-e-um-transistor-mosfet.md": [
		56610,
		56610
	],
	"./02193-o-que-e-um-oscilador-de-wien-e-como-ele-funciona.md": [
		44271,
		44271
	],
	"./02194-como-os-transistores-mos-sao-utilizados-em-circuitos-digitais-cmos.md": [
		28848,
		28848
	],
	"./02195-como-funcionam-os-circuitos-rc-de-segunda-ordem.md": [
		34272,
		34272
	],
	"./02196-o-que-e-um-curto-circuito-e-como-ele-afeta-um-circuito-eletrico.md": [
		58668,
		58668
	],
	"./02197-como-funcionam-os-diodos-em-circuitos-eletricos.md": [
		701,
		701
	],
	"./02198-o-que-e-uma-supermalha-e-como-ela-e-utilizada-na-analise-de-circuitos.md": [
		21325,
		21325
	],
	"./02199-como-a-energia-armazenada-em-um-indutor-afeta-a-tensao-em-um-circuito-de-primeira-ordem.md": [
		67561,
		67561
	],
	"./02200-qual-a-diferenca-entre-um-circuito-rlc-subamortecido-e-superamortecido.md": [
		15630,
		15630
	],
	"./02201-como-a-superposicao-afeta-circuitos-em-corrente-alternada.md": [
		21288,
		98907
	],
	"./02202-qual-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		1241,
		1241
	],
	"./02203-o-que-e-um-filtro-passa-faixas-e-como-ele-funciona-em-um-circuito-rlc-serie.md": [
		47777,
		47777
	],
	"./02204-como-os-transistores-bipolares-de-juncao-bjt-funcionam-em-circuitos-eletricos.md": [
		3801,
		3801
	],
	"./02205-o-que-e-um-multivibrador-e-como-ele-funciona-em-circuitos-analogicos.md": [
		81193,
		81193
	],
	"./02206-como-simplificar-circuitos-combinacionais-usando-o-mapa-de-karnaugh.md": [
		26788,
		26788
	],
	"./02207-como-configurar-um-circuito-rlc-para-analise-de-sinais-senoidais.md": [
		76310,
		76310
	],
	"./02208-o-que-e-carga-eletrica-e-qual-sua-importancia-em-circuitos-eletricos.md": [
		18071,
		18071
	],
	"./02209-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		63148,
		63148
	],
	"./02210-como-a-superposicao-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		66325,
		66325
	],
	"./02211-como-obter-a-variavel-de-estado-em-um-circuito-com-capacitor-de-primeira-ordem.md": [
		35150,
		35150
	],
	"./02212-o-que-e-uma-resposta-super-amortecida-em-circuitos-de-segunda-ordem.md": [
		3564,
		3564
	],
	"./02213-como-funciona-a-analise-instantanea-em-circuitos-de-corrente-alternada.md": [
		57949,
		57949
	],
	"./02214-o-que-e-um-circuito-trifasico-equilibrado.md": [
		43318,
		43318
	],
	"./02215-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-rlc.md": [
		85385,
		85385
	],
	"./02216-como-os-transistores-bipolares-de-juncao-bjt-funcionam-em-circuitos-eletricos.md": [
		33234,
		33234
	],
	"./02217-como-os-amplificadores-operacionais-funcionam-em-circuitos-analogicos.md": [
		19155,
		19155
	],
	"./02218-como-as-funcoes-booleanas-sao-implementadas-em-circuitos-digitais.md": [
		6871,
		6871
	],
	"./02219-como-funciona-o-uso-de-um-dac-em-medicoes-analogicas-em-circuitos-eletricos.md": [
		97827,
		97827
	],
	"./02220-o-que-e-um-curto-circuito-e-como-ele-ocorre-em-um-circuito-eletrico.md": [
		21338,
		21338
	],
	"./02221-o-que-e-um-transistor-e-qual-a-sua-funcao-em-circuitos-eletronicos.md": [
		67137,
		89518
	],
	"./02222-como-funciona-a-analise-nodal-em-circuitos-eletricos.md": [
		83710,
		83710
	],
	"./02223-como-funciona-a-descarga-de-um-capacitor-em-um-circuito-de-primeira-ordem.md": [
		56916,
		56916
	],
	"./02224-como-resolver-circuitos-de-segunda-ordem-com-fontes-dependentes.md": [
		53732,
		53732
	],
	"./02225-o-que-e-o-teorema-de-norton-em-circuitos-de-corrente-alternada.md": [
		30475,
		30475
	],
	"./02226-qual-a-diferenca-entre-as-conexoes-triangulo-e-estrela-em-circuitos-trifasicos.md": [
		66511,
		66511
	],
	"./02227-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-rlc.md": [
		51276,
		51276
	],
	"./02228-como-funciona-a-juncao-em-um-transistor-mosfet.md": [
		91231,
		91231
	],
	"./02229-como-funciona-um-amplificador-analogico-em-circuitos-eletricos.md": [
		93007,
		93007
	],
	"./02230-como-simplificar-uma-expressao-logica-usando-o-mapa-de-karnaugh.md": [
		83664,
		83664
	],
	"./02231-como-funciona-um-amplificador-em-um-circuito-eletrico.md": [
		38413,
		38413
	],
	"./02232-o-que-e-a-lei-de-ohm-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		94825,
		94825
	],
	"./02233-como-funcionam-os-componentes-eletronicos-em-circuitos-eletricos.md": [
		34271,
		34271
	],
	"./02234-como-aplicar-o-teorema-de-thevenin-na-analise-de-circuitos.md": [
		68791,
		68791
	],
	"./02235-como-obter-a-resposta-de-um-circuito-rc-de-primeira-ordem.md": [
		26210,
		26210
	],
	"./02236-o-que-significa-um-circuito-rlc-ser-criticamente-amortecido.md": [
		11813,
		11813
	],
	"./02237-o-que-e-o-fator-de-potencia-em-circuitos-de-corrente-alternada.md": [
		22936,
		22936
	],
	"./02238-o-que-e-a-potencia-instantanea-em-circuitos-trifasicos.md": [
		78165,
		78165
	],
	"./02239-como-a-resposta-impulsiva-de-um-circuito-pode-ser-utilizada-na-analise-avancada-de-circuitos.md": [
		24196,
		24196
	],
	"./02240-como-o-diodo-funciona-em-um-circuito-eletrico-simples.md": [
		25426,
		25426
	],
	"./02241-como-funciona-um-oscilador-de-ponte-de-wien.md": [
		27885,
		27885
	],
	"./02242-como-simplificar-expressoes-booleanas-usando-o-mapa-de-karnaugh.md": [
		86087,
		86087
	],
	"./02243-qual-a-diferenca-entre-um-filtro-rc-e-um-filtro-r2r.md": [
		27991,
		27991
	],
	"./02244-o-que-sao-as-leis-de-kirchhoff-e-como-elas-se-aplicam-em-circuitos-simples.md": [
		18565,
		18565
	],
	"./02245-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		25996,
		25996
	],
	"./02246-o-que-e-a-transferencia-de-potencia-maxima-em-circuitos-eletricos.md": [
		20124,
		20124
	],
	"./02247-como-a-energia-e-armazenada-em-um-indutor-em-um-circuito-de-primeira-ordem.md": [
		41822,
		41822
	],
	"./02248-o-que-e-uma-resposta-amortecida-em-circuitos-de-segunda-ordem.md": [
		92881,
		92881
	],
	"./02249-o-que-e-admitancia-em-circuitos-de-corrente-alternada.md": [
		55268,
		55268
	],
	"./02250-qual-a-diferenca-entre-as-conexoes-triangulo-estrela-e-triangulo-triangulo-em-circuitos-trifasicos.md": [
		50152,
		50152
	],
	"./02251-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-com-funcoes-de-impulso-e-exponenciais.md": [
		20546,
		20546
	],
	"./02252-como-funcionam-os-transistores-bipolares-de-juncao-bjt-em-circuitos-eletricos.md": [
		49026,
		49026
	],
	"./02253-como-funciona-um-conversor-r2r-em-circuitos-analogicos.md": [
		22169,
		22169
	],
	"./02254-como-converter-uma-expressao-booleana-em-um-circuito-logico.md": [
		75053,
		75053
	],
	"./02255-como-funciona-um-circuito-schmitt-trigger.md": [
		62593,
		62593
	],
	"./02256-o-que-e-a-lei-de-ohm-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		65707,
		65707
	],
	"./02257-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		51997,
		51997
	],
	"./02258-o-que-e-o-teorema-da-linearidade-em-circuitos-eletricos.md": [
		93286,
		93286
	],
	"./02259-como-a-energia-armazenada-em-um-indutor-varia-com-o-tempo-em-um-circuito-rl.md": [
		67380,
		67380
	],
	"./02260-o-que-e-um-circuito-criticamente-amortecido.md": [
		76181,
		76181
	],
	"./02261-o-que-e-o-fator-de-potencia-em-circuitos-rlc-senoidais.md": [
		60745,
		60745
	],
	"./02262-qual-a-diferenca-entre-a-conexao-estrela-e-a-conexao-triangulo-em-circuitos-trifasicos.md": [
		31051,
		31051
	],
	"./02263-como-o-teorema-de-fourier-e-aplicado-na-analise-de-circuitos-eletricos.md": [
		36886,
		36886
	],
	"./02264-como-funciona-um-mesfet-em-circuitos-eletricos.md": [
		33191,
		33191
	],
	"./02265-o-que-e-um-amplificador-operacional-e-como-ele-funciona-em-circuitos-analogicos.md": [
		95244,
		95244
	],
	"./02266-como-converter-um-numero-binario-para-decimal-e-vice-versa.md": [
		42228,
		42228
	],
	"./02267-o-que-e-um-conversor-r2r-e-como-ele-funciona.md": [
		54019,
		54019
	],
	"./02268-o-que-e-um-curto-circuito-e-como-ele-ocorre.md": [
		17485,
		17485
	],
	"./02269-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		17382,
		17382
	],
	"./02270-como-a-linearidade-afeta-a-analise-de-circuitos-eletricos.md": [
		66210,
		66210
	],
	"./02271-o-que-acontece-com-a-energia-armazenada-em-um-capacitor-apos-a-comutacao-em-um-circuito-de-primeira-ordem.md": [
		26493,
		26493
	],
	"./02272-o-que-e-uma-resposta-sub-amortecida-em-circuitos-de-segunda-ordem.md": [
		71741,
		71741
	],
	"./02273-o-que-e-o-periodo-em-um-circuito-de-corrente-alternada.md": [
		79632,
		79632
	],
	"./02274-qual-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		34938,
		34938
	],
	"./02275-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		41718,
		41718
	],
	"./02276-como-funciona-um-diodo-pn-em-um-circuito-eletrico.md": [
		64283,
		64283
	],
	"./02277-como-funciona-um-filtro-passa-baixa-em-circuitos-analogicos.md": [
		27194,
		27194
	],
	"./02278-como-simplificar-expressoes-logicas-usando-o-mapa-de-karnaugh.md": [
		3544,
		3544
	],
	"./02279-o-que-e-um-filtro-rc-e-como-ele-funciona-em-circuitos-eletricos.md": [
		48106,
		48106
	],
	"./02280-o-que-e-tensao-eletrica-e-como-ela-se-relaciona-com-os-conceitos-basicos-de-circuitos-eletricos.md": [
		75848,
		75848
	],
	"./02281-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		30016,
		30016
	],
	"./02282-como-funciona-a-analise-nodal-em-circuitos-eletricos.md": [
		28044,
		28044
	],
	"./02283-o-que-acontece-com-a-tensao-em-um-capacitor-durante-a-comutacao-em-um-circuito-de-primeira-ordem.md": [
		74328,
		74328
	],
	"./02284-como-a-continuidade-da-corrente-afeta-a-resposta-de-um-circuito-de-segunda-ordem.md": [
		85410,
		85410
	],
	"./02285-o-que-e-potencia-instantanea-em-circuitos-de-corrente-alternada.md": [
		58226,
		35845
	],
	"./02286-qual-a-diferenca-entre-sistemas-monofasicos-e-trifasicos.md": [
		49969,
		49969
	],
	"./02287-como-a-transformada-de-fourier-e-utilizada-na-analise-de-circuitos-passivos.md": [
		21123,
		21123
	],
	"./02288-como-funciona-a-saturacao-em-um-transistor-bipolar-de-juncao-bjt.md": [
		80255,
		2636
	],
	"./02289-como-funciona-um-amplificador-operacional-em-um-circuito-analogico.md": [
		47130,
		47130
	],
	"./02290-qual-a-diferenca-entre-circuitos-combinacionais-e-sequenciais.md": [
		50421,
		50421
	],
	"./02291-qual-a-importancia-da-configuracao-em-serie-em-circuitos-eletricos-experimentais.md": [
		64299,
		64299
	],
	"./02292-o-que-e-um-curto-circuito-e-como-ele-afeta-um-sistema-eletrico.md": [
		10109,
		10109
	],
	"./02293-qual-a-funcao-de-um-transistor-em-um-circuito-eletronico.md": [
		79420,
		79420
	],
	"./02294-como-o-teorema-de-thevenin-facilita-a-analise-de-circuitos-eletricos.md": [
		79679,
		79679
	],
	"./02295-como-a-comutacao-afeta-a-resposta-de-um-circuito-rl-de-primeira-ordem.md": [
		8367,
		8367
	],
	"./02296-o-que-e-um-circuito-criticamente-amortecido.md": [
		82260,
		82260
	],
	"./02297-o-que-e-a-impedancia-em-circuitos-de-corrente-alternada-e-como-ela-afeta-a-transferencia-de-energia.md": [
		76887,
		76887
	],
	"./02298-o-que-e-a-conexao-estrela-triangulo-em-circuitos-trifasicos.md": [
		62539,
		62539
	],
	"./02299-como-a-transformada-inversa-de-laplace-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		52023,
		52023
	],
	"./02300-qual-a-diferenca-entre-bjt-e-mesfet.md": [
		50456,
		50456
	],
	"./02301-como-funciona-um-diagrama-de-bode-em-circuitos-analogicos.md": [
		55518,
		55518
	],
	"./02302-como-implementar-uma-funcao-combinacional-a-partir-de-uma-tabela-verdade.md": [
		7429,
		7429
	],
	"./02303-o-que-e-um-conversor-r2r-e-como-ele-funciona.md": [
		17516,
		17516
	],
	"./02304-o-que-e-a-lei-de-kirchhoff-das-tensoes-lkt-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		19614,
		19614
	],
	"./02305-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		45141,
		45141
	],
	"./02306-como-funciona-a-transformacao-de-um-circuito-para-seu-equivalente-de-thevenin.md": [
		74656,
		74656
	],
	"./02307-o-que-e-um-circuito-rc-de-primeira-ordem.md": [
		70394,
		70394
	],
	"./02308-o-que-e-uma-resposta-sub-amortecida-em-circuitos-de-segunda-ordem.md": [
		6559,
		6559
	],
	"./02309-como-a-frequencia-afeta-a-analise-de-circuitos-em-corrente-alternada.md": [
		58860,
		58860
	],
	"./02310-qual-a-diferenca-entre-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		61272,
		61272
	],
	"./02311-o-que-e-a-transformada-de-laplace-e-como-ela-e-utilizada-na-analise-de-circuitos-rlc.md": [
		32695,
		32695
	],
	"./02312-como-funciona-a-regiao-de-saturacao-em-um-transistor-bjt.md": [
		69706,
		69706
	],
	"./02313-o-que-e-um-circuito-astavel-e-como-ele-funciona.md": [
		29044,
		29044
	],
	"./02314-como-os-flip-flops-sao-utilizados-em-circuitos-digitais.md": [
		94182,
		94182
	],
	"./02315-como-funcionam-os-filtros-passa-alta-em-circuitos-eletricos.md": [
		41810,
		41810
	],
	"./02316-o-que-e-um-ramo-em-um-circuito-eletrico.md": [
		21660,
		21660
	],
	"./02317-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		85096,
		85096
	],
	"./02318-o-que-e-o-teorema-de-thevenin-e-como-ele-pode-ser-aplicado-na-analise-de-circuitos.md": [
		93898,
		93898
	],
	"./02319-o-que-sao-circuitos-de-primeira-ordem-e-como-eles-funcionam.md": [
		89129,
		89129
	],
	"./02320-o-que-e-um-circuito-de-segunda-ordem-e-como-ele-responde-a-uma-excitacao.md": [
		27602,
		27602
	],
	"./02321-o-que-e-potencia-instantanea-em-circuitos-de-corrente-alternada.md": [
		48812,
		48812
	],
	"./02322-o-que-e-um-circuito-trifasico-equilibrado.md": [
		60620,
		60620
	],
	"./02323-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		69052,
		69052
	],
	"./02324-qual-a-diferenca-entre-mosfet-e-bjt-em-circuitos-eletricos.md": [
		38308,
		38308
	],
	"./02325-o-que-e-um-oscilador-de-wien-e-como-ele-funciona-em-circuitos-analogicos.md": [
		81320,
		81320
	],
	"./02326-como-implementar-uma-expressao-logica-usando-mosfets-em-circuitos-digitais.md": [
		26619,
		26619
	],
	"./02327-como-funcionam-os-amplificadores-em-circuitos-eletricos.md": [
		75085,
		75085
	],
	"./02328-o-que-e-um-no-em-um-circuito-eletrico.md": [
		84643,
		84643
	],
	"./02329-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		4507,
		4507
	],
	"./02330-como-funciona-o-principio-da-superposicao-na-analise-de-circuitos.md": [
		76799,
		76799
	],
	"./02331-como-determinar-a-corrente-em-um-circuito-rc-de-primeira-ordem.md": [
		32052,
		32052
	],
	"./02332-o-que-e-um-circuito-rlc-paralelo-sub-amortecido.md": [
		19760,
		19760
	],
	"./02333-como-funcionam-os-fasores-em-circuitos-de-corrente-alternada.md": [
		6281,
		6281
	],
	"./02334-qual-a-diferenca-entre-uma-conexao-estrela-e-uma-conexao-triangulo-em-circuitos-trifasicos.md": [
		74479,
		74479
	],
	"./02335-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-rlc.md": [
		25104,
		25104
	],
	"./02336-o-que-significa-um-transistor-estar-em-modo-saturado.md": [
		43008,
		43008
	],
	"./02337-o-que-e-um-circuito-schmitt-trigger-e-como-ele-funciona.md": [
		88993,
		88993
	],
	"./02338-como-funcionam-os-circuitos-sequenciais-em-sistemas-digitais.md": [
		28032,
		28032
	],
	"./02339-como-funciona-um-circuito-rc-em-regime-permanente.md": [
		83851,
		83851
	],
	"./02340-o-que-e-um-curto-circuito-e-como-ele-ocorre.md": [
		57832,
		57832
	],
	"./02341-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		83653,
		83653
	],
	"./02342-como-a-analise-nodal-e-utilizada-na-analise-basica-de-circuitos.md": [
		71321,
		71321
	],
	"./02343-o-que-e-um-circuito-de-primeira-ordem-e-como-ele-se-comporta-durante-a-descarga-de-um-capacitor.md": [
		67894,
		67894
	],
	"./02344-o-que-e-uma-resposta-super-amortecida-em-circuitos-de-segunda-ordem.md": [
		15172,
		15172
	],
	"./02345-como-funciona-a-analise-de-circuitos-em-corrente-alternada-usando-fasores.md": [
		1637,
		1637
	],
	"./02346-qual-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		13340,
		13340
	],
	"./02347-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-rlc.md": [
		42867,
		42867
	],
	"./02348-como-funciona-a-juncao-pn-em-semicondutores.md": [
		15334,
		15334
	],
	"./02349-o-que-e-um-filtro-ativo-em-circuitos-analogicos.md": [
		39196,
		39196
	],
	"./02350-como-funcionam-os-circuitos-cmos-em-circuitos-digitais.md": [
		1228,
		1228
	],
	"./02351-como-funcionam-os-filtros-analogicos-em-circuitos-eletricos.md": [
		53559,
		53559
	],
	"./02352-o-que-e-um-circuito-eletrico-aberto.md": [
		16840,
		16840
	],
	"./02353-qual-a-diferenca-entre-componentes-passivos-e-ativos-em-circuitos-eletricos.md": [
		75562,
		75562
	],
	"./02354-o-que-e-um-no-em-um-circuito-eletrico-e-qual-sua-importancia-na-analise-de-circuitos.md": [
		18788,
		18788
	],
	"./02355-o-que-sao-circuitos-de-primeira-ordem-e-como-eles-funcionam.md": [
		89369,
		89369
	],
	"./02356-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-se-comportam.md": [
		24303,
		24303
	],
	"./02357-o-que-e-admitancia-em-circuitos-de-corrente-alternada.md": [
		43948,
		43948
	],
	"./02358-o-que-e-uma-conexao-triangulo-triangulo-em-circuitos-trifasicos.md": [
		38123,
		38123
	],
	"./02359-como-o-teorema-de-parseval-e-aplicado-na-analise-de-circuitos-eletricos.md": [
		85518,
		85518
	],
	"./02360-como-funcionam-os-transistores-bjt-e-mosfet-em-circuitos-eletricos.md": [
		54514,
		54514
	],
	"./02361-como-funciona-um-circuito-trigger-analogico.md": [
		3944,
		3944
	],
	"./02362-como-simplificar-circuitos-combinacionais-usando-portas-logicas.md": [
		24110,
		24110
	],
	"./02363-o-que-e-um-circuito-em-regime-senoidal-e-como-ele-se-comporta.md": [
		46404,
		46404
	],
	"./02364-o-que-e-resistencia-eletrica-e-como-ela-afeta-a-corrente-em-um-circuito.md": [
		31106,
		31106
	],
	"./02365-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		68699,
		68699
	],
	"./02366-como-o-teorema-da-superposicao-e-aplicado-na-analise-de-circuitos.md": [
		33942,
		33942
	],
	"./02367-como-a-corrente-e-a-tensao-se-comportam-em-um-circuito-de-primeira-ordem-com-indutor-e-capacitor.md": [
		48777,
		48777
	],
	"./02368-qual-a-diferenca-entre-circuitos-lc-e-circuitos-rlc-de-segunda-ordem.md": [
		83346,
		83346
	],
	"./02369-o-que-e-a-admitancia-em-circuitos-de-corrente-alternada.md": [
		85759,
		85759
	],
	"./02370-qual-e-a-diferenca-entre-as-conexoes-triangulo-e-estrela-em-circuitos-trifasicos.md": [
		29261,
		29261
	],
	"./02371-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-passivos.md": [
		78723,
		1104
	],
	"./02372-como-os-semicondutores-sao-utilizados-em-circuitos-eletricos.md": [
		28658,
		28658
	],
	"./02373-o-que-e-um-amplificador-operacional-e-como-ele-funciona-em-circuitos-analogicos.md": [
		18012,
		18012
	],
	"./02374-como-funciona-a-simplificacao-de-circuitos-combinacionais-usando-o-mapa-de-karnaugh.md": [
		91119,
		91119
	],
	"./02375-como-funciona-um-conversor-rc-em-circuitos-eletricos.md": [
		80501,
		80501
	],
	"./02376-o-que-e-um-no-em-um-circuito-eletrico.md": [
		39908,
		39908
	],
	"./02377-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		16686,
		16686
	],
	"./02378-o-que-e-uma-supermalha-em-circuitos-eletricos.md": [
		27127,
		27127
	],
	"./02379-o-que-sao-circuitos-de-primeira-ordem-e-como-eles-se-comportam-ao-longo-do-tempo.md": [
		13367,
		13367
	],
	"./02380-qual-e-a-importancia-da-continuidade-em-circuitos-de-segunda-ordem.md": [
		16346,
		16346
	],
	"./02381-o-que-e-o-regime-permanente-em-circuitos-de-corrente-alternada.md": [
		48213,
		48213
	],
	"./02382-qual-a-diferenca-entre-as-conexoes-triangulo-triangulo-e-triangulo-estrela-em-circuitos-trifasicos.md": [
		92392,
		92392
	],
	"./02383-o-que-e-um-filtro-passa-faixas-e-como-ele-funciona-em-um-circuito-rlc.md": [
		63643,
		63643
	],
	"./02384-como-funciona-a-juncao-pn-em-um-diodo-semicondutor.md": [
		28257,
		28257
	],
	"./02385-o-que-e-um-circuito-astavel-e-como-ele-opera-em-circuitos-analogicos.md": [
		21651,
		21651
	],
	"./02386-como-funcionam-os-flip-flops-em-circuitos-digitais.md": [
		34007,
		34007
	],
	"./02387-como-funciona-um-amplificador-de-emissor-comum-em-um-circuito-analogico.md": [
		6730,
		6730
	],
	"./02388-o-que-e-a-lei-de-kirchhoff-das-correntes-lkc.md": [
		99687,
		99687
	],
	"./02389-qual-a-diferenca-entre-componentes-passivos-e-ativos-em-circuitos-eletronicos.md": [
		5456,
		5456
	],
	"./02390-o-que-e-uma-supermalha-em-circuitos-eletricos.md": [
		94257,
		94257
	],
	"./02391-como-a-corrente-se-comporta-em-um-circuito-rc-de-primeira-ordem.md": [
		21749,
		21749
	],
	"./02392-como-a-resposta-de-um-circuito-rlc-a-um-degrau-e-determinada.md": [
		4464,
		4464
	],
	"./02393-o-que-e-a-impedancia-em-circuitos-de-corrente-alternada.md": [
		84644,
		84644
	],
	"./02394-o-que-e-potencia-instantanea-em-circuitos-trifasicos.md": [
		42344,
		42344
	],
	"./02395-o-que-e-o-teorema-de-parseval-e-como-ele-se-aplica-na-analise-de-circuitos-eletricos.md": [
		92867,
		92867
	],
	"./02396-como-a-corrente-e-controlada-em-um-transistor-mesfet.md": [
		61699,
		61699
	],
	"./02397-como-funciona-um-circuito-astavel-em-um-filtro-analogico.md": [
		14356,
		14356
	],
	"./02398-como-implementar-uma-funcao-logica-booleana-usando-circuitos-combinacionais.md": [
		15000,
		15000
	],
	"./02399-como-funcionam-os-circuitos-combinacionais-em-um-laboratorio-de-engenharia.md": [
		94430,
		94430
	],
	"./02400-como-funciona-a-associacao-de-resistores-em-serie-e-paralelo.md": [
		26195,
		26195
	],
	"./02401-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		16058,
		16058
	],
	"./02402-o-que-e-uma-supermalha-e-como-ela-e-utilizada-na-analise-de-circuitos.md": [
		50033,
		50033
	],
	"./02403-o-que-acontece-durante-a-descarga-de-um-capacitor-em-um-circuito-rl.md": [
		30723,
		30723
	],
	"./02404-qual-a-diferenca-entre-circuitos-de-primeira-e-segunda-ordem.md": [
		68683,
		68683
	],
	"./02405-o-que-e-impedancia-em-circuitos-de-corrente-alternada.md": [
		97519,
		97519
	],
	"./02406-qual-a-diferenca-entre-sistemas-monofasicos-e-trifasicos.md": [
		57575,
		57575
	],
	"./02407-como-a-transformada-de-fourier-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		47637,
		47637
	],
	"./02408-como-identificar-se-um-bjt-esta-na-regiao-de-saturacao.md": [
		49741,
		49741
	],
	"./02409-como-os-amplificadores-operacionais-sao-utilizados-em-filtros-analogicos.md": [
		38952,
		38952
	],
	"./02410-como-funcionam-os-flip-flops-em-circuitos-digitais.md": [
		20405,
		20405
	],
	"./02411-o-que-e-um-amplificador-e-como-ele-funciona-em-um-circuito-eletrico.md": [
		13018,
		13018
	],
	"./02412-qual-a-diferenca-entre-a-associacao-em-serie-e-em-paralelo-de-resistores.md": [
		18163,
		18163
	],
	"./02413-qual-a-diferenca-entre-capacitores-e-indutores-em-circuitos-eletricos.md": [
		98864,
		98864
	],
	"./02414-como-funciona-o-principio-da-superposicao-na-analise-de-circuitos.md": [
		50668,
		50668
	],
	"./02415-como-a-carga-armazenada-em-um-capacitor-varia-com-o-tempo-em-um-circuito-de-primeira-ordem.md": [
		27777,
		27777
	],
	"./02416-o-que-e-uma-resposta-super-amortecida-em-circuitos-de-segunda-ordem.md": [
		38894,
		38894
	],
	"./02417-o-que-e-a-admitancia-em-circuitos-de-corrente-alternada.md": [
		96275,
		96275
	],
	"./02418-o-que-e-uma-conexao-triangulo-triangulo-em-circuitos-trifasicos.md": [
		29710,
		29710
	],
	"./02419-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-rlc.md": [
		69907,
		69907
	],
	"./02420-qual-a-diferenca-entre-mosfet-e-bjt-em-circuitos-eletricos.md": [
		98503,
		98503
	],
	"./02421-o-que-e-o-ponto-de-operacao-em-um-circuito-analogico.md": [
		32862,
		32862
	],
	"./02422-como-funciona-a-simplificacao-de-expressoes-logicas-em-circuitos-combinacionais.md": [
		42156,
		42156
	],
	"./02423-o-que-e-um-trigger-em-circuitos-eletricos.md": [
		15495,
		15495
	],
	"./02424-como-a-lei-de-kirchhoff-se-aplica-a-circuitos-em-paralelo.md": [
		47139,
		47139
	],
	"./02425-qual-a-diferenca-entre-componentes-passivos-e-ativos-em-circuitos-eletricos.md": [
		42682,
		42682
	],
	"./02426-como-o-teorema-da-superposicao-e-aplicado-na-analise-de-circuitos-eletricos.md": [
		55842,
		55842
	],
	"./02427-como-os-circuitos-rc-e-rl-de-primeira-ordem-sao-aplicados-na-pratica.md": [
		97620,
		97620
	],
	"./02428-qual-e-a-diferenca-entre-um-circuito-de-segunda-ordem-subamortecido-e-superamortecido.md": [
		54446,
		54446
	],
	"./02429-como-funciona-a-superposicao-em-circuitos-de-corrente-alternada.md": [
		49093,
		49093
	],
	"./02430-o-que-e-uma-conexao-triangulo-estrela-em-circuitos-trifasicos.md": [
		66129,
		66129
	],
	"./02431-como-o-teorema-de-superposicao-e-aplicado-em-circuitos-com-fontes-de-impulso.md": [
		76046,
		76046
	],
	"./02432-o-que-sao-dispositivos-semicondutores-e-como-eles-funcionam-em-circuitos-eletricos.md": [
		70565,
		70565
	],
	"./02433-o-que-e-um-filtro-ativo-em-circuitos-analogicos.md": [
		42852,
		42852
	],
	"./02434-como-funciona-a-simplificacao-de-expressoes-booleanas-usando-o-mapa-de-karnaugh.md": [
		36445,
		36445
	],
	"./02435-como-funcionam-os-circuitos-rlc-em-experimentos-de-laboratorio.md": [
		34911,
		34911
	],
	"./02436-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		5262,
		5262
	],
	"./02437-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		36793,
		36793
	],
	"./02438-como-aplicar-o-teorema-de-thevenin-na-analise-de-circuitos.md": [
		18857,
		18857
	],
	"./02439-o-que-acontece-com-a-corrente-em-um-circuito-rl-apos-a-comutacao.md": [
		53113,
		53113
	],
	"./02440-o-que-e-um-circuito-criticamente-amortecido-e-como-ele-se-comporta.md": [
		53940,
		53940
	],
	"./02441-como-funciona-a-transferencia-de-potencia-em-circuitos-em-serie-de-corrente-alternada.md": [
		69235,
		69235
	],
	"./02442-o-que-e-um-circuito-equivalente-estrela-triangulo.md": [
		35009,
		35009
	],
	"./02443-o-que-e-um-filtro-passa-faixas-e-como-ele-e-utilizado-em-circuitos-eletricos.md": [
		40353,
		40353
	],
	"./02444-qual-a-diferenca-entre-mosfet-e-igbt-em-circuitos-eletricos.md": [
		22215,
		22215
	],
	"./02445-o-que-e-um-multivibrador-e-como-ele-funciona-em-circuitos-analogicos.md": [
		54711,
		54711
	],
	"./02446-como-funcionam-os-circuitos-sequenciais-em-sistemas-digitais.md": [
		62264,
		62264
	],
	"./02447-como-realizar-medicoes-precisas-em-circuitos-eletricos-experimentais.md": [
		12059,
		12059
	],
	"./02448-o-que-e-um-curto-circuito-e-como-ele-ocorre-em-um-sistema-eletrico-simples.md": [
		14206,
		14206
	],
	"./02449-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		10814,
		10814
	],
	"./02450-como-aplicar-o-teorema-de-norton-na-analise-basica-de-circuitos.md": [
		48740,
		48740
	],
	"./02451-como-a-corrente-em-um-circuito-rc-de-primeira-ordem-varia-ao-longo-do-tempo.md": [
		26590,
		26590
	],
	"./02452-o-que-e-uma-resposta-amortecida-em-circuitos-de-segunda-ordem.md": [
		33099,
		55480
	],
	"./02453-o-que-e-impedancia-em-circuitos-de-corrente-alternada.md": [
		65239,
		65239
	],
	"./02454-o-que-e-a-transformacao-triangulo-estrela-em-circuitos-trifasicos.md": [
		5688,
		5688
	],
	"./02455-o-que-e-a-transformada-de-laplace-e-como-ela-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		33759,
		33759
	],
	"./02456-o-que-significa-um-mosfet-estar-em-modo-saturado.md": [
		87588,
		87588
	],
	"./02457-o-que-e-um-oscilador-de-ponte-de-wien-e-como-ele-funciona.md": [
		60403,
		60403
	],
	"./02458-como-simplificar-expressoes-booleanas-em-circuitos-digitais.md": [
		77261,
		77261
	],
	"./02459-como-funciona-um-conversor-digital-analogico-dac-em-circuitos-eletricos.md": [
		52418,
		52418
	],
	"./02460-o-que-e-uma-carga-eletrica-em-um-circuito-simples.md": [
		8568,
		8568
	],
	"./02461-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		97524,
		97524
	],
	"./02462-como-verificar-a-potencia-dissipada-em-um-resistor-em-um-circuito-basico.md": [
		27269,
		27269
	],
	"./02463-como-a-energia-armazenada-em-um-capacitor-afeta-a-corrente-em-um-circuito-de-primeira-ordem.md": [
		8480,
		8480
	],
	"./02464-o-que-e-um-circuito-de-segunda-ordem-criticamente-amortecido.md": [
		94601,
		94601
	],
	"./02465-como-funciona-a-analise-nodal-em-circuitos-de-corrente-alternada.md": [
		72112,
		72112
	],
	"./02466-o-que-e-a-conexao-triangulo-estrela-em-circuitos-trifasicos.md": [
		58532,
		58532
	],
	"./02467-o-que-e-a-resposta-ao-degrau-em-um-circuito-rc-serie.md": [
		36037,
		36037
	],
	"./02468-como-funciona-o-diodo-em-um-circuito-eletrico.md": [
		13676,
		13676
	],
	"./02469-como-funciona-um-oscilador-de-wien-em-circuitos-analogicos.md": [
		26570,
		26570
	],
	"./02470-como-funcionam-as-portas-logicas-em-circuitos-digitais.md": [
		59562,
		59562
	],
	"./02471-como-funciona-o-filtro-passa-baixa-em-um-amplificador-emissor-comum.md": [
		28214,
		28214
	],
	"./02472-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		78086,
		78086
	],
	"./02473-qual-a-diferenca-entre-componentes-eletronicos-lineares-e-nao-lineares.md": [
		91821,
		14202
	],
	"./02474-como-o-teorema-da-superposicao-e-aplicado-na-analise-de-circuitos-eletricos.md": [
		39289,
		39289
	],
	"./02475-como-um-indutor-se-comporta-em-um-circuito-de-primeira-ordem-durante-a-descarga.md": [
		85666,
		85666
	],
	"./02476-o-que-e-uma-resposta-sub-amortecida-em-circuitos-de-segunda-ordem.md": [
		18771,
		18771
	],
	"./02477-o-que-e-a-tensao-rms-e-por-que-ela-e-importante-em-circuitos-de-corrente-alternada.md": [
		20950,
		20950
	],
	"./02478-o-que-e-um-circuito-trifasico-e-como-ele-funciona.md": [
		73766,
		73766
	],
	"./02479-o-que-e-o-teorema-de-parseval-e-como-ele-se-aplica-na-analise-de-circuitos-eletricos.md": [
		58330,
		58330
	],
	"./02480-o-que-e-um-transistor-hemt-e-como-ele-funciona.md": [
		31736,
		31736
	],
	"./02481-o-que-e-um-trigger-em-circuitos-analogicos.md": [
		59173,
		59173
	],
	"./02482-o-que-e-um-latch-e-como-ele-funciona-em-circuitos-digitais.md": [
		1172,
		1172
	],
	"./02483-qual-e-a-importancia-da-configuracao-em-serie-em-circuitos-eletricos-experimentais.md": [
		20098,
		20098
	],
	"./02484-o-que-e-a-lei-das-malhas-de-kirchhoff-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		65960,
		65960
	],
	"./02485-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		99258,
		99258
	],
	"./02486-como-determinar-a-maxima-transferencia-de-potencia-em-um-circuito.md": [
		3444,
		3444
	],
	"./02487-como-funciona-a-descarga-de-um-capacitor-em-um-circuito-rc-de-primeira-ordem.md": [
		76874,
		76874
	],
	"./02488-como-determinar-a-resposta-natural-de-um-circuito-de-segunda-ordem.md": [
		53893,
		53893
	],
	"./02489-como-funciona-o-principio-da-superposicao-em-circuitos-de-corrente-alternada.md": [
		1633,
		1633
	],
	"./02490-qual-a-diferenca-entre-a-conexao-estrela-e-a-conexao-triangulo-em-circuitos-trifasicos.md": [
		49510,
		49510
	],
	"./02491-como-o-teorema-de-laplace-e-aplicado-na-analise-de-circuitos-rlc.md": [
		72394,
		72394
	],
	"./02492-o-que-e-um-igbt-e-como-ele-funciona-em-circuitos-eletricos.md": [
		48327,
		48327
	],
	"./02493-como-funciona-o-oscilador-de-wien-em-circuitos-analogicos.md": [
		99392,
		99392
	],
	"./02494-o-que-e-um-circuito-combinacional-e-como-ele-funciona.md": [
		78007,
		78007
	],
	"./02495-como-funcionam-as-portas-logicas-em-circuitos-combinacionais.md": [
		8589,
		8589
	],
	"./02496-o-que-e-um-ramo-em-um-circuito-eletrico.md": [
		74297,
		74297
	],
	"./02497-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		64895,
		64895
	],
	"./02498-como-verificar-a-validade-do-teorema-de-thevenin-em-um-circuito-com-fontes-dependentes.md": [
		51328,
		51328
	],
	"./02499-como-a-energia-e-armazenada-em-indutores-e-capacitores-em-circuitos-de-primeira-ordem.md": [
		7671,
		7671
	],
	"./02500-como-determinar-o-comportamento-de-um-circuito-lc-de-segunda-ordem.md": [
		67709,
		67709
	],
	"./02501-o-que-e-a-impedancia-em-um-circuito-em-corrente-alternada.md": [
		74145,
		96526
	],
	"./02502-qual-a-diferenca-entre-a-conexao-estrela-e-a-conexao-delta-em-circuitos-trifasicos.md": [
		4727,
		4727
	],
	"./02503-como-a-transformada-de-fourier-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		22686,
		22686
	],
	"./02504-como-funciona-a-juncao-pn-em-semicondutores.md": [
		27384,
		27384
	],
	"./02505-o-que-e-um-filtro-passivo-em-circuitos-analogicos.md": [
		22598,
		22598
	],
	"./02506-como-utilizar-mapas-de-karnaugh-para-simplificar-expressoes-logicas.md": [
		71206,
		71206
	],
	"./02507-o-que-e-um-conversor-r2r-e-como-ele-funciona.md": [
		81034,
		81034
	],
	"./02508-o-que-e-um-curto-circuito-e-como-ele-afeta-um-sistema-eletrico.md": [
		7335,
		7335
	],
	"./02509-qual-a-diferenca-entre-componentes-passivos-e-ativos-em-circuitos-eletronicos.md": [
		50230,
		50230
	],
	"./02510-como-aplicar-o-teorema-de-thevenin-na-analise-de-circuitos.md": [
		1574,
		1574
	],
	"./02511-como-ocorre-a-carga-e-descarga-de-um-capacitor-em-um-circuito-rl-de-primeira-ordem.md": [
		84603,
		84603
	],
	"./02512-como-determinar-a-resposta-de-um-circuito-rlc-sub-amortecido.md": [
		6156,
		6156
	],
	"./02513-o-que-e-a-corrente-eficaz-rms-em-circuitos-de-corrente-alternada.md": [
		49111,
		49111
	],
	"./02514-como-a-potencia-em-circuitos-trifasicos-e-calculada-e-aplicada.md": [
		32881,
		32881
	],
	"./02515-o-que-e-um-filtro-passa-faixas-e-como-ele-funciona.md": [
		87797,
		87797
	],
	"./02516-como-funciona-a-juncao-pn-em-um-diodo-semicondutor.md": [
		30530,
		30530
	],
	"./02517-o-que-e-um-amplificador-operacional-amp-op-e-como-ele-funciona-em-circuitos-analogicos.md": [
		3819,
		3819
	],
	"./02518-como-os-flip-flops-sao-utilizados-na-implementacao-de-circuitos-digitais.md": [
		41563,
		41563
	],
	"./02519-o-que-e-um-circuito-rlc-e-como-ele-se-comporta-em-uma-analise-senoidal.md": [
		47149,
		47149
	],
	"./02520-o-que-e-um-no-em-um-circuito-eletrico.md": [
		81753,
		81753
	],
	"./02521-qual-a-funcao-de-um-capacitor-em-um-circuito-eletrico.md": [
		37204,
		37204
	],
	"./02522-o-que-e-a-transferencia-de-potencia-maxima-em-circuitos-eletricos.md": [
		38451,
		38451
	],
	"./02523-o-que-acontece-com-a-tensao-em-um-capacitor-apos-a-comutacao-em-um-circuito-de-primeira-ordem.md": [
		60711,
		60711
	],
	"./02524-qual-e-a-diferenca-entre-um-circuito-subamortecido-criticamente-amortecido-e-superamortecido.md": [
		64990,
		64990
	],
	"./02525-o-que-e-a-corrente-rms-e-por-que-ela-e-importante-em-circuitos-de-corrente-alternada.md": [
		23515,
		29544
	],
	"./02526-qual-a-diferenca-entre-circuitos-monofasicos-e-trifasicos.md": [
		55376,
		55376
	],
	"./02527-como-a-serie-de-fourier-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		19882,
		19882
	],
	"./02528-como-funciona-a-juncao-em-dispositivos-semicondutores.md": [
		3534,
		3534
	],
	"./02529-como-funciona-um-amplificador-schmitt-trigger-em-circuitos-analogicos.md": [
		22140,
		22140
	],
	"./02530-como-funciona-um-flip-flop-em-circuitos-digitais.md": [
		78438,
		78438
	],
	"./02531-como-utilizar-o-osciloscopio-para-medir-sinais-eletricos-em-circuitos.md": [
		42955,
		42955
	],
	"./02532-como-aplicar-as-leis-de-kirchhoff-em-um-circuito-simples.md": [
		28591,
		28591
	],
	"./02533-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		40468,
		40468
	],
	"./02534-o-que-e-a-transferencia-de-potencia-maxima-em-circuitos-eletricos.md": [
		77380,
		77380
	],
	"./02535-como-funciona-a-descarga-de-um-capacitor-em-um-circuito-rc-de-primeira-ordem.md": [
		27460,
		27460
	],
	"./02536-o-que-e-um-circuito-lc-criticamente-amortecido.md": [
		28924,
		28924
	],
	"./02537-o-que-e-a-impedancia-em-circuitos-de-corrente-alternada.md": [
		81128,
		81128
	],
	"./02538-qual-a-diferenca-entre-as-conexoes-triangulo-e-estrela-em-circuitos-trifasicos.md": [
		51509,
		51509
	],
	"./02539-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-passa-faixas.md": [
		64414,
		64414
	],
	"./02540-como-funciona-um-diodo-em-um-circuito-eletrico.md": [
		48726,
		48726
	],
	"./02541-como-funciona-um-circuito-astavel-com-amplificador-operacional.md": [
		15060,
		15060
	],
	"./02542-como-funcionam-as-portas-logicas-em-circuitos-digitais.md": [
		60055,
		60055
	],
	"./02543-como-funciona-a-configuracao-em-serie-em-circuitos-eletricos.md": [
		38495,
		38495
	],
	"./02544-o-que-e-um-no-em-um-circuito-eletrico.md": [
		11827,
		11827
	],
	"./02545-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		14527,
		14527
	],
	"./02546-como-aplicar-o-teorema-de-thevenin-na-analise-de-circuitos.md": [
		67867,
		67867
	],
	"./02547-o-que-e-a-constante-de-tempo-em-circuitos-de-primeira-ordem.md": [
		48477,
		48477
	],
	"./02548-o-que-e-um-circuito-super-amortecido-de-segunda-ordem.md": [
		47123,
		47123
	],
	"./02549-como-o-teorema-de-thevenin-e-aplicado-em-circuitos-de-corrente-alternada.md": [
		38490,
		38490
	],
	"./02550-o-que-e-um-circuito-trifasico-equilibrado-e-como-ele-funciona.md": [
		6493,
		6493
	],
	"./02551-o-que-e-a-transformada-de-laplace-e-como-ela-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		97460,
		97460
	],
	"./02552-como-funciona-um-transistor-bipolar-de-juncao-bjt.md": [
		31244,
		31244
	],
	"./02553-o-que-e-um-diagrama-de-bode-e-qual-sua-importancia-em-circuitos-analogicos.md": [
		56908,
		56908
	],
	"./02554-o-que-e-um-flip-flop-e-qual-sua-importancia-em-circuitos-digitais.md": [
		10759,
		10759
	],
	"./02555-o-que-e-um-circuito-rc-e-como-ele-funciona.md": [
		33907,
		33907
	],
	"./02556-o-que-e-um-no-em-um-circuito-eletrico.md": [
		32724,
		32724
	],
	"./02557-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		67326,
		67326
	],
	"./02558-como-verificar-se-dois-circuitos-sao-equivalentes.md": [
		67013,
		67013
	],
	"./02559-como-a-energia-armazenada-em-um-capacitor-ou-indutor-se-comporta-ao-longo-do-tempo-em-circuitos-de-primeira-ordem.md": [
		7178,
		7178
	],
	"./02560-o-que-e-um-circuito-de-segunda-ordem-e-como-ele-se-comporta.md": [
		73972,
		73972
	],
	"./02561-o-que-e-o-fator-de-potencia-em-circuitos-de-corrente-alternada.md": [
		98434,
		98434
	],
	"./02562-qual-a-diferenca-entre-sistemas-monofasicos-e-trifasicos.md": [
		27436,
		27436
	],
	"./02563-o-que-e-a-transformada-de-laplace-e-como-ela-e-aplicada-na-analise-avancada-de-circuitos.md": [
		4350,
		4350
	],
	"./02564-como-funciona-um-transistor-bjt-em-um-circuito-eletrico.md": [
		80913,
		80913
	],
	"./02565-como-funciona-um-filtro-passa-baixa-utilizando-amplificadores-operacionais.md": [
		2270,
		2270
	],
	"./02566-como-funcionam-as-portas-logicas-em-circuitos-digitais.md": [
		4421,
		4421
	],
	"./02567-o-que-e-um-circuito-schmitt-trigger-e-como-ele-funciona.md": [
		53214,
		53214
	],
	"./02568-o-que-e-um-curto-circuito-e-como-ele-ocorre-em-um-circuito-eletrico.md": [
		66119,
		66119
	],
	"./02569-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		57517,
		57517
	],
	"./02570-como-aplicar-o-teorema-de-thevenin-na-analise-de-circuitos.md": [
		54528,
		54528
	],
	"./02571-como-a-carga-de-um-capacitor-em-um-circuito-rc-de-primeira-ordem-se-comporta-ao-longo-do-tempo.md": [
		73498,
		73498
	],
	"./02572-como-a-continuidade-da-corrente-e-mantida-em-um-circuito-rlc-paralelo-de-segunda-ordem.md": [
		24448,
		24448
	],
	"./02573-o-que-e-potencia-instantanea-em-circuitos-de-corrente-alternada.md": [
		32993,
		32993
	],
	"./02574-o-que-e-um-circuito-trifasico-em-configuracao-triangulo-triangulo.md": [
		43038,
		43038
	],
	"./02575-o-que-e-uma-singularidade-em-circuitos-eletricos-e-como-ela-afeta-a-analise-avancada.md": [
		94048,
		94048
	],
	"./02576-como-funciona-a-juncao-pn-em-semicondutores.md": [
		43797,
		43797
	],
	"./02577-o-que-e-um-circuito-astavel-e-como-ele-funciona.md": [
		69628,
		69628
	],
	"./02578-como-converter-um-circuito-combinacional-em-um-circuito-sequencial.md": [
		36004,
		36004
	],
	"./02579-como-configurar-o-trigger-em-um-circuito-rc-durante-uma-aula-experimental.md": [
		47156,
		47156
	],
	"./02580-o-que-e-um-circuito-aberto-e-como-ele-afeta-a-resistencia-total.md": [
		73783,
		73783
	],
	"./02581-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		17147,
		17147
	],
	"./02582-como-funciona-o-teorema-da-superposicao-em-circuitos-eletricos.md": [
		73800,
		73800
	],
	"./02583-o-que-e-a-constante-de-tempo-em-um-circuito-rc-de-primeira-ordem.md": [
		2481,
		2481
	],
	"./02584-como-a-constante-de-tempo-afeta-a-resposta-de-um-circuito-de-segunda-ordem.md": [
		82024,
		82024
	],
	"./02585-o-que-e-potencia-instantanea-em-circuitos-de-corrente-alternada.md": [
		656,
		656
	],
	"./02586-como-o-fator-de-potencia-afeta-circuitos-trifasicos.md": [
		17121,
		17121
	],
	"./02587-como-a-serie-de-fourier-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		70532,
		70532
	],
	"./02588-como-funciona-um-transistor-bipolar-de-juncao-bjt.md": [
		98863,
		98863
	],
	"./02589-o-que-e-um-circuito-de-ponte-e-como-ele-funciona.md": [
		5055,
		5055
	],
	"./02590-como-implementar-um-circuito-digital-a-partir-de-uma-expressao-logica.md": [
		41943,
		41943
	],
	"./02591-o-que-e-um-amplificador-bjt-e-como-ele-funciona.md": [
		82903,
		82903
	],
	"./02592-o-que-e-um-curto-circuito-e-como-ele-afeta-um-circuito-eletrico.md": [
		15964,
		15964
	],
	"./02593-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		63034,
		63034
	],
	"./02594-como-a-teoria-da-superposicao-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		13547,
		13547
	],
	"./02595-o-que-acontece-com-a-corrente-em-um-circuito-rc-apos-a-comutacao.md": [
		15633,
		15633
	],
	"./02596-o-que-e-um-circuito-super-amortecido-e-como-ele-se-comporta.md": [
		83137,
		83137
	],
	"./02597-o-que-e-a-impedancia-em-circuitos-de-corrente-alternada.md": [
		49666,
		49666
	],
	"./02598-o-que-e-uma-conexao-estrela-triangulo-em-circuitos-trifasicos.md": [
		96484,
		96484
	],
	"./02599-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		22715,
		22715
	],
	"./02600-o-que-e-um-diodo-e-como-ele-funciona-em-um-circuito-eletrico.md": [
		97848,
		97848
	],
	"./02601-como-funciona-o-disparo-trigger-em-um-circuito-amplificador-com-bjt.md": [
		81888,
		81888
	],
	"./02602-como-funcionam-as-portas-logicas-em-circuitos-digitais.md": [
		16260,
		16260
	],
	"./02603-o-que-e-uma-porta-logica-combinacional-e-como-ela-funciona.md": [
		94242,
		94242
	],
	"./02604-o-que-e-um-curto-circuito-e-como-ele-afeta-um-sistema-eletrico.md": [
		42136,
		42136
	],
	"./02605-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		27864,
		27864
	],
	"./02606-como-aplicar-o-teorema-de-thevenin-em-um-circuito-eletrico.md": [
		4165,
		4165
	],
	"./02607-o-que-acontece-com-a-energia-armazenada-em-um-capacitor-durante-a-comutacao-em-um-circuito-rc.md": [
		34418,
		34418
	],
	"./02608-o-que-e-um-circuito-de-segunda-ordem-e-como-ele-se-comporta.md": [
		2455,
		2455
	],
	"./02609-como-a-impedancia-afeta-a-transferencia-de-potencia-em-circuitos-de-corrente-alternada.md": [
		54859,
		54859
	],
	"./02610-qual-a-diferenca-entre-as-conexoes-triangulo-e-estrela-em-circuitos-trifasicos.md": [
		34472,
		34472
	],
	"./02611-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-com-entrada-em-forma-de-rampa.md": [
		1914,
		1914
	],
	"./02612-qual-a-diferenca-entre-um-bjt-e-um-hbt.md": [
		23006,
		23006
	],
	"./02613-o-que-e-um-multivibrador-astavel-e-como-ele-funciona-em-circuitos-analogicos.md": [
		47019,
		47019
	],
	"./02614-como-implementar-uma-porta-logica-and-usando-transistores-mos.md": [
		10519,
		10519
	],
	"./02615-o-que-e-uma-onda-senoidal-e-como-ela-se-aplica-em-circuitos-rlc.md": [
		18378,
		18378
	],
	"./02616-o-que-e-um-ramo-em-um-circuito-eletrico.md": [
		29063,
		29063
	],
	"./02617-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		87189,
		87189
	],
	"./02618-como-verificar-o-circuito-equivalente-usando-ltspice.md": [
		3457,
		3457
	],
	"./02619-como-a-energia-armazenada-em-um-capacitor-e-obtida-em-circuitos-de-primeira-ordem.md": [
		33582,
		33582
	],
	"./02620-o-que-e-uma-resposta-super-amortecida-em-circuitos-de-segunda-ordem.md": [
		60289,
		60289
	],
	"./02621-o-que-e-a-amplitude-de-uma-onda-senoidal-em-um-circuito-de-corrente-alternada.md": [
		3871,
		3871
	],
	"./02622-o-que-sao-circuitos-trifasicos-equilibrados-e-onde-sao-usados.md": [
		69226,
		69226
	],
	"./02623-como-o-teorema-de-laplace-e-aplicado-na-analise-de-circuitos-rlc.md": [
		18423,
		18423
	],
	"./02624-como-funciona-a-operacao-de-um-diodo-em-um-circuito-eletrico.md": [
		91966,
		91966
	],
	"./02625-como-funciona-um-oscilador-baseado-em-amplificador-operacional-amp-op.md": [
		23520,
		23520
	],
	"./02626-como-funciona-uma-porta-logica-and-em-circuitos-digitais.md": [
		98820,
		98820
	],
	"./02627-como-funciona-um-amplificador-bjt-em-configuracao-comum.md": [
		2636,
		80255
	],
	"./02628-o-que-e-um-curto-circuito-e-como-ele-ocorre.md": [
		93717,
		93717
	],
	"./02629-como-funcionam-os-transformadores-em-circuitos-eletricos.md": [
		38467,
		38467
	],
	"./02630-o-que-e-o-principio-da-superposicao-em-circuitos-eletricos.md": [
		46424,
		46424
	],
	"./02631-como-a-energia-armazenada-em-um-capacitor-se-comporta-ao-longo-do-tempo-durante-a-descarga.md": [
		59256,
		59256
	],
	"./02632-como-identificar-o-tipo-de-resposta-em-circuitos-de-segunda-ordem.md": [
		30929,
		30929
	],
	"./02633-o-que-e-a-potencia-rms-em-circuitos-de-corrente-alternada.md": [
		88416,
		88416
	],
	"./02634-o-que-e-um-circuito-trifasico-equilibrado.md": [
		7876,
		7876
	],
	"./02635-o-que-e-a-resposta-ao-degrau-em-circuitos-eletricos-passivos.md": [
		64247,
		64247
	],
	"./02636-como-funciona-a-polarizacao-de-um-transistor-bjt-utilizando-o-teorema-de-thevenin.md": [
		21704,
		21704
	],
	"./02637-como-funciona-a-implementacao-de-um-amplificador-analogico-utilizando-bjt.md": [
		4683,
		4683
	],
	"./02638-qual-a-diferenca-entre-um-flip-flop-e-um-latch-em-circuitos-digitais.md": [
		8875,
		8875
	],
	"./02639-como-funcionam-os-amplificadores-em-circuitos-eletricos.md": [
		47709,
		47709
	],
	"./02640-o-que-e-potencia-em-um-circuito-eletrico-e-como-ela-e-medida.md": [
		48490,
		48490
	],
	"./02641-qual-a-diferenca-entre-componentes-passivos-e-ativos-em-circuitos-eletricos.md": [
		57722,
		57722
	],
	"./02642-como-funciona-a-analise-nodal-em-circuitos-eletricos.md": [
		6716,
		6716
	],
	"./02643-como-obter-a-tensao-em-um-circuito-de-primeira-ordem-com-indutor-apos-a-comutacao.md": [
		4164,
		4164
	],
	"./02644-o-que-e-uma-resposta-sub-amortecida-em-circuitos-de-segunda-ordem.md": [
		82080,
		82080
	],
	"./02645-o-que-e-a-impedancia-em-circuitos-de-corrente-alternada.md": [
		83684,
		83684
	],
	"./02646-qual-a-diferenca-entre-um-sistema-trifasico-e-um-sistema-monofasico.md": [
		90775,
		90775
	],
	"./02647-o-que-e-um-filtro-passa-faixas-e-como-ele-funciona.md": [
		13451,
		13451
	],
	"./02648-como-funciona-um-diodo-semicondutor.md": [
		24621,
		24621
	],
	"./02649-o-que-e-um-multivibrador-e-como-ele-funciona-em-circuitos-analogicos.md": [
		63645,
		63645
	],
	"./02650-como-converter-numeros-decimais-para-binarios-e-vice-versa-em-circuitos-digitais.md": [
		29414,
		29414
	],
	"./02651-o-que-e-um-sinal-senoidal-e-como-ele-e-utilizado-em-circuitos-eletricos.md": [
		39351,
		39351
	],
	"./02652-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		67438,
		67438
	],
	"./02653-qual-a-diferenca-entre-componentes-passivos-e-ativos-em-circuitos-eletronicos.md": [
		57248,
		57248
	],
	"./02654-como-funciona-a-analise-nodal-em-circuitos-eletricos.md": [
		61729,
		61729
	],
	"./02655-o-que-acontece-com-a-energia-armazenada-em-um-circuito-rl-apos-a-comutacao.md": [
		95987,
		95987
	],
	"./02656-o-que-e-um-circuito-de-segunda-ordem-criticamente-amortecido.md": [
		50908,
		50908
	],
	"./02657-como-a-analise-de-circuitos-em-corrente-alternada-difere-da-analise-em-corrente-continua.md": [
		30810,
		30810
	],
	"./02658-o-que-e-um-circuito-trifasico-equilibrado-e-como-ele-e-usado-em-sistemas-eletricos.md": [
		9099,
		9099
	],
	"./02659-o-que-e-uma-singularidade-em-circuitos-eletricos-e-como-ela-se-aplica-na-analise-avancada.md": [
		54341,
		54341
	],
	"./02660-como-funciona-a-analise-de-um-transistor-igbt-em-modo-saturado.md": [
		42092,
		42092
	],
	"./02661-o-que-e-um-circuito-de-ponte-de-wien-e-como-ele-funciona.md": [
		33362,
		33362
	],
	"./02662-como-converter-um-numero-decimal-para-binario-e-vice-versa.md": [
		52226,
		52226
	],
	"./02663-como-funciona-um-circuito-schmitt-trigger-em-uma-montagem-experimental.md": [
		65727,
		65727
	],
	"./02664-o-que-e-um-circuito-aberto-e-como-ele-difere-de-um-curto-circuito.md": [
		71738,
		71738
	],
	"./02665-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		19898,
		19898
	],
	"./02666-como-aplicar-o-teorema-da-superposicao-na-analise-de-circuitos-eletricos.md": [
		1243,
		1243
	],
	"./02667-como-a-energia-armazenada-em-um-indutor-afeta-a-corrente-em-um-circuito-rl-de-primeira-ordem.md": [
		80594,
		80594
	],
	"./02668-como-resolver-circuitos-rlc-de-segunda-ordem-no-caso-subamortecido.md": [
		89831,
		89831
	],
	"./02669-o-que-e-a-admitancia-em-circuitos-de-corrente-alternada.md": [
		62544,
		62544
	],
	"./02670-o-que-e-um-circuito-trifasico-equilibrado.md": [
		11924,
		11924
	],
	"./02671-como-a-transformada-de-laplace-e-utilizada-na-analise-avancada-de-circuitos.md": [
		89739,
		89739
	],
	"./02672-como-funciona-a-juncao-pn-em-semicondutores.md": [
		77980,
		77980
	],
	"./02673-o-que-e-um-multivibrador-e-quais-sao-suas-aplicacoes-praticas.md": [
		13440,
		13440
	],
	"./02674-como-funciona-uma-tabela-verdade-em-circuitos-digitais.md": [
		20152,
		20152
	],
	"./02675-como-funciona-um-circuito-rc-de-primeira-ordem-em-uma-configuracao-de-trigger.md": [
		12749,
		12749
	],
	"./02676-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		99764,
		99764
	],
	"./02677-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		20435,
		20435
	],
	"./02678-como-aplicar-o-teorema-de-norton-na-analise-de-circuitos.md": [
		59604,
		59604
	],
	"./02679-como-ocorre-a-carga-e-descarga-de-um-capacitor-em-um-circuito-rc.md": [
		32511,
		32511
	],
	"./02680-o-que-e-a-continuidade-em-circuitos-de-segunda-ordem.md": [
		61655,
		61655
	],
	"./02681-o-que-e-a-potencia-em-circuitos-de-corrente-alternada.md": [
		24852,
		24852
	],
	"./02682-qual-a-diferenca-entre-um-circuito-trifasico-equilibrado-e-um-circuito-monofasico.md": [
		18455,
		18455
	],
	"./02683-como-a-transformada-de-fourier-inversa-e-utilizada-na-analise-de-circuitos-rlc.md": [
		94821,
		94821
	],
	"./02684-como-os-semicondutores-sao-utilizados-em-circuitos-eletricos.md": [
		29840,
		29840
	],
	"./02685-o-que-e-um-trigger-em-circuitos-analogicos.md": [
		18415,
		18415
	],
	"./02686-o-que-e-um-circuito-combinacional-e-como-ele-difere-de-um-circuito-sequencial.md": [
		39793,
		39793
	],
	"./02687-o-que-e-uma-porta-logica-ttl-e-como-ela-funciona.md": [
		88615,
		88615
	],
	"./02688-o-que-e-um-circuito-em-serie-e-como-ele-se-comporta.md": [
		10187,
		10187
	],
	"./02689-qual-a-funcao-de-um-capacitor-em-um-circuito-eletrico.md": [
		29303,
		29303
	],
	"./02690-como-funciona-o-principio-da-superposicao-em-circuitos-eletricos.md": [
		34478,
		34478
	],
	"./02691-como-a-constante-de-tempo-afeta-o-comportamento-de-um-circuito-rc-de-primeira-ordem.md": [
		50476,
		50476
	],
	"./02692-como-a-continuidade-da-corrente-e-da-tensao-afeta-circuitos-de-segunda-ordem.md": [
		14378,
		14378
	],
	"./02693-o-que-e-um-fasor-e-como-ele-e-utilizado-em-circuitos-de-corrente-alternada.md": [
		62974,
		62974
	],
	"./02694-qual-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		8236,
		8236
	],
	"./02695-o-que-e-a-transformada-de-laplace-e-como-ela-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		41589,
		41589
	],
	"./02696-qual-a-diferenca-entre-a-regiao-de-saturacao-de-um-mosfet-e-um-mesfet.md": [
		12686,
		12686
	],
	"./02697-o-que-e-um-amplificador-operacional-e-como-ele-funciona-em-circuitos-analogicos.md": [
		87641,
		87641
	],
	"./02698-como-funciona-a-simplificacao-de-funcoes-logicas-usando-o-mapa-de-karnaugh.md": [
		93759,
		93759
	],
	"./02699-como-funciona-um-circuito-schmitt-trigger-em-uma-montagem-experimental.md": [
		52428,
		52428
	],
	"./02700-o-que-e-a-lei-de-kirchhoff-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		9517,
		9517
	],
	"./02701-qual-a-funcao-de-um-transformador-em-um-circuito-eletrico.md": [
		51844,
		51844
	],
	"./02702-como-funciona-o-metodo-nodal-na-analise-basica-de-circuitos-eletricos.md": [
		59523,
		59523
	],
	"./02703-como-a-constante-de-tempo-afeta-a-resposta-de-um-circuito-rc-de-primeira-ordem.md": [
		45821,
		45821
	],
	"./02704-o-que-e-um-circuito-super-amortecido-de-segunda-ordem.md": [
		13381,
		13381
	],
	"./02705-o-que-e-um-fasor-e-como-ele-e-utilizado-em-circuitos-de-corrente-alternada.md": [
		22018,
		22018
	],
	"./02706-o-que-e-potencia-instantanea-em-circuitos-trifasicos.md": [
		2061,
		2061
	],
	"./02707-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		99504,
		99504
	],
	"./02708-qual-e-a-diferenca-entre-um-mosfet-e-um-transistor-de-juncao-bipolar-bjt.md": [
		41571,
		41571
	],
	"./02709-o-que-e-um-circuito-astavel-e-como-ele-funciona.md": [
		77503,
		77503
	],
	"./02710-como-utilizar-tabelas-verdade-para-simplificar-expressoes-logicas-em-circuitos-digitais.md": [
		27309,
		27309
	],
	"./02711-o-que-e-um-schmitt-trigger-e-como-ele-funciona-em-circuitos-eletricos.md": [
		72354,
		72354
	],
	"./02712-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		46249,
		46249
	],
	"./02713-qual-a-funcao-de-um-diodo-em-um-circuito-eletrico.md": [
		66,
		66
	],
	"./02714-o-que-e-o-metodo-de-superposicao-na-analise-de-circuitos-eletricos.md": [
		12080,
		12080
	],
	"./02715-o-que-acontece-em-um-circuito-rc-quando-a-chave-e-comutada.md": [
		17879,
		17879
	],
	"./02716-como-os-circuitos-rlc-de-segunda-ordem-se-comportam-em-paralelo.md": [
		26922,
		26922
	],
	"./02717-o-que-e-admitancia-em-circuitos-de-corrente-alternada.md": [
		22812,
		22812
	],
	"./02718-o-que-e-uma-conexao-triangulo-triangulo-em-circuitos-trifasicos.md": [
		20059,
		20059
	],
	"./02719-como-os-filtros-rlc-sao-aplicados-na-analise-de-circuitos.md": [
		17568,
		17568
	],
	"./02720-como-o-mosfet-funciona-em-um-circuito-eletrico.md": [
		14722,
		14722
	],
	"./02721-como-funciona-um-amplificador-operacional-em-um-circuito-analogico.md": [
		67701,
		67701
	],
	"./02722-como-a-algebra-booleana-e-utilizada-em-circuitos-digitais.md": [
		41819,
		41819
	],
	"./02723-o-que-e-um-trigger-em-um-osciloscopio-e-como-ele-funciona.md": [
		26247,
		26247
	],
	"./02724-o-que-e-um-curto-circuito-e-como-ele-ocorre.md": [
		29734,
		29734
	],
	"./02725-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		64504,
		42123
	],
	"./02726-como-aplicar-o-teorema-de-thevenin-em-um-circuito-linear.md": [
		80872,
		80872
	],
	"./02727-como-funciona-a-descarga-de-um-indutor-em-um-circuito-de-primeira-ordem.md": [
		97792,
		97792
	],
	"./02728-como-determinar-a-resposta-super-amortecida-em-circuitos-rlc-paralelos.md": [
		29745,
		29745
	],
	"./02729-o-que-e-um-fasor-e-como-ele-e-utilizado-em-circuitos-de-corrente-alternada.md": [
		89423,
		89423
	],
	"./02730-qual-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		12891,
		12891
	],
	"./02731-como-a-transformada-de-fourier-e-aplicada-na-analise-de-circuitos-rlc.md": [
		52278,
		52278
	],
	"./02732-o-que-significa-um-transistor-mosfet-estar-em-modo-saturado.md": [
		39681,
		39681
	],
	"./02733-o-que-e-um-oscilador-de-wien-e-como-ele-funciona-em-circuitos-analogicos.md": [
		16957,
		16957
	],
	"./02734-qual-a-diferenca-entre-circuitos-combinacionais-e-sequenciais.md": [
		53656,
		53656
	],
	"./02735-como-a-transformada-de-fourier-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		68889,
		68889
	],
	"./02736-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		35931,
		35931
	],
	"./02737-como-os-diodos-influenciam-a-tensao-em-um-circuito-eletronico.md": [
		98817,
		98817
	],
	"./02738-como-funciona-a-transferencia-de-potencia-maxima-em-um-circuito-com-resistores.md": [
		98588,
		98588
	],
	"./02739-como-a-energia-armazenada-em-um-capacitor-e-obtida-em-um-circuito-rc.md": [
		4827,
		4827
	],
	"./02740-o-que-e-um-circuito-rlc-super-amortecido.md": [
		77579,
		77579
	],
	"./02741-como-aplicar-o-teorema-de-superposicao-em-circuitos-de-corrente-alternada.md": [
		17137,
		17137
	],
	"./02742-o-que-e-potencia-instantanea-em-circuitos-trifasicos.md": [
		38845,
		38845
	],
	"./02743-o-que-e-o-teorema-de-parseval-e-como-ele-se-aplica-na-analise-de-circuitos.md": [
		31603,
		31603
	],
	"./02744-qual-a-diferenca-entre-jfet-mosfet-mesfet-e-igbt.md": [
		43071,
		43071
	],
	"./02745-o-que-e-um-ponto-de-operacao-em-circuitos-analogicos.md": [
		63217,
		63217
	],
	"./02746-como-os-flip-flops-sao-utilizados-em-circuitos-digitais.md": [
		95137,
		95137
	],
	"./02747-qual-e-a-diferenca-entre-os-niveis-de-tensao-ttl-e-cmos-em-circuitos-digitais.md": [
		85614,
		85614
	],
	"./02748-o-que-e-a-lei-de-ohm-e-como-ela-se-aplica-em-circuitos-simples.md": [
		32496,
		32496
	],
	"./02749-qual-a-diferenca-entre-componentes-eletronicos-lineares-e-nao-lineares.md": [
		86602,
		86602
	],
	"./02750-como-funciona-a-analise-nodal-em-circuitos-eletricos.md": [
		59088,
		59088
	],
	"./02751-como-obter-a-resposta-de-um-circuito-rc-de-primeira-ordem.md": [
		27527,
		27527
	],
	"./02752-o-que-e-a-resposta-natural-de-um-circuito-de-segunda-ordem.md": [
		90718,
		90718
	],
	"./02753-como-o-teorema-de-thevenin-e-aplicado-em-circuitos-de-corrente-alternada.md": [
		97761,
		97761
	],
	"./02754-o-que-e-um-circuito-trifasico-equilibrado-em-configuracao-triangulo-triangulo.md": [
		48496,
		48496
	],
	"./02755-o-que-e-o-teorema-de-parseval-e-como-ele-se-aplica-na-analise-de-circuitos-eletricos.md": [
		21275,
		21275
	],
	"./02756-como-funcionam-os-transistores-em-circuitos-eletricos.md": [
		71779,
		71779
	],
	"./02757-o-que-e-um-schmitt-trigger-e-como-ele-funciona-em-circuitos-analogicos.md": [
		78028,
		78028
	],
	"./02758-como-funcionam-os-flip-flops-em-circuitos-digitais.md": [
		13602,
		13602
	],
	"./02759-o-que-e-um-filtro-passa-baixa-e-como-ele-funciona-em-circuitos-eletricos.md": [
		57694,
		57694
	],
	"./02760-o-que-e-um-no-em-um-circuito-eletrico.md": [
		96459,
		96459
	],
	"./02761-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		90579,
		90579
	],
	"./02762-como-funciona-o-principio-da-superposicao-em-circuitos-eletricos.md": [
		42740,
		42740
	],
	"./02763-como-funciona-a-carga-e-descarga-de-um-indutor-em-um-circuito-rl.md": [
		50992,
		50992
	],
	"./02764-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-se-comportam.md": [
		49366,
		49366
	],
	"./02765-o-que-e-admitancia-em-circuitos-de-corrente-alternada.md": [
		47525,
		47525
	],
	"./02766-qual-e-a-diferenca-entre-a-conexao-estrela-e-a-conexao-triangulo-em-circuitos-trifasicos.md": [
		85596,
		85596
	],
	"./02767-o-que-e-um-filtro-passa-faixas-e-como-ele-funciona-em-circuitos-eletricos.md": [
		87678,
		87678
	],
	"./02768-qual-a-diferenca-entre-bjt-e-mosfet.md": [
		71444,
		71444
	],
	"./02769-qual-a-diferenca-entre-sinais-analogicos-e-digitais-em-circuitos-eletricos.md": [
		8549,
		8549
	],
	"./02770-como-simplificar-uma-funcao-logica-usando-o-mapa-de-karnaugh.md": [
		53335,
		53335
	],
	"./02771-o-que-e-o-regime-permanente-em-circuitos-eletricos.md": [
		55127,
		55127
	],
	"./02772-o-que-e-a-lei-de-kirchhoff-das-malhas-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		41014,
		41014
	],
	"./02773-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		40582,
		40582
	],
	"./02774-como-funciona-a-analise-nodal-em-circuitos-eletricos.md": [
		8174,
		8174
	],
	"./02775-como-os-circuitos-de-primeira-ordem-respondem-a-uma-fonte-de-tensao.md": [
		6551,
		6551
	],
	"./02776-o-que-e-uma-resposta-super-amortecida-em-circuitos-rlc-de-segunda-ordem.md": [
		50415,
		50415
	],
	"./02777-o-que-e-o-valor-eficaz-em-circuitos-de-corrente-alternada.md": [
		26858,
		26858
	],
	"./02778-como-funciona-a-conexao-triangulo-triangulo-em-circuitos-trifasicos.md": [
		38282,
		38282
	],
	"./02779-o-que-e-a-analise-de-circuitos-usando-o-teorema-de-parseval.md": [
		68465,
		68465
	],
	"./02780-qual-a-diferenca-entre-um-diodo-e-um-transistor.md": [
		64648,
		64648
	],
	"./02781-o-que-e-um-circuito-biestavel-e-como-ele-funciona.md": [
		48292,
		48292
	],
	"./02782-como-funcionam-os-latches-em-circuitos-digitais.md": [
		46617,
		46617
	],
	"./02783-o-que-e-um-trigger-de-schmitt-e-como-ele-e-utilizado-em-circuitos-digitais.md": [
		76747,
		76747
	],
	"./02784-o-que-e-um-no-em-um-circuito-eletrico.md": [
		6465,
		6465
	],
	"./02785-qual-a-funcao-de-um-capacitor-em-um-circuito-eletrico.md": [
		43756,
		43756
	],
	"./02786-como-verificar-a-linearidade-de-um-circuito-com-resistores-e-fontes-de-corrente.md": [
		6522,
		6522
	],
	"./02787-como-determinar-a-constante-de-tempo-em-um-circuito-rl.md": [
		59607,
		59607
	],
	"./02788-como-determinar-o-comportamento-de-um-circuito-rlc-super-amortecido.md": [
		89275,
		89275
	],
	"./02789-como-a-frequencia-afeta-a-transferencia-de-potencia-em-circuitos-de-corrente-alternada.md": [
		66404,
		66404
	],
	"./02790-como-converter-um-circuito-trifasico-de-configuracao-triangulo-triangulo-para-triangulo-estrela.md": [
		13189,
		13189
	],
	"./02791-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-com-entrada-em-rampa.md": [
		81351,
		81351
	],
	"./02792-como-funciona-o-modelo-equivalente-de-thevenin-para-um-diodo-pn.md": [
		61397,
		61397
	],
	"./02793-o-que-e-um-oscilador-astavel-e-como-ele-funciona-em-circuitos-analogicos.md": [
		51528,
		51528
	],
	"./02794-como-funciona-a-conversao-de-numeros-binarios-para-decimais-em-circuitos-digitais.md": [
		4181,
		4181
	],
	"./02795-como-identificar-componentes-comuns-em-circuitos-combinacionais.md": [
		25490,
		25490
	],
	"./02796-o-que-e-um-circuito-eletrico-e-quais-sao-seus-componentes-basicos.md": [
		5148,
		5148
	],
	"./02797-qual-a-diferenca-entre-capacitores-e-indutores-em-circuitos-eletricos.md": [
		77177,
		77177
	],
	"./02798-como-a-teoria-da-superposicao-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		25525,
		25525
	],
	"./02799-o-que-e-um-circuito-de-primeira-ordem-e-como-ele-se-comporta-apos-a-comutacao.md": [
		49159,
		49159
	],
	"./02800-o-que-e-uma-resposta-super-amortecida-em-circuitos-de-segunda-ordem.md": [
		15061,
		15061
	],
	"./02801-o-que-e-a-amplitude-em-um-circuito-rlc-em-corrente-alternada.md": [
		67535,
		67535
	],
	"./02802-qual-a-diferenca-entre-as-conexoes-triangulo-estrela-e-triangulo-triangulo-em-circuitos-trifasicos.md": [
		94883,
		94883
	],
	"./02803-o-que-e-o-teorema-de-parseval-e-como-ele-se-aplica-em-circuitos-rlc.md": [
		36719,
		36719
	],
	"./02804-como-funciona-a-regiao-de-saturacao-em-um-mosfet.md": [
		16342,
		16342
	],
	"./02805-como-funciona-um-amplificador-operacional-em-circuitos-analogicos.md": [
		50887,
		50887
	],
	"./02806-como-converter-um-numero-decimal-para-binario-em-circuitos-digitais.md": [
		35824,
		35824
	],
	"./02807-o-que-e-um-filtro-passa-baixa-em-circuitos-eletricos.md": [
		49006,
		49006
	],
	"./02808-o-que-e-um-no-em-um-circuito-eletrico.md": [
		86608,
		86608
	],
	"./02809-qual-a-funcao-de-um-transistor-em-um-circuito-eletronico.md": [
		53371,
		53371
	],
	"./02810-como-aplicar-o-teorema-da-superposicao-em-um-circuito-com-multiplas-fontes.md": [
		9952,
		9952
	],
	"./02811-o-que-e-a-constante-de-tempo-em-circuitos-de-primeira-ordem.md": [
		74933,
		74933
	],
	"./02812-o-que-e-um-circuito-criticamente-amortecido.md": [
		75142,
		75142
	],
	"./02813-o-que-e-a-transferencia-de-potencia-media-em-circuitos-de-corrente-alternada.md": [
		10886,
		10886
	],
	"./02814-qual-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		64558,
		64558
	],
	"./02815-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		76538,
		76538
	],
	"./02816-como-funciona-a-juncao-pn-em-um-diodo-semicondutor.md": [
		3683,
		3683
	],
	"./02817-o-que-e-um-circuito-biestavel-e-como-ele-funciona.md": [
		49593,
		71974
	],
	"./02818-como-funcionam-os-circuitos-sequenciais-em-sistemas-digitais.md": [
		21169,
		21169
	],
	"./02819-como-funciona-um-conversor-r2r-em-circuitos-eletricos.md": [
		92379,
		92379
	],
	"./02820-o-que-e-tensao-eletrica-e-qual-sua-importancia-em-um-circuito.md": [
		57672,
		57672
	],
	"./02821-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		90388,
		90388
	],
	"./02822-como-o-ltspice-pode-ser-utilizado-para-simular-a-analise-de-malhas-em-circuitos-eletricos.md": [
		46226,
		46226
	],
	"./02823-como-a-constante-de-tempo-afeta-a-resposta-de-um-circuito-rl-de-primeira-ordem.md": [
		85693,
		85693
	],
	"./02824-como-resolver-circuitos-de-segunda-ordem-usando-edos.md": [
		9819,
		9819
	],
	"./02825-como-funciona-o-principio-da-superposicao-em-circuitos-de-corrente-alternada.md": [
		42611,
		42611
	],
	"./02826-qual-e-a-diferenca-entre-as-conexoes-triangulo-e-estrela-em-circuitos-trifasicos.md": [
		99791,
		99791
	],
	"./02827-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		31681,
		31681
	],
	"./02828-como-funciona-um-transistor-jfet-em-um-circuito-eletrico.md": [
		43063,
		43063
	],
	"./02829-como-funciona-um-oscilador-de-ponte-de-wien-em-circuitos-analogicos.md": [
		31147,
		31147
	],
	"./02830-como-funciona-uma-tabela-verdade-em-circuitos-digitais.md": [
		50010,
		27629
	],
	"./02831-o-que-e-um-trigger-schmitt-e-como-ele-funciona-em-circuitos-eletricos.md": [
		22057,
		22057
	],
	"./02832-o-que-e-um-no-em-um-circuito-eletrico.md": [
		79633,
		79633
	],
	"./02833-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		24369,
		24369
	],
	"./02834-o-que-e-o-teorema-da-maxima-transferencia-de-potencia.md": [
		94584,
		94584
	],
	"./02835-como-a-energia-e-armazenada-em-capacitores-e-indutores-em-circuitos-de-primeira-ordem.md": [
		63437,
		63437
	],
	"./02836-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-funcionam.md": [
		44335,
		44335
	],
	"./02837-como-aplicar-o-teorema-de-superposicao-em-circuitos-de-corrente-alternada.md": [
		75445,
		75445
	],
	"./02838-o-que-e-um-circuito-trifasico-e-como-ele-funciona.md": [
		9286,
		9286
	],
	"./02839-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-rlc.md": [
		29635,
		29635
	],
	"./02840-qual-a-diferenca-entre-um-transistor-bjt-e-um-transistor-hbt.md": [
		23349,
		23349
	],
	"./02841-como-funciona-um-amplificador-operacional-em-um-circuito-analogico.md": [
		68664,
		68664
	],
	"./02842-como-os-transistores-cmos-sao-usados-para-implementar-expressoes-booleanas-em-circuitos-digitais.md": [
		22426,
		22426
	],
	"./02843-o-que-e-o-regime-permanente-em-circuitos-eletricos.md": [
		55647,
		55647
	],
	"./02844-o-que-sao-as-leis-de-kirchhoff-e-como-elas-se-aplicam-em-circuitos-eletricos.md": [
		52896,
		52896
	],
	"./02845-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		32078,
		32078
	],
	"./02846-como-funciona-a-transformacao-de-uma-fonte-de-corrente-em-uma-fonte-de-tensao-usando-o-teorema-de-norton.md": [
		17815,
		17815
	],
	"./02847-como-a-tensao-em-um-capacitor-e-obtida-em-circuitos-de-primeira-ordem.md": [
		85615,
		85615
	],
	"./02848-como-funciona-um-circuito-rlc-paralelo-de-segunda-ordem.md": [
		27678,
		27678
	],
	"./02849-como-aplicar-o-teorema-da-superposicao-em-circuitos-de-corrente-alternada.md": [
		8532,
		8532
	],
	"./02850-qual-a-diferenca-entre-as-conexoes-triangulo-estrela-e-triangulo-triangulo-em-circuitos-trifasicos.md": [
		28558,
		28558
	],
	"./02851-como-funciona-um-filtro-passa-faixas-em-circuitos-eletricos-avancados.md": [
		66966,
		66966
	],
	"./02852-como-os-diodos-e-mosfets-influenciam-o-comportamento-de-um-circuito.md": [
		51979,
		51979
	],
	"./02853-como-funciona-a-implementacao-de-um-amplificador-de-pequeno-sinal-usando-bjt.md": [
		77589,
		99970
	],
	"./02854-como-funciona-a-simplificacao-de-circuitos-combinacionais-digitais.md": [
		22592,
		22592
	],
	"./02855-como-funciona-um-transistor-bjt-em-um-circuito-basico.md": [
		46526,
		46526
	],
	"./02856-o-que-e-um-sistema-de-malha-aberta-em-circuitos-eletricos.md": [
		16815,
		16815
	],
	"./02857-qual-a-diferenca-entre-componentes-passivos-e-ativos-em-circuitos-eletricos.md": [
		50507,
		50507
	],
	"./02858-o-que-e-a-analise-nodal-em-circuitos-eletricos.md": [
		66172,
		66172
	],
	"./02859-como-a-energia-e-armazenada-e-dissipada-em-um-circuito-rc.md": [
		86940,
		86940
	],
	"./02860-o-que-e-uma-resposta-sub-amortecida-em-circuitos-de-segunda-ordem.md": [
		24256,
		24256
	],
	"./02861-o-que-e-impedancia-em-circuitos-de-corrente-alternada.md": [
		78902,
		78902
	],
	"./02862-qual-e-a-diferenca-entre-as-conexoes-triangulo-e-estrela-em-circuitos-trifasicos.md": [
		26519,
		26519
	],
	"./02863-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		14937,
		14937
	],
	"./02864-como-os-semicondutores-funcionam-em-circuitos-eletricos.md": [
		78096,
		78096
	],
	"./02865-o-que-e-um-multivibrador-astavel-e-como-ele-funciona-em-circuitos-analogicos.md": [
		1790,
		1790
	],
	"./02866-como-converter-um-numero-binario-para-decimal-e-vice-versa.md": [
		16970,
		16970
	],
	"./02867-como-medir-a-tensao-em-um-circuito-em-serie.md": [
		38836,
		16455
	],
	"./02868-como-funciona-a-associacao-de-resistores-em-serie-e-paralelo.md": [
		5409,
		5409
	],
	"./02869-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		65488,
		65488
	],
	"./02870-como-aplicar-o-teorema-de-superposicao-em-circuitos-eletricos.md": [
		23611,
		23611
	],
	"./02871-como-a-constante-de-tempo-afeta-a-resposta-de-um-circuito-rl-de-primeira-ordem.md": [
		55124,
		55124
	],
	"./02872-como-resolver-circuitos-de-segunda-ordem-com-fontes-dependentes.md": [
		43929,
		43929
	],
	"./02873-o-que-e-a-transferencia-de-potencia-maxima-em-circuitos-de-corrente-alternada.md": [
		13605,
		13605
	],
	"./02874-qual-e-a-diferenca-entre-as-conexoes-triangulo-e-estrela-em-circuitos-trifasicos.md": [
		38410,
		38410
	],
	"./02875-como-a-analise-de-circuitos-com-degrau-e-aplicada-em-sistemas-passivos.md": [
		27236,
		27236
	],
	"./02876-como-o-mosfet-opera-em-um-circuito-saturado.md": [
		81998,
		81998
	],
	"./02877-como-funciona-um-conversor-r2r-em-circuitos-analogicos.md": [
		55917,
		55917
	],
	"./02878-como-os-mapas-de-karnaugh-simplificam-expressoes-logicas-em-circuitos-digitais.md": [
		27924,
		27924
	],
	"./02879-como-funciona-o-conversor-r2r-em-circuitos-digitais.md": [
		5896,
		5896
	],
	"./02880-o-que-e-um-curto-circuito-e-como-ele-ocorre-em-um-circuito-eletrico.md": [
		79858,
		79858
	],
	"./02881-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		35218,
		35218
	],
	"./02882-o-que-e-o-metodo-das-malhas-na-analise-de-circuitos-eletricos.md": [
		1980,
		1980
	],
	"./02883-como-obter-a-carga-armazenada-em-um-capacitor-em-circuitos-de-primeira-ordem.md": [
		96901,
		96901
	],
	"./02884-o-que-e-um-circuito-de-segunda-ordem-super-amortecido.md": [
		22236,
		22236
	],
	"./02885-o-que-e-a-impedancia-em-circuitos-rlc-e-como-ela-afeta-o-comportamento-do-circuito.md": [
		10164,
		10164
	],
	"./02886-qual-a-diferenca-entre-as-conexoes-triangulo-estrela-e-triangulo-triangulo-em-circuitos-trifasicos.md": [
		72087,
		72087
	],
	"./02887-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-rlc.md": [
		1568,
		1568
	],
	"./02888-qual-a-diferenca-entre-mosfet-e-mesfet.md": [
		82211,
		82211
	],
	"./02889-o-que-e-um-conversor-r2r-e-como-ele-funciona-em-circuitos-analogicos.md": [
		75951,
		75951
	],
	"./02890-como-funcionam-as-portas-logicas-cmos-em-circuitos-digitais.md": [
		38810,
		38810
	],
	"./02891-o-que-e-um-circuito-schmitt-trigger-e-qual-sua-aplicacao-em-sistemas-digitais.md": [
		33748,
		33748
	],
	"./02892-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		40312,
		40312
	],
	"./02893-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		36591,
		36591
	],
	"./02894-o-que-e-uma-supermalha-e-como-ela-e-utilizada-na-analise-de-circuitos.md": [
		72878,
		72878
	],
	"./02895-como-ocorre-a-descarga-de-um-capacitor-em-um-circuito-de-primeira-ordem.md": [
		29262,
		29262
	],
	"./02896-o-que-e-uma-resposta-super-amortecida-em-circuitos-de-segunda-ordem.md": [
		50314,
		50314
	],
	"./02897-o-que-e-o-fator-de-potencia-em-circuitos-de-corrente-alternada.md": [
		76800,
		76800
	],
	"./02898-o-que-e-um-circuito-trifasico-equilibrado.md": [
		90828,
		90828
	],
	"./02899-como-a-transformada-de-fourier-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		44622,
		44622
	],
	"./02900-qual-a-diferenca-entre-um-bjt-e-um-jfet.md": [
		83853,
		83853
	],
	"./02901-o-que-e-um-filtro-analogico-e-como-ele-funciona-em-circuitos-eletricos.md": [
		3982,
		3982
	],
	"./02902-como-funcionam-os-circuitos-cmos-em-sistemas-digitais.md": [
		623,
		623
	],
	"./02903-como-funciona-um-amplificador-logico-combinacional-em-um-projeto-ttl.md": [
		82517,
		82517
	],
	"./02904-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		68584,
		68584
	],
	"./02905-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		75391,
		75391
	],
	"./02906-o-que-e-o-teorema-da-supermalha-e-como-ele-e-aplicado-na-analise-de-circuitos.md": [
		86394,
		86394
	],
	"./02907-como-funciona-a-descarga-de-um-indutor-em-um-circuito-de-primeira-ordem.md": [
		91008,
		91008
	],
	"./02908-como-a-resposta-de-um-circuito-rlc-paralelo-a-um-degrau-e-influenciada-pelas-condicoes-iniciais.md": [
		43933,
		43933
	],
	"./02909-o-que-e-a-impedancia-em-circuitos-rlc-e-como-ela-afeta-o-comportamento-do-circuito.md": [
		69909,
		69909
	],
	"./02910-o-que-e-um-sistema-trifasico-e-por-que-ele-e-usado-em-circuitos-eletricos.md": [
		69853,
		69853
	],
	"./02911-como-a-transformada-de-laplace-e-utilizada-na-analise-de-circuitos-com-entrada-em-rampa.md": [
		17265,
		17265
	],
	"./02912-como-funcionam-os-dispositivos-semicondutores-em-circuitos-eletricos.md": [
		93167,
		93167
	],
	"./02913-como-funciona-a-operacao-de-um-circuito-ativo-em-um-grafico-de-bode.md": [
		48052,
		48052
	],
	"./02914-qual-e-a-diferenca-entre-um-latch-e-um-flip-flop.md": [
		64970,
		42589
	],
	"./02915-como-montar-um-circuito-logico-analogico-em-um-projeto-experimental.md": [
		34691,
		34691
	],
	"./02916-o-que-e-a-lei-de-ohm-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		25816,
		25816
	],
	"./02917-como-funcionam-os-diodos-em-circuitos-eletricos.md": [
		91101,
		91101
	],
	"./02918-o-que-e-a-analise-nodal-em-circuitos-eletricos.md": [
		25838,
		25838
	],
	"./02919-o-que-acontece-com-a-corrente-em-um-circuito-rc-apos-a-comutacao.md": [
		82025,
		82025
	],
	"./02920-o-que-e-um-circuito-de-segunda-ordem-criticamente-amortecido.md": [
		21948,
		21948
	],
	"./02921-como-a-frequencia-afeta-a-impedancia-em-circuitos-de-corrente-alternada.md": [
		91470,
		91470
	],
	"./02922-qual-a-diferenca-entre-as-conexoes-triangulo-estrela-e-triangulo-triangulo-em-circuitos-trifasicos.md": [
		20728,
		20728
	],
	"./02923-qual-e-a-importancia-da-propriedade-do-impulso-na-analise-avancada-de-circuitos.md": [
		64612,
		64612
	],
	"./02924-qual-a-diferenca-entre-um-transistor-bipolar-de-juncao-bjt-e-um-transistor-de-efeito-de-campo-fet.md": [
		9504,
		9504
	],
	"./02925-o-que-e-um-multivibrador-e-como-ele-funciona-em-circuitos-analogicos.md": [
		37860,
		37860
	],
	"./02926-como-funciona-a-simplificacao-de-circuitos-logicos-digitais.md": [
		34681,
		34681
	],
	"./02927-como-configurar-um-amplificador-basico-em-um-circuito-experimental.md": [
		87779,
		87779
	],
	"./02928-o-que-e-a-lei-de-ohm-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		58719,
		58719
	],
	"./02929-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		15185,
		15185
	],
	"./02930-como-a-analise-nodal-e-utilizada-na-analise-de-circuitos-eletricos.md": [
		9831,
		9831
	],
	"./02931-como-a-energia-armazenada-em-um-indutor-e-obtida-em-circuitos-de-primeira-ordem.md": [
		33504,
		33504
	],
	"./02932-o-que-e-um-circuito-de-segunda-ordem-super-amortecido.md": [
		66682,
		66682
	],
	"./02933-o-que-e-admitancia-em-circuitos-de-corrente-alternada.md": [
		90928,
		90928
	],
	"./02934-qual-e-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		66375,
		66375
	],
	"./02935-como-a-transformada-de-fourier-e-utilizada-na-analise-de-circuitos-rlc.md": [
		72332,
		72332
	],
	"./02936-como-a-juncao-pn-afeta-a-corrente-e-a-tensao-em-semicondutores.md": [
		98903,
		98903
	],
	"./02937-como-funciona-um-circuito-biestavel-em-sistemas-analogicos.md": [
		11976,
		11976
	],
	"./02938-qual-a-diferenca-entre-circuitos-combinacionais-e-sequenciais.md": [
		87142,
		87142
	],
	"./02939-o-que-e-um-circuito-rc-e-como-ele-funciona.md": [
		63805,
		63805
	],
	"./02940-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		82800,
		82800
	],
	"./02941-como-funciona-um-diodo-em-um-circuito-eletrico.md": [
		68695,
		68695
	],
	"./02942-o-que-e-o-teorema-de-thevenin-e-como-ele-e-aplicado-na-analise-de-circuitos.md": [
		19729,
		19729
	],
	"./02943-o-que-e-a-constante-de-tempo-em-circuitos-de-primeira-ordem.md": [
		57397,
		57397
	],
	"./02944-o-que-e-uma-resposta-super-amortecida-em-circuitos-de-segunda-ordem.md": [
		2322,
		2322
	],
	"./02945-como-funciona-a-analise-nodal-em-circuitos-de-corrente-alternada.md": [
		81779,
		81779
	],
	"./02946-o-que-e-uma-conexao-estrela-triangulo-em-circuitos-trifasicos.md": [
		81371,
		81371
	],
	"./02947-o-que-e-o-teorema-de-parseval-e-como-ele-se-aplica-a-circuitos-rlc-em-serie.md": [
		13227,
		13227
	],
	"./02948-qual-a-diferenca-entre-bjt-e-jfet-em-circuitos-eletricos.md": [
		31773,
		31773
	],
	"./02949-como-funciona-um-amplificador-operacional-em-um-circuito-analogico.md": [
		29873,
		29873
	],
	"./02950-como-funciona-a-conversao-de-numeros-binarios-para-decimais-em-circuitos-digitais.md": [
		62895,
		62895
	],
	"./02951-como-funciona-um-conversor-combinacional-em-circuitos-eletricos.md": [
		98401,
		98401
	],
	"./02952-o-que-e-uma-associacao-em-paralelo-em-circuitos-eletricos.md": [
		86351,
		86351
	],
	"./02953-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		66930,
		66930
	],
	"./02954-como-aplicar-o-teorema-de-thevenin-na-analise-basica-de-circuitos.md": [
		64562,
		64562
	],
	"./02955-o-que-e-a-constante-de-tempo-em-circuitos-rc-e-rl.md": [
		63909,
		63909
	],
	"./02956-o-que-e-uma-resposta-subamortecida-em-um-circuito-lc-de-segunda-ordem.md": [
		72899,
		72899
	],
	"./02957-o-que-e-a-admitancia-em-circuitos-de-corrente-alternada.md": [
		37216,
		37216
	],
	"./02958-o-que-e-um-circuito-trifasico-equilibrado-e-como-ele-se-aplica-em-sistemas-triangulo-triangulo.md": [
		6220,
		6220
	],
	"./02959-como-a-transformada-de-fourier-e-utilizada-na-analise-de-circuitos-rlc.md": [
		36986,
		36986
	],
	"./02960-o-que-significa-um-mosfet-estar-em-modo-saturado.md": [
		53394,
		53394
	],
	"./02961-o-que-e-um-circuito-biestavel-e-como-ele-funciona.md": [
		87968,
		87968
	],
	"./02962-como-converter-uma-tabela-verdade-em-uma-funcao-logica.md": [
		80887,
		80887
	],
	"./02963-como-a-configuracao-em-serie-afeta-a-tensao-em-um-circuito.md": [
		15627,
		15627
	],
	"./02964-o-que-e-a-lei-dos-nos-de-kirchhoff-e-como-ela-se-aplica-em-circuitos-eletricos.md": [
		33423,
		33423
	],
	"./02965-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		7013,
		7013
	],
	"./02966-como-o-teorema-da-superposicao-e-aplicado-na-analise-de-circuitos.md": [
		85188,
		85188
	],
	"./02967-o-que-acontece-durante-a-descarga-de-um-capacitor-em-um-circuito-rl.md": [
		11594,
		11594
	],
	"./02968-o-que-e-um-circuito-de-segunda-ordem-e-como-ele-se-comporta-em-diferentes-condicoes-iniciais.md": [
		33739,
		33739
	],
	"./02969-o-que-e-a-corrente-eficaz-em-circuitos-de-corrente-alternada.md": [
		11105,
		11105
	],
	"./02970-qual-a-diferenca-entre-sistemas-trifasicos-e-monofasicos.md": [
		80581,
		80581
	],
	"./02971-como-a-resposta-de-um-circuito-rlc-a-uma-entrada-em-degrau-pode-ser-analisada.md": [
		76103,
		76103
	],
	"./02972-o-que-significa-um-transistor-bjt-estar-em-modo-saturado.md": [
		51177,
		51177
	],
	"./02973-o-que-e-um-circuito-biestavel-e-como-ele-funciona.md": [
		29707,
		29707
	],
	"./02974-como-funciona-a-implementacao-de-flip-flops-em-circuitos-digitais.md": [
		71020,
		71020
	],
	"./02975-como-funciona-um-circuito-schmitt-trigger-em-um-laboratorio-de-circuitos-eletricos.md": [
		99502,
		99502
	],
	"./02976-o-que-acontece-com-a-corrente-em-um-circuito-aberto.md": [
		56449,
		56449
	],
	"./02977-qual-a-diferenca-entre-componentes-passivos-e-ativos-em-circuitos-eletricos.md": [
		43762,
		43762
	],
	"./02978-como-funciona-a-analise-de-circuitos-usando-o-teorema-de-thevenin.md": [
		94228,
		94228
	],
	"./02979-como-o-indutor-se-comporta-em-um-circuito-de-primeira-ordem.md": [
		78286,
		78286
	],
	"./02980-o-que-sao-circuitos-de-segunda-ordem-sub-amortecidos-e-super-amortecidos.md": [
		15410,
		15410
	],
	"./02981-o-que-e-o-fator-de-potencia-em-circuitos-de-corrente-alternada.md": [
		41064,
		41064
	],
	"./02982-o-que-e-um-circuito-trifasico-equilibrado-e-como-ele-e-usado.md": [
		65878,
		65878
	],
	"./02983-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		24216,
		24216
	],
	"./02984-qual-a-diferenca-entre-um-transistor-mosfet-e-um-bjt.md": [
		56904,
		56904
	],
	"./02985-o-que-e-um-oscilador-de-wien-e-como-ele-funciona-em-circuitos-analogicos.md": [
		82884,
		82884
	],
	"./02986-como-simplificar-expressoes-logicas-em-circuitos-digitais.md": [
		50571,
		50571
	],
	"./02987-o-que-e-o-regime-permanente-em-circuitos-rc.md": [
		69847,
		69847
	],
	"./02988-o-que-e-um-curto-circuito-e-como-ele-ocorre.md": [
		15565,
		37946
	],
	"./02989-qual-a-funcao-de-um-capacitor-em-um-circuito-eletrico.md": [
		8710,
		8710
	],
	"./02990-como-o-teorema-de-thevenin-pode-ser-aplicado-na-analise-basica-de-circuitos.md": [
		75047,
		75047
	],
	"./02991-como-obter-a-resposta-de-um-circuito-rl-de-primeira-ordem.md": [
		69972,
		69972
	],
	"./02992-o-que-e-uma-resposta-criticamente-amortecida-em-circuitos-de-segunda-ordem.md": [
		16054,
		16054
	],
	"./02993-como-determinar-o-equivalente-de-thevenin-em-circuitos-de-corrente-alternada.md": [
		69651,
		69651
	],
	"./02994-o-que-e-um-circuito-trifasico-equilibrado-e-como-ele-funciona.md": [
		10113,
		10113
	],
	"./02995-como-a-propriedade-de-impulso-afeta-a-resposta-de-um-circuito-rlc-em-serie.md": [
		96450,
		96450
	],
	"./02996-como-funciona-um-diodo-em-um-circuito-eletrico.md": [
		15271,
		15271
	],
	"./02997-o-que-e-um-circuito-astavel-e-como-ele-funciona.md": [
		77238,
		77238
	],
	"./02998-como-utilizar-mapas-de-karnaugh-para-simplificar-expressoes-booleanas.md": [
		58551,
		58551
	],
	"./02999-como-medir-a-ordem-de-grandeza-de-uma-tensao-alta-em-um-circuito.md": [
		90862,
		90862
	],
	"./03000-o-que-e-um-curto-circuito-em-um-sistema-eletrico-e-como-ele-afeta-a-tensao-em-um-ramo.md": [
		25053,
		25053
	],
	"./03001-qual-e-a-funcao-dos-componentes-eletronicos-em-um-circuito-eletrico.md": [
		9327,
		9327
	],
	"./03002-como-a-analise-basica-de-circuitos-ajuda-na-verificacao-de-tensao-em-simulacoes-eletricas.md": [
		18968,
		18968
	],
	"./03003-como-a-constante-de-tempo-afeta-circuitos-de-primeira-ordem.md": [
		26651,
		26651
	],
	"./03004-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-se-comportam.md": [
		45488,
		45488
	],
	"./03005-como-a-corrente-alternada-e-representada-em-circuitos-eletricos.md": [
		71096,
		71096
	],
	"./03006-como-funciona-a-conexao-triangulo-triangulo-em-circuitos-trifasicos.md": [
		29183,
		29183
	],
	"./03007-como-a-singularidade-afeta-a-analise-de-circuitos-rlc.md": [
		6676,
		6676
	],
	"./03008-como-funcionam-os-diodos-de-juncao-em-circuitos-eletricos.md": [
		28240,
		28240
	],
	"./03009-qual-e-a-diferenca-entre-circuitos-analogicos-passivos-e-ativos.md": [
		39560,
		39560
	],
	"./03010-como-os-mapas-de-karnaugh-simplificam-circuitos-digitais.md": [
		38071,
		38071
	],
	"./03011-como-funcionam-os-conversores-analogicos-em-circuitos-eletricos.md": [
		35875,
		35875
	],
	"./03012-o-que-acontece-quando-um-circuito-esta-aberto.md": [
		12526,
		12526
	],
	"./03013-como-funcionam-os-transformadores-em-circuitos-eletricos.md": [
		87629,
		87629
	],
	"./03014-como-funciona-a-transformacao-de-fontes-em-circuitos-eletricos.md": [
		53750,
		53750
	],
	"./03015-como-os-circuitos-de-primeira-ordem-funcionam-em-aplicacoes-praticas.md": [
		43790,
		43790
	],
	"./03016-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-se-comportam.md": [
		55855,
		55855
	],
	"./03017-como-a-impedancia-afeta-a-analise-de-circuitos-em-corrente-alternada.md": [
		61943,
		61943
	],
	"./03018-qual-e-a-diferenca-entre-as-conexoes-triangulo-e-estrela-em-circuitos-trifasicos.md": [
		54531,
		54531
	],
	"./03019-como-a-transformada-de-laplace-facilita-a-analise-de-circuitos-com-sinais-de-impulso-e-degrau.md": [
		94669,
		94669
	],
	"./03020-como-os-semicondutores-influenciam-o-comportamento-dos-circuitos-eletricos.md": [
		90807,
		90807
	],
	"./03021-como-os-osciladores-operacionais-funcionam-em-circuitos-analogicos.md": [
		60480,
		60480
	],
	"./03022-como-os-flip-flops-funcionam-em-circuitos-digitais.md": [
		43949,
		43949
	],
	"./03023-como-a-analise-de-fourier-e-aplicada-em-circuitos-eletricos.md": [
		17024,
		17024
	],
	"./03024-como-funciona-a-divisao-de-tensao-em-circuitos-eletricos-simples.md": [
		89795,
		89795
	],
	"./03025-qual-e-a-funcao-dos-componentes-eletronicos-em-um-circuito-eletrico.md": [
		5073,
		5073
	],
	"./03026-como-a-analise-de-circuitos-em-malha-afeta-a-potencia-em-um-circuito.md": [
		33354,
		33354
	],
	"./03027-como-ocorre-a-descarga-em-circuitos-de-primeira-ordem.md": [
		31197,
		53578
	],
	"./03028-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-se-comportam.md": [
		44006,
		44006
	],
	"./03029-como-o-teorema-de-thevenin-e-aplicado-em-circuitos-de-corrente-alternada.md": [
		39466,
		39466
	],
	"./03030-qual-e-a-diferenca-entre-as-conexoes-triangulo-e-estrela-em-circuitos-trifasicos.md": [
		8237,
		8237
	],
	"./03031-como-o-teorema-do-impulso-e-aplicado-na-analise-avancada-de-circuitos.md": [
		90148,
		90148
	],
	"./03032-como-os-bjts-funcionam-em-circuitos-de-engenharia.md": [
		35913,
		35913
	],
	"./03033-como-os-circuitos-r2r-sao-utilizados-em-circuitos-analogicos.md": [
		22067,
		22067
	],
	"./03034-como-os-circuitos-digitais-convertem-numeros-decimais-em-binarios.md": [
		28434,
		28434
	],
	"./03035-como-a-transformada-de-fourier-e-aplicada-em-circuitos-eletricos.md": [
		7116,
		7116
	],
	"./03036-o-que-e-um-circuito-aberto-e-como-ele-afeta-o-funcionamento-de-um-sistema-eletrico.md": [
		81246,
		81246
	],
	"./03037-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		97786,
		97786
	],
	"./03038-como-funciona-a-analise-de-supermalhas-em-circuitos-eletricos.md": [
		92077,
		92077
	],
	"./03039-como-funciona-a-descarga-em-circuitos-de-primeira-ordem.md": [
		27896,
		27896
	],
	"./03040-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-se-comportam-em-diferentes-condicoes-de-amortecimento.md": [
		45937,
		45937
	],
	"./03041-como-a-analise-de-circuitos-em-corrente-alternada-e-realizada.md": [
		65058,
		65058
	],
	"./03042-qual-e-a-diferenca-entre-circuitos-monofasicos-e-trifasicos.md": [
		78534,
		78534
	],
	"./03043-como-a-propriedade-de-degrau-afeta-circuitos-rlc-passivos.md": [
		5953,
		5953
	],
	"./03044-qual-e-a-diferenca-entre-mosfet-e-bjt-em-circuitos-eletricos.md": [
		78384,
		78384
	],
	"./03045-como-funciona-um-circuito-biestavel-schmitt-trigger.md": [
		31271,
		31271
	],
	"./03046-como-funciona-a-conversao-de-numeros-binarios-em-circuitos-digitais.md": [
		52371,
		52371
	],
	"./03047-como-funcionam-os-amplificadores-em-circuitos-eletricos.md": [
		56159,
		56159
	],
	"./03048-o-que-acontece-em-um-curto-circuito-em-circuitos-paralelos.md": [
		90374,
		90374
	],
	"./03049-como-os-componentes-eletronicos-influenciam-o-funcionamento-de-um-circuito-eletrico.md": [
		89741,
		89741
	],
	"./03050-como-a-lei-de-kirchhoff-se-aplica-na-analise-de-circuitos-eletricos.md": [
		88044,
		88044
	],
	"./03051-como-funcionam-os-circuitos-de-primeira-ordem.md": [
		83478,
		83478
	],
	"./03052-qual-e-a-diferenca-entre-um-circuito-rlc-subamortecido-e-superamortecido.md": [
		5080,
		5080
	],
	"./03053-como-a-superposicao-e-aplicada-em-circuitos-de-corrente-alternada.md": [
		13301,
		13301
	],
	"./03054-como-funciona-a-transformacao-estrela-triangulo-em-circuitos-trifasicos.md": [
		33844,
		33844
	],
	"./03055-como-o-teorema-de-parseval-e-aplicado-na-analise-avancada-de-circuitos.md": [
		31579,
		31579
	],
	"./03056-como-os-semicondutores-influenciam-o-comportamento-dos-circuitos-eletricos.md": [
		91964,
		91964
	],
	"./03057-como-funciona-um-circuito-schmitt-trigger-em-circuitos-analogicos.md": [
		78174,
		78174
	],
	"./03058-como-funcionam-os-circuitos-sequenciais-em-circuitos-digitais.md": [
		62572,
		62572
	],
	"./03059-como-os-circuitos-rlc-sao-utilizados-em-aulas-experimentais-de-engenharia.md": [
		88674,
		88674
	],
	"./03060-como-funciona-a-associacao-de-resistores-em-serie-e-paralelo.md": [
		25589,
		47970
	],
	"./03061-qual-e-a-funcao-de-um-transistor-em-um-circuito-eletronico.md": [
		26936,
		26936
	],
	"./03062-como-determinar-o-circuito-equivalente-de-thevenin.md": [
		86961,
		86961
	],
	"./03063-como-a-energia-e-armazenada-em-circuitos-de-primeira-ordem.md": [
		27879,
		27879
	],
	"./03064-qual-e-a-diferenca-entre-a-resposta-subamortecida-e-a-criticamente-amortecida-em-circuitos-de-segunda-ordem.md": [
		64478,
		64478
	],
	"./03065-como-o-teorema-da-superposicao-e-aplicado-em-circuitos-de-corrente-alternada.md": [
		42242,
		42242
	],
	"./03066-como-funciona-a-conexao-triangulo-estrela-em-circuitos-trifasicos-equilibrados.md": [
		68181,
		68181
	],
	"./03067-como-a-transformada-de-laplace-facilita-a-analise-de-circuitos-rlc.md": [
		90041,
		90041
	],
	"./03068-qual-e-a-diferenca-entre-mosfet-e-bjt-em-circuitos-eletricos.md": [
		7290,
		7290
	],
	"./03069-como-funcionam-os-circuitos-astaveis-em-circuitos-analogicos.md": [
		15614,
		15614
	],
	"./03070-como-os-circuitos-digitais-utilizam-a-logica-para-implementar-funcoes.md": [
		39481,
		39481
	],
	"./03071-qual-e-a-diferenca-entre-componentes-digitais-e-analogicos-em-circuitos-eletricos.md": [
		63006,
		63006
	],
	"./03072-o-que-e-uma-malha-em-um-circuito-eletrico-e-qual-sua-importancia.md": [
		75259,
		75259
	],
	"./03073-qual-e-a-funcao-dos-componentes-eletronicos-em-um-circuito-eletrico.md": [
		72158,
		72158
	],
	"./03074-como-a-analise-nodal-facilita-a-compreensao-de-circuitos-eletricos.md": [
		46547,
		68928
	],
	"./03075-como-a-energia-e-armazenada-em-circuitos-rl-de-primeira-ordem.md": [
		64897,
		64897
	],
	"./03076-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-funcionam.md": [
		81164,
		81164
	],
	"./03077-como-a-impedancia-afeta-circuitos-em-corrente-alternada.md": [
		64905,
		64905
	],
	"./03078-o-que-e-um-circuito-trifasico-equilibrado-e-como-ele-funciona.md": [
		28217,
		28217
	],
	"./03079-como-a-transformada-de-laplace-e-aplicada-na-analise-avancada-de-circuitos.md": [
		11612,
		11612
	],
	"./03080-como-funcionam-os-dispositivos-semicondutores-em-circuitos-eletricos.md": [
		16455,
		38836
	],
	"./03081-como-funcionam-os-circuitos-biestaveis-em-sistemas-analogicos.md": [
		58961,
		58961
	],
	"./03082-como-funcionam-os-latches-em-circuitos-digitais.md": [
		3497,
		3497
	],
	"./03083-como-os-equipamentos-de-medicao-influenciam-na-analise-de-circuitos-rc.md": [
		25927,
		25927
	],
	"./03084-como-a-lei-de-ohm-se-aplica-em-circuitos-abertos.md": [
		54608,
		54608
	],
	"./03085-qual-e-a-funcao-dos-componentes-passivos-em-circuitos-eletronicos.md": [
		40036,
		40036
	],
	"./03086-como-aplicar-o-teorema-de-thevenin-na-analise-basica-de-circuitos.md": [
		9115,
		9115
	],
	"./03087-como-os-circuitos-de-primeira-ordem-funcionam-com-indutores.md": [
		95547,
		95547
	],
	"./03088-como-a-continuidade-afeta-circuitos-de-segunda-ordem.md": [
		8474,
		8474
	],
	"./03089-como-a-impedancia-afeta-circuitos-em-corrente-alternada.md": [
		4580,
		4580
	],
	"./03090-qual-e-a-diferenca-entre-circuitos-monofasicos-e-trifasicos.md": [
		82417,
		82417
	],
	"./03091-como-a-analise-de-circuitos-com-funcoes-de-impulso-e-rampa-e-aplicada-em-filtros-eletricos.md": [
		73306,
		73306
	],
	"./03092-como-os-semicondutores-afetam-o-funcionamento-dos-circuitos-eletricos.md": [
		71209,
		71209
	],
	"./03093-como-funcionam-os-filtros-passivos-em-circuitos-analogicos.md": [
		91813,
		91813
	],
	"./03094-como-funcionam-as-portas-logicas-em-circuitos-digitais.md": [
		29908,
		29908
	],
	"./03095-como-funciona-um-amplificador-schmitt-trigger-em-circuitos-eletricos.md": [
		77295,
		77295
	],
	"./03096-como-as-leis-de-kirchhoff-se-aplicam-em-circuitos-eletricos.md": [
		29736,
		29736
	],
	"./03097-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		28612,
		28612
	],
	"./03098-como-a-transformacao-de-fontes-afeta-a-analise-de-circuitos.md": [
		95924,
		95924
	],
	"./03099-como-os-circuitos-de-primeira-ordem-afetam-a-resposta-de-um-capacitor.md": [
		56364,
		56364
	],
	"./03100-como-a-resposta-de-um-circuito-de-segunda-ordem-e-influenciada-por-diferentes-condicoes-de-amortecimento.md": [
		66923,
		66923
	],
	"./03101-como-a-impedancia-afeta-circuitos-em-corrente-alternada.md": [
		35375,
		35375
	],
	"./03102-como-funciona-a-conexao-estrela-triangulo-em-circuitos-trifasicos.md": [
		95729,
		95729
	],
	"./03103-como-a-transformada-de-fourier-e-aplicada-na-analise-avancada-de-circuitos.md": [
		39004,
		39004
	],
	"./03104-qual-e-a-diferenca-entre-bjt-e-mosfet-em-circuitos-eletricos.md": [
		96831,
		96831
	],
	"./03105-como-funciona-o-oscilador-de-wien-em-circuitos-analogicos.md": [
		21921,
		21921
	],
	"./03106-como-funciona-um-latch-em-circuitos-digitais.md": [
		55171,
		55171
	],
	"./03107-como-funcionam-os-filtros-rc-em-circuitos-analogicos.md": [
		26852,
		26852
	],
	"./03108-qual-e-a-diferenca-entre-um-circuito-aberto-e-um-circuito-fechado.md": [
		72848,
		72848
	],
	"./03109-como-funcionam-os-componentes-passivos-em-circuitos-eletricos.md": [
		19756,
		97375
	],
	"./03110-como-a-transformacao-de-fontes-afeta-a-analise-basica-de-circuitos.md": [
		13741,
		13741
	],
	"./03111-como-a-energia-e-armazenada-em-circuitos-de-primeira-ordem.md": [
		26625,
		26625
	],
	"./03112-como-funciona-a-resposta-subamortecida-em-circuitos-de-segunda-ordem.md": [
		74752,
		74752
	],
	"./03113-o-que-e-a-corrente-eficaz-em-circuitos-de-corrente-alternada.md": [
		14189,
		14189
	],
	"./03114-como-funciona-a-conexao-triangulo-triangulo-em-circuitos-trifasicos.md": [
		72407,
		72407
	],
	"./03115-como-a-transformada-de-laplace-facilita-a-analise-de-circuitos-eletricos.md": [
		99100,
		99100
	],
	"./03116-como-os-transistores-mosfet-e-mesfet-funcionam-em-circuitos-eletricos.md": [
		79314,
		79314
	],
	"./03117-como-funciona-a-implementacao-de-um-conversor-r2r-em-circuitos-analogicos.md": [
		32703,
		32703
	],
	"./03118-como-os-mapas-de-karnaugh-simplificam-funcoes-logicas-em-circuitos-digitais.md": [
		69120,
		69120
	],
	"./03119-como-a-configuracao-em-serie-afeta-o-comportamento-de-circuitos-combinacionais.md": [
		44854,
		44854
	],
	"./03120-como-as-leis-de-kirchhoff-se-aplicam-em-circuitos-eletricos.md": [
		47542,
		47542
	],
	"./03121-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		46930,
		46930
	],
	"./03122-como-funciona-o-teorema-de-thevenin-na-analise-de-circuitos.md": [
		3603,
		3603
	],
	"./03123-como-os-circuitos-de-primeira-ordem-funcionam-com-indutores.md": [
		91270,
		91270
	],
	"./03124-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-se-comportam.md": [
		57513,
		57513
	],
	"./03125-como-determinar-o-valor-eficaz-em-circuitos-de-corrente-alternada.md": [
		8385,
		8385
	],
	"./03126-qual-e-a-diferenca-entre-as-conexoes-triangulo-triangulo-e-triangulo-estrela-em-circuitos-trifasicos.md": [
		88225,
		88225
	],
	"./03127-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-rlc.md": [
		83124,
		83124
	],
	"./03128-como-os-semicondutores-influenciam-o-comportamento-dos-circuitos-eletricos.md": [
		21458,
		21458
	],
	"./03129-como-os-circuitos-analogicos-processam-sinais-de-forma-eficiente.md": [
		58577,
		58577
	],
	"./03130-como-a-simplificacao-de-expressoes-booleanas-facilita-o-projeto-de-circuitos-digitais.md": [
		61499,
		61499
	],
	"./03131-como-a-analise-de-circuitos-em-regime-permanente-senoidal-e-realizada-em-laboratorios-de-engenharia.md": [
		20966,
		20966
	],
	"./03132-qual-e-a-diferenca-entre-circuitos-em-serie-e-em-paralelo.md": [
		67242,
		67242
	],
	"./03133-qual-e-a-funcao-dos-componentes-passivos-em-circuitos-eletricos.md": [
		13839,
		13839
	],
	"./03134-como-analisar-circuitos-usando-os-teoremas-de-thevenin-e-norton.md": [
		28388,
		28388
	],
	"./03135-como-a-constante-de-tempo-afeta-a-carga-em-um-capacitor-em-circuitos-de-primeira-ordem.md": [
		43590,
		43590
	],
	"./03136-qual-e-a-diferenca-entre-os-tipos-de-resposta-em-circuitos-de-segunda-ordem.md": [
		4352,
		4352
	],
	"./03137-como-a-impedancia-afeta-circuitos-em-corrente-alternada.md": [
		90090,
		90090
	],
	"./03138-como-funciona-a-conversao-de-circuitos-trifasicos-estrela-para-triangulo.md": [
		4127,
		4127
	],
	"./03139-como-analisar-circuitos-rlc-de-forma-eficiente.md": [
		56216,
		56216
	],
	"./03140-qual-e-a-diferenca-entre-os-tipos-de-transistores-semicondutores.md": [
		84345,
		84345
	],
	"./03141-como-funcionam-os-circuitos-biestaveis-em-circuitos-analogicos.md": [
		77836,
		77836
	],
	"./03142-como-os-circuitos-sequenciais-diferem-dos-circuitos-combinacionais.md": [
		67905,
		67905
	],
	"./03143-como-os-conversores-sao-utilizados-em-aulas-experimentais-de-circuitos-eletricos.md": [
		73988,
		73988
	],
	"./03144-como-a-lei-de-ohm-se-aplica-a-circuitos-em-paralelo.md": [
		31161,
		31161
	],
	"./03145-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		3976,
		3976
	],
	"./03146-como-a-teoria-da-superposicao-e-aplicada-na-analise-basica-de-circuitos.md": [
		90204,
		90204
	],
	"./03147-como-a-comutacao-afeta-o-comportamento-de-circuitos-de-primeira-ordem-com-indutores.md": [
		63530,
		63530
	],
	"./03148-qual-e-a-diferenca-entre-uma-resposta-sub-amortecida-e-uma-resposta-amortecida-em-circuitos-de-segunda-ordem.md": [
		33873,
		33873
	],
	"./03149-como-a-analise-nodal-e-aplicada-em-circuitos-de-corrente-alternada.md": [
		78494,
		78494
	],
	"./03150-o-que-e-o-fator-de-potencia-em-circuitos-trifasicos-e-por-que-ele-e-importante.md": [
		33426,
		33426
	],
	"./03151-como-funciona-um-filtro-passa-faixas-em-circuitos-eletricos.md": [
		61303,
		61303
	],
	"./03152-como-os-mosfets-funcionam-em-circuitos-eletricos.md": [
		41332,
		41332
	],
	"./03153-como-funcionam-os-osciladores-em-circuitos-analogicos.md": [
		19234,
		19234
	],
	"./03154-como-simplificar-funcoes-logicas-usando-mapas-de-karnaugh.md": [
		39979,
		39979
	],
	"./03155-como-funcionam-as-portas-logicas-ttl-em-circuitos-eletricos.md": [
		48201,
		48201
	],
	"./03156-o-que-e-uma-malha-em-um-circuito-eletrico-e-qual-sua-importancia.md": [
		67708,
		67708
	],
	"./03157-qual-e-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		7475,
		7475
	],
	"./03158-como-funciona-a-transformacao-de-fontes-em-circuitos-eletricos.md": [
		26491,
		26491
	],
	"./03159-como-a-tensao-em-um-capacitor-se-comporta-em-um-circuito-rc-de-primeira-ordem.md": [
		28927,
		28927
	],
	"./03160-como-os-circuitos-de-segunda-ordem-respondem-a-um-degrau-de-tensao.md": [
		99853,
		99853
	],
	"./03161-como-a-amplitude-afeta-o-valor-da-potencia-em-circuitos-de-corrente-alternada.md": [
		8866,
		8866
	],
	"./03162-como-funciona-a-conexao-triangulo-triangulo-em-circuitos-trifasicos.md": [
		72646,
		72646
	],
	"./03163-como-a-transformada-de-fourier-e-aplicada-na-analise-avancada-de-circuitos.md": [
		53730,
		53730
	],
	"./03164-como-os-transistores-de-heterojuncao-hbt-funcionam-em-circuitos-eletricos.md": [
		84438,
		84438
	],
	"./03165-como-funcionam-os-circuitos-analogicos-com-amplificadores-operacionais.md": [
		89681,
		89681
	],
	"./03166-como-funcionam-os-circuitos-digitais-sequenciais.md": [
		75601,
		75601
	],
	"./03167-como-funcionam-os-circuitos-r2r-em-aplicacoes-analogicas.md": [
		1584,
		1584
	],
	"./03168-o-que-e-uma-malha-em-um-circuito-eletrico-e-qual-sua-importancia.md": [
		8223,
		8223
	],
	"./03169-qual-e-a-funcao-de-um-capacitor-em-um-circuito-eletrico.md": [
		73903,
		73903
	],
	"./03170-como-analisar-circuitos-eletricos-basicos-com-fontes-e-resistores.md": [
		66314,
		66314
	],
	"./03171-como-os-capacitores-armazenam-energia-em-circuitos-de-primeira-ordem.md": [
		85291,
		85291
	],
	"./03172-o-que-e-um-circuito-de-segunda-ordem-super-amortecido.md": [
		54815,
		54815
	],
	"./03173-como-a-impedancia-afeta-circuitos-em-corrente-alternada.md": [
		89146,
		89146
	],
	"./03174-como-funciona-a-ligacao-triangulo-triangulo-em-circuitos-trifasicos.md": [
		82136,
		82136
	],
	"./03175-como-a-transformada-de-laplace-facilita-a-analise-de-circuitos-eletricos.md": [
		18038,
		18038
	],
	"./03176-como-os-transistores-bipolares-de-juncao-bjt-funcionam-em-circuitos-eletricos.md": [
		57148,
		57148
	],
	"./03177-como-funcionam-os-multivibradores-em-circuitos-analogicos.md": [
		49758,
		49758
	],
	"./03178-como-funciona-a-simplificacao-de-circuitos-combinacionais.md": [
		15247,
		15247
	],
	"./03179-como-o-trigger-de-schmitt-e-utilizado-em-circuitos-digitais.md": [
		97785,
		97785
	],
	"./03180-qual-e-a-diferenca-entre-circuitos-em-serie-e-em-paralelo.md": [
		79955,
		79955
	],
	"./03181-qual-e-a-funcao-dos-componentes-passivos-em-um-circuito-eletrico.md": [
		28027,
		28027
	],
	"./03182-como-a-tensao-maxima-de-uma-fonte-e-verificada-em-um-circuito.md": [
		38405,
		38405
	],
	"./03183-como-a-corrente-se-comporta-em-um-circuito-de-primeira-ordem-durante-a-descarga.md": [
		67208,
		67208
	],
	"./03184-como-os-circuitos-de-segunda-ordem-se-comportam-em-diferentes-condicoes-de-amortecimento.md": [
		53913,
		53913
	],
	"./03185-como-a-impedancia-afeta-circuitos-em-corrente-alternada.md": [
		7971,
		7971
	],
	"./03186-como-funciona-a-conversao-estrela-triangulo-em-circuitos-trifasicos.md": [
		79686,
		79686
	],
	"./03187-como-a-transformada-de-laplace-facilita-a-analise-de-circuitos-rlc.md": [
		47398,
		47398
	],
	"./03188-como-os-transistores-mesfet-e-hemt-funcionam-em-circuitos-eletricos.md": [
		84107,
		84107
	],
	"./03189-como-funcionam-os-amplificadores-em-circuitos-analogicos.md": [
		27110,
		27110
	],
	"./03190-como-os-circuitos-combinacionais-digitais-funcionam.md": [
		46223,
		46223
	],
	"./03191-como-a-medicao-de-componentes-em-circuitos-rc-e-realizada-em-aulas-experimentais.md": [
		26416,
		26416
	],
	"./03192-o-que-e-um-curto-circuito-e-como-ele-afeta-um-circuito-eletrico.md": [
		19237,
		19237
	],
	"./03193-como-os-componentes-eletronicos-influenciam-a-tensao-em-um-circuito.md": [
		27850,
		27850
	],
	"./03194-como-o-teorema-de-norton-e-aplicado-na-analise-de-circuitos-eletricos.md": [
		5692,
		5692
	],
	"./03195-como-os-circuitos-de-primeira-ordem-armazenam-e-liberam-energia-ao-longo-do-tempo.md": [
		3397,
		3397
	],
	"./03196-como-determinar-o-comportamento-de-circuitos-de-segunda-ordem-lc.md": [
		88523,
		88523
	],
	"./03197-como-a-corrente-senoidal-afeta-circuitos-rlc-em-corrente-alternada.md": [
		2049,
		2049
	],
	"./03198-qual-e-a-diferenca-entre-as-conexoes-estrela-triangulo-e-triangulo-triangulo-em-circuitos-trifasicos.md": [
		95498,
		95498
	],
	"./03199-como-a-transformada-de-laplace-facilita-a-analise-avancada-de-circuitos-eletricos.md": [
		3628,
		3628
	],
	"./03200-como-os-semicondutores-influenciam-o-comportamento-dos-circuitos-eletricos.md": [
		54395,
		54395
	],
	"./03201-como-funcionam-os-circuitos-astaveis-em-circuitos-analogicos.md": [
		8694,
		8694
	],
	"./03202-como-os-flip-flops-sao-utilizados-em-circuitos-digitais.md": [
		66103,
		66103
	],
	"./03203-como-os-circuitos-digitais-utilizam-o-conceito-de-trigger-em-suas-configuracoes.md": [
		32140,
		32140
	],
	"./03204-como-a-lei-de-kirchhoff-se-aplica-a-circuitos-simples-em-paralelo.md": [
		34172,
		34172
	],
	"./03205-qual-e-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		24693,
		24693
	],
	"./03206-como-aplicar-o-teorema-da-maxima-transferencia-de-potencia-em-circuitos-eletricos.md": [
		23687,
		23687
	],
	"./03207-como-funciona-a-descarga-em-circuitos-de-primeira-ordem.md": [
		72511,
		72511
	],
	"./03208-como-os-circuitos-de-segunda-ordem-respondem-a-uma-fonte-de-tensao.md": [
		28641,
		28641
	],
	"./03209-como-ocorre-a-transferencia-maxima-de-potencia-em-circuitos-de-corrente-alternada.md": [
		82655,
		82655
	],
	"./03210-qual-e-a-diferenca-entre-as-conexoes-triangulo-e-estrela-em-circuitos-trifasicos.md": [
		20673,
		20673
	],
	"./03211-como-analisar-circuitos-rlc-em-serie-com-resposta-exponencial.md": [
		76733,
		76733
	],
	"./03212-como-funcionam-os-transistores-bipolares-de-juncao-bjt-em-circuitos-eletricos.md": [
		89615,
		89615
	],
	"./03213-como-a-analise-de-bode-e-utilizada-em-circuitos-analogicos.md": [
		64141,
		64141
	],
	"./03214-como-os-circuitos-digitais-utilizam-sistemas-de-numeracao.md": [
		84813,
		84813
	],
	"./03215-como-os-equipamentos-comuns-ajudam-a-entender-circuitos-eletricos-avancados.md": [
		46408,
		46408
	],
	"./03216-qual-e-a-diferenca-entre-associacoes-em-serie-e-em-paralelo-em-circuitos-eletricos.md": [
		92091,
		92091
	],
	"./03217-qual-e-a-funcao-de-um-indutor-em-circuitos-eletronicos.md": [
		31564,
		31564
	],
	"./03218-como-funciona-o-teorema-de-norton-na-analise-de-circuitos.md": [
		28428,
		28428
	],
	"./03219-como-os-circuitos-de-primeira-ordem-armazenam-energia-ao-longo-do-tempo.md": [
		49645,
		49645
	],
	"./03220-o-que-e-um-circuito-de-segunda-ordem-sub-amortecido.md": [
		62882,
		62882
	],
	"./03221-como-analisar-circuitos-em-corrente-alternada-utilizando-numeros-complexos.md": [
		16299,
		16299
	],
	"./03222-como-funciona-o-fator-de-potencia-em-circuitos-trifasicos.md": [
		16490,
		16490
	],
	"./03223-como-a-transformada-de-laplace-e-aplicada-na-analise-avancada-de-circuitos.md": [
		48135,
		48135
	],
	"./03224-como-os-semicondutores-influenciam-a-analise-de-circuitos-eletricos.md": [
		92825,
		92825
	],
	"./03225-qual-e-a-diferenca-entre-componentes-ativos-e-passivos-em-circuitos-analogicos.md": [
		76449,
		76449
	],
	"./03226-como-funciona-a-conversao-de-numeros-decimais-para-binarios-em-circuitos-digitais.md": [
		24578,
		24578
	],
	"./03227-como-funcionam-os-amplificadores-em-circuitos-eletricos.md": [
		84492,
		84492
	],
	"./03228-o-que-e-um-no-em-um-circuito-eletrico-e-qual-sua-importancia.md": [
		57441,
		57441
	],
	"./03229-qual-e-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		40891,
		40891
	],
	"./03230-qual-e-a-diferenca-entre-malha-e-supermalha-na-analise-de-circuitos.md": [
		83808,
		83808
	],
	"./03231-como-a-energia-e-armazenada-e-liberada-em-circuitos-de-primeira-ordem-com-indutores.md": [
		56587,
		56587
	],
	"./03232-como-os-circuitos-de-segunda-ordem-se-comportam-em-diferentes-condicoes-iniciais.md": [
		63039,
		63039
	],
	"./03233-como-a-impedancia-afeta-circuitos-em-corrente-alternada.md": [
		5724,
		83343
	],
	"./03234-qual-e-a-diferenca-entre-as-conexoes-estrela-triangulo-e-triangulo-triangulo-em-circuitos-trifasicos.md": [
		44623,
		44623
	],
	"./03235-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-rlc.md": [
		69190,
		69190
	],
	"./03236-como-funcionam-os-semicondutores-em-circuitos-eletricos.md": [
		91632,
		91632
	],
	"./03237-como-funcionam-os-amplificadores-em-circuitos-analogicos.md": [
		42362,
		42362
	],
	"./03238-como-os-transistores-mos-sao-utilizados-em-circuitos-digitais.md": [
		3703,
		3703
	],
	"./03239-como-a-analise-de-circuitos-em-regime-permanente-e-realizada-em-aulas-experimentais.md": [
		82630,
		82630
	],
	"./03240-o-que-e-um-no-em-um-circuito-eletrico-e-como-ele-afeta-a-tensao.md": [
		54120,
		54120
	],
	"./03241-como-funcionam-os-transformadores-em-circuitos-eletricos.md": [
		79410,
		79410
	],
	"./03242-como-a-superposicao-e-aplicada-na-analise-basica-de-circuitos-eletricos.md": [
		70435,
		70435
	],
	"./03243-como-os-circuitos-de-primeira-ordem-armazenam-e-liberam-energia.md": [
		82916,
		82916
	],
	"./03244-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-se-comportam.md": [
		50818,
		50818
	],
	"./03245-como-a-analise-de-circuitos-em-corrente-alternada-difere-da-corrente-continua.md": [
		69523,
		69523
	],
	"./03246-qual-a-diferenca-entre-conexoes-estrela-e-triangulo-em-circuitos-trifasicos-equilibrados.md": [
		21254,
		21254
	],
	"./03247-como-a-analise-de-circuitos-avancada-ajuda-na-compreensao-de-filtros-eletricos.md": [
		91277,
		91277
	],
	"./03248-como-os-semicondutores-influenciam-a-tensao-em-um-circuito-eletrico.md": [
		15506,
		15506
	],
	"./03249-como-funcionam-os-amplificadores-em-circuitos-analogicos.md": [
		99649,
		99649
	],
	"./03250-como-funciona-a-implementacao-de-circuitos-combinacionais-usando-mapas-de-karnaugh.md": [
		69253,
		69253
	],
	"./03251-como-funcionam-os-amplificadores-em-circuitos-eletricos.md": [
		46766,
		46766
	],
	"./03252-como-a-lei-das-malhas-de-kirchhoff-se-aplica-em-circuitos-eletricos.md": [
		24751,
		24751
	],
	"./03253-qual-e-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		73172,
		73172
	],
	"./03254-como-a-linearidade-afeta-a-analise-basica-de-circuitos.md": [
		59112,
		59112
	],
	"./03255-como-a-energia-e-armazenada-em-um-indutor-em-circuitos-de-primeira-ordem.md": [
		84331,
		84331
	],
	"./03256-o-que-e-um-circuito-de-segunda-ordem-super-amortecido.md": [
		17052,
		17052
	],
	"./03257-qual-e-a-diferenca-entre-o-regime-transitorio-e-o-regime-permanente-em-circuitos-de-corrente-alternada.md": [
		98476,
		98476
	],
	"./03258-qual-a-diferenca-entre-conexoes-monofasicas-e-trifasicas-em-circuitos-eletricos.md": [
		37852,
		37852
	],
	"./03259-como-a-transformada-de-fourier-e-aplicada-na-analise-avancada-de-circuitos.md": [
		35018,
		35018
	],
	"./03260-qual-e-a-diferenca-entre-bjt-e-mosfet-em-circuitos-eletricos.md": [
		14538,
		14538
	],
	"./03261-como-os-circuitos-analogicos-utilizam-amplificadores-operacionais.md": [
		77551,
		77551
	],
	"./03262-como-os-circuitos-digitais-convertem-numeros-decimais-em-binarios-e-vice-versa.md": [
		85915,
		85915
	],
	"./03263-como-a-configuracao-ttl-afeta-o-desempenho-de-circuitos-eletricos.md": [
		28856,
		28856
	],
	"./03264-como-a-lei-de-ohm-se-aplica-em-circuitos-simples.md": [
		23365,
		23365
	],
	"./03265-qual-e-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		90647,
		90647
	],
	"./03266-como-analisar-circuitos-usando-o-metodo-das-malhas.md": [
		87098,
		87098
	],
	"./03267-como-a-energia-e-armazenada-em-um-indutor-em-circuitos-de-primeira-ordem.md": [
		21519,
		21519
	],
	"./03268-qual-e-a-diferenca-entre-um-circuito-de-segunda-ordem-subamortecido-e-criticamente-amortecido.md": [
		8099,
		8099
	],
	"./03269-como-a-analise-de-circuitos-em-corrente-alternada-difere-da-corrente-continua.md": [
		13021,
		13021
	],
	"./03270-como-funciona-um-circuito-trifasico-equilibrado.md": [
		34440,
		34440
	],
	"./03271-como-a-propriedade-de-parseval-e-aplicada-na-analise-avancada-de-circuitos.md": [
		47867,
		47867
	],
	"./03272-qual-e-a-diferenca-entre-bjt-e-mosfet-em-circuitos-eletricos.md": [
		2711,
		2711
	],
	"./03273-como-funciona-um-circuito-biestavel-em-circuitos-analogicos.md": [
		28294,
		28294
	],
	"./03274-como-os-latches-funcionam-em-circuitos-digitais.md": [
		93052,
		93052
	],
	"./03275-como-funcionam-os-circuitos-rlc-em-aulas-experimentais.md": [
		59119,
		59119
	],
	"./03276-o-que-sao-elementos-de-circuito-eletrico-e-como-eles-se-relacionam-com-as-leis-de-circuito.md": [
		51536,
		51536
	],
	"./03277-qual-e-a-funcao-dos-componentes-eletronicos-em-um-circuito-eletrico.md": [
		49268,
		49268
	],
	"./03278-como-realizar-a-analise-basica-de-circuitos-utilizando-o-teorema-de-norton.md": [
		96943,
		96943
	],
	"./03279-como-funcionam-os-circuitos-de-primeira-ordem.md": [
		62474,
		62474
	],
	"./03280-como-funcionam-os-circuitos-de-segunda-ordem-super-amortecidos.md": [
		94593,
		94593
	],
	"./03281-como-a-frequencia-afeta-o-comportamento-de-circuitos-em-corrente-alternada.md": [
		91457,
		91457
	],
	"./03282-qual-e-a-diferenca-entre-circuitos-monofasicos-e-trifasicos.md": [
		51456,
		51456
	],
	"./03283-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-rlc-serie.md": [
		27810,
		27810
	],
	"./03284-qual-a-diferenca-entre-mosfet-e-bjt-em-circuitos-eletricos.md": [
		56495,
		78876
	],
	"./03285-como-funcionam-os-circuitos-analogicos-em-conversores-dc.md": [
		51251,
		51251
	],
	"./03286-como-as-portas-logicas-sao-implementadas-em-circuitos-digitais.md": [
		53261,
		53261
	],
	"./03287-como-funcionam-os-conversores-logicos-em-circuitos-digitais.md": [
		36936,
		36936
	],
	"./03288-como-a-lei-de-kirchhoff-se-aplica-em-circuitos-eletricos-basicos.md": [
		46955,
		46955
	],
	"./03289-qual-e-a-funcao-de-um-transistor-em-um-circuito-eletronico.md": [
		59464,
		59464
	],
	"./03290-como-a-analise-nodal-facilita-a-compreensao-de-circuitos-eletricos.md": [
		38276,
		38276
	],
	"./03291-como-os-circuitos-de-primeira-ordem-funcionam-com-indutores-e-capacitores.md": [
		66829,
		66829
	],
	"./03292-como-funcionam-os-circuitos-de-segunda-ordem.md": [
		50945,
		50945
	],
	"./03293-como-analisar-circuitos-em-corrente-alternada.md": [
		81009,
		81009
	],
	"./03294-qual-e-a-diferenca-entre-as-conexoes-triangulo-e-estrela-em-circuitos-trifasicos.md": [
		76573,
		76573
	],
	"./03295-como-a-analise-avancada-de-circuitos-explica-o-comportamento-de-filtros-eletricos.md": [
		19347,
		19347
	],
	"./03296-como-a-juncao-de-um-diodo-afeta-a-analise-de-circuitos-eletricos.md": [
		39764,
		39764
	],
	"./03297-como-funcionam-os-circuitos-analogicos-em-operacao-ativa.md": [
		59317,
		59317
	],
	"./03298-como-funciona-uma-porta-logica-em-circuitos-digitais.md": [
		20548,
		20548
	],
	"./03299-como-os-amplificadores-operacionais-funcionam-em-circuitos-basicos.md": [
		74504,
		74504
	],
	"./03300-como-a-lei-de-ohm-se-aplica-em-um-circuito-aberto.md": [
		31092,
		31092
	],
	"./03301-qual-e-a-funcao-de-um-capacitor-em-um-circuito-eletronico.md": [
		28072,
		28072
	],
	"./03302-como-a-linearidade-afeta-a-analise-de-circuitos-eletricos.md": [
		80997,
		80997
	],
	"./03303-como-a-comutacao-afeta-a-tensao-em-circuitos-de-primeira-ordem.md": [
		86207,
		86207
	],
	"./03304-como-a-continuidade-afeta-circuitos-de-segunda-ordem.md": [
		78153,
		78153
	],
	"./03305-como-a-frequencia-afeta-a-potencia-em-circuitos-de-corrente-alternada.md": [
		62519,
		62519
	],
	"./03306-qual-e-a-importancia-dos-circuitos-trifasicos-equilibrados-na-engenharia.md": [
		67375,
		67375
	],
	"./03307-o-que-e-a-singularidade-em-circuitos-rlc-e-como-ela-afeta-a-analise-avancada.md": [
		90787,
		90787
	],
	"./03308-como-os-semicondutores-afetam-o-comportamento-de-um-circuito-eletrico.md": [
		29159,
		29159
	],
	"./03309-como-funcionam-os-multivibradores-em-circuitos-analogicos.md": [
		9653,
		9653
	],
	"./03310-como-funciona-a-conversao-de-numeros-decimais-para-binarios-em-circuitos-digitais.md": [
		43200,
		43200
	],
	"./03311-como-funciona-a-configuracao-r2r-em-circuitos-analogicos.md": [
		86278,
		86278
	],
	"./03312-como-a-lei-de-ohm-se-aplica-em-um-circuito-simples.md": [
		68875,
		68875
	],
	"./03313-qual-e-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		26213,
		26213
	],
	"./03314-como-aplicar-o-teorema-de-thevenin-na-analise-basica-de-circuitos.md": [
		28049,
		28049
	],
	"./03315-como-os-circuitos-rc-de-primeira-ordem-funcionam.md": [
		35579,
		35579
	],
	"./03316-como-os-circuitos-de-segunda-ordem-respondem-a-um-degrau-de-tensao.md": [
		20184,
		20184
	],
	"./03317-como-a-admitancia-afeta-o-comportamento-de-circuitos-em-corrente-alternada.md": [
		43569,
		43569
	],
	"./03318-qual-e-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		64556,
		64556
	],
	"./03319-como-a-analise-avancada-de-circuitos-lida-com-componentes-passivos-em-serie.md": [
		106,
		77725
	],
	"./03320-qual-e-a-diferenca-entre-bjt-e-mosfet-em-circuitos-eletricos.md": [
		18843,
		18843
	],
	"./03321-como-funcionam-os-amplificadores-operacionais-em-circuitos-analogicos.md": [
		5938,
		5938
	],
	"./03322-qual-e-a-diferenca-entre-um-flip-flop-e-um-latch-em-circuitos-digitais.md": [
		97510,
		97510
	],
	"./03323-como-funcionam-os-filtros-em-circuitos-logicos-avancados.md": [
		71225,
		71225
	],
	"./03324-como-a-lei-de-kirchhoff-se-aplica-em-circuitos-com-curto-circuito.md": [
		52487,
		52487
	],
	"./03325-qual-e-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		75342,
		75342
	],
	"./03326-como-verificar-a-maxima-transferencia-de-potencia-em-um-circuito-eletrico.md": [
		9114,
		9114
	],
	"./03327-como-ocorre-a-descarga-em-circuitos-rl-e-rc-de-primeira-ordem.md": [
		39754,
		39754
	],
	"./03328-o-que-sao-circuitos-de-segunda-ordem-sub-amortecidos.md": [
		94698,
		94698
	],
	"./03329-como-ocorre-a-transferencia-de-energia-em-circuitos-de-corrente-alternada.md": [
		51860,
		51860
	],
	"./03330-o-que-e-um-circuito-trifasico-equilibrado-e-como-ele-funciona.md": [
		18404,
		18404
	],
	"./03331-como-a-analise-avancada-de-circuitos-utiliza-o-teorema-de-parseval.md": [
		9683,
		9683
	],
	"./03332-como-funciona-o-mosfet-em-modo-de-saturacao.md": [
		28492,
		28492
	],
	"./03333-como-funciona-um-oscilador-de-ponte-de-wien-em-circuitos-analogicos.md": [
		88356,
		88356
	],
	"./03334-como-os-transistores-cmos-funcionam-em-circuitos-digitais.md": [
		51733,
		51733
	],
	"./03335-como-a-configuracao-de-emissor-comum-afeta-o-desempenho-de-um-amplificador-rc.md": [
		84554,
		84554
	],
	"./03336-o-que-e-um-no-em-um-circuito-eletrico-e-qual-sua-importancia.md": [
		93113,
		93113
	],
	"./03337-como-funcionam-os-transformadores-em-circuitos-eletricos.md": [
		44128,
		44128
	],
	"./03338-como-funciona-a-analise-basica-de-circuitos-eletricos.md": [
		63119,
		63119
	],
	"./03339-como-funciona-a-descarga-de-um-capacitor-em-um-circuito-de-primeira-ordem.md": [
		8837,
		8837
	],
	"./03340-como-a-continuidade-da-corrente-afeta-circuitos-de-segunda-ordem.md": [
		77822,
		77822
	],
	"./03341-como-a-corrente-eficaz-e-determinada-em-circuitos-de-corrente-alternada.md": [
		64060,
		64060
	],
	"./03342-qual-a-diferenca-entre-conexoes-triangulo-e-estrela-em-circuitos-trifasicos.md": [
		93462,
		93462
	],
	"./03343-como-a-transformada-de-laplace-facilita-a-analise-de-circuitos-rlc.md": [
		72024,
		72024
	],
	"./03344-qual-e-a-diferenca-entre-mosfet-e-mesfet-em-circuitos-eletricos.md": [
		90617,
		90617
	],
	"./03345-como-funciona-um-circuito-biestavel-em-circuitos-analogicos.md": [
		13128,
		13128
	],
	"./03346-como-funciona-a-simplificacao-de-expressoes-em-circuitos-digitais.md": [
		27629,
		50010
	],
	"./03347-como-funcionam-os-amplificadores-em-circuitos-analogicos-e-digitais.md": [
		47761,
		47761
	],
	"./03348-qual-e-a-diferenca-entre-resistencias-em-serie-e-em-paralelo.md": [
		32283,
		32283
	],
	"./03349-qual-e-a-funcao-dos-componentes-passivos-em-circuitos-eletronicos.md": [
		53525,
		53525
	],
	"./03350-como-a-lei-de-superposicao-e-aplicada-na-analise-basica-de-circuitos.md": [
		17923,
		17923
	],
	"./03351-como-a-energia-e-dissipada-em-um-circuito-de-primeira-ordem-com-indutor.md": [
		24447,
		24447
	],
	"./03352-como-a-continuidade-afeta-circuitos-rlc-de-segunda-ordem.md": [
		61698,
		61698
	],
	"./03353-como-a-superposicao-e-aplicada-em-circuitos-de-corrente-alternada.md": [
		35000,
		35000
	],
	"./03354-por-que-os-circuitos-trifasicos-sao-amplamente-usados-em-sistemas-eletricos.md": [
		54801,
		54801
	],
	"./03355-como-a-transformada-de-laplace-facilita-a-analise-de-circuitos-eletricos.md": [
		64654,
		64654
	],
	"./03356-como-funcionam-os-semicondutores-em-circuitos-eletricos.md": [
		60205,
		60205
	],
	"./03357-como-funcionam-os-osciladores-ativos-em-circuitos-analogicos.md": [
		68709,
		68709
	],
	"./03358-como-o-mapa-de-karnaugh-simplifica-circuitos-logicos.md": [
		30887,
		30887
	],
	"./03359-como-os-circuitos-rc-em-serie-funcionam-em-um-regime-basico.md": [
		30567,
		30567
	],
	"./03360-como-a-lei-de-ohm-se-aplica-em-circuitos-em-serie.md": [
		95835,
		95835
	],
	"./03361-qual-e-a-funcao-de-um-diodo-em-um-circuito-eletrico.md": [
		24668,
		24668
	],
	"./03362-como-aplicar-o-teorema-de-thevenin-na-analise-basica-de-circuitos.md": [
		27720,
		27720
	],
	"./03363-como-a-energia-e-armazenada-em-um-circuito-rl-de-primeira-ordem.md": [
		46867,
		46867
	],
	"./03364-como-a-continuidade-afeta-circuitos-de-segunda-ordem.md": [
		69507,
		69507
	],
	"./03365-como-funciona-a-analise-nodal-em-circuitos-de-corrente-alternada.md": [
		43936,
		43936
	],
	"./03366-como-funciona-a-conexao-triangulo-triangulo-em-circuitos-trifasicos.md": [
		45780,
		45780
	],
	"./03367-como-a-analise-avancada-de-circuitos-pode-melhorar-a-compreensao-de-sistemas-eletricos-complexos.md": [
		29223,
		29223
	],
	"./03368-qual-e-a-diferenca-entre-mosfet-bjt-e-igbt-em-circuitos-eletricos.md": [
		18366,
		18366
	],
	"./03369-como-funcionam-os-amplificadores-em-circuitos-analogicos.md": [
		70562,
		70562
	],
	"./03370-como-funcionam-as-portas-logicas-em-circuitos-digitais.md": [
		41069,
		41069
	],
	"./03371-como-a-medida-de-sinais-senoidais-e-realizada-em-circuitos-avancados.md": [
		92214,
		92214
	],
	"./03372-como-funciona-a-divisao-de-tensao-em-circuitos-em-serie.md": [
		2728,
		2728
	],
	"./03373-qual-e-a-funcao-de-um-capacitor-em-um-circuito-eletrico.md": [
		77362,
		77362
	],
	"./03374-como-funciona-a-analise-nodal-em-circuitos-eletricos.md": [
		43801,
		43801
	],
	"./03375-como-ocorre-a-descarga-de-um-capacitor-em-um-circuito-de-primeira-ordem.md": [
		61584,
		61584
	],
	"./03376-o-que-e-uma-resposta-super-amortecida-em-circuitos-de-segunda-ordem.md": [
		66904,
		66904
	],
	"./03377-como-a-impedancia-afeta-circuitos-em-corrente-alternada.md": [
		64220,
		64220
	],
	"./03378-como-funciona-a-conexao-estrela-triangulo-em-circuitos-trifasicos.md": [
		58666,
		58666
	],
	"./03379-como-a-transformada-de-laplace-facilita-a-analise-avancada-de-circuitos.md": [
		26353,
		26353
	],
	"./03380-qual-a-diferenca-entre-jfet-e-mosfet-em-circuitos-eletricos.md": [
		51080,
		51080
	],
	"./03381-como-funcionam-os-circuitos-astaveis-em-circuitos-analogicos.md": [
		11643,
		11643
	],
	"./03382-como-funciona-a-simplificacao-de-expressoes-logicas-em-circuitos-digitais.md": [
		43509,
		43509
	],
	"./03383-como-os-componentes-rlc-afetam-o-comportamento-de-circuitos-em-aulas-experimentais.md": [
		42248,
		42248
	],
	"./03384-como-a-lei-de-kirchhoff-se-aplica-a-circuitos-em-serie.md": [
		19349,
		19349
	],
	"./03385-como-funcionam-os-transformadores-em-circuitos-eletricos.md": [
		17471,
		17471
	],
	"./03386-como-a-transformacao-de-fontes-facilita-a-analise-de-circuitos-eletricos.md": [
		75447,
		75447
	],
	"./03387-como-os-circuitos-de-primeira-ordem-armazenam-e-liberam-energia.md": [
		11371,
		11371
	],
	"./03388-como-os-circuitos-de-segunda-ordem-respondem-a-um-degrau-de-tensao.md": [
		23121,
		23121
	],
	"./03389-como-ocorre-a-transferencia-maxima-de-potencia-em-circuitos-de-corrente-alternada.md": [
		93432,
		93432
	],
	"./03390-qual-e-a-importancia-do-fator-de-potencia-em-circuitos-trifasicos.md": [
		35653,
		35653
	],
	"./03391-como-a-transformada-de-laplace-e-utilizada-na-analise-avancada-de-circuitos.md": [
		25031,
		25031
	],
	"./03392-qual-e-a-diferenca-entre-bjt-e-mosfet-em-circuitos-semicondutores.md": [
		94948,
		94948
	],
	"./03393-como-os-amplificadores-operacionais-sao-utilizados-em-circuitos-analogicos.md": [
		78783,
		78783
	],
	"./03394-como-os-circuitos-digitais-convertem-sinais-analogicos-em-digitais.md": [
		56829,
		56829
	],
	"./03395-como-a-ordem-de-conexao-afeta-circuitos-digitais-em-aulas-experimentais.md": [
		14225,
		14225
	],
	"./03396-como-a-lei-de-kirchhoff-se-aplica-em-circuitos-eletricos.md": [
		97726,
		97726
	],
	"./03397-como-os-transformadores-funcionam-em-circuitos-eletricos.md": [
		37844,
		37844
	],
	"./03398-como-a-superposicao-afeta-a-analise-basica-de-circuitos.md": [
		69626,
		69626
	],
	"./03399-como-os-circuitos-rc-de-primeira-ordem-funcionam-em-aplicacoes-praticas.md": [
		4751,
		4751
	],
	"./03400-como-os-circuitos-de-segunda-ordem-respondem-a-um-degrau-de-tensao.md": [
		88066,
		88066
	],
	"./03401-como-funciona-o-conceito-de-admitancia-em-circuitos-de-corrente-alternada.md": [
		85141,
		85141
	],
	"./03402-como-funciona-a-conexao-triangulo-triangulo-em-circuitos-trifasicos.md": [
		16703,
		16703
	],
	"./03403-como-a-analise-avancada-de-circuitos-lida-com-sinais-de-degrau-e-rampa.md": [
		1104,
		78723
	],
	"./03404-como-os-semicondutores-influenciam-o-funcionamento-dos-circuitos-eletricos.md": [
		21003,
		21003
	],
	"./03405-qual-e-a-diferenca-entre-amplificadores-analogicos-e-digitais-em-circuitos-analogicos.md": [
		2395,
		2395
	],
	"./03406-como-funcionam-os-circuitos-combinacionais-e-sequenciais.md": [
		90859,
		90859
	],
	"./03407-como-os-filtros-afetam-a-tensao-em-circuitos-eletricos.md": [
		80748,
		80748
	],
	"./03408-como-funciona-a-associacao-de-resistores-em-paralelo.md": [
		70257,
		70257
	],
	"./03409-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		57409,
		57409
	],
	"./03410-como-aplicar-a-analise-nodal-em-circuitos-basicos.md": [
		88595,
		88595
	],
	"./03411-como-a-energia-e-armazenada-em-circuitos-de-primeira-ordem.md": [
		58308,
		58308
	],
	"./03412-como-funcionam-os-circuitos-de-segunda-ordem-em-paralelo.md": [
		84883,
		84883
	],
	"./03413-como-determinar-o-equivalente-de-thevenin-em-circuitos-de-corrente-alternada.md": [
		50933,
		50933
	],
	"./03414-qual-e-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		83363,
		83363
	],
	"./03415-como-a-transformada-de-laplace-facilita-a-analise-de-circuitos-eletricos.md": [
		7661,
		7661
	],
	"./03416-qual-e-a-diferenca-entre-jfet-e-mosfet-em-circuitos-semicondutores.md": [
		76996,
		76996
	],
	"./03417-como-funcionam-os-osciladores-ativos-em-circuitos-analogicos.md": [
		63206,
		63206
	],
	"./03418-como-os-transistores-sao-utilizados-em-circuitos-digitais.md": [
		3563,
		3563
	],
	"./03419-como-a-tensao-senoidal-afeta-o-comportamento-de-um-bjt-em-circuitos.md": [
		71403,
		71403
	],
	"./03420-qual-e-a-relacao-entre-corrente-tensao-e-potencia-em-um-circuito-eletrico.md": [
		27657,
		27657
	],
	"./03421-qual-e-a-funcao-de-um-diodo-em-um-circuito-eletronico.md": [
		43170,
		43170
	],
	"./03422-como-a-analise-nodal-facilita-a-compreensao-de-circuitos-eletricos.md": [
		90017,
		90017
	],
	"./03423-como-os-circuitos-de-primeira-ordem-se-comportam-durante-a-descarga.md": [
		84065,
		84065
	],
	"./03424-qual-e-a-diferenca-entre-circuitos-de-segunda-ordem-subamortecidos-e-superamortecidos.md": [
		76907,
		76907
	],
	"./03425-como-a-admitancia-afeta-a-analise-de-circuitos-em-corrente-alternada.md": [
		67718,
		67718
	],
	"./03426-como-funciona-a-conexao-estrela-triangulo-em-circuitos-trifasicos.md": [
		15320,
		15320
	],
	"./03427-como-a-transformada-de-fourier-e-aplicada-na-analise-avancada-de-circuitos.md": [
		63175,
		63175
	],
	"./03428-como-os-semicondutores-influenciam-o-funcionamento-dos-circuitos-eletricos.md": [
		98649,
		98649
	],
	"./03429-como-funcionam-os-circuitos-analogicos-com-amplificadores-operacionais.md": [
		85580,
		85580
	],
	"./03430-como-os-transistores-mos-sao-utilizados-na-implementacao-de-portas-logicas-digitais.md": [
		22469,
		22469
	],
	"./03431-como-a-transformada-de-fourier-e-aplicada-em-circuitos-eletricos.md": [
		54468,
		54468
	],
	"./03432-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		24323,
		24323
	],
	"./03433-qual-e-a-funcao-dos-capacitores-em-circuitos-eletronicos.md": [
		45221,
		45221
	],
	"./03434-como-a-linearidade-afeta-a-analise-de-circuitos-eletricos.md": [
		13633,
		13633
	],
	"./03435-como-os-circuitos-rc-de-primeira-ordem-funcionam.md": [
		15242,
		15242
	],
	"./03436-como-os-circuitos-de-segunda-ordem-respondem-a-um-degrau-de-tensao.md": [
		43685,
		43685
	],
	"./03437-como-funciona-a-analise-de-circuitos-rlc-em-corrente-alternada.md": [
		91665,
		91665
	],
	"./03438-qual-e-a-diferenca-entre-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		6660,
		6660
	],
	"./03439-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		83519,
		83519
	],
	"./03440-como-os-semicondutores-influenciam-o-comportamento-dos-circuitos-eletricos.md": [
		10849,
		10849
	],
	"./03441-como-os-circuitos-analogicos-influenciam-o-comportamento-de-amplificadores-operacionais.md": [
		5704,
		5704
	],
	"./03442-como-funciona-a-simplificacao-de-circuitos-combinacionais.md": [
		7205,
		7205
	],
	"./03443-como-a-transformada-de-fourier-e-aplicada-em-circuitos-analogicos.md": [
		38769,
		38769
	],
	"./03444-o-que-e-um-no-em-um-circuito-eletrico-e-qual-sua-importancia.md": [
		70441,
		70441
	],
	"./03445-como-os-diodos-funcionam-em-circuitos-eletricos.md": [
		34516,
		34516
	],
	"./03446-como-a-analise-nodal-e-utilizada-na-simulacao-de-circuitos-eletricos.md": [
		8959,
		8959
	],
	"./03447-como-a-energia-armazenada-em-um-capacitor-varia-com-o-tempo.md": [
		4355,
		4355
	],
	"./03448-como-os-circuitos-de-segunda-ordem-respondem-a-um-degrau-de-tensao.md": [
		66286,
		66286
	],
	"./03449-como-a-impedancia-afeta-o-comportamento-de-circuitos-em-corrente-alternada.md": [
		13181,
		13181
	],
	"./03450-qual-e-a-importancia-dos-circuitos-trifasicos-equilibrados-em-sistemas-eletricos.md": [
		12140,
		12140
	],
	"./03451-como-a-transformada-de-laplace-facilita-a-analise-de-circuitos-com-entrada-em-rampa.md": [
		97543,
		97543
	],
	"./03452-como-os-semicondutores-influenciam-o-funcionamento-dos-circuitos-eletricos.md": [
		78906,
		78906
	],
	"./03453-como-funcionam-os-amplificadores-em-circuitos-analogicos.md": [
		67570,
		67570
	],
	"./03454-como-funcionam-os-latches-em-circuitos-digitais.md": [
		43250,
		43250
	],
	"./03455-como-a-resposta-em-regime-permanente-de-um-circuito-rlc-e-afetada-por-uma-fonte-senoidal.md": [
		34735,
		34735
	],
	"./03456-como-funciona-a-divisao-de-corrente-em-circuitos-eletricos.md": [
		31532,
		31532
	],
	"./03457-qual-e-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		41674,
		41674
	],
	"./03458-como-funciona-a-analise-de-supermalha-em-circuitos-eletricos.md": [
		75962,
		75962
	],
	"./03459-como-ocorre-a-descarga-de-um-capacitor-em-um-circuito-de-primeira-ordem.md": [
		49327,
		49327
	],
	"./03460-o-que-e-uma-resposta-criticamente-amortecida-em-circuitos-de-segunda-ordem.md": [
		50187,
		50187
	],
	"./03461-como-a-potencia-e-calculada-em-circuitos-de-corrente-alternada.md": [
		80970,
		80970
	],
	"./03462-como-funciona-a-potencia-em-circuitos-trifasicos.md": [
		53579,
		53579
	],
	"./03463-como-a-transformada-de-fourier-e-aplicada-na-analise-avancada-de-circuitos.md": [
		58287,
		58287
	],
	"./03464-como-os-semicondutores-influenciam-o-comportamento-dos-circuitos-eletricos.md": [
		94739,
		94739
	],
	"./03465-qual-e-a-diferenca-entre-circuitos-analogicos-e-digitais.md": [
		60481,
		60481
	],
	"./03466-como-funciona-a-conversao-de-codigo-decimal-para-binario-em-circuitos-combinacionais.md": [
		31666,
		31666
	],
	"./03467-como-a-transformada-de-fourier-e-aplicada-em-circuitos-eletricos.md": [
		55373,
		55373
	],
	"./03468-o-que-e-um-circuito-eletrico-simples-em-serie.md": [
		19377,
		19377
	],
	"./03469-qual-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		65991,
		65991
	],
	"./03470-como-a-transformacao-de-fontes-facilita-a-analise-de-circuitos.md": [
		53538,
		53538
	],
	"./03471-como-a-comutacao-afeta-circuitos-de-primeira-ordem.md": [
		4969,
		4969
	],
	"./03472-como-a-continuidade-da-corrente-afeta-circuitos-de-segunda-ordem.md": [
		74518,
		74518
	],
	"./03473-como-a-potencia-instantanea-e-calculada-em-circuitos-de-corrente-alternada.md": [
		73623,
		73623
	],
	"./03474-como-funciona-a-conexao-triangulo-estrela-em-circuitos-trifasicos.md": [
		96675,
		96675
	],
	"./03475-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-passa-faixas.md": [
		62632,
		62632
	],
	"./03476-como-funciona-a-saturacao-em-um-circuito-com-semicondutores.md": [
		56051,
		56051
	],
	"./03477-como-funciona-um-circuito-astavel-utilizando-bjt.md": [
		10706,
		10706
	],
	"./03478-como-os-transistores-mos-sao-utilizados-em-circuitos-digitais.md": [
		60405,
		60405
	],
	"./03479-como-a-analise-de-circuitos-rlc-e-rc-e-realizada-em-aulas-experimentais.md": [
		30157,
		30157
	],
	"./03480-como-a-lei-dos-nos-de-kirchhoff-se-aplica-em-circuitos-eletricos.md": [
		78458,
		78458
	],
	"./03481-qual-e-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		76975,
		76975
	],
	"./03482-como-funciona-a-analise-de-circuitos-em-malha.md": [
		9901,
		9901
	],
	"./03483-como-os-circuitos-de-primeira-ordem-afetam-a-corrente-ao-longo-do-tempo.md": [
		62321,
		62321
	],
	"./03484-como-os-circuitos-de-segunda-ordem-afetam-a-tensao-em-componentes-em-paralelo.md": [
		11822,
		11822
	],
	"./03485-como-os-fasores-facilitam-a-analise-de-circuitos-em-corrente-alternada.md": [
		95110,
		95110
	],
	"./03486-qual-e-a-diferenca-entre-conexoes-triangulo-triangulo-e-estrela-estrela-em-circuitos-trifasicos.md": [
		20596,
		20596
	],
	"./03487-como-a-transformada-de-laplace-e-aplicada-na-analise-de-filtros-passa-faixas.md": [
		20537,
		20537
	],
	"./03488-como-os-semicondutores-influenciam-o-comportamento-dos-circuitos-eletricos.md": [
		65365,
		65365
	],
	"./03489-qual-e-a-diferenca-entre-circuitos-analogicos-passivos-e-ativos.md": [
		28516,
		28516
	],
	"./03490-como-os-circuitos-combinacionais-e-sequenciais-se-diferenciam-em-circuitos-digitais.md": [
		77778,
		77778
	],
	"./03491-como-a-configuracao-de-circuitos-rlc-afeta-o-comportamento-em-aulas-experimentais.md": [
		53964,
		53964
	],
	"./03492-qual-a-diferenca-entre-associacao-em-serie-e-em-paralelo-em-circuitos-eletricos.md": [
		88960,
		88960
	],
	"./03493-qual-e-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		47982,
		47982
	],
	"./03494-como-o-teorema-de-thevenin-facilita-a-analise-de-circuitos.md": [
		21815,
		21815
	],
	"./03495-como-os-circuitos-de-primeira-ordem-armazenam-e-liberam-energia.md": [
		23206,
		23206
	],
	"./03496-o-que-sao-circuitos-de-segunda-ordem-super-amortecidos.md": [
		39399,
		39399
	],
	"./03497-como-o-teorema-de-thevenin-se-aplica-a-circuitos-em-corrente-alternada.md": [
		20743,
		20743
	],
	"./03498-qual-a-diferenca-entre-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		45896,
		45896
	],
	"./03499-como-a-transformada-de-laplace-facilita-a-analise-de-circuitos-com-impulsos.md": [
		61343,
		61343
	],
	"./03500-como-os-transistores-bipolares-de-juncao-bjt-funcionam-em-circuitos-eletricos.md": [
		81957,
		81957
	],
	"./03501-como-funciona-a-operacao-de-um-circuito-multivibrador-com-bjt.md": [
		93931,
		93931
	],
	"./03502-como-as-portas-logicas-simplificam-circuitos-digitais.md": [
		48145,
		48145
	],
	"./03503-como-os-circuitos-rlc-sao-utilizados-em-experimentos-de-laboratorio.md": [
		54336,
		54336
	],
	"./03504-o-que-e-um-no-em-um-circuito-eletrico-e-qual-sua-importancia.md": [
		22040,
		22040
	],
	"./03505-como-os-componentes-eletronicos-influenciam-o-comportamento-de-um-circuito-eletrico.md": [
		13140,
		13140
	],
	"./03506-como-aplicar-o-teorema-de-thevenin-na-analise-de-circuitos.md": [
		58820,
		58820
	],
	"./03507-como-a-energia-armazenada-em-um-indutor-e-liberada-em-um-circuito-de-primeira-ordem.md": [
		88639,
		88639
	],
	"./03508-como-os-circuitos-de-segunda-ordem-funcionam-em-sistemas-rlc.md": [
		9908,
		9908
	],
	"./03509-como-os-teoremas-de-thevenin-e-norton-se-aplicam-a-circuitos-em-corrente-alternada.md": [
		66505,
		66505
	],
	"./03510-como-a-conexao-triangulo-triangulo-afeta-a-potencia-em-circuitos-trifasicos.md": [
		41717,
		41717
	],
	"./03511-como-o-teorema-de-parseval-se-aplica-na-analise-avancada-de-circuitos.md": [
		97329,
		97329
	],
	"./03512-como-funcionam-os-dispositivos-semicondutores-jfet-e-mesfet.md": [
		2287,
		2287
	],
	"./03513-como-funcionam-os-circuitos-analogicos-em-engenharia.md": [
		27018,
		27018
	],
	"./03514-qual-e-a-diferenca-entre-flip-flops-e-latches-em-circuitos-digitais.md": [
		94790,
		94790
	],
	"./03515-como-funcionam-os-circuitos-rlc-em-experimentos-praticos.md": [
		68670,
		68670
	],
	"./03516-como-a-resistencia-afeta-a-corrente-em-um-circuito-eletrico-simples.md": [
		22283,
		22283
	],
	"./03517-qual-e-a-funcao-dos-componentes-passivos-em-circuitos-eletricos.md": [
		70173,
		70173
	],
	"./03518-como-a-analise-de-supermalha-facilita-a-resolucao-de-circuitos-complexos.md": [
		55018,
		55018
	],
	"./03519-como-a-energia-e-armazenada-em-circuitos-de-primeira-ordem.md": [
		59661,
		59661
	],
	"./03520-como-os-circuitos-de-segunda-ordem-diferem-dos-de-primeira-ordem.md": [
		11758,
		11758
	],
	"./03521-como-funciona-o-regime-permanente-em-circuitos-de-corrente-alternada.md": [
		96385,
		96385
	],
	"./03522-qual-e-a-diferenca-entre-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		40208,
		40208
	],
	"./03523-como-a-teoria-de-parseval-e-aplicada-na-analise-avancada-de-circuitos.md": [
		75378,
		75378
	],
	"./03524-como-os-semicondutores-influenciam-o-comportamento-de-corrente-em-circuitos-eletricos.md": [
		65949,
		65949
	],
	"./03525-como-funcionam-os-osciladores-astaveis-em-circuitos-analogicos.md": [
		9966,
		9966
	],
	"./03526-como-funciona-a-conversao-de-sistemas-de-numeracao-em-circuitos-digitais.md": [
		4904,
		4904
	],
	"./03527-como-funciona-um-circuito-rc-em-serie-nas-aulas-experimentais.md": [
		23696,
		23696
	],
	"./03528-o-que-e-um-curto-circuito-e-como-ele-afeta-um-circuito-eletrico.md": [
		73512,
		73512
	],
	"./03529-qual-e-a-funcao-dos-componentes-eletronicos-em-um-circuito-eletrico.md": [
		47634,
		47634
	],
	"./03530-como-funciona-a-analise-de-circuitos-usando-o-metodo-das-malhas.md": [
		2334,
		2334
	],
	"./03531-como-funciona-a-descarga-de-um-indutor-em-um-circuito-de-primeira-ordem.md": [
		13672,
		13672
	],
	"./03532-qual-e-a-diferenca-entre-um-circuito-rlc-subamortecido-e-superamortecido.md": [
		19023,
		19023
	],
	"./03533-como-a-analise-de-malha-e-aplicada-em-circuitos-de-corrente-alternada.md": [
		49700,
		49700
	],
	"./03534-qual-e-a-diferenca-entre-as-conexoes-triangulo-triangulo-e-triangulo-estrela-em-circuitos-trifasicos.md": [
		65624,
		65624
	],
	"./03535-como-a-transformada-de-laplace-e-utilizada-na-analise-avancada-de-circuitos-eletricos.md": [
		85142,
		85142
	],
	"./03536-como-os-semicondutores-influenciam-o-funcionamento-dos-circuitos-eletricos.md": [
		12029,
		12029
	],
	"./03537-qual-e-a-diferenca-entre-circuitos-astaveis-e-biestaveis.md": [
		39486,
		39486
	],
	"./03538-como-funciona-a-conversao-de-sistemas-numericos-em-circuitos-digitais.md": [
		68935,
		68935
	],
	"./03539-como-funcionam-os-conversores-digitais-de-tensao-em-circuitos-eletricos.md": [
		25305,
		25305
	],
	"./03540-o-que-e-potencia-eletrica-e-como-ela-se-relaciona-com-circuitos-basicos.md": [
		67415,
		67415
	],
	"./03541-qual-e-a-funcao-de-um-transformador-em-um-circuito-eletrico.md": [
		38285,
		38285
	],
	"./03542-como-a-analise-de-supermalha-facilita-a-resolucao-de-circuitos-complexos.md": [
		96227,
		96227
	],
	"./03543-como-os-circuitos-de-primeira-ordem-funcionam-em-aplicacoes-praticas.md": [
		26174,
		26174
	],
	"./03544-o-que-e-um-circuito-de-segunda-ordem-criticamente-amortecido.md": [
		62237,
		62237
	],
	"./03545-como-a-transferencia-de-energia-funciona-em-circuitos-de-corrente-alternada.md": [
		15793,
		15793
	],
	"./03546-qual-e-a-diferenca-entre-circuitos-trifasicos-equilibrados-e-desequilibrados.md": [
		58643,
		58643
	],
	"./03547-como-a-transformada-de-laplace-e-aplicada-na-analise-avancada-de-circuitos-eletricos.md": [
		51847,
		51847
	],
	"./03548-como-funcionam-os-transistores-bjt-em-circuitos-eletricos.md": [
		71368,
		71368
	],
	"./03549-como-funcionam-os-amplificadores-operacionais-em-circuitos-analogicos.md": [
		13242,
		13242
	],
	"./03550-como-os-transistores-mos-sao-utilizados-em-circuitos-digitais.md": [
		40200,
		40200
	],
	"./03551-como-a-analise-de-circuitos-r2r-e-aplicada-em-aulas-experimentais.md": [
		21865,
		21865
	],
	"./03552-como-a-lei-de-kirchhoff-se-aplica-na-divisao-de-corrente-em-circuitos.md": [
		43112,
		43112
	],
	"./03553-qual-e-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		36300,
		36300
	],
	"./03554-como-a-teoria-da-superposicao-e-aplicada-na-analise-basica-de-circuitos.md": [
		58435,
		58435
	],
	"./03555-como-a-comutacao-afeta-circuitos-de-primeira-ordem-com-capacitores.md": [
		21855,
		21855
	],
	"./03556-como-a-resposta-de-um-circuito-de-segunda-ordem-e-influenciada-pelas-condicoes-iniciais.md": [
		43816,
		43816
	],
	"./03557-como-a-impedancia-afeta-circuitos-em-corrente-alternada.md": [
		91040,
		91040
	],
	"./03558-como-funcionam-os-circuitos-trifasicos-em-configuracao-triangulo-triangulo.md": [
		41321,
		41321
	],
	"./03559-o-que-e-um-circuito-rlc-serie-e-como-ele-funciona-como-um-filtro-passa-faixas.md": [
		63527,
		85908
	],
	"./03560-como-funcionam-os-transistores-de-juncao-bipolar-bjt-em-circuitos-eletricos.md": [
		42431,
		42431
	],
	"./03561-como-os-filtros-de-bode-funcionam-em-circuitos-analogicos.md": [
		60039,
		60039
	],
	"./03562-como-os-flip-flops-funcionam-em-circuitos-digitais.md": [
		99172,
		99172
	],
	"./03563-como-os-filtros-digitais-funcionam-em-circuitos-eletricos.md": [
		13203,
		13203
	],
	"./03564-como-as-leis-de-kirchhoff-se-aplicam-em-circuitos-eletricos.md": [
		39002,
		39002
	],
	"./03565-qual-e-a-funcao-de-um-indutor-em-um-circuito-eletrico.md": [
		67074,
		67074
	],
	"./03566-como-a-supermalha-facilita-a-analise-de-circuitos-eletricos.md": [
		73431,
		73431
	],
	"./03567-como-a-comutacao-afeta-a-corrente-em-circuitos-rl-de-primeira-ordem.md": [
		98348,
		98348
	],
	"./03568-o-que-sao-circuitos-de-segunda-ordem-e-como-suas-respostas-sao-classificadas.md": [
		63608,
		63608
	],
	"./03569-o-que-e-a-corrente-alternada-e-como-ela-funciona-em-circuitos-eletricos.md": [
		7141,
		7141
	],
	"./03570-como-funciona-a-conversao-de-circuitos-estrela-para-triangulo.md": [
		72803,
		72803
	],
	"./03571-como-a-transformada-de-laplace-facilita-a-analise-de-circuitos-eletricos.md": [
		10606,
		10606
	],
	"./03572-como-os-mosfets-funcionam-em-circuitos-eletricos.md": [
		9146,
		9146
	],
	"./03573-como-os-circuitos-analogicos-utilizam-bjts-em-amplificadores-de-sinal.md": [
		13434,
		13434
	],
	"./03574-como-os-transistores-sao-usados-em-circuitos-digitais.md": [
		43153,
		43153
	],
	"./03575-como-a-configuracao-serie-afeta-a-medida-em-circuitos-eletricos.md": [
		16759,
		16759
	],
	"./03576-o-que-e-um-no-em-um-circuito-eletrico.md": [
		94939,
		94939
	],
	"./03577-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		23671,
		23671
	],
	"./03578-como-a-analise-nodal-e-aplicada-na-analise-basica-de-circuitos.md": [
		60549,
		60549
	],
	"./03579-como-a-constante-de-tempo-afeta-circuitos-rc-de-primeira-ordem.md": [
		65009,
		65009
	],
	"./03580-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-funcionam.md": [
		3946,
		3946
	],
	"./03581-como-funciona-a-transferencia-de-energia-em-circuitos-rlc-em-serie-no-regime-permanente.md": [
		75735,
		75735
	],
	"./03582-como-a-potencia-instantanea-e-usada-em-circuitos-trifasicos.md": [
		90474,
		90474
	],
	"./03583-como-a-transformada-de-laplace-facilita-a-analise-de-circuitos-eletricos.md": [
		19333,
		19333
	],
	"./03584-como-os-semicondutores-funcionam-em-circuitos-eletricos.md": [
		54012,
		54012
	],
	"./03585-como-os-circuitos-analogicos-processam-sinais.md": [
		94694,
		94694
	],
	"./03586-como-o-mapa-de-karnaugh-simplifica-circuitos-logicos.md": [
		12836,
		12836
	],
	"./03587-como-funciona-um-circuito-rc-em-aulas-experimentais.md": [
		94795,
		94795
	],
	"./03588-o-que-e-tensao-eletrica-e-como-ela-afeta-um-circuito.md": [
		50771,
		50771
	],
	"./03589-qual-e-a-funcao-de-um-indutor-em-um-circuito-eletrico.md": [
		95132,
		95132
	],
	"./03590-como-a-analise-nodal-e-aplicada-em-circuitos-com-fontes-de-tensao.md": [
		81194,
		81194
	],
	"./03591-como-a-energia-e-armazenada-e-liberada-em-circuitos-de-primeira-ordem-com-indutores.md": [
		6284,
		6284
	],
	"./03592-como-os-circuitos-de-segunda-ordem-mantem-a-continuidade-de-corrente-e-tensao.md": [
		5582,
		5582
	],
	"./03593-como-a-impedancia-afeta-circuitos-em-corrente-alternada.md": [
		44672,
		44672
	],
	"./03594-qual-e-a-diferenca-entre-as-conexoes-triangulo-triangulo-e-triangulo-estrela-em-circuitos-trifasicos.md": [
		11826,
		11826
	],
	"./03595-o-que-e-um-filtro-passa-faixas-e-como-ele-funciona-em-circuitos-eletricos.md": [
		6604,
		6604
	],
	"./03596-qual-e-a-diferenca-entre-jfet-e-mosfet-em-circuitos-semicondutores.md": [
		78169,
		78169
	],
	"./03597-como-funcionam-os-multivibradores-astaveis-em-circuitos-analogicos.md": [
		12551,
		12551
	],
	"./03598-como-funciona-a-conversao-de-numeros-decimais-para-binarios-em-circuitos-digitais.md": [
		62294,
		62294
	],
	"./03599-como-a-configuracao-de-emissor-comum-afeta-a-tensao-em-circuitos.md": [
		31610,
		31610
	],
	"./03600-como-funciona-a-associacao-de-resistores-em-paralelo.md": [
		51547,
		51547
	],
	"./03601-qual-e-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		32353,
		32353
	],
	"./03602-como-o-teorema-de-thevenin-facilita-a-analise-basica-de-circuitos.md": [
		10676,
		10676
	],
	"./03603-como-funcionam-os-circuitos-rc-de-primeira-ordem.md": [
		27651,
		27651
	],
	"./03604-como-analisar-circuitos-de-segunda-ordem-sub-amortecidos.md": [
		30522,
		30522
	],
	"./03605-como-funciona-o-principio-da-superposicao-em-circuitos-de-corrente-alternada.md": [
		50236,
		50236
	],
	"./03606-como-funciona-a-potencia-instantanea-em-circuitos-trifasicos.md": [
		18582,
		18582
	],
	"./03607-qual-e-a-importancia-das-transformadas-de-fourier-e-laplace-na-analise-avancada-de-circuitos.md": [
		38129,
		38129
	],
	"./03608-como-os-semicondutores-influenciam-o-projeto-de-circuitos-eletricos.md": [
		5307,
		5307
	],
	"./03609-como-funciona-a-implementacao-pratica-de-um-oscilador-de-wien-em-circuitos-analogicos.md": [
		27480,
		27480
	],
	"./03610-como-os-flip-flops-funcionam-em-circuitos-digitais.md": [
		75472,
		75472
	],
	"./03611-como-os-conversores-analogicos-influenciam-a-ordem-dos-circuitos-eletricos.md": [
		36978,
		36978
	],
	"./03612-como-os-conceitos-basicos-de-circuitos-eletricos-se-relacionam.md": [
		80285,
		80285
	],
	"./03613-qual-e-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		31416,
		31416
	],
	"./03614-como-funciona-o-teorema-de-superposicao-na-analise-basica-de-circuitos.md": [
		91705,
		91705
	],
	"./03615-como-a-constante-de-tempo-afeta-circuitos-de-primeira-ordem-com-indutores.md": [
		20542,
		20542
	],
	"./03616-qual-e-a-diferenca-entre-circuitos-de-segunda-ordem-super-amortecidos-e-sub-amortecidos.md": [
		58236,
		58236
	],
	"./03617-como-a-impedancia-afeta-o-comportamento-de-circuitos-em-corrente-alternada.md": [
		754,
		754
	],
	"./03618-qual-e-a-diferenca-entre-circuitos-monofasicos-e-trifasicos.md": [
		60543,
		60543
	],
	"./03619-como-a-transformada-de-fourier-e-aplicada-na-analise-avancada-de-circuitos.md": [
		37202,
		37202
	],
	"./03620-como-os-semicondutores-afetam-o-comportamento-dos-circuitos-eletricos.md": [
		8956,
		8956
	],
	"./03621-como-funcionam-os-circuitos-analogicos-em-engenharia.md": [
		73246,
		73246
	],
	"./03622-como-as-portas-logicas-funcionam-em-circuitos-digitais.md": [
		40733,
		40733
	],
	"./03623-como-a-configuracao-de-um-circuito-rlc-afeta-seu-comportamento-em-aulas-experimentais.md": [
		35305,
		35305
	],
	"./03624-o-que-e-um-curto-circuito-e-como-ele-afeta-um-circuito-eletrico.md": [
		22633,
		22633
	],
	"./03625-qual-e-a-funcao-dos-componentes-eletronicos-em-um-circuito-eletrico.md": [
		74115,
		74115
	],
	"./03626-como-o-teorema-de-norton-e-aplicado-na-analise-de-circuitos.md": [
		34133,
		34133
	],
	"./03627-como-a-energia-e-armazenada-em-circuitos-de-primeira-ordem.md": [
		41714,
		41714
	],
	"./03628-como-a-resposta-amortecida-afeta-circuitos-de-segunda-ordem.md": [
		32778,
		32778
	],
	"./03629-como-a-admitancia-afeta-circuitos-em-corrente-alternada.md": [
		55114,
		55114
	],
	"./03630-qual-e-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		26995,
		26995
	],
	"./03631-como-a-transformada-de-laplace-facilita-a-analise-de-circuitos-com-entrada-em-rampa.md": [
		65279,
		65279
	],
	"./03632-como-os-transistores-bipolares-de-juncao-bjt-funcionam-em-circuitos-eletricos.md": [
		5413,
		5413
	],
	"./03633-como-os-circuitos-analogicos-sao-implementados-em-engenharia.md": [
		97699,
		97699
	],
	"./03634-como-os-transistores-sao-utilizados-em-circuitos-digitais.md": [
		87539,
		87539
	],
	"./03635-como-os-circuitos-schmitt-trigger-funcionam-em-aplicacoes-digitais.md": [
		12781,
		12781
	],
	"./03636-o-que-e-um-no-em-um-circuito-eletrico-e-qual-sua-importancia.md": [
		90200,
		90200
	],
	"./03637-como-os-capacitores-funcionam-em-circuitos-eletricos.md": [
		45467,
		45467
	],
	"./03638-como-determinar-o-circuito-equivalente-em-uma-analise-basica-de-circuitos.md": [
		4839,
		4839
	],
	"./03639-como-os-circuitos-de-primeira-ordem-funcionam-em-aplicacoes-praticas.md": [
		34434,
		34434
	],
	"./03640-como-funcionam-os-circuitos-de-segunda-ordem-amortecidos.md": [
		54371,
		54371
	],
	"./03641-como-a-admitancia-afeta-circuitos-em-corrente-alternada.md": [
		83672,
		83672
	],
	"./03642-como-funciona-a-conversao-de-circuitos-trifasicos-de-triangulo-para-estrela.md": [
		97221,
		97221
	],
	"./03643-como-funciona-a-analise-de-circuitos-passa-faixas.md": [
		68525,
		68525
	],
	"./03644-como-funciona-a-saturacao-em-transistores-bjt.md": [
		50664,
		50664
	],
	"./03645-como-funciona-um-oscilador-de-wien-em-circuitos-analogicos.md": [
		61749,
		61749
	],
	"./03646-como-a-logica-cmos-e-utilizada-na-implementacao-de-circuitos-digitais.md": [
		9432,
		9432
	],
	"./03647-como-configurar-um-filtro-em-um-circuito-eletrico-experimental.md": [
		14490,
		14490
	],
	"./03648-qual-e-a-diferenca-entre-no-e-malha-em-um-circuito-eletrico.md": [
		15005,
		15005
	],
	"./03649-qual-e-a-funcao-de-um-transformador-em-circuitos-eletronicos.md": [
		42589,
		64970
	],
	"./03650-como-analisar-circuitos-usando-o-metodo-das-malhas.md": [
		457,
		457
	],
	"./03651-como-funcionam-os-circuitos-de-primeira-ordem.md": [
		27244,
		27244
	],
	"./03652-como-a-continuidade-afeta-o-comportamento-de-circuitos-de-segunda-ordem.md": [
		33678,
		33678
	],
	"./03653-como-a-analise-de-circuitos-em-corrente-alternada-e-realizada.md": [
		66071,
		66071
	],
	"./03654-qual-a-diferenca-entre-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		70974,
		70974
	],
	"./03655-como-a-transformada-de-laplace-e-aplicada-na-analise-avancada-de-circuitos.md": [
		96112,
		96112
	],
	"./03656-como-os-semicondutores-influenciam-o-comportamento-de-circuitos-eletricos.md": [
		83835,
		83835
	],
	"./03657-qual-e-a-diferenca-entre-circuitos-analogicos-e-digitais-em-engenharia-eletrica.md": [
		42944,
		42944
	],
	"./03658-como-os-circuitos-cmos-funcionam-em-sistemas-digitais.md": [
		14036,
		14036
	],
	"./03659-como-a-analise-de-circuitos-r2r-e-aplicada-em-aulas-experimentais.md": [
		54056,
		54056
	],
	"./03660-o-que-sao-elementos-basicos-em-circuitos-eletricos.md": [
		37377,
		37377
	],
	"./03661-qual-e-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		23775,
		23775
	],
	"./03662-como-analisar-circuitos-usando-o-teorema-de-norton.md": [
		29454,
		29454
	],
	"./03663-como-a-comutacao-afeta-circuitos-de-primeira-ordem.md": [
		95506,
		95506
	],
	"./03664-qual-e-a-diferenca-entre-circuitos-sub-amortecidos-e-super-amortecidos-de-segunda-ordem.md": [
		82315,
		82315
	],
	"./03665-como-a-fase-afeta-circuitos-em-corrente-alternada.md": [
		23150,
		23150
	],
	"./03666-qual-e-a-diferenca-entre-as-conexoes-triangulo-triangulo-e-triangulo-estrela-em-circuitos-trifasicos.md": [
		45786,
		45786
	],
	"./03667-como-a-transformada-de-fourier-e-aplicada-na-analise-avancada-de-circuitos.md": [
		68273,
		68273
	],
	"./03668-como-os-semicondutores-afetam-o-comportamento-dos-circuitos-eletricos.md": [
		81400,
		81400
	],
	"./03669-como-os-amplificadores-de-sinal-funcionam-em-circuitos-analogicos.md": [
		28171,
		28171
	],
	"./03670-como-funcionam-as-portas-logicas-em-circuitos-digitais.md": [
		32348,
		32348
	],
	"./03671-como-funcionam-os-filtros-rlc-em-circuitos-eletricos.md": [
		90320,
		90320
	],
	"./03672-o-que-e-tensao-eletrica-e-como-ela-se-relaciona-com-a-energia-em-um-circuito.md": [
		12346,
		12346
	],
	"./03673-qual-e-a-funcao-dos-componentes-eletronicos-em-um-circuito-eletrico.md": [
		58500,
		58500
	],
	"./03674-como-funciona-a-analise-nodal-em-circuitos-eletricos.md": [
		99516,
		99516
	],
	"./03675-como-funciona-a-carga-e-descarga-em-circuitos-rl-de-primeira-ordem.md": [
		58630,
		58630
	],
	"./03676-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-se-comportam.md": [
		63099,
		63099
	],
	"./03677-qual-e-a-diferenca-entre-potencia-eficaz-e-potencia-instantanea-em-circuitos-de-corrente-alternada.md": [
		37457,
		37457
	],
	"./03678-qual-e-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		53823,
		53823
	],
	"./03679-como-a-transformada-de-fourier-e-aplicada-na-analise-avancada-de-circuitos.md": [
		61180,
		61180
	],
	"./03680-como-os-semicondutores-influenciam-a-corrente-em-circuitos-eletricos.md": [
		37295,
		37295
	],
	"./03681-como-os-amplificadores-operacionais-funcionam-em-circuitos-analogicos.md": [
		6349,
		6349
	],
	"./03682-como-os-latches-funcionam-em-circuitos-digitais.md": [
		65853,
		65853
	],
	"./03683-como-funcionam-os-filtros-em-circuitos-eletricos.md": [
		49337,
		49337
	],
	"./03684-o-que-e-um-ramo-em-um-circuito-eletrico.md": [
		7273,
		7273
	],
	"./03685-qual-e-a-funcao-dos-componentes-passivos-em-um-circuito-eletrico.md": [
		57192,
		57192
	],
	"./03686-como-a-linearidade-afeta-a-analise-de-circuitos-eletricos.md": [
		662,
		662
	],
	"./03687-como-funcionam-os-circuitos-de-primeira-ordem-rc.md": [
		55271,
		55271
	],
	"./03688-como-a-continuidade-afeta-circuitos-de-segunda-ordem.md": [
		71816,
		71816
	],
	"./03689-como-os-numeros-complexos-sao-utilizados-em-circuitos-de-corrente-alternada.md": [
		37469,
		37469
	],
	"./03690-qual-e-a-diferenca-entre-circuitos-monofasicos-e-trifasicos.md": [
		3999,
		3999
	],
	"./03691-como-a-transformada-de-laplace-e-aplicada-na-analise-avancada-de-circuitos.md": [
		41120,
		41120
	],
	"./03692-como-funcionam-os-semicondutores-em-circuitos-eletricos.md": [
		50094,
		50094
	],
	"./03693-como-funciona-um-amplificador-operacional-em-circuitos-analogicos.md": [
		34755,
		34755
	],
	"./03694-como-funcionam-os-circuitos-combinacionais-em-sistemas-digitais.md": [
		46827,
		46827
	],
	"./03695-como-a-tensao-de-trigger-afeta-o-comportamento-de-circuitos-digitais.md": [
		71512,
		71512
	],
	"./03696-o-que-e-um-no-em-um-circuito-eletrico-e-qual-sua-importancia.md": [
		16190,
		16190
	],
	"./03697-qual-e-a-funcao-de-um-capacitor-em-um-circuito-eletrico.md": [
		73571,
		73571
	],
	"./03698-como-a-analise-nodal-facilita-a-compreensao-de-circuitos-eletricos.md": [
		32640,
		32640
	],
	"./03699-como-a-constante-de-tempo-afeta-a-descarga-de-um-indutor-em-circuitos-de-primeira-ordem.md": [
		24393,
		24393
	],
	"./03700-como-os-circuitos-de-segunda-ordem-sao-resolvidos-e-simulados.md": [
		26387,
		26387
	],
	"./03701-como-a-impedancia-afeta-circuitos-em-corrente-alternada.md": [
		61537,
		61537
	],
	"./03702-o-que-e-um-circuito-trifasico-equilibrado-e-qual-sua-importancia.md": [
		94663,
		94663
	],
	"./03703-como-funciona-a-analise-avancada-de-circuitos-com-foco-em-filtros-passa-faixas.md": [
		46579,
		46579
	],
	"./03704-como-funcionam-os-transistores-bjt-em-circuitos-eletricos.md": [
		35686,
		35686
	],
	"./03705-como-funcionam-os-osciladores-em-circuitos-analogicos.md": [
		23331,
		23331
	],
	"./03706-como-os-transistores-mos-e-cmos-funcionam-em-circuitos-digitais.md": [
		66810,
		66810
	],
	"./03707-como-funciona-um-circuito-schmitt-trigger-em-aulas-experimentais.md": [
		40979,
		40979
	],
	"./03708-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		67439,
		67439
	],
	"./03709-qual-e-a-funcao-dos-componentes-passivos-em-um-circuito-eletrico.md": [
		76737,
		76737
	],
	"./03710-como-a-supermalha-facilita-a-analise-de-circuitos-complexos.md": [
		92342,
		92342
	],
	"./03711-como-a-energia-e-armazenada-em-um-capacitor-em-circuitos-de-primeira-ordem.md": [
		66706,
		66706
	],
	"./03712-qual-e-a-diferenca-entre-uma-resposta-subamortecida-e-uma-criticamente-amortecida-em-circuitos-de-segunda-ordem.md": [
		66750,
		66750
	],
	"./03713-como-ocorre-a-transferencia-maxima-de-potencia-em-circuitos-rlc-em-serie.md": [
		87687,
		87687
	],
	"./03714-qual-e-a-diferenca-entre-as-conexoes-triangulo-estrela-e-triangulo-triangulo-em-circuitos-trifasicos.md": [
		76348,
		76348
	],
	"./03715-como-funciona-um-filtro-passa-faixas-em-circuitos-eletricos.md": [
		72697,
		72697
	],
	"./03716-como-os-semicondutores-afetam-o-comportamento-dos-circuitos-eletricos.md": [
		16250,
		16250
	],
	"./03717-como-os-circuitos-analogicos-utilizam-o-trigger-de-schmitt.md": [
		34631,
		34631
	],
	"./03718-como-os-mapas-de-karnaugh-simplificam-expressoes-booleanas-em-circuitos-digitais.md": [
		81156,
		81156
	],
	"./03719-como-funcionam-os-circuitos-logicos-em-aulas-experimentais-de-engenharia.md": [
		546,
		546
	],
	"./03720-o-que-e-um-no-em-um-circuito-eletrico.md": [
		1258,
		1258
	],
	"./03721-qual-e-a-funcao-de-um-diodo-em-um-circuito-eletronico.md": [
		6043,
		6043
	],
	"./03722-como-funciona-o-teorema-de-thevenin-na-analise-de-circuitos.md": [
		7813,
		7813
	],
	"./03723-como-ocorre-a-descarga-de-um-capacitor-em-um-circuito-rc-de-primeira-ordem.md": [
		25807,
		25807
	],
	"./03724-qual-e-a-diferenca-entre-circuitos-de-segunda-ordem-subamortecidos-criticamente-amortecidos-e-superamortecidos.md": [
		26394,
		26394
	],
	"./03725-o-que-e-admitancia-em-circuitos-de-corrente-alternada.md": [
		5836,
		5836
	],
	"./03726-como-funciona-a-potencia-em-circuitos-trifasicos.md": [
		48404,
		48404
	],
	"./03727-como-a-transformada-de-laplace-facilita-a-analise-de-circuitos-eletricos.md": [
		27601,
		27601
	],
	"./03728-como-o-bjt-opera-em-diferentes-regioes-de-polarizacao.md": [
		65302,
		65302
	],
	"./03729-como-os-amplificadores-operacionais-funcionam-em-circuitos-analogicos.md": [
		1488,
		1488
	],
	"./03730-como-os-transistores-cmos-funcionam-em-circuitos-digitais.md": [
		13717,
		13717
	],
	"./03731-como-os-filtros-afetam-a-forma-de-onda-senoidal-em-circuitos-eletricos.md": [
		59880,
		59880
	],
	"./03732-qual-a-diferenca-entre-circuitos-em-serie-e-em-paralelo.md": [
		37790,
		37790
	],
	"./03733-como-funcionam-os-componentes-eletronicos-em-circuitos-eletricos.md": [
		48621,
		48621
	],
	"./03734-como-a-superposicao-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		99137,
		99137
	],
	"./03735-como-os-circuitos-de-primeira-ordem-funcionam-com-capacitores-e-indutores.md": [
		42316,
		42316
	],
	"./03736-o-que-caracteriza-um-circuito-rlc-de-segunda-ordem-super-amortecido.md": [
		87481,
		87481
	],
	"./03737-como-analisar-circuitos-em-corrente-alternada-usando-o-metodo-de-norton.md": [
		22761,
		22761
	],
	"./03738-como-o-fator-de-potencia-afeta-circuitos-trifasicos.md": [
		36759,
		36759
	],
	"./03739-o-que-e-a-resposta-ao-degrau-em-um-circuito-rlc-serie.md": [
		59662,
		59662
	],
	"./03740-como-a-juncao-de-semicondutores-afeta-o-funcionamento-de-um-transistor-bjt.md": [
		97538,
		97538
	],
	"./03741-como-funcionam-os-circuitos-analogicos-em-engenharia.md": [
		98093,
		98093
	],
	"./03742-como-funciona-a-simplificacao-de-circuitos-digitais-usando-mapas-de-karnaugh.md": [
		34235,
		34235
	],
	"./03743-como-funcionam-as-medidas-em-circuitos-de-primeira-ordem-em-um-laboratorio-experimental.md": [
		27201,
		27201
	],
	"./03744-o-que-e-um-curto-circuito-e-como-ele-afeta-um-sistema-eletrico.md": [
		76302,
		76302
	],
	"./03745-qual-e-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		83400,
		83400
	],
	"./03746-como-a-superposicao-afeta-a-analise-de-circuitos-eletricos.md": [
		22526,
		22526
	],
	"./03747-como-a-energia-e-armazenada-e-descarregada-em-circuitos-de-primeira-ordem.md": [
		92113,
		92113
	],
	"./03748-qual-e-a-diferenca-entre-circuitos-super-amortecidos-sub-amortecidos-e-criticamente-amortecidos.md": [
		69500,
		69500
	],
	"./03749-como-funciona-a-analise-de-circuitos-em-corrente-alternada.md": [
		50323,
		50323
	],
	"./03750-qual-e-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		24700,
		24700
	],
	"./03751-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-rlc.md": [
		14739,
		14739
	],
	"./03752-qual-e-a-diferenca-entre-hbt-e-bjt-em-circuitos-semicondutores.md": [
		46532,
		46532
	],
	"./03753-como-os-amplificadores-operacionais-funcionam-em-circuitos-analogicos.md": [
		97581,
		97581
	],
	"./03754-como-os-circuitos-cmos-simplificam-a-conversao-de-numeros-decimais-em-binarios.md": [
		91571,
		91571
	],
	"./03755-como-funcionam-as-portas-logicas-em-circuitos-digitais.md": [
		17982,
		17982
	],
	"./03756-qual-e-a-diferenca-entre-tensao-e-potencia-em-circuitos-eletricos.md": [
		65725,
		65725
	],
	"./03757-qual-e-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		1237,
		1237
	],
	"./03758-como-a-analise-nodal-e-aplicada-em-circuitos-eletricos.md": [
		2637,
		2637
	],
	"./03759-como-a-energia-e-armazenada-em-circuitos-de-primeira-ordem.md": [
		4107,
		4107
	],
	"./03760-o-que-e-uma-resposta-sub-amortecida-em-circuitos-de-segunda-ordem.md": [
		41256,
		41256
	],
	"./03761-como-a-potencia-eficaz-e-calculada-em-circuitos-de-corrente-alternada.md": [
		58477,
		58477
	],
	"./03762-qual-e-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		51103,
		51103
	],
	"./03763-como-a-transformada-de-laplace-e-utilizada-na-analise-avancada-de-circuitos.md": [
		44102,
		44102
	],
	"./03764-como-os-semicondutores-funcionam-em-circuitos-eletricos.md": [
		77256,
		77256
	],
	"./03765-como-funcionam-os-osciladores-em-circuitos-analogicos.md": [
		86381,
		86381
	],
	"./03766-qual-e-a-funcao-de-um-latch-em-circuitos-digitais.md": [
		56781,
		56781
	],
	"./03767-como-os-filtros-combinacionais-funcionam-em-circuitos-eletricos.md": [
		40988,
		40988
	],
	"./03768-como-funciona-a-associacao-de-resistores-em-paralelo.md": [
		54268,
		54268
	],
	"./03769-qual-e-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		64798,
		64798
	],
	"./03770-como-a-transferencia-de-potencia-e-analisada-em-circuitos-eletricos.md": [
		43553,
		43553
	],
	"./03771-como-funcionam-os-circuitos-de-primeira-ordem-em-engenharia-eletrica.md": [
		45143,
		45143
	],
	"./03772-como-a-continuidade-da-tensao-afeta-circuitos-de-segunda-ordem.md": [
		91327,
		91327
	],
	"./03773-como-a-fase-afeta-a-analise-de-circuitos-rlc-em-corrente-alternada.md": [
		36018,
		36018
	],
	"./03774-qual-e-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		13154,
		13154
	],
	"./03775-o-que-e-um-filtro-passa-faixas-e-como-ele-funciona-em-circuitos-eletricos.md": [
		71024,
		71024
	],
	"./03776-como-os-semicondutores-influenciam-o-funcionamento-dos-circuitos-eletricos.md": [
		93903,
		93903
	],
	"./03777-como-funcionam-os-amplificadores-em-circuitos-analogicos.md": [
		55247,
		55247
	],
	"./03778-como-os-circuitos-cmos-funcionam-em-circuitos-digitais.md": [
		70249,
		70249
	],
	"./03779-como-funcionam-os-filtros-digitais-em-circuitos-eletricos.md": [
		83450,
		83450
	],
	"./03780-como-a-lei-de-ohm-se-aplica-em-circuitos-eletricos-basicos.md": [
		12668,
		12668
	],
	"./03781-qual-e-a-funcao-de-um-transistor-em-um-circuito-eletronico.md": [
		42809,
		42809
	],
	"./03782-como-a-analise-de-circuitos-ajuda-na-transferencia-de-energia-em-um-no.md": [
		52093,
		52093
	],
	"./03783-como-ocorre-a-carga-e-descarga-de-um-capacitor-em-circuitos-de-primeira-ordem.md": [
		23156,
		23156
	],
	"./03784-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-se-comportam.md": [
		60621,
		60621
	],
	"./03785-qual-e-a-diferenca-entre-valor-medio-e-valor-instantaneo-em-circuitos-de-corrente-alternada.md": [
		32441,
		32441
	],
	"./03786-como-funciona-a-conversao-de-circuitos-trifasicos-de-triangulo-para-estrela.md": [
		38954,
		38954
	],
	"./03787-como-os-filtros-passa-faixas-sao-aplicados-na-analise-avancada-de-circuitos.md": [
		66754,
		66754
	],
	"./03788-como-os-semicondutores-influenciam-o-funcionamento-dos-circuitos-eletricos.md": [
		53360,
		53360
	],
	"./03789-como-os-circuitos-ativos-funcionam-em-aplicacoes-praticas.md": [
		21039,
		21039
	],
	"./03790-como-os-circuitos-digitais-utilizam-transistores-para-armazenar-dados.md": [
		59537,
		59537
	],
	"./03791-como-funcionam-os-amplificadores-em-circuitos-eletricos.md": [
		23681,
		23681
	],
	"./03792-o-que-e-um-no-em-um-circuito-eletrico.md": [
		48859,
		48859
	],
	"./03793-qual-e-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		27345,
		27345
	],
	"./03794-como-o-teorema-de-norton-e-aplicado-na-analise-basica-de-circuitos.md": [
		51201,
		51201
	],
	"./03795-como-ocorre-a-descarga-em-um-circuito-rc-de-primeira-ordem.md": [
		1548,
		1548
	],
	"./03796-o-que-e-um-circuito-de-segunda-ordem-super-amortecido.md": [
		70139,
		70139
	],
	"./03797-como-a-impedancia-afeta-o-fator-de-potencia-em-circuitos-de-corrente-alternada.md": [
		59489,
		59489
	],
	"./03798-qual-e-a-diferenca-entre-circuitos-trifasicos-e-monofasicos.md": [
		31476,
		31476
	],
	"./03799-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-com-sinais-de-rampa.md": [
		99409,
		99409
	],
	"./03800-como-os-semicondutores-influenciam-o-funcionamento-dos-mosfets-em-circuitos-eletricos.md": [
		8832,
		8832
	],
	"./03801-como-funciona-um-circuito-schmitt-trigger-em-circuitos-analogicos.md": [
		11949,
		11949
	],
	"./03802-como-funcionam-as-portas-logicas-em-circuitos-digitais.md": [
		98721,
		98721
	],
	"./03803-como-a-montagem-de-circuitos-combinacionais-ttl-e-realizada-em-laboratorios-de-engenharia.md": [
		20203,
		20203
	],
	"./03804-como-a-lei-de-ohm-se-aplica-em-circuitos-em-paralelo.md": [
		467,
		467
	],
	"./03805-como-os-transistores-funcionam-em-circuitos-eletricos.md": [
		41499,
		41499
	],
	"./03806-como-a-analise-de-thevenin-e-norton-facilita-a-compreensao-de-circuitos-eletricos.md": [
		26525,
		26525
	],
	"./03807-como-a-comutacao-afeta-circuitos-rl-de-primeira-ordem.md": [
		853,
		853
	],
	"./03808-o-que-e-uma-resposta-criticamente-amortecida-em-circuitos-de-segunda-ordem.md": [
		75341,
		75341
	],
	"./03809-como-a-frequencia-afeta-o-comportamento-de-circuitos-em-corrente-alternada.md": [
		35587,
		35587
	],
	"./03810-como-funciona-a-conversao-de-circuitos-trifasicos-estrela-para-triangulo.md": [
		59548,
		59548
	],
	"./03811-como-a-transformada-de-laplace-facilita-a-analise-de-circuitos-rlc.md": [
		13406,
		13406
	],
	"./03812-como-os-semicondutores-influenciam-o-projeto-de-circuitos-eletricos.md": [
		50674,
		50674
	],
	"./03813-como-funcionam-os-amplificadores-operacionais-em-circuitos-analogicos.md": [
		58334,
		58334
	],
	"./03814-como-a-simplificacao-de-circuitos-digitais-e-realizada-usando-mapas-de-karnaugh.md": [
		80559,
		80559
	],
	"./03815-como-funcionam-os-filtros-rc-em-circuitos-eletricos.md": [
		53984,
		53984
	],
	"./03816-o-que-e-uma-malha-em-um-circuito-eletrico-e-como-ela-afeta-a-corrente.md": [
		72996,
		72996
	],
	"./03817-qual-e-a-funcao-dos-componentes-eletronicos-em-um-circuito-eletrico.md": [
		29084,
		29084
	],
	"./03818-como-a-superposicao-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		61048,
		61048
	],
	"./03819-como-os-circuitos-de-primeira-ordem-respondem-ao-longo-do-tempo.md": [
		61646,
		61646
	],
	"./03820-o-que-caracteriza-a-resposta-de-um-circuito-de-segunda-ordem.md": [
		13035,
		13035
	],
	"./03821-como-a-amplitude-afeta-o-comportamento-de-circuitos-em-corrente-alternada.md": [
		81175,
		81175
	],
	"./03822-como-a-conexao-em-estrela-e-triangulo-afeta-a-tensao-em-circuitos-trifasicos.md": [
		59688,
		59688
	],
	"./03823-como-a-transformada-de-laplace-e-aplicada-na-analise-avancada-de-circuitos.md": [
		51821,
		51821
	],
	"./03824-como-funcionam-os-semicondutores-em-circuitos-eletricos.md": [
		66041,
		66041
	],
	"./03825-como-funcionam-os-filtros-passivos-em-circuitos-analogicos.md": [
		36618,
		36618
	],
	"./03826-como-funciona-a-conversao-de-numeros-em-circuitos-digitais.md": [
		73429,
		73429
	],
	"./03827-como-a-configuracao-rc-afeta-o-comportamento-de-circuitos-logicos.md": [
		77983,
		77983
	],
	"./03828-o-que-e-tensao-em-um-circuito-eletrico.md": [
		403,
		403
	],
	"./03829-qual-e-a-funcao-de-um-capacitor-em-um-circuito-eletronico.md": [
		63931,
		63931
	],
	"./03830-como-o-teorema-de-thevenin-facilita-a-analise-de-circuitos.md": [
		73898,
		73898
	],
	"./03831-como-a-constante-de-tempo-afeta-a-resposta-de-um-circuito-de-primeira-ordem.md": [
		91724,
		91724
	],
	"./03832-como-os-circuitos-de-segunda-ordem-respondem-a-condicoes-iniciais.md": [
		98870,
		98870
	],
	"./03833-como-a-admitancia-afeta-circuitos-em-corrente-alternada.md": [
		37787,
		37787
	],
	"./03834-qual-e-a-diferenca-entre-as-conexoes-triangulo-estrela-e-triangulo-triangulo-em-circuitos-trifasicos.md": [
		30425,
		30425
	],
	"./03835-como-a-transformada-de-fourier-e-utilizada-na-analise-avancada-de-circuitos.md": [
		82294,
		82294
	],
	"./03836-como-os-semicondutores-influenciam-a-tensao-em-circuitos-eletricos.md": [
		50164,
		50164
	],
	"./03837-como-funcionam-os-circuitos-astaveis-com-amplificadores-operacionais.md": [
		99201,
		99201
	],
	"./03838-como-os-circuitos-mos-sao-utilizados-em-circuitos-digitais.md": [
		84531,
		84531
	],
	"./03839-como-funcionam-os-conversores-de-primeira-ordem-em-circuitos-ttl.md": [
		63484,
		63484
	],
	"./03840-o-que-e-um-curto-circuito-e-como-ele-afeta-um-circuito-eletrico.md": [
		75369,
		75369
	],
	"./03841-qual-e-a-diferenca-entre-componentes-eletronicos-passivos-e-ativos.md": [
		3419,
		3419
	],
	"./03842-como-a-superposicao-afeta-a-analise-de-circuitos-eletricos.md": [
		32941,
		32941
	],
	"./03843-como-os-circuitos-de-primeira-ordem-funcionam-com-capacitores-e-indutores.md": [
		9528,
		9528
	],
	"./03844-como-os-circuitos-de-segunda-ordem-sao-aplicados-na-engenharia.md": [
		55409,
		55409
	],
	"./03845-como-a-amplitude-e-o-periodo-afetam-a-potencia-em-circuitos-de-corrente-alternada.md": [
		38924,
		38924
	],
	"./03846-como-funciona-a-conexao-em-estrela-nos-circuitos-trifasicos.md": [
		33413,
		33413
	],
	"./03847-como-o-teorema-do-circuito-inverso-se-aplica-a-circuitos-rlc.md": [
		87729,
		87729
	],
	"./03848-como-funcionam-os-semicondutores-em-circuitos-eletricos.md": [
		68727,
		68727
	],
	"./03849-como-os-amplificadores-operacionais-sao-utilizados-em-circuitos-analogicos.md": [
		87101,
		87101
	],
	"./03850-como-funciona-um-circuito-combinacional-em-circuitos-digitais.md": [
		89921,
		89921
	],
	"./03851-como-funcionam-os-filtros-em-circuitos-eletricos.md": [
		90882,
		90882
	],
	"./03852-o-que-acontece-em-um-circuito-quando-ocorre-um-curto-circuito.md": [
		40856,
		40856
	],
	"./03853-qual-e-a-funcao-de-um-transistor-em-um-circuito-eletronico.md": [
		20095,
		20095
	],
	"./03854-como-funciona-a-analise-de-superposicao-em-circuitos-eletricos.md": [
		63455,
		63455
	],
	"./03855-como-a-energia-e-armazenada-em-circuitos-de-primeira-ordem.md": [
		41616,
		41616
	],
	"./03856-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-se-comportam.md": [
		363,
		363
	],
	"./03857-como-a-impedancia-afeta-circuitos-em-corrente-alternada.md": [
		49283,
		49283
	],
	"./03858-qual-e-a-importancia-do-fator-de-potencia-em-circuitos-trifasicos.md": [
		23484,
		23484
	],
	"./03859-como-a-transformada-de-fourier-e-aplicada-na-analise-avancada-de-circuitos.md": [
		83340,
		83340
	],
	"./03860-como-funcionam-os-dispositivos-semicondutores-em-circuitos-eletricos.md": [
		55470,
		55470
	],
	"./03861-como-funcionam-os-circuitos-biestaveis-em-circuitos-analogicos.md": [
		51867,
		51867
	],
	"./03862-como-os-mapas-de-karnaugh-simplificam-circuitos-digitais.md": [
		88332,
		88332
	],
	"./03863-como-montar-um-circuito-amplificador-em-aulas-experimentais.md": [
		6902,
		6902
	],
	"./03864-o-que-e-um-no-em-um-circuito-eletrico.md": [
		63631,
		63631
	],
	"./03865-qual-e-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		88617,
		88617
	],
	"./03866-como-a-transformacao-de-fontes-facilita-a-analise-de-circuitos-eletricos.md": [
		12434,
		12434
	],
	"./03867-como-a-energia-e-armazenada-em-circuitos-de-primeira-ordem-apos-a-comutacao.md": [
		11728,
		11728
	],
	"./03868-o-que-e-uma-resposta-sub-amortecida-em-circuitos-de-segunda-ordem.md": [
		72529,
		72529
	],
	"./03869-como-a-transferencia-de-potencia-maxima-e-alcancada-em-circuitos-de-corrente-alternada.md": [
		58681,
		58681
	],
	"./03870-o-que-e-um-circuito-trifasico-equilibrado-em-configuracao-triangulo-triangulo.md": [
		34610,
		34610
	],
	"./03871-como-a-serie-de-fourier-e-aplicada-na-analise-avancada-de-circuitos.md": [
		3373,
		25754
	],
	"./03872-como-os-semicondutores-influenciam-o-funcionamento-dos-circuitos-eletricos.md": [
		77156,
		77156
	],
	"./03873-como-a-frequencia-afeta-a-resposta-de-um-amplificador-em-circuitos-analogicos.md": [
		82527,
		82527
	],
	"./03874-como-funciona-a-conversao-de-circuitos-combinacionais-em-tabelas-verdade-e-vice-versa.md": [
		98584,
		98584
	],
	"./03875-como-montar-um-circuito-rc-basico-em-serie.md": [
		28868,
		28868
	],
	"./03876-qual-e-a-diferenca-entre-um-ramo-e-um-elemento-em-um-circuito-eletrico.md": [
		35850,
		35850
	],
	"./03877-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		67474,
		67474
	],
	"./03878-como-a-corrente-se-comporta-em-um-circuito-com-multiplas-fontes.md": [
		13730,
		13730
	],
	"./03879-como-a-comutacao-afeta-circuitos-de-primeira-ordem-rl.md": [
		38880,
		38880
	],
	"./03880-o-que-e-um-circuito-de-segunda-ordem-e-como-ele-se-comporta.md": [
		66900,
		66900
	],
	"./03881-como-a-impedancia-afeta-a-analise-de-circuitos-em-corrente-alternada.md": [
		18494,
		18494
	],
	"./03882-como-funcionam-os-circuitos-trifasicos-equilibrados.md": [
		33321,
		33321
	],
	"./03883-o-que-e-a-transformada-de-laplace-e-como-ela-e-aplicada-na-analise-de-circuitos-eletricos.md": [
		30665,
		30665
	],
	"./03884-qual-e-a-diferenca-entre-um-bjt-e-um-mosfet.md": [
		77396,
		77396
	],
	"./03885-qual-e-a-diferenca-entre-circuitos-analogicos-e-digitais.md": [
		95727,
		95727
	],
	"./03886-como-os-mapas-de-karnaugh-simplificam-expressoes-logicas-em-circuitos-digitais.md": [
		89592,
		89592
	],
	"./03887-como-a-analise-de-circuitos-ttl-se-relaciona-com-dacs-em-aulas-experimentais.md": [
		43343,
		43343
	],
	"./03888-como-a-lei-de-ohm-se-aplica-em-circuitos-eletricos-basicos.md": [
		18687,
		18687
	],
	"./03889-qual-e-a-funcao-de-um-capacitor-em-um-circuito-eletronico.md": [
		61605,
		61605
	],
	"./03890-como-funciona-a-analise-de-circuitos-com-supermalhas.md": [
		60147,
		60147
	],
	"./03891-como-a-descarga-de-energia-ocorre-em-circuitos-de-primeira-ordem.md": [
		71681,
		71681
	],
	"./03892-como-os-circuitos-de-segunda-ordem-se-comportam-em-resposta-a-condicoes-iniciais.md": [
		28403,
		28403
	],
	"./03893-como-o-teorema-de-thevenin-se-aplica-a-circuitos-em-corrente-alternada.md": [
		96164,
		96164
	],
	"./03894-qual-e-a-importancia-da-conexao-em-circuitos-trifasicos.md": [
		31345,
		31345
	],
	"./03895-como-o-teorema-de-fourier-se-aplica-na-analise-de-circuitos-rlc.md": [
		20569,
		20569
	],
	"./03896-qual-e-a-diferenca-entre-um-bjt-e-um-mosfet.md": [
		79935,
		79935
	],
	"./03897-como-funcionam-os-amplificadores-em-circuitos-analogicos.md": [
		8782,
		8782
	],
	"./03898-como-funcionam-os-circuitos-sequenciais-em-circuitos-digitais.md": [
		66720,
		66720
	],
	"./03899-como-funcionam-os-circuitos-rlc-em-experimentos-de-laboratorio.md": [
		68126,
		68126
	],
	"./03900-como-as-leis-de-kirchhoff-se-aplicam-aos-circuitos-eletricos-basicos.md": [
		34602,
		34602
	],
	"./03901-qual-e-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		74254,
		74254
	],
	"./03902-como-determinar-o-circuito-equivalente-de-norton.md": [
		16337,
		16337
	],
	"./03903-como-os-circuitos-rl-e-rc-de-primeira-ordem-funcionam.md": [
		10009,
		10009
	],
	"./03904-o-que-e-um-circuito-de-segunda-ordem-super-amortecido.md": [
		51402,
		51402
	],
	"./03905-qual-e-a-importancia-do-fator-de-potencia-em-circuitos-de-corrente-alternada.md": [
		70943,
		70943
	],
	"./03906-qual-e-a-diferenca-entre-as-conexoes-triangulo-e-estrela-em-circuitos-trifasicos.md": [
		79435,
		79435
	],
	"./03907-como-a-transformada-de-laplace-e-aplicada-na-analise-avancada-de-circuitos.md": [
		89786,
		89786
	],
	"./03908-como-os-semicondutores-influenciam-o-funcionamento-dos-transistores-mosfet.md": [
		63800,
		63800
	],
	"./03909-como-funcionam-os-circuitos-analogicos-em-engenharia.md": [
		49983,
		49983
	],
	"./03910-como-os-circuitos-cmos-simplificam-a-logica-combinacional.md": [
		69249,
		69249
	],
	"./03911-como-configurar-um-circuito-com-bjt-em-aulas-experimentais.md": [
		58312,
		58312
	],
	"./03912-o-que-e-um-curto-circuito-e-como-ele-afeta-um-circuito-eletrico-basico.md": [
		74301,
		74301
	],
	"./03913-como-os-componentes-eletronicos-influenciam-a-tensao-em-um-circuito.md": [
		10602,
		10602
	],
	"./03914-como-a-superposicao-afeta-a-analise-de-circuitos-com-multiplas-fontes.md": [
		59032,
		59032
	],
	"./03915-como-ocorre-a-descarga-em-um-circuito-rl-de-primeira-ordem.md": [
		2979,
		2979
	],
	"./03916-qual-e-a-diferenca-entre-uma-resposta-super-amortecida-e-uma-resposta-criticamente-amortecida-em-circuitos-de-segunda-ordem.md": [
		92142,
		92142
	],
	"./03917-como-o-fator-de-potencia-afeta-o-desempenho-de-circuitos-em-corrente-alternada.md": [
		64076,
		64076
	],
	"./03918-qual-e-o-conceito-de-tensao-instantanea-em-circuitos-trifasicos.md": [
		32199,
		32199
	],
	"./03919-como-a-transformada-de-laplace-facilita-a-analise-avancada-de-circuitos.md": [
		49901,
		49901
	],
	"./03920-qual-e-a-funcao-dos-semicondutores-em-circuitos-eletricos.md": [
		46887,
		46887
	],
	"./03921-como-funcionam-os-filtros-em-circuitos-analogicos.md": [
		12862,
		12862
	],
	"./03922-como-os-mapas-de-karnaugh-ajudam-na-simplificacao-de-circuitos-digitais.md": [
		76430,
		76430
	],
	"./03923-como-funcionam-os-filtros-rlc-em-circuitos-eletricos.md": [
		34146,
		34146
	],
	"./03924-como-a-lei-de-ohm-se-aplica-em-circuitos-em-serie.md": [
		52986,
		52986
	],
	"./03925-qual-e-a-funcao-dos-capacitores-em-circuitos-eletronicos.md": [
		1873,
		1873
	],
	"./03926-como-a-teoria-de-thevenin-facilita-a-analise-de-circuitos.md": [
		52974,
		52974
	],
	"./03927-como-a-constante-de-tempo-afeta-circuitos-de-primeira-ordem.md": [
		69622,
		69622
	],
	"./03928-o-que-sao-circuitos-de-segunda-ordem-e-como-eles-se-comportam.md": [
		32394,
		32394
	],
	"./03929-como-analisar-circuitos-em-corrente-alternada-no-regime-permanente.md": [
		23163,
		23163
	],
	"./03930-como-funciona-a-conversao-de-circuitos-trifasicos-de-estrela-para-triangulo.md": [
		10667,
		10667
	],
	"./03931-como-a-transformada-de-laplace-e-aplicada-na-analise-avancada-de-circuitos.md": [
		54093,
		54093
	],
	"./03932-qual-e-a-diferenca-entre-mosfet-e-bjt-em-circuitos-eletricos.md": [
		87070,
		87070
	],
	"./03933-como-funcionam-os-filtros-analogicos-em-circuitos-eletricos.md": [
		57544,
		57544
	],
	"./03934-como-os-circuitos-cmos-implementam-funcoes-logicas-em-sistemas-digitais.md": [
		11551,
		11551
	],
	"./03935-como-o-regime-permanente-afeta-a-tensao-em-circuitos-eletricos.md": [
		45354,
		45354
	],
	"./03936-o-que-e-um-curto-circuito-e-como-ele-afeta-um-circuito-eletrico.md": [
		43351,
		43351
	],
	"./03937-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		45959,
		45959
	],
	"./03938-como-a-lei-de-norton-e-aplicada-na-analise-basica-de-circuitos.md": [
		62292,
		62292
	],
	"./03939-como-ocorre-a-descarga-em-um-circuito-rl-de-primeira-ordem.md": [
		73741,
		73741
	],
	"./03940-como-os-circuitos-de-segunda-ordem-respondem-a-estimulos.md": [
		5204,
		5204
	],
	"./03941-como-a-analise-nodal-e-aplicada-em-circuitos-de-corrente-alternada.md": [
		45854,
		45854
	],
	"./03942-como-funciona-a-conversao-de-circuitos-trifasicos-triangulo-triangulo.md": [
		26559,
		48940
	],
	"./03943-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-passa-faixas.md": [
		56970,
		56970
	],
	"./03944-como-funcionam-os-semicondutores-em-circuitos-eletricos.md": [
		70892,
		70892
	],
	"./03945-como-os-amplificadores-operacionais-funcionam-em-circuitos-analogicos.md": [
		61423,
		83804
	],
	"./03946-como-os-circuitos-digitais-utilizam-logica-para-implementacao-de-sistemas.md": [
		38874,
		38874
	],
	"./03947-como-funciona-um-amplificador-emissor-comum-em-circuitos-eletricos.md": [
		47368,
		47368
	],
	"./03948-como-a-lei-de-kirchhoff-se-aplica-a-circuitos-em-serie.md": [
		52627,
		52627
	],
	"./03949-qual-a-diferenca-entre-componentes-eletronicos-ativos-e-passivos.md": [
		14784,
		14784
	],
	"./03950-como-a-analise-nodal-facilita-a-verificacao-de-corrente-em-circuitos.md": [
		57628,
		57628
	],
	"./03951-como-a-energia-e-armazenada-em-circuitos-de-primeira-ordem.md": [
		86101,
		86101
	],
	"./03952-como-a-continuidade-afeta-circuitos-de-segunda-ordem.md": [
		5134,
		5134
	],
	"./03953-como-a-associacao-de-componentes-rlc-afeta-a-resposta-em-circuitos-de-corrente-alternada.md": [
		92643,
		92643
	],
	"./03954-como-funciona-a-conexao-em-circuitos-trifasicos.md": [
		72183,
		72183
	],
	"./03955-como-a-transformada-de-laplace-e-utilizada-na-analise-avancada-de-circuitos.md": [
		85377,
		85377
	],
	"./03956-como-funcionam-os-jfets-em-circuitos-eletricos.md": [
		39391,
		39391
	],
	"./03957-como-funcionam-os-amplificadores-operacionais-em-circuitos-analogicos.md": [
		54433,
		54433
	],
	"./03958-como-funcionam-os-latches-em-circuitos-digitais.md": [
		74805,
		74805
	],
	"./03959-como-o-circuito-schmitt-trigger-funciona-em-aplicacoes-praticas.md": [
		3590,
		3590
	],
	"./03960-o-que-e-uma-malha-em-um-circuito-eletrico.md": [
		8831,
		8831
	],
	"./03961-como-os-componentes-eletronicos-influenciam-o-comportamento-de-circuitos-eletricos.md": [
		44433,
		44433
	],
	"./03962-como-funciona-a-analise-nodal-em-circuitos-eletricos.md": [
		98078,
		98078
	],
	"./03963-como-a-comutacao-afeta-circuitos-de-primeira-ordem.md": [
		64273,
		64273
	],
	"./03964-como-funcionam-os-circuitos-rlc-de-segunda-ordem.md": [
		12723,
		12723
	],
	"./03965-como-a-impedancia-afeta-a-transferencia-de-energia-em-circuitos-de-corrente-alternada.md": [
		2449,
		2449
	],
	"./03966-qual-e-a-diferenca-entre-as-conexoes-estrela-e-triangulo-em-circuitos-trifasicos.md": [
		11705,
		11705
	],
	"./03967-como-a-funcao-impulso-e-aplicada-na-analise-avancada-de-circuitos.md": [
		56849,
		56849
	],
	"./03968-como-os-semicondutores-se-relacionam-com-o-teorema-de-thevenin.md": [
		70370,
		70370
	],
	"./03969-como-funciona-um-conversor-r2r-em-circuitos-analogicos.md": [
		52010,
		52010
	],
	"./03970-como-funciona-a-implementacao-de-circuitos-combinacionais-digitais.md": [
		83455,
		83455
	],
	"./03971-como-os-circuitos-rc-se-comportam-em-regime-permanente.md": [
		60445,
		60445
	],
	"./03972-como-a-lei-de-ohm-se-aplica-a-circuitos-em-serie.md": [
		87282,
		87282
	],
	"./03973-qual-e-a-funcao-dos-componentes-eletronicos-em-um-circuito-eletrico.md": [
		95273,
		95273
	],
	"./03974-como-a-analise-de-circuitos-pode-ajudar-na-simulacao-de-sistemas-eletricos.md": [
		3825,
		3825
	],
	"./03975-como-a-comutacao-afeta-a-tensao-em-circuitos-rl-de-primeira-ordem.md": [
		63013,
		63013
	],
	"./03976-o-que-e-uma-resposta-sub-amortecida-em-circuitos-de-segunda-ordem.md": [
		67501,
		67501
	],
	"./03977-como-a-impedancia-afeta-a-analise-de-circuitos-em-corrente-alternada.md": [
		54516,
		54516
	],
	"./03978-como-funciona-a-conexao-estrela-triangulo-em-circuitos-trifasicos.md": [
		31124,
		31124
	],
	"./03979-o-que-e-a-propriedade-de-parseval-na-analise-avancada-de-circuitos.md": [
		5133,
		5133
	],
	"./03980-como-os-semicondutores-influenciam-o-funcionamento-de-circuitos-eletricos.md": [
		48251,
		48251
	],
	"./03981-como-a-frequencia-afeta-o-desempenho-de-circuitos-analogicos.md": [
		42088,
		42088
	],
	"./03982-como-funciona-a-logica-combinacional-em-circuitos-digitais.md": [
		23169,
		23169
	],
	"./03983-como-funcionam-os-amplificadores-em-circuitos-ttl.md": [
		36268,
		36268
	],
	"./03984-o-que-e-uma-malha-em-um-circuito-eletrico-e-como-ela-funciona.md": [
		37331,
		37331
	],
	"./03985-qual-e-a-funcao-de-um-diodo-em-um-circuito-eletronico.md": [
		76515,
		76515
	],
	"./03986-como-verificar-a-corrente-maxima-em-um-circuito-basico.md": [
		86259,
		86259
	],
	"./03987-como-funciona-a-descarga-de-um-capacitor-em-um-circuito-rc-de-primeira-ordem.md": [
		4148,
		4148
	],
	"./03988-como-os-circuitos-de-segunda-ordem-amortecidos-funcionam.md": [
		852,
		852
	],
	"./03989-qual-e-a-importancia-do-fator-de-potencia-em-circuitos-de-corrente-alternada.md": [
		74835,
		74835
	],
	"./03990-qual-e-a-diferenca-entre-circuitos-monofasicos-e-trifasicos.md": [
		29082,
		29082
	],
	"./03991-como-a-transformada-de-laplace-e-aplicada-na-analise-de-circuitos-rlc.md": [
		31097,
		31097
	],
	"./03992-como-funcionam-os-semicondutores-em-circuitos-eletricos.md": [
		36747,
		36747
	],
	"./03993-como-funcionam-os-circuitos-de-filtro-em-circuitos-analogicos.md": [
		6648,
		6648
	],
	"./03994-como-a-simplificacao-de-circuitos-digitais-pode-ser-realizada-usando-o-mapa-de-karnaugh.md": [
		70667,
		70667
	],
	"./03995-qual-e-a-importancia-das-aulas-experimentais-no-estudo-de-circuitos-rlc.md": [
		38408,
		38408
	],
	"./03996-como-a-lei-de-ohm-se-aplica-em-circuitos-abertos.md": [
		7856,
		7856
	],
	"./03997-qual-e-a-funcao-dos-capacitores-e-transformadores-em-circuitos-eletronicos.md": [
		1307,
		1307
	],
	"./03998-como-a-superposicao-afeta-a-analise-de-circuitos-eletricos.md": [
		98521,
		98521
	],
	"./03999-como-a-comutacao-afeta-a-corrente-em-um-circuito-de-primeira-ordem-com-indutor.md": [
		87374,
		87374
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 67540;
module.exports = webpackAsyncContext;